const words = [
  { LID: '1', TranslateData: 'תקנון הבניין', TranslateKey: 'תקנון הבניין' },
  {
    LID: '2',
    TranslateData: 'Building regulations',
    TranslateKey: 'תקנון הבניין',
  },
  {
    LID: '3',
    TranslateData: 'Réglementation de la construction',
    TranslateKey: 'תקנון הבניין',
  },
  {
    LID: '4',
    TranslateData: 'Строительные нормы и правила',
    TranslateKey: 'תקנון הבניין',
  },
  { LID: '1', TranslateData: 'תחזוקה ומתקנים', TranslateKey: 'תחזוקה ומתקנים' },
  {
    LID: '2',
    TranslateData: 'Maintenance and facilities',
    TranslateKey: 'תחזוקה ומתקנים',
  },
  {
    LID: '3',
    TranslateData: 'Entretien et installations',
    TranslateKey: 'תחזוקה ומתקנים',
  },
  {
    LID: '4',
    TranslateData: 'Обслуживание и удобства',
    TranslateKey: 'תחזוקה ומתקנים',
  },
  { LID: '1', TranslateData: 'שילוט', TranslateKey: 'שילוט' },
  { LID: '2', TranslateData: 'Signage', TranslateKey: 'שילוט' },
  { LID: '3', TranslateData: 'Signalétique', TranslateKey: 'שילוט' },
  { LID: '4', TranslateData: 'Вывески', TranslateKey: 'שילוט' },
  { LID: '1', TranslateData: 'רכזות אש', TranslateKey: 'רכזות אש' },
  { LID: '2', TranslateData: 'Fire hubs', TranslateKey: 'רכזות אש' },
  { LID: '3', TranslateData: "Centres d'incendie", TranslateKey: 'רכזות אש' },
  { LID: '4', TranslateData: 'Пожарные узлы', TranslateKey: 'רכזות אש' },
  { LID: '1', TranslateData: 'רישום הוצאות', TranslateKey: 'רישום הוצאות' },
  {
    LID: '2',
    TranslateData: 'Recording expenses',
    TranslateKey: 'רישום הוצאות',
  },
  {
    LID: '3',
    TranslateData: "Dépenses d'enregistrement",
    TranslateKey: 'רישום הוצאות',
  },
  { LID: '4', TranslateData: 'Учет расходов', TranslateKey: 'רישום הוצאות' },
  { LID: '1', TranslateData: 'קריאות שירות', TranslateKey: 'קריאות שירות' },
  { LID: '2', TranslateData: 'Service calls', TranslateKey: 'קריאות שירות' },
  {
    LID: '3',
    TranslateData: 'Appels de service',
    TranslateKey: 'קריאות שירות',
  },
  { LID: '4', TranslateData: 'Сервисные звонки', TranslateKey: 'קריאות שירות' },
  {
    LID: '1',
    TranslateData: 'פתיחת קריאת שירות',
    TranslateKey: 'פתיחת קריאת שירות',
  },
  {
    LID: '2',
    TranslateData: 'Open a service call',
    TranslateKey: 'פתיחת קריאת שירות',
  },
  {
    LID: '3',
    TranslateData: 'Ouvrir un appel de service',
    TranslateKey: 'פתיחת קריאת שירות',
  },
  {
    LID: '4',
    TranslateData: 'Откройте сервисный звонок',
    TranslateKey: 'פתיחת קריאת שירות',
  },
  { LID: '1', TranslateData: 'פרופיל משתמש', TranslateKey: 'פרופיל משתמש' },
  { LID: '2', TranslateData: 'User profile', TranslateKey: 'פרופיל משתמש' },
  {
    LID: '3',
    TranslateData: "Profil de l'utilisateur",
    TranslateKey: 'פרופיל משתמש',
  },
  {
    LID: '4',
    TranslateData: 'Профиль пользователя',
    TranslateKey: 'פרופיל משתמש',
  },
  { LID: '1', TranslateData: 'פרופיל בניין', TranslateKey: 'פרופיל בניין' },
  { LID: '2', TranslateData: 'Building profile', TranslateKey: 'פרופיל בניין' },
  {
    LID: '3',
    TranslateData: 'Profil du bâtiment',
    TranslateKey: 'פרופיל בניין',
  },
  {
    LID: '4',
    TranslateData: 'Строительный профиль',
    TranslateKey: 'פרופיל בניין',
  },
  { LID: '1', TranslateData: 'פירוט מצב כספי', TranslateKey: 'פירוט מצב כספי' },
  {
    LID: '2',
    TranslateData: 'Financial status details',
    TranslateKey: 'פירוט מצב כספי',
  },
  {
    LID: '3',
    TranslateData: 'Détails de la situation financière',
    TranslateKey: 'פירוט מצב כספי',
  },
  {
    LID: '4',
    TranslateData: 'Детали финансового статуса',
    TranslateKey: 'פירוט מצב כספי',
  },
  { LID: '1', TranslateData: 'עמדות כיבוי אש', TranslateKey: 'עמדות כיבוי אש' },
  { LID: '2', TranslateData: 'Fire equipment', TranslateKey: 'עמדות כיבוי אש' },
  {
    LID: '3',
    TranslateData: "Équipement d'incendie",
    TranslateKey: 'עמדות כיבוי אש',
  },
  {
    LID: '4',
    TranslateData: 'Пожарное оборудование',
    TranslateKey: 'עמדות כיבוי אש',
  },
  { LID: '1', TranslateData: 'ספרינקלרים', TranslateKey: 'ספרינקלרים' },
  { LID: '2', TranslateData: 'Sprinklers', TranslateKey: 'ספרינקלרים' },
  { LID: '3', TranslateData: 'Gicleurs', TranslateKey: 'ספרינקלרים' },
  { LID: '4', TranslateData: 'Спринклеры', TranslateKey: 'ספרינקלרים' },
  { LID: '1', TranslateData: 'ניקיון', TranslateKey: 'ניקיון' },
  { LID: '2', TranslateData: 'Cleanliness', TranslateKey: 'ניקיון' },
  { LID: '3', TranslateData: 'Propreté', TranslateKey: 'ניקיון' },
  { LID: '4', TranslateData: 'Чистота', TranslateKey: 'ניקיון' },
  { LID: '1', TranslateData: 'משאבות לחץ מים', TranslateKey: 'משאבות לחץ מים' },
  {
    LID: '2',
    TranslateData: 'Water pressure pumps',
    TranslateKey: 'משאבות לחץ מים',
  },
  {
    LID: '3',
    TranslateData: 'Pompes à eau sous pression',
    TranslateKey: 'משאבות לחץ מים',
  },
  {
    LID: '4',
    TranslateData: 'Насосы давления воды',
    TranslateKey: 'משאבות לחץ מים',
  },
  { LID: '1', TranslateData: 'משאבות טבולות', TranslateKey: 'משאבות טבולות' },
  {
    LID: '2',
    TranslateData: 'Submersible drainage pump',
    TranslateKey: 'משאבות טבולות',
  },
  {
    LID: '3',
    TranslateData: 'Pompe de drainage submersible',
    TranslateKey: 'משאבות טבולות',
  },
  {
    LID: '4',
    TranslateData: 'Погружной дренажный насос',
    TranslateKey: 'משאבות טבולות',
  },
  { LID: '1', TranslateData: 'מקלט', TranslateKey: 'מקלט' },
  { LID: '2', TranslateData: 'Shelter', TranslateKey: 'מקלט' },
  { LID: '3', TranslateData: 'Abri', TranslateKey: 'מקלט' },
  { LID: '4', TranslateData: 'Приют', TranslateKey: 'מקלט' },
  { LID: '1', TranslateData: 'מצלמות ואבטחה', TranslateKey: 'מצלמות ואבטחה' },
  {
    LID: '2',
    TranslateData: 'Cameras and security',
    TranslateKey: 'מצלמות ואבטחה',
  },
  {
    LID: '3',
    TranslateData: 'Caméras et sécurité',
    TranslateKey: 'מצלמות ואבטחה',
  },
  {
    LID: '4',
    TranslateData: 'Камеры и безопасность',
    TranslateKey: 'מצלמות ואבטחה',
  },
  { LID: '1', TranslateData: 'דוח מצב כספי', TranslateKey: 'מצב כספי לבניין' },
  {
    LID: '2',
    TranslateData: 'Financial status',
    TranslateKey: 'מצב כספי לבניין',
  },
  {
    LID: '3',
    TranslateData: 'Statut financier',
    TranslateKey: 'מצב כספי לבניין',
  },
  {
    LID: '4',
    TranslateData: 'Финансовый статус',
    TranslateKey: 'מצב כספי לבניין',
  },
  { LID: '1', TranslateData: 'מפתחות', TranslateKey: 'מפתחות' },
  { LID: '2', TranslateData: 'Keys', TranslateKey: 'מפתחות' },
  { LID: '3', TranslateData: 'Clés', TranslateKey: 'מפתחות' },
  { LID: '4', TranslateData: 'Ключи', TranslateKey: 'מפתחות' },
  { LID: '1', TranslateData: 'מפוחים', TranslateKey: 'מפוחים' },
  { LID: '2', TranslateData: 'Blowers', TranslateKey: 'מפוחים' },
  { LID: '3', TranslateData: 'Souffleurs', TranslateKey: 'מפוחים' },
  { LID: '4', TranslateData: 'Воздуходувки', TranslateKey: 'מפוחים' },
  {
    LID: '1',
    TranslateData: 'מערכות מיזוג אויר',
    TranslateKey: 'מערכות מיזוג אויר',
  },
  {
    LID: '2',
    TranslateData: 'Air conditioning',
    TranslateKey: 'מערכות מיזוג אויר',
  },
  {
    LID: '3',
    TranslateData: 'Climatisation',
    TranslateKey: 'מערכות מיזוג אויר',
  },
  { LID: '4', TranslateData: 'Кондиционер', TranslateKey: 'מערכות מיזוג אויר' },
  { LID: '1', TranslateData: 'מעליות', TranslateKey: 'מעליות' },
  { LID: '2', TranslateData: 'Elevators', TranslateKey: 'מעליות' },
  { LID: '3', TranslateData: 'Ascenseurs', TranslateKey: 'מעליות' },
  { LID: '4', TranslateData: 'Лифтов', TranslateKey: 'מעליות' },
  { LID: '1', TranslateData: 'מעטפה', TranslateKey: 'מעטפה' },
  { LID: '2', TranslateData: 'envelope', TranslateKey: 'מעטפה' },
  { LID: '3', TranslateData: 'enveloppe', TranslateKey: 'מעטפה' },
  { LID: '4', TranslateData: 'конверт', TranslateKey: 'מעטפה' },
  { LID: '1', TranslateData: 'מסמכים ליחידה', TranslateKey: 'מסמכים ליחידה' },
  { LID: '2', TranslateData: 'Unit documents', TranslateKey: 'מסמכים ליחידה' },
  {
    LID: '3',
    TranslateData: "Documents de l'unité",
    TranslateKey: 'מסמכים ליחידה',
  },
  {
    LID: '4',
    TranslateData: 'Документы на единицу',
    TranslateKey: 'מסמכים ליחידה',
  },
  { LID: '1', TranslateData: 'פתוח', TranslateKey: 'ממתין לטיפול' },
  { LID: '2', TranslateData: 'Open', TranslateKey: 'ממתין לטיפול' },
  { LID: '3', TranslateData: 'Ouvrir', TranslateKey: 'ממתין לטיפול' },
  { LID: '4', TranslateData: 'Открыть', TranslateKey: 'ממתין לטיפול' },
  { LID: '1', TranslateData: 'מים', TranslateKey: 'מים' },
  { LID: '2', TranslateData: 'Water', TranslateKey: 'מים' },
  { LID: '3', TranslateData: "L'eau", TranslateKey: 'מים' },
  { LID: '4', TranslateData: 'Воды', TranslateKey: 'מים' },
  { LID: '1', TranslateData: 'מאגרי מים', TranslateKey: 'מאגרי מים' },
  { LID: '2', TranslateData: 'Water reservoirs', TranslateKey: 'מאגרי מים' },
  { LID: '3', TranslateData: "Réservoirs d'eau", TranslateKey: 'מאגרי מים' },
  { LID: '4', TranslateData: 'Водохранилища', TranslateKey: 'מאגרי מים' },
  {
    LID: '1',
    TranslateData: 'כניסה ואינטרקום',
    TranslateKey: 'כניסה ואינטרקום',
  },
  {
    LID: '2',
    TranslateData: 'Entrance and intercom',
    TranslateKey: 'כניסה ואינטרקום',
  },
  {
    LID: '3',
    TranslateData: 'Entrée et interphone',
    TranslateKey: 'כניסה ואינטרקום',
  },
  {
    LID: '4',
    TranslateData: 'Подъезд и домофон',
    TranslateKey: 'כניסה ואינטרקום',
  },
  { LID: '1', TranslateData: 'כללי', TranslateKey: 'כללי' },
  { LID: '2', TranslateData: 'General', TranslateKey: 'כללי' },
  { LID: '3', TranslateData: 'Général', TranslateKey: 'כללי' },
  { LID: '4', TranslateData: 'Общий', TranslateKey: 'כללי' },
  { LID: '1', TranslateData: 'טפסים לחתימה', TranslateKey: 'טפסים לחתימה' },
  { LID: '2', TranslateData: 'Fill out forms', TranslateKey: 'טפסים לחתימה' },
  {
    LID: '3',
    TranslateData: 'Remplissez les formulaires',
    TranslateKey: 'טפסים לחתימה',
  },
  { LID: '4', TranslateData: 'Заполнять формы', TranslateKey: 'טפסים לחתימה' },
  { LID: '1', TranslateData: 'טופל', TranslateKey: 'טופל' },
  { LID: '2', TranslateData: 'Done', TranslateKey: 'טופל' },
  { LID: '3', TranslateData: 'Fait', TranslateKey: 'טופל' },
  { LID: '4', TranslateData: 'Сделанный', TranslateKey: 'טופל' },
  { LID: '1', TranslateData: 'חשמל', TranslateKey: 'חשמל' },
  { LID: '2', TranslateData: 'Electricity', TranslateKey: 'חשמל' },
  { LID: '3', TranslateData: 'Électricité', TranslateKey: 'חשמל' },
  { LID: '4', TranslateData: 'Электричество', TranslateKey: 'חשמל' },
  { LID: '1', TranslateData: 'חניה', TranslateKey: 'חניה' },
  { LID: '2', TranslateData: 'Parking', TranslateKey: 'חניה' },
  { LID: '3', TranslateData: 'Parking', TranslateKey: 'חניה' },
  { LID: '4', TranslateData: 'Стоянка', TranslateKey: 'חניה' },
  { LID: '1', TranslateData: 'חימום', TranslateKey: 'חימום' },
  { LID: '2', TranslateData: 'Heating', TranslateKey: 'חימום' },
  { LID: '3', TranslateData: 'Chauffage', TranslateKey: 'חימום' },
  { LID: '4', TranslateData: 'Обогрев', TranslateKey: 'חימום' },
  { LID: '1', TranslateData: 'חדר דיירים', TranslateKey: 'חדר דיירים' },
  { LID: '2', TranslateData: "Tenants' room", TranslateKey: 'חדר דיירים' },
  {
    LID: '3',
    TranslateData: 'Chambre des locataires',
    TranslateKey: 'חדר דיירים',
  },
  {
    LID: '4',
    TranslateData: 'Комната арендаторов',
    TranslateKey: 'חדר דיירים',
  },
  { LID: '1', TranslateData: 'חבילה', TranslateKey: 'חבילה' },
  { LID: '2', TranslateData: 'package', TranslateKey: 'חבילה' },
  { LID: '3', TranslateData: 'emballer', TranslateKey: 'חבילה' },
  { LID: '4', TranslateData: 'упаковка', TranslateKey: 'חבילה' },
  {
    LID: '1',
    TranslateData: 'הצעות מחיר לאישור',
    TranslateKey: 'הצעות מחיר לאישור',
  },
  {
    LID: '2',
    TranslateData: 'Quotations for approval',
    TranslateKey: 'הצעות מחיר לאישור',
  },
  {
    LID: '3',
    TranslateData: 'Devis pour approbation',
    TranslateKey: 'הצעות מחיר לאישור',
  },
  {
    LID: '4',
    TranslateData: 'Расценки на согласование',
    TranslateKey: 'הצעות מחיר לאישור',
  },
  { LID: '1', TranslateData: 'הצעות מחיר', TranslateKey: 'הצעות מחיר' },
  { LID: '2', TranslateData: 'Quotes', TranslateKey: 'הצעות מחיר' },
  { LID: '3', TranslateData: 'Devis', TranslateKey: 'הצעות מחיר' },
  { LID: '4', TranslateData: 'Котировки', TranslateKey: 'הצעות מחיר' },
  { LID: '1', TranslateData: 'הוראת קבע', TranslateKey: 'הוראת קבע' },
  { LID: '2', TranslateData: 'Periodic payment', TranslateKey: 'הוראת קבע' },
  { LID: '3', TranslateData: 'Paiement périodique', TranslateKey: 'הוראת קבע' },
  {
    LID: '4',
    TranslateData: 'Периодическая оплата',
    TranslateKey: 'הוראת קבע',
  },
  { LID: '1', TranslateData: 'הדף לא נמצא', TranslateKey: 'הדף לא נמצא' },
  { LID: '2', TranslateData: 'Page not found', TranslateKey: 'הדף לא נמצא' },
  { LID: '3', TranslateData: 'Page non trouvée', TranslateKey: 'הדף לא נמצא' },
  {
    LID: '4',
    TranslateData: 'Страница не найдена',
    TranslateKey: 'הדף לא נמצא',
  },
  { LID: '1', TranslateData: 'הדברה', TranslateKey: 'הדברה' },
  { LID: '2', TranslateData: 'Pesticide', TranslateKey: 'הדברה' },
  { LID: '3', TranslateData: 'Pesticide', TranslateKey: 'הדברה' },
  { LID: '4', TranslateData: 'Пестицид', TranslateKey: 'הדברה' },
  { LID: '1', TranslateData: 'דף הבית', TranslateKey: 'דף הבית' },
  { LID: '2', TranslateData: 'Home page', TranslateKey: 'דף הבית' },
  { LID: '3', TranslateData: "Page d'accueil", TranslateKey: 'דף הבית' },
  { LID: '4', TranslateData: 'Домашняя страница', TranslateKey: 'דף הבית' },
  { LID: '1', TranslateData: 'גנרטור', TranslateKey: 'גנרטור' },
  { LID: '2', TranslateData: 'Electric generator', TranslateKey: 'גנרטור' },
  { LID: '3', TranslateData: 'Générateur électrique', TranslateKey: 'גנרטור' },
  {
    LID: '4',
    TranslateData: 'Электрический генератор',
    TranslateKey: 'גנרטור',
  },
  { LID: '1', TranslateData: 'גינון', TranslateKey: 'גינון' },
  { LID: '2', TranslateData: 'Gardening', TranslateKey: 'גינון' },
  { LID: '3', TranslateData: 'Jardinage', TranslateKey: 'גינון' },
  { LID: '4', TranslateData: 'Садоводство', TranslateKey: 'גינון' },
  { LID: '1', TranslateData: 'גז', TranslateKey: 'גז' },
  { LID: '2', TranslateData: 'Gas', TranslateKey: 'גז' },
  { LID: '3', TranslateData: 'Gaz', TranslateKey: 'גז' },
  { LID: '4', TranslateData: 'Газ', TranslateKey: 'גז' },
  { LID: '1', TranslateData: 'גג', TranslateKey: 'גג' },
  { LID: '2', TranslateData: 'Roof', TranslateKey: 'גג' },
  { LID: '3', TranslateData: 'Toit', TranslateKey: 'גג' },
  { LID: '4', TranslateData: 'Крыша', TranslateKey: 'גג' },
  { LID: '1', TranslateData: 'ביטוחים', TranslateKey: 'ביטוחים' },
  { LID: '2', TranslateData: 'Insurance', TranslateKey: 'ביטוחים' },
  { LID: '3', TranslateData: 'Assurance', TranslateKey: 'ביטוחים' },
  { LID: '4', TranslateData: 'Страхование', TranslateKey: 'ביטוחים' },
  { LID: '1', TranslateData: 'בטיפול', TranslateKey: 'בטיפול' },
  { LID: '2', TranslateData: 'In Execution', TranslateKey: 'בטיפול' },
  { LID: '3', TranslateData: 'En exécution', TranslateKey: 'בטיפול' },
  { LID: '4', TranslateData: 'В исполнении', TranslateKey: 'בטיפול' },
  { LID: '1', TranslateData: 'אשפה', TranslateKey: 'אשפה' },
  { LID: '2', TranslateData: 'Garbage', TranslateKey: 'אשפה' },
  { LID: '3', TranslateData: 'Des ordures', TranslateKey: 'אשפה' },
  { LID: '4', TranslateData: 'Мусор', TranslateKey: 'אשפה' },
  { LID: '1', TranslateData: 'אינטרנט וטלפון', TranslateKey: 'אינטרנט וטלפון' },
  {
    LID: '2',
    TranslateData: 'Internet and telephone',
    TranslateKey: 'אינטרנט וטלפון',
  },
  {
    LID: '3',
    TranslateData: 'Internet et téléphone',
    TranslateKey: 'אינטרנט וטלפון',
  },
  {
    LID: '4',
    TranslateData: 'Интернет и телефон',
    TranslateKey: 'אינטרנט וטלפון',
  },
  { LID: '1', TranslateData: 'אחר', TranslateKey: 'אחר' },
  { LID: '2', TranslateData: 'Other', TranslateKey: 'אחר' },
  { LID: '3', TranslateData: 'Autre', TranslateKey: 'אחר' },
  { LID: '4', TranslateData: 'Другой', TranslateKey: 'אחר' },
  { LID: '1', TranslateData: 'אודות בילד אפ', TranslateKey: 'אודות בילד אפ' },
  { LID: '2', TranslateData: 'About Build App', TranslateKey: 'אודות בילד אפ' },
  {
    LID: '3',
    TranslateData: 'À propos de Créer une application',
    TranslateKey: 'אודות בילד אפ',
  },
  {
    LID: '4',
    TranslateData: 'О приложении для сборки',
    TranslateKey: 'אודות בילד אפ',
  },
  {
    LID: '1',
    TranslateData: 'התשובה שלך התקבלה בהצלחה, ההודעה נשלחה לספק!',
    TranslateKey:
      'Your reply was successfully received, the message was sent to the supplier!',
  },
  {
    LID: '2',
    TranslateData: 'Your message was sent to the service provider !',
    TranslateKey:
      'Your reply was successfully received, the message was sent to the supplier!',
  },
  {
    LID: '3',
    TranslateData: 'Votre message a été envoyé au prestataire !',
    TranslateKey:
      'Your reply was successfully received, the message was sent to the supplier!',
  },
  {
    LID: '4',
    TranslateData: 'Ваше сообщение отправлено поставщику услуг!',
    TranslateKey:
      'Your reply was successfully received, the message was sent to the supplier!',
  },
  {
    LID: '1',
    TranslateData: 'יש לבצע אימות למספר הטלפון שלך',
    TranslateKey: 'Your phone number must be verified',
  },
  {
    LID: '2',
    TranslateData: 'Your phone number must be verified',
    TranslateKey: 'Your phone number must be verified',
  },
  {
    LID: '3',
    TranslateData: 'Votre numéro de téléphone doit être vérifié',
    TranslateKey: 'Your phone number must be verified',
  },
  {
    LID: '4',
    TranslateData: 'Ваш номер телефона должен быть подтвержден',
    TranslateKey: 'Your phone number must be verified',
  },
  {
    LID: '1',
    TranslateData: 'מספר הטלפון שלך',
    TranslateKey: 'Your phone number',
  },
  {
    LID: '2',
    TranslateData: 'Your phone number',
    TranslateKey: 'Your phone number',
  },
  {
    LID: '3',
    TranslateData: 'Votre numéro de téléphone',
    TranslateKey: 'Your phone number',
  },
  {
    LID: '4',
    TranslateData: 'Ваш номер телефона',
    TranslateKey: 'Your phone number',
  },
  {
    LID: '1',
    TranslateData: 'יש לבחור אפשרות לשליחת הודעה',
    TranslateKey: 'You must select an option to send a message',
  },
  {
    LID: '2',
    TranslateData: 'You must select an option to send a message',
    TranslateKey: 'You must select an option to send a message',
  },
  {
    LID: '3',
    TranslateData: 'Vous devez sélectionner une option pour envoyer un message',
    TranslateKey: 'You must select an option to send a message',
  },
  {
    LID: '4',
    TranslateData: 'Вы должны выбрать вариант отправки сообщения',
    TranslateKey: 'You must select an option to send a message',
  },
  {
    LID: '1',
    TranslateData: 'יש לאשר אותם על מנת להמשיך להשתמש בה.',
    TranslateKey: 'you must approve them in order to continue using it.',
  },
  {
    LID: '2',
    TranslateData: 'you must approve them in order to continue using it.',
    TranslateKey: 'you must approve them in order to continue using it.',
  },
  {
    LID: '3',
    TranslateData: "vous devez les approuver pour continuer à l'utiliser.",
    TranslateKey: 'you must approve them in order to continue using it.',
  },
  {
    LID: '4',
    TranslateData: 'вы должны одобрить их, чтобы продолжить его использование.',
    TranslateKey: 'you must approve them in order to continue using it.',
  },
  {
    LID: '1',
    TranslateData:
      'עליך לצרף את מספר הטלפון של איי פוינט {0} לרשימת המספרים המורשים לפתיחת השער',
    TranslateKey:
      'You must add the A Point phone number {0} to the list of numbers allowed to open the gate',
  },
  {
    LID: '2',
    TranslateData:
      'You must add the phone number of A Point {0} to the list of numbers authorized to open the gate',
    TranslateKey:
      'You must add the A Point phone number {0} to the list of numbers allowed to open the gate',
  },
  {
    LID: '3',
    TranslateData:
      'Vous devez ajouter le numéro de téléphone du Point A {0} à la liste des numéros autorisés à ouvrir le portail',
    TranslateKey:
      'You must add the A Point phone number {0} to the list of numbers allowed to open the gate',
  },
  {
    LID: '4',
    TranslateData:
      'Вы должны добавить номер телефона A Point {0} в список номеров, которым разрешено открывать ворота.',
    TranslateKey:
      'You must add the A Point phone number {0} to the list of numbers allowed to open the gate',
  },
  {
    LID: '1',
    TranslateData: 'למועד זה אין חוב לוועד הבית.',
    TranslateKey: 'You have no debt to the House Committee',
  },
  {
    LID: '2',
    TranslateData: 'You have no debt to the House Committee',
    TranslateKey: 'You have no debt to the House Committee',
  },
  {
    LID: '3',
    TranslateData: "Vous n'avez aucune dette envers le comité de la Chambre",
    TranslateKey: 'You have no debt to the House Committee',
  },
  {
    LID: '4',
    TranslateData: 'У вас нет долга перед комитетом палаты представителей',
    TranslateKey: 'You have no debt to the House Committee',
  },
  { LID: '1', TranslateData: 'כן', TranslateKey: 'Yes' },
  { LID: '2', TranslateData: 'Yes', TranslateKey: 'Yes' },
  { LID: '3', TranslateData: 'Oui', TranslateKey: 'Yes' },
  { LID: '4', TranslateData: 'да', TranslateKey: 'Yes' },
  {
    LID: '1',
    TranslateData: 'תרצה לשלם את זה כעת?',
    TranslateKey: 'Would you like to pay it now?',
  },
  {
    LID: '2',
    TranslateData: 'Would you like to pay it now?',
    TranslateKey: 'Would you like to pay it now?',
  },
  {
    LID: '3',
    TranslateData: 'Souhaitez-vous le payer maintenant ?',
    TranslateKey: 'Would you like to pay it now?',
  },
  {
    LID: '4',
    TranslateData: 'Хотите заплатить сейчас?',
    TranslateKey: 'Would you like to pay it now?',
  },
  { LID: '1', TranslateData: 'כותרת שבוע', TranslateKey: 'Wk' },
  { LID: '2', TranslateData: 'Wk', TranslateKey: 'Wk' },
  { LID: '3', TranslateData: 'Semaine', TranslateKey: 'Wk' },
  { LID: '4', TranslateData: 'Нед.', TranslateKey: 'Wk' },
  { LID: '1', TranslateData: 'עם פריטים', TranslateKey: 'With items' },
  { LID: '2', TranslateData: 'With items', TranslateKey: 'With items' },
  { LID: '3', TranslateData: 'Avec des articles', TranslateKey: 'With items' },
  { LID: '4', TranslateData: 'С предметами', TranslateKey: 'With items' },
  {
    LID: '1',
    TranslateData: 'מאיפה אתה רוצה להעלות תמונה?',
    TranslateKey: 'Where do you want to upload a photo from?',
  },
  {
    LID: '2',
    TranslateData: 'Where do you want to upload a photo from?',
    TranslateKey: 'Where do you want to upload a photo from?',
  },
  {
    LID: '3',
    TranslateData: "D'où voulez-vous télécharger une photo ?",
    TranslateKey: 'Where do you want to upload a photo from?',
  },
  {
    LID: '4',
    TranslateData: 'Откуда вы хотите загрузить фото?',
    TranslateKey: 'Where do you want to upload a photo from?',
  },
  {
    LID: '1',
    TranslateData: 'קבוצת ווטסאפ של השכנים',
    TranslateKey: 'WhatsApp group of the building',
  },
  {
    LID: '2',
    TranslateData: 'Tenants WhatsApp group',
    TranslateKey: 'WhatsApp group of the building',
  },
  {
    LID: '3',
    TranslateData: 'Groupe WhatsApp des locataires',
    TranslateKey: 'WhatsApp group of the building',
  },
  {
    LID: '4',
    TranslateData: 'Арендаторы WhatsApp group',
    TranslateKey: 'WhatsApp group of the building',
  },
  {
    LID: '1',
    TranslateData: 'מה ישפר את חווית המובייל שלך?',
    TranslateKey: 'What will make your mobile experience better?',
  },
  {
    LID: '2',
    TranslateData:
      'What will make your mobile experience better? \nShare your thoughts with us',
    TranslateKey: 'What will make your mobile experience better?',
  },
  {
    LID: '3',
    TranslateData: "Qu'est-ce qui améliorera votre expérience mobile ?",
    TranslateKey: 'What will make your mobile experience better?',
  },
  {
    LID: '4',
    TranslateData: 'Что улучшит ваш мобильный опыт?',
    TranslateKey: 'What will make your mobile experience better?',
  },
  { LID: '1', TranslateData: 'טופלו', TranslateKey: 'Were treated' },
  { LID: '2', TranslateData: 'Were treated', TranslateKey: 'Were treated' },
  { LID: '3', TranslateData: 'Ont été traitées', TranslateKey: 'Were treated' },
  { LID: '4', TranslateData: 'Были обработаны', TranslateKey: 'Were treated' },
  { LID: '1', TranslateData: 'כל הכבוד!', TranslateKey: 'Well done!' },
  { LID: '2', TranslateData: 'Well done !', TranslateKey: 'Well done!' },
  { LID: '3', TranslateData: 'Bien fait !', TranslateKey: 'Well done!' },
  { LID: '4', TranslateData: 'Отличная работа !', TranslateKey: 'Well done!' },
  { LID: '1', TranslateData: 'רביעי', TranslateKey: 'Wednesday' },
  { LID: '2', TranslateData: 'Wednesday', TranslateKey: 'Wednesday' },
  { LID: '3', TranslateData: 'Mercredi', TranslateKey: 'Wednesday' },
  { LID: '4', TranslateData: 'Среда', TranslateKey: 'Wednesday' },
  { LID: '1', TranslateData: 'ד', TranslateKey: 'Wed' },
  { LID: '2', TranslateData: 'We', TranslateKey: 'Wed' },
  { LID: '3', TranslateData: 'Nous', TranslateKey: 'Wed' },
  { LID: '4', TranslateData: 'Мы', TranslateKey: 'Wed' },
  { LID: '1', TranslateData: 'אתר', TranslateKey: 'Website' },
  { LID: '2', TranslateData: 'Website', TranslateKey: 'Website' },
  { LID: '3', TranslateData: 'Site Internet', TranslateKey: 'Website' },
  { LID: '4', TranslateData: 'Веб-сайт', TranslateKey: 'Website' },
  { LID: '1', TranslateData: 'חלש', TranslateKey: 'Weak' },
  { LID: '2', TranslateData: 'Weak', TranslateKey: 'Weak' },
  { LID: '3', TranslateData: 'Faible', TranslateKey: 'Weak' },
  { LID: '4', TranslateData: 'Слабый', TranslateKey: 'Weak' },
  {
    LID: '1',
    TranslateData: 'נשמח לשמוע מכם על חווית השימוש באפליקציה:',
    TranslateKey:
      'We would love to hear from you about the experience of using the app:',
  },
  {
    LID: '2',
    TranslateData:
      'We would love to hear from you about your experience of using the app:',
    TranslateKey:
      'We would love to hear from you about the experience of using the app:',
  },
  {
    LID: '3',
    TranslateData:
      "Nous aimerions connaître votre expérience d'utilisation de l'application :",
    TranslateKey:
      'We would love to hear from you about the experience of using the app:',
  },
  {
    LID: '4',
    TranslateData:
      'Мы хотели бы услышать от вас о вашем опыте использования приложения:',
    TranslateKey:
      'We would love to hear from you about the experience of using the app:',
  },
  {
    LID: '1',
    TranslateData: ' ניסינו לחייב את כרטיסך לאחרונה ללא הצלחה,',
    TranslateKey: 'We tried to charge your card recently without success,',
  },
  {
    LID: '2',
    TranslateData: 'We tried to charge your card recently without success,',
    TranslateKey: 'We tried to charge your card recently without success,',
  },
  {
    LID: '3',
    TranslateData:
      'Nous avons essayé de débiter votre carte récemment sans succès,',
    TranslateKey: 'We tried to charge your card recently without success,',
  },
  {
    LID: '4',
    TranslateData: 'Недавно мы безуспешно пытались снять деньги с вашей карты,',
    TranslateKey: 'We tried to charge your card recently without success,',
  },
  {
    LID: '1',
    TranslateData: 'שמנו לב שיש לך חוב של',
    TranslateKey: 'We noticed that you have a debt of',
  },
  {
    LID: '2',
    TranslateData: 'We noticed that you have a debt of',
    TranslateKey: 'We noticed that you have a debt of',
  },
  {
    LID: '3',
    TranslateData: 'Nous avons remarqué que vous avez une dette de',
    TranslateKey: 'We noticed that you have a debt of',
  },
  {
    LID: '4',
    TranslateData: 'Мы заметили, что у вас есть задолженность в размере',
    TranslateKey: 'We noticed that you have a debt of',
  },
  { LID: '1', TranslateData: 'עדכנו את', TranslateKey: 'We have updated the' },
  {
    LID: '2',
    TranslateData: 'We have updated the',
    TranslateKey: 'We have updated the',
  },
  {
    LID: '3',
    TranslateData: 'Nous avons mis à jour le',
    TranslateKey: 'We have updated the',
  },
  {
    LID: '4',
    TranslateData: 'Мы обновили',
    TranslateKey: 'We have updated the',
  },
  {
    LID: '1',
    TranslateData: 'לא הצלחנו לתרגם',
    TranslateKey: 'We could not translate',
  },
  {
    LID: '2',
    TranslateData: 'We could not translate',
    TranslateKey: 'We could not translate',
  },
  {
    LID: '3',
    TranslateData: "Nous n'avons pas pu traduire",
    TranslateKey: 'We could not translate',
  },
  {
    LID: '4',
    TranslateData: 'Мы не могли перевести',
    TranslateKey: 'We could not translate',
  },
  { LID: '1', TranslateData: 'ד', TranslateKey: 'We' },
  { LID: '2', TranslateData: 'We', TranslateKey: 'We' },
  { LID: '3', TranslateData: 'Nous', TranslateKey: 'We' },
  { LID: '4', TranslateData: 'Мы', TranslateKey: 'We' },
  { LID: '1', TranslateData: 'שטח מחסן', TranslateKey: 'Warehouse space' },
  {
    LID: '2',
    TranslateData: 'Storage room area',
    TranslateKey: 'Warehouse space',
  },
  {
    LID: '3',
    TranslateData: 'Zone de stockage',
    TranslateKey: 'Warehouse space',
  },
  {
    LID: '4',
    TranslateData: 'Площадь кладовой',
    TranslateKey: 'Warehouse space',
  },
  { LID: '1', TranslateData: 'בטל', TranslateKey: 'Void' },
  { LID: '2', TranslateData: 'Cancel', TranslateKey: 'Void' },
  { LID: '3', TranslateData: 'Annuler', TranslateKey: 'Void' },
  { LID: '4', TranslateData: 'Отмена', TranslateKey: 'Void' },
  { LID: '1', TranslateData: 'הצג מקור', TranslateKey: 'View source' },
  { LID: '2', TranslateData: 'View source', TranslateKey: 'View source' },
  { LID: '3', TranslateData: 'Voir la source', TranslateKey: 'View source' },
  {
    LID: '4',
    TranslateData: 'Посмотреть источник',
    TranslateKey: 'View source',
  },
  {
    LID: '1',
    TranslateData: 'הצג קריאות מתוכננות',
    TranslateKey: 'View scheduled readings',
  },
  {
    LID: '2',
    TranslateData: 'View scheduled readings',
    TranslateKey: 'View scheduled readings',
  },
  {
    LID: '3',
    TranslateData: 'Voir les lectures programmées',
    TranslateKey: 'View scheduled readings',
  },
  {
    LID: '4',
    TranslateData: 'Посмотреть запланированные чтения',
    TranslateKey: 'View scheduled readings',
  },
  { LID: '1', TranslateData: 'הצג חשבונית', TranslateKey: 'View invoice' },
  { LID: '2', TranslateData: 'View invoice', TranslateKey: 'View invoice' },
  { LID: '3', TranslateData: 'Voir la facture', TranslateKey: 'View invoice' },
  { LID: '4', TranslateData: 'Посмотреть счет', TranslateKey: 'View invoice' },
  { LID: '1', TranslateData: 'צפיה בקובץ', TranslateKey: 'View file' },
  { LID: '2', TranslateData: 'View file', TranslateKey: 'View file' },
  { LID: '3', TranslateData: 'Voir la fiche', TranslateKey: 'View file' },
  { LID: '4', TranslateData: 'Посмотреть файл', TranslateKey: 'View file' },
  { LID: '1', TranslateData: 'לצפייה', TranslateKey: 'View' },
  { LID: '2', TranslateData: 'View', TranslateKey: 'View' },
  { LID: '3', TranslateData: 'Vue', TranslateKey: 'View' },
  { LID: '4', TranslateData: 'Вид', TranslateKey: 'View' },
  { LID: '1', TranslateData: 'גרסא', TranslateKey: 'Version' },
  { LID: '2', TranslateData: 'Version', TranslateKey: 'Version' },
  { LID: '3', TranslateData: 'Version', TranslateKey: 'Version' },
  { LID: '4', TranslateData: 'Версия', TranslateKey: 'Version' },
  { LID: '1', TranslateData: 'הערות הספק', TranslateKey: 'Vendor notes' },
  {
    LID: '2',
    TranslateData: 'Service provider notes',
    TranslateKey: 'Vendor notes',
  },
  {
    LID: '3',
    TranslateData: 'Remarques du fournisseur de services',
    TranslateKey: 'Vendor notes',
  },
  {
    LID: '4',
    TranslateData: 'Примечания к поставщику услуг',
    TranslateKey: 'Vendor notes',
  },
  {
    LID: '1',
    TranslateData: 'תוקף ההו"ק',
    TranslateKey: 'Validity of the HOC',
  },
  {
    LID: '2',
    TranslateData: 'Validity of the HOC',
    TranslateKey: 'Validity of the HOC',
  },
  {
    LID: '3',
    TranslateData: 'Validité du HOC',
    TranslateKey: 'Validity of the HOC',
  },
  {
    LID: '4',
    TranslateData: 'Срок действия HOC',
    TranslateKey: 'Validity of the HOC',
  },
  {
    LID: '1',
    TranslateData: 'תוקף הוגדר בהצלחה',
    TranslateKey: 'Validity has been set successfully',
  },
  {
    LID: '2',
    TranslateData: 'Validity has been set successfully',
    TranslateKey: 'Validity has been set successfully',
  },
  {
    LID: '3',
    TranslateData: 'La validité a été définie avec succès',
    TranslateKey: 'Validity has been set successfully',
  },
  {
    LID: '4',
    TranslateData: 'Срок действия успешно установлен',
    TranslateKey: 'Validity has been set successfully',
  },
  {
    LID: '1',
    TranslateData: 'הגדרת תוקף להוראת קבע',
    TranslateKey: 'Validity definition for a standing order',
  },
  {
    LID: '2',
    TranslateData: 'Validity definition for a standing order',
    TranslateKey: 'Validity definition for a standing order',
  },
  {
    LID: '3',
    TranslateData: "Définition de la validité d'un ordre permanent",
    TranslateKey: 'Validity definition for a standing order',
  },
  {
    LID: '4',
    TranslateData: 'Определение срока действия постоянного поручения',
    TranslateKey: 'Validity definition for a standing order',
  },
  { LID: '1', TranslateData: 'תוקף', TranslateKey: 'validity' },
  { LID: '2', TranslateData: 'validity', TranslateKey: 'validity' },
  { LID: '3', TranslateData: 'validité', TranslateKey: 'validity' },
  { LID: '4', TranslateData: 'период действия', TranslateKey: 'validity' },
  { LID: '1', TranslateData: 'תקין', TranslateKey: 'valid' },
  { LID: '2', TranslateData: 'valid', TranslateKey: 'valid' },
  { LID: '3', TranslateData: 'valide', TranslateKey: 'valid' },
  { LID: '4', TranslateData: 'действительный', TranslateKey: 'valid' },
  { LID: '1', TranslateData: 'שם משתמש', TranslateKey: 'Username' },
  { LID: '2', TranslateData: 'Username', TranslateKey: 'Username' },
  { LID: '3', TranslateData: "Nom d'utilisateur", TranslateKey: 'Username' },
  { LID: '4', TranslateData: 'Имя пользователя', TranslateKey: 'Username' },
  { LID: '1', TranslateData: 'פרופיל משתמש', TranslateKey: 'User profile' },
  { LID: '2', TranslateData: 'User profile', TranslateKey: 'User profile' },
  {
    LID: '3',
    TranslateData: "Profil de l'utilisateur",
    TranslateKey: 'User profile',
  },
  {
    LID: '4',
    TranslateData: 'Профиль пользователя',
    TranslateKey: 'User profile',
  },
  { LID: '1', TranslateData: 'אחראי', TranslateKey: 'User' },
  { LID: '2', TranslateData: 'User', TranslateKey: 'User' },
  { LID: '3', TranslateData: 'Utilisateur', TranslateKey: 'User' },
  { LID: '4', TranslateData: 'Пользователь', TranslateKey: 'User' },
  {
    LID: '1',
    TranslateData: 'העלאת תמונה',
    TranslateKey: 'Uploading a picture',
  },
  {
    LID: '2',
    TranslateData: 'Uploading a picture',
    TranslateKey: 'Uploading a picture',
  },
  {
    LID: '3',
    TranslateData: "Téléchargement d'une image",
    TranslateKey: 'Uploading a picture',
  },
  {
    LID: '4',
    TranslateData: 'Загрузка изображения',
    TranslateKey: 'Uploading a picture',
  },
  { LID: '1', TranslateData: 'העלה', TranslateKey: 'Upload' },
  { LID: '2', TranslateData: 'Upload', TranslateKey: 'Upload' },
  { LID: '3', TranslateData: 'Télécharger', TranslateKey: 'Upload' },
  { LID: '4', TranslateData: 'Загрузить', TranslateKey: 'Upload' },
  { LID: '1', TranslateData: 'עדכונים:', TranslateKey: 'Updates:' },
  { LID: '2', TranslateData: 'Updates:', TranslateKey: 'Updates:' },
  { LID: '3', TranslateData: 'Mises à jour:', TranslateKey: 'Updates:' },
  { LID: '4', TranslateData: 'Обновления:', TranslateKey: 'Updates:' },
  {
    LID: '1',
    TranslateData: "עריכת קריאת שירות מס'",
    TranslateKey: 'update service call num',
  },
  {
    LID: '2',
    TranslateData: 'update service call num',
    TranslateKey: 'update service call num',
  },
  {
    LID: '3',
    TranslateData: "mettre à jour le numéro d'appel du service",
    TranslateKey: 'update service call num',
  },
  {
    LID: '4',
    TranslateData: 'номер вызова службы обновления',
    TranslateKey: 'update service call num',
  },
  {
    LID: '1',
    TranslateData: 'עדכון נושא תמונה',
    TranslateKey: 'Update Image Subject',
  },
  {
    LID: '2',
    TranslateData: 'Update Image Subject',
    TranslateKey: 'Update Image Subject',
  },
  {
    LID: '3',
    TranslateData: "Mettre à jour le sujet de l'image",
    TranslateKey: 'Update Image Subject',
  },
  {
    LID: '4',
    TranslateData: 'Обновить тему изображения',
    TranslateKey: 'Update Image Subject',
  },
  { LID: '1', TranslateData: 'שלח פרטים לעדכון', TranslateKey: 'Update' },
  { LID: '2', TranslateData: 'Update', TranslateKey: 'Update' },
  { LID: '3', TranslateData: 'Mettre à jour', TranslateKey: 'Update' },
  { LID: '4', TranslateData: 'Обновлять', TranslateKey: 'Update' },
  { LID: '1', TranslateData: 'עדכון', TranslateKey: 'update' },
  { LID: '2', TranslateData: 'update', TranslateKey: 'update' },
  { LID: '3', TranslateData: 'mise à jour', TranslateKey: 'update' },
  { LID: '4', TranslateData: 'обновлять', TranslateKey: 'update' },
  { LID: '1', TranslateData: 'עד -', TranslateKey: 'Until-' },
  { LID: '2', TranslateData: 'Until -', TranslateKey: 'Until-' },
  { LID: '3', TranslateData: "Jusqu'à -", TranslateKey: 'Until-' },
  { LID: '4', TranslateData: 'До того как -', TranslateKey: 'Until-' },
  { LID: '1', TranslateData: 'לא מוגבל', TranslateKey: 'Unlimited' },
  { LID: '2', TranslateData: 'Unlimited', TranslateKey: 'Unlimited' },
  { LID: '3', TranslateData: 'Illimité', TranslateKey: 'Unlimited' },
  { LID: '4', TranslateData: 'Безлимитный', TranslateKey: 'Unlimited' },
  { LID: '1', TranslateData: 'שוכר', TranslateKey: 'unit renter' },
  { LID: '2', TranslateData: 'unit renter', TranslateKey: 'unit renter' },
  {
    LID: '3',
    TranslateData: "locataire de l'unité",
    TranslateKey: 'unit renter',
  },
  {
    LID: '4',
    TranslateData: 'арендатор квартиры',
    TranslateKey: 'unit renter',
  },
  { LID: '1', TranslateData: 'בעל הדירה', TranslateKey: 'unit owner' },
  { LID: '2', TranslateData: 'unit owner', TranslateKey: 'unit owner' },
  {
    LID: '3',
    TranslateData: "propriétaire de l'unité",
    TranslateKey: 'unit owner',
  },
  { LID: '4', TranslateData: 'владелец объекта', TranslateKey: 'unit owner' },
  { LID: '1', TranslateData: 'דירה', TranslateKey: 'Unit number' },
  { LID: '2', TranslateData: 'Unit number', TranslateKey: 'Unit number' },
  { LID: '3', TranslateData: "Numéro d'unité", TranslateKey: 'Unit number' },
  { LID: '4', TranslateData: 'Номер блока', TranslateKey: 'Unit number' },
  { LID: '1', TranslateData: 'יחידה', TranslateKey: 'Unit' },
  { LID: '2', TranslateData: 'Unit', TranslateKey: 'Unit' },
  { LID: '3', TranslateData: 'Unité', TranslateKey: 'Unit' },
  { LID: '4', TranslateData: 'Единица', TranslateKey: 'Unit' },
  { LID: '1', TranslateData: 'בטל סינון', TranslateKey: 'Unfilter' },
  { LID: '2', TranslateData: 'Clear filter', TranslateKey: 'Unfilter' },
  { LID: '3', TranslateData: 'Effacer le filtre', TranslateKey: 'Unfilter' },
  { LID: '4', TranslateData: 'Очистить фильтр', TranslateKey: 'Unfilter' },
  { LID: '1', TranslateData: 'לא נבדק', TranslateKey: 'Unchecked' },
  { LID: '2', TranslateData: 'Unchecked', TranslateKey: 'Unchecked' },
  { LID: '3', TranslateData: 'Décoché', TranslateKey: 'Unchecked' },
  { LID: '4', TranslateData: 'Не проверено', TranslateKey: 'Unchecked' },
  { LID: '1', TranslateData: 'סוג הכנסות', TranslateKey: 'Type of income' },
  { LID: '2', TranslateData: 'Type of income', TranslateKey: 'Type of income' },
  { LID: '3', TranslateData: 'Type de revenu', TranslateKey: 'Type of income' },
  { LID: '4', TranslateData: 'Тип дохода', TranslateKey: 'Type of income' },
  { LID: '1', TranslateData: 'סוג הוצאה', TranslateKey: 'Type of Expenditure' },
  {
    LID: '2',
    TranslateData: 'Type of expenditure',
    TranslateKey: 'Type of Expenditure',
  },
  {
    LID: '3',
    TranslateData: 'Type de dépense',
    TranslateKey: 'Type of Expenditure',
  },
  {
    LID: '4',
    TranslateData: 'Тип расходов',
    TranslateKey: 'Type of Expenditure',
  },
  { LID: '1', TranslateData: 'סוג', TranslateKey: 'Type' },
  { LID: '2', TranslateData: 'Type', TranslateKey: 'Type' },
  { LID: '3', TranslateData: 'Taper', TranslateKey: 'Type' },
  { LID: '4', TranslateData: 'Тип', TranslateKey: 'Type' },
  { LID: '1', TranslateData: 'טופל', TranslateKey: 'Tupal' },
  { LID: '2', TranslateData: 'Done', TranslateKey: 'Tupal' },
  { LID: '3', TranslateData: 'Fait', TranslateKey: 'Tupal' },
  { LID: '4', TranslateData: 'Сделанный', TranslateKey: 'Tupal' },
  { LID: '1', TranslateData: 'שלישי', TranslateKey: 'Tuesday' },
  { LID: '2', TranslateData: 'Tuesday', TranslateKey: 'Tuesday' },
  { LID: '3', TranslateData: 'Mardi', TranslateKey: 'Tuesday' },
  { LID: '4', TranslateData: 'Вторник', TranslateKey: 'Tuesday' },
  { LID: '1', TranslateData: 'ג', TranslateKey: 'Tue' },
  { LID: '2', TranslateData: 'Tu', TranslateKey: 'Tue' },
  { LID: '3', TranslateData: 'Ma', TranslateKey: 'Tue' },
  { LID: '4', TranslateData: 'Вт', TranslateKey: 'Tue' },
  { LID: '1', TranslateData: 'ג', TranslateKey: 'Tu' },
  { LID: '2', TranslateData: 'Tu', TranslateKey: 'Tu' },
  { LID: '3', TranslateData: 'Ma', TranslateKey: 'Tu' },
  { LID: '4', TranslateData: 'Вт', TranslateKey: 'Tu' },
  { LID: '1', TranslateData: 'שגיאת תרגום', TranslateKey: 'Translation error' },
  {
    LID: '2',
    TranslateData: 'Translation error',
    TranslateKey: 'Translation error',
  },
  {
    LID: '3',
    TranslateData: 'Erreur de traduction',
    TranslateKey: 'Translation error',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка перевода',
    TranslateKey: 'Translation error',
  },
  {
    LID: '1',
    TranslateData: 'תרגם לעברית',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '2',
    TranslateData: 'Translate into Hebrew',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '3',
    TranslateData: 'Traduire en hébreu',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '4',
    TranslateData: 'Перевести на иврит',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '1',
    TranslateData: 'סה"כ עמלה לעסקה זו {0} ש"ח',
    TranslateKey: 'Total transaction fee: {0} NIS',
  },
  {
    LID: '2',
    TranslateData: 'Total transaction fee: {0}NIS',
    TranslateKey: 'Total transaction fee: {0} NIS',
  },
  {
    LID: '3',
    TranslateData: 'Frais de transaction totaux : {0}NIS',
    TranslateKey: 'Total transaction fee: {0} NIS',
  },
  {
    LID: '4',
    TranslateData: 'Общая комиссия за транзакцию: {0}NIS',
    TranslateKey: 'Total transaction fee: {0} NIS',
  },
  {
    LID: '1',
    TranslateData: 'סה"כ לתשלום: {0} ₪',
    TranslateKey: 'Total payment: {0} NIS',
  },
  {
    LID: '2',
    TranslateData: 'Total to pay: {0} NIS',
    TranslateKey: 'Total payment: {0} NIS',
  },
  {
    LID: '3',
    TranslateData: 'Total à payer : {0} NIS',
    TranslateKey: 'Total payment: {0} NIS',
  },
  {
    LID: '4',
    TranslateData: 'Итого к оплате: {0} шек.',
    TranslateKey: 'Total payment: {0} NIS',
  },
  {
    LID: '1',
    TranslateData: 'סך כל הגבייה בתקופת הדוח',
    TranslateKey:
      'Total payment confirmations generated in the system during the reporting period',
  },
  {
    LID: '2',
    TranslateData: 'Total colletion during the reporting period',
    TranslateKey:
      'Total payment confirmations generated in the system during the reporting period',
  },
  {
    LID: '3',
    TranslateData: 'Collecte totale au cours de la période de référence',
    TranslateKey:
      'Total payment confirmations generated in the system during the reporting period',
  },
  {
    LID: '4',
    TranslateData: 'Общий сбор за отчетный период',
    TranslateKey:
      'Total payment confirmations generated in the system during the reporting period',
  },
  { LID: '1', TranslateData: 'סה"כ הוצאות:', TranslateKey: 'Total expenses:' },
  {
    LID: '2',
    TranslateData: 'Total expenses:',
    TranslateKey: 'Total expenses:',
  },
  {
    LID: '3',
    TranslateData: 'Dépenses totales:',
    TranslateKey: 'Total expenses:',
  },
  {
    LID: '4',
    TranslateData: 'Суммарные расходы:',
    TranslateKey: 'Total expenses:',
  },
  {
    LID: '1',
    TranslateData: 'סה"כ הוצאות שוטפות',
    TranslateKey: 'Total current expenses',
  },
  {
    LID: '2',
    TranslateData: 'Total current expenses',
    TranslateKey: 'Total current expenses',
  },
  {
    LID: '3',
    TranslateData: 'Total des dépenses courantes',
    TranslateKey: 'Total current expenses',
  },
  {
    LID: '4',
    TranslateData: 'Итого текущие расходы',
    TranslateKey: 'Total current expenses',
  },
  { LID: '1', TranslateData: 'סה"כ מחיר', TranslateKey: 'Total cost' },
  { LID: '2', TranslateData: 'Total cost', TranslateKey: 'Total cost' },
  { LID: '3', TranslateData: 'Coût total', TranslateKey: 'Total cost' },
  { LID: '4', TranslateData: 'Общая стоимость', TranslateKey: 'Total cost' },
  {
    LID: '1',
    TranslateData: 'סה"כ גביה בתקופת הדוח',
    TranslateKey: 'Total collection in the reporting period',
  },
  {
    LID: '2',
    TranslateData: 'Total collection in the reporting period',
    TranslateKey: 'Total collection in the reporting period',
  },
  {
    LID: '3',
    TranslateData: 'Collecte totale au cours de la période de référence',
    TranslateKey: 'Total collection in the reporting period',
  },
  {
    LID: '4',
    TranslateData: 'Итого сбор за отчетный период',
    TranslateKey: 'Total collection in the reporting period',
  },
  {
    LID: '1',
    TranslateData: 'סה"כ לתשלום {0} ₪',
    TranslateKey: 'Total  payment: {0} NIS',
  },
  {
    LID: '2',
    TranslateData: 'Total payment: {0}',
    TranslateKey: 'Total  payment: {0} NIS',
  },
  {
    LID: '3',
    TranslateData: 'Paiement total : {0}',
    TranslateKey: 'Total  payment: {0} NIS',
  },
  {
    LID: '4',
    TranslateData: 'Общая сумма платежа: {0}',
    TranslateKey: 'Total  payment: {0} NIS',
  },
  { LID: '1', TranslateData: 'סה"כ', TranslateKey: 'Total' },
  { LID: '2', TranslateData: 'Total', TranslateKey: 'Total' },
  { LID: '3', TranslateData: 'Total', TranslateKey: 'Total' },
  { LID: '4', TranslateData: 'Всего', TranslateKey: 'Total' },
  { LID: '1', TranslateData: 'נושא', TranslateKey: 'Topic' },
  { LID: '2', TranslateData: 'Topic', TranslateKey: 'Topic' },
  { LID: '3', TranslateData: 'Sujet', TranslateKey: 'Topic' },
  { LID: '4', TranslateData: 'Тема', TranslateKey: 'Topic' },
  { LID: '1', TranslateData: 'היום', TranslateKey: 'Today' },
  { LID: '2', TranslateData: 'Today', TranslateKey: 'Today' },
  { LID: '3', TranslateData: "Aujourd'hui", TranslateKey: 'Today' },
  { LID: '4', TranslateData: 'Сегодня', TranslateKey: 'Today' },
  {
    LID: '1',
    TranslateData: 'למתן משוב על השימוש באפליקציה, כתבו לנו כאן',
    TranslateKey:
      'To provide feedback on the use of the application, write to us here',
  },
  {
    LID: '2',
    TranslateData:
      'To provide feedback on the use of the application, write to us here',
    TranslateKey:
      'To provide feedback on the use of the application, write to us here',
  },
  {
    LID: '3',
    TranslateData:
      "Pour donner votre avis sur l'utilisation de l'application, écrivez-nous ici ",
    TranslateKey:
      'To provide feedback on the use of the application, write to us here',
  },
  {
    LID: '4',
    TranslateData:
      'Чтобы оставить отзыв об использовании приложения, напишите нам сюда',
    TranslateKey:
      'To provide feedback on the use of the application, write to us here',
  },
  {
    LID: '1',
    TranslateData: ':לתשלום בכרטיס אשראי פנה לחברת איי פוינט בטל',
    TranslateKey: 'To pay by credit card, contact APoint by phone:',
  },
  {
    LID: '2',
    TranslateData: 'To pay by credit card, please contact A-Point at:',
    TranslateKey: 'To pay by credit card, contact APoint by phone:',
  },
  {
    LID: '3',
    TranslateData:
      'Pour payer par carte de crédit, veuillez contacter A-Point à :',
    TranslateKey: 'To pay by credit card, contact APoint by phone:',
  },
  {
    LID: '4',
    TranslateData:
      'Для оплаты кредитной картой, пожалуйста, свяжитесь с A-Point по адресу:',
    TranslateKey: 'To pay by credit card, contact APoint by phone:',
  },
  {
    LID: '1',
    TranslateData: 'כדי לשלם בכרטיס אשראי, צור קשר עם {0} בטלפון:',
    TranslateKey: 'To pay by credit card, contact {0} by phone:',
  },
  {
    LID: '2',
    TranslateData: 'To pay by credit card, contact {0} by phone:',
    TranslateKey: 'To pay by credit card, contact {0} by phone:',
  },
  {
    LID: '3',
    TranslateData:
      'Pour payer par carte de crédit, contactez {0} par téléphone : ',
    TranslateKey: 'To pay by credit card, contact {0} by phone:',
  },
  {
    LID: '4',
    TranslateData:
      'Чтобы заплатить кредитной картой, свяжитесь с {0} по телефону:',
    TranslateKey: 'To pay by credit card, contact {0} by phone:',
  },
  { LID: '1', TranslateData: 'הזמן אירוע', TranslateKey: 'To order' },
  { LID: '2', TranslateData: 'Schedule an event', TranslateKey: 'To order' },
  {
    LID: '3',
    TranslateData: 'Programmer un événement',
    TranslateKey: 'To order',
  },
  {
    LID: '4',
    TranslateData: 'Запланировать мероприятие',
    TranslateKey: 'To order',
  },
  { LID: '1', TranslateData: 'לתאריכים', TranslateKey: 'To Dates' },
  { LID: '2', TranslateData: 'To dates', TranslateKey: 'To Dates' },
  { LID: '3', TranslateData: 'Aux dates', TranslateKey: 'To Dates' },
  { LID: '4', TranslateData: 'На свидания', TranslateKey: 'To Dates' },
  {
    LID: '1',
    TranslateData: 'כדי ליצור שער ציבורי, יש לפנות לוועד',
    TranslateKey: 'To create a public gate, one has to turn to the committee',
  },
  {
    LID: '2',
    TranslateData: 'To create a public gate, one has to turn to the committee',
    TranslateKey: 'To create a public gate, one has to turn to the committee',
  },
  {
    LID: '3',
    TranslateData:
      "Pour créer une porte publique, il faut s'adresser au comité",
    TranslateKey: 'To create a public gate, one has to turn to the committee',
  },
  {
    LID: '4',
    TranslateData:
      'Для создания публичных ворот необходимо обратиться в комитет',
    TranslateKey: 'To create a public gate, one has to turn to the committee',
  },
  {
    LID: '1',
    TranslateData: 'ליצירת קשר עם חברת הניהול ',
    TranslateKey: 'To contact the management company',
  },
  {
    LID: '2',
    TranslateData: 'To contact the management company',
    TranslateKey: 'To contact the management company',
  },
  {
    LID: '3',
    TranslateData: 'Pour contacter la société de gestion ',
    TranslateKey: 'To contact the management company',
  },
  {
    LID: '4',
    TranslateData: 'Для связи с управляющей компанией ',
    TranslateKey: 'To contact the management company',
  },
  { LID: '1', TranslateData: 'חמישי', TranslateKey: 'Thursday' },
  { LID: '2', TranslateData: 'Thursday', TranslateKey: 'Thursday' },
  { LID: '3', TranslateData: 'Jeudi', TranslateKey: 'Thursday' },
  { LID: '4', TranslateData: 'Четверг', TranslateKey: 'Thursday' },
  { LID: '1', TranslateData: 'ה', TranslateKey: 'Thu' },
  { LID: '2', TranslateData: 'Th', TranslateKey: 'Thu' },
  { LID: '3', TranslateData: 'E', TranslateKey: 'Thu' },
  { LID: '4', TranslateData: 'Чт', TranslateKey: 'Thu' },
  {
    LID: '1',
    TranslateData:
      'יחידה זו נמצאת בטיפול משפטי ולפי מדיניות חברת הניהול יש להסדיר את התשלום ישירות מול חברת הניהול או עו"ד המטפל',
    TranslateKey:
      'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.',
  },
  {
    LID: '2',
    TranslateData:
      'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.',
    TranslateKey:
      'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.',
  },
  {
    LID: '3',
    TranslateData:
      "Cette unité est en procédure judiciaire et selon la politique de la société de gestion, le paiement doit être organisé directement avec la société de gestion ou l'avocat traitant.",
    TranslateKey:
      'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.',
  },
  {
    LID: '4',
    TranslateData:
      'Эта единица находится в судебном процессе, и согласно политике управляющей компании, оплата должна быть согласована непосредственно с управляющей компанией или присутствующим адвокатом.',
    TranslateKey:
      'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.',
  },
  {
    LID: '1',
    TranslateData:
      'פניה זו נפתחה לפני {0} ימים, האם ברצונך לשלוח מסרון סגירת הפניה?',
    TranslateKey:
      'This referral was opened {0} days ago, do you want to send a referral closing message?',
  },
  {
    LID: '2',
    TranslateData:
      'This referral was opened {0} days ago, do you want to send a referral closing message?',
    TranslateKey:
      'This referral was opened {0} days ago, do you want to send a referral closing message?',
  },
  {
    LID: '3',
    TranslateData:
      'Ce parrainage a été ouvert il y a {0} jours, voulez-vous envoyer un message de clôture du parrainage ?',
    TranslateKey:
      'This referral was opened {0} days ago, do you want to send a referral closing message?',
  },
  {
    LID: '4',
    TranslateData:
      'Этот реферал был открыт {0} дней назад. Вы хотите отправить сообщение о закрытии реферала?',
    TranslateKey:
      'This referral was opened {0} days ago, do you want to send a referral closing message?',
  },
  {
    LID: '1',
    TranslateData: 'מספר זה לא נמצא במערכת',
    TranslateKey: 'This number could not be found on the system',
  },
  {
    LID: '2',
    TranslateData: 'This number could not be found on the system',
    TranslateKey: 'This number could not be found on the system',
  },
  {
    LID: '3',
    TranslateData: 'Ce numéro est introuvable sur le système',
    TranslateKey: 'This number could not be found on the system',
  },
  {
    LID: '4',
    TranslateData: 'Этот номер не найден в системе',
    TranslateKey: 'This number could not be found on the system',
  },
  {
    LID: '1',
    TranslateData: 'טופס זה לא מיועד לבניין שלך',
    TranslateKey: 'This form is not for your building',
  },
  {
    LID: '2',
    TranslateData: 'This form is not for your building',
    TranslateKey: 'This form is not for your building',
  },
  {
    LID: '3',
    TranslateData: "Ce formulaire n'est pas pour votre immeuble",
    TranslateKey: 'This form is not for your building',
  },
  {
    LID: '4',
    TranslateData: 'Эта форма не для вашего здания',
    TranslateKey: 'This form is not for your building',
  },
  {
    LID: '1',
    TranslateData: 'פעולה זו תשלח בקשה למחיקת פרטי משתמש למנהל המערכת',
    TranslateKey:
      'This action will send a request to delete user information to the system administrator',
  },
  {
    LID: '2',
    TranslateData:
      'This action will send a request to delete user information to the system administrator',
    TranslateKey:
      'This action will send a request to delete user information to the system administrator',
  },
  {
    LID: '3',
    TranslateData:
      "Cette action enverra une demande de suppression des informations utilisateur à l'administrateur système",
    TranslateKey:
      'This action will send a request to delete user information to the system administrator',
  },
  {
    LID: '4',
    TranslateData:
      'Это действие отправит системному администратору запрос на удаление информации о пользователе.',
    TranslateKey:
      'This action will send a request to delete user information to the system administrator',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בשליחת הדוח',
    TranslateKey: 'There was an error submitting the report',
  },
  {
    LID: '2',
    TranslateData: 'There was an error submitting the report',
    TranslateKey: 'There was an error submitting the report',
  },
  {
    LID: '3',
    TranslateData: "Une erreur s'est produite lors de l'envoi du rapport",
    TranslateKey: 'There was an error submitting the report',
  },
  {
    LID: '4',
    TranslateData: 'При отправке отчета произошла ошибка',
    TranslateKey: 'There was an error submitting the report',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בשמירת התמונה',
    TranslateKey: 'There was an error saving the image',
  },
  {
    LID: '2',
    TranslateData: 'There was an error saving the image',
    TranslateKey: 'There was an error saving the image',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de l'enregistrement de l'image",
    TranslateKey: 'There was an error saving the image',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при сохранении изображения',
    TranslateKey: 'There was an error saving the image',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בביצוע התשלום, נסה מאוחר יותר',
    TranslateKey:
      'There was an error making the payment, please try again later',
  },
  {
    LID: '2',
    TranslateData:
      'There was an error making the payment, please try again later',
    TranslateKey:
      'There was an error making the payment, please try again later',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors du paiement, veuillez réessayer plus tard",
    TranslateKey:
      'There was an error making the payment, please try again later',
  },
  {
    LID: '4',
    TranslateData: 'При оплате произошла ошибка, повторите попытку позже.',
    TranslateKey:
      'There was an error making the payment, please try again later',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בסגירת הפניה',
    TranslateKey: 'There was an error closing the referral',
  },
  {
    LID: '2',
    TranslateData: 'There was an error closing the referral',
    TranslateKey: 'There was an error closing the referral',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de la fermeture de la référence",
    TranslateKey: 'There was an error closing the referral',
  },
  {
    LID: '4',
    TranslateData: 'Не удалось закрыть реферал',
    TranslateKey: 'There was an error closing the referral',
  },
  {
    LID: '1',
    TranslateData: 'אין חברת ניהול',
    TranslateKey: 'There is no management company',
  },
  {
    LID: '2',
    TranslateData: 'There is no management company',
    TranslateKey: 'There is no management company',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a pas de société de gestion",
    TranslateKey: 'There is no management company',
  },
  {
    LID: '4',
    TranslateData: 'Нет управляющей компании',
    TranslateKey: 'There is no management company',
  },
  {
    LID: '1',
    TranslateData: 'קיים אירוע חופף לזמן האירוע המבוקש',
    TranslateKey:
      'There is an event that coincides with the time of the requested event',
  },
  {
    LID: '2',
    TranslateData:
      'Another event coincides with the time of the requested event',
    TranslateKey:
      'There is an event that coincides with the time of the requested event',
  },
  {
    LID: '3',
    TranslateData:
      "Un autre événement coïncide avec l'heure de l'événement demandé",
    TranslateKey:
      'There is an event that coincides with the time of the requested event',
  },
  {
    LID: '4',
    TranslateData: 'Другое событие совпадает со временем запрошенного события',
    TranslateKey:
      'There is an event that coincides with the time of the requested event',
  },
  { LID: '1', TranslateData: 'קיים חוב', TranslateKey: 'There is a debt' },
  {
    LID: '2',
    TranslateData: 'There is a debt',
    TranslateKey: 'There is a debt',
  },
  {
    LID: '3',
    TranslateData: 'Il y a une dette',
    TranslateKey: 'There is a debt',
  },
  { LID: '4', TranslateData: 'Есть долг', TranslateKey: 'There is a debt' },
  {
    LID: '1',
    TranslateData: 'לא קיימים עדכונים לקריאה זו',
    TranslateKey: 'There are no updates for this call',
  },
  {
    LID: '2',
    TranslateData: 'There are no updates for this service call',
    TranslateKey: 'There are no updates for this call',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a aucune mise à jour pour cet appel de service",
    TranslateKey: 'There are no updates for this call',
  },
  {
    LID: '4',
    TranslateData: 'Нет обновлений для этого обращения в службу поддержки',
    TranslateKey: 'There are no updates for this call',
  },
  {
    LID: '1',
    TranslateData: 'לא קיימות קריאות שירות לבניין',
    TranslateKey: 'There are no service calls for the building',
  },
  {
    LID: '2',
    TranslateData: 'There are no service calls for the building',
    TranslateKey: 'There are no service calls for the building',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a pas d'appels de service pour l'immeuble",
    TranslateKey: 'There are no service calls for the building',
  },
  {
    LID: '4',
    TranslateData: 'Заявок на обслуживание здания нет',
    TranslateKey: 'There are no service calls for the building',
  },
  {
    LID: '1',
    TranslateData: 'אין אירועים לתאריך זה',
    TranslateKey: 'There are no events on this date',
  },
  {
    LID: '2',
    TranslateData: 'There are no events at this date',
    TranslateKey: 'There are no events on this date',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a pas d'événements à cette date",
    TranslateKey: 'There are no events on this date',
  },
  {
    LID: '4',
    TranslateData: 'На эту дату нет событий',
    TranslateKey: 'There are no events on this date',
  },
  {
    LID: '1',
    TranslateData: 'לא קיימים חובות לדירה זו',
    TranslateKey: 'There are no debts for this apartment',
  },
  {
    LID: '2',
    TranslateData: 'There are no debts for this apartment',
    TranslateKey: 'There are no debts for this apartment',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a pas de dettes pour cet appartement",
    TranslateKey: 'There are no debts for this apartment',
  },
  {
    LID: '4',
    TranslateData: 'У этой квартиры нет долгов',
    TranslateKey: 'There are no debts for this apartment',
  },
  {
    LID: '1',
    TranslateData: 'לא קיים תקנון לבניין זה, אנא צור קשר עם נציגות הדיירים',
    TranslateKey: 'There are no bylaws for this building',
  },
  {
    LID: '2',
    TranslateData:
      'No regulations were updated for this building, please contact house committee',
    TranslateKey: 'There are no bylaws for this building',
  },
  {
    LID: '3',
    TranslateData:
      "Aucun règlement n'a été mis à jour pour ce bâtiment, veuillez contacter le comité de la maison",
    TranslateKey: 'There are no bylaws for this building',
  },
  {
    LID: '4',
    TranslateData:
      'Никакие правила для этого здания не обновлялись, пожалуйста, свяжитесь с домовым комитетом.',
    TranslateKey: 'There are no bylaws for this building',
  },
  {
    LID: '1',
    TranslateData: 'אין דירות לבניין זה',
    TranslateKey: 'There are no apartments for this building',
  },
  {
    LID: '2',
    TranslateData: 'There are no apartments for this building',
    TranslateKey: 'There are no apartments for this building',
  },
  {
    LID: '3',
    TranslateData: "Il n'y a pas d'appartements pour ce bâtiment",
    TranslateKey: 'There are no apartments for this building',
  },
  {
    LID: '4',
    TranslateData: 'В этом доме нет квартир',
    TranslateKey: 'There are no apartments for this building',
  },
  {
    LID: '1',
    TranslateData: 'קיימות {0} קריאות פתוחות בתחום זה',
    TranslateKey: 'There are {0} open readings in this area',
  },
  {
    LID: '2',
    TranslateData: 'There are {0} open service calls in this category',
    TranslateKey: 'There are {0} open readings in this area',
  },
  {
    LID: '3',
    TranslateData: 'Il y a {0} appels de service ouverts dans cette catégorie',
    TranslateKey: 'There are {0} open readings in this area',
  },
  {
    LID: '4',
    TranslateData:
      'В этой категории имеется {0} открытых обращений в службу поддержки.',
    TranslateKey: 'There are {0} open readings in this area',
  },
  {
    LID: '1',
    TranslateData: 'קיימות {0} קריאות פתוחות בתחום זה',
    TranslateKey: 'There are {0}  OPEN readings in this area',
  },
  {
    LID: '2',
    TranslateData: 'There are {0} open service calls in this category',
    TranslateKey: 'There are {0}  OPEN readings in this area',
  },
  {
    LID: '3',
    TranslateData: 'Il y a {0} appels de service ouverts dans cette catégorie',
    TranslateKey: 'There are {0}  OPEN readings in this area',
  },
  {
    LID: '4',
    TranslateData:
      'В этой категории имеется {0} открытых обращений в службу поддержки.',
    TranslateKey: 'There are {0}  OPEN readings in this area',
  },
  {
    LID: '1',
    TranslateData: 'ואז לבחור "העתקת קישור"',
    TranslateKey: 'Then select Link Copy',
  },
  {
    LID: '2',
    TranslateData: 'Then select "Copy URL"',
    TranslateKey: 'Then select Link Copy',
  },
  {
    LID: '3',
    TranslateData: 'Sélectionnez ensuite "Copier l\'URL"',
    TranslateKey: 'Then select Link Copy',
  },
  {
    LID: '4',
    TranslateData: 'Затем выберите «Копировать URL».',
    TranslateKey: 'Then select Link Copy',
  },
  { LID: '1', TranslateData: 'שנת', TranslateKey: 'The year' },
  { LID: '2', TranslateData: 'The year', TranslateKey: 'The year' },
  { LID: '3', TranslateData: "L'année", TranslateKey: 'The year' },
  { LID: '4', TranslateData: 'Год', TranslateKey: 'The year' },
  {
    LID: '1',
    TranslateData: 'העדכון נמחק בהצלחה',
    TranslateKey: 'The update was successfully deleted',
  },
  {
    LID: '2',
    TranslateData: 'The update was successfully deleted',
    TranslateKey: 'The update was successfully deleted',
  },
  {
    LID: '3',
    TranslateData: 'La mise à jour a été supprimée avec succès',
    TranslateKey: 'The update was successfully deleted',
  },
  {
    LID: '4',
    TranslateData: 'Обновление успешно удалено',
    TranslateKey: 'The update was successfully deleted',
  },
  {
    LID: '1',
    TranslateData: 'העדכון נשמר בהצלחה',
    TranslateKey: 'The update was saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The update was saved successfully',
    TranslateKey: 'The update was saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'La mise à jour a été enregistrée avec succès',
    TranslateKey: 'The update was saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Обновление успешно сохранено',
    TranslateKey: 'The update was saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'העסקה בוצעה בהצלחה',
    TranslateKey: 'The transaction was completed successfully',
  },
  {
    LID: '2',
    TranslateData: 'Transaction completed successfully',
    TranslateKey: 'The transaction was completed successfully',
  },
  {
    LID: '3',
    TranslateData: 'Transaction terminée avec succès',
    TranslateKey: 'The transaction was completed successfully',
  },
  {
    LID: '4',
    TranslateData: 'Транзакция успешно завершена',
    TranslateKey: 'The transaction was completed successfully',
  },
  {
    LID: '1',
    TranslateData: 'סכום עמלת פעולה לעסקאות אלו הוא:',
    TranslateKey:
      'The transaction fee amount that will be charged based on these transactions is:',
  },
  {
    LID: '2',
    TranslateData:
      'The transaction fee amount that will be charged based on these transactions is:',
    TranslateKey:
      'The transaction fee amount that will be charged based on these transactions is:',
  },
  {
    LID: '3',
    TranslateData:
      'Le montant des frais de transaction qui sera facturé en fonction de ces transactions est :',
    TranslateKey:
      'The transaction fee amount that will be charged based on these transactions is:',
  },
  {
    LID: '4',
    TranslateData:
      'Сумма комиссии за транзакцию, которая будет взиматься на основе этих транзакций, составляет:',
    TranslateKey:
      'The transaction fee amount that will be charged based on these transactions is:',
  },
  {
    LID: '1',
    TranslateData: 'העסקה נכשלה',
    TranslateKey: 'The transaction failed',
  },
  {
    LID: '2',
    TranslateData: 'Transaction failed',
    TranslateKey: 'The transaction failed',
  },
  {
    LID: '3',
    TranslateData: 'La transaction a échoué',
    TranslateKey: 'The transaction failed',
  },
  {
    LID: '4',
    TranslateData: 'Транзакция не удалась',
    TranslateKey: 'The transaction failed',
  },
  {
    LID: '1',
    TranslateData: 'יש לאשר את תנאי השימוש',
    TranslateKey: 'The terms of use must be approved',
  },
  {
    LID: '2',
    TranslateData: 'The terms of use must be approved',
    TranslateKey: 'The terms of use must be approved',
  },
  {
    LID: '3',
    TranslateData: "Les conditions d'utilisation doivent être approuvées",
    TranslateKey: 'The terms of use must be approved',
  },
  {
    LID: '4',
    TranslateData: 'Условия использования должны быть одобрены',
    TranslateKey: 'The terms of use must be approved',
  },
  {
    LID: '1',
    TranslateData:
      'חדר הדיירים הינו לרווחת דיירי הבניין. בדוק זמינות לאירוע משלך.',
    TranslateKey:
      "The tenants' room is for the well-being of the tenants the building. Check availability for your own event.",
  },
  {
    LID: '2',
    TranslateData:
      "The tenants' room is for the well-being of the buuilding's tenants. Check availability for your own event.",
    TranslateKey:
      "The tenants' room is for the well-being of the tenants the building. Check availability for your own event.",
  },
  {
    LID: '3',
    TranslateData:
      "La chambre des locataires est destinée au bien-être des locataires de l'immeuble. Vérifiez la disponibilité pour votre propre événement.",
    TranslateKey:
      "The tenants' room is for the well-being of the tenants the building. Check availability for your own event.",
  },
  {
    LID: '4',
    TranslateData:
      'Комната для жильцов предназначена для благополучия жильцов здания. Проверьте доступность для вашего собственного мероприятия.',
    TranslateKey:
      "The tenants' room is for the well-being of the tenants the building. Check availability for your own event.",
  },
  {
    LID: '1',
    TranslateData: 'קריאת השירות נשמרה בהצלחה',
    TranslateKey: 'The service call was saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The service call was saved successfully',
    TranslateKey: 'The service call was saved successfully',
  },
  {
    LID: '3',
    TranslateData: "L'appel de service a été enregistré avec succès",
    TranslateKey: 'The service call was saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Вызов службы был успешно сохранен',
    TranslateKey: 'The service call was saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'קריאת השירות נמחקה בהצלחה',
    TranslateKey: 'The service call was deleted successfully',
  },
  {
    LID: '2',
    TranslateData: 'The service call was deleted successfully',
    TranslateKey: 'The service call was deleted successfully',
  },
  {
    LID: '3',
    TranslateData: "L'appel de service a été supprimé avec succès",
    TranslateKey: 'The service call was deleted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Вызов службы был успешно удален',
    TranslateKey: 'The service call was deleted successfully',
  },
  {
    LID: '1',
    TranslateData: 'הדוח נשלח בהצלחה',
    TranslateKey: 'The report was submitted successfully',
  },
  {
    LID: '2',
    TranslateData: 'The report was submitted successfully',
    TranslateKey: 'The report was submitted successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le rapport a été soumis avec succès',
    TranslateKey: 'The report was submitted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Отчет успешно отправлен',
    TranslateKey: 'The report was submitted successfully',
  },
  {
    LID: '1',
    TranslateData: 'התשלום בוצע בהצלחה',
    TranslateKey: 'The payment was succesful',
  },
  {
    LID: '2',
    TranslateData: 'The payment was succesful',
    TranslateKey: 'The payment was succesful',
  },
  {
    LID: '3',
    TranslateData: 'le paiement a réussi',
    TranslateKey: 'The payment was succesful',
  },
  {
    LID: '4',
    TranslateData: 'платеж прошел успешно',
    TranslateKey: 'The payment was succesful',
  },
  {
    LID: '1',
    TranslateData: 'הקובץ נשמר בהצלחה',
    TranslateKey: 'The file saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'File saved successfully',
    TranslateKey: 'The file saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Fichier enregistré avec succès',
    TranslateKey: 'The file saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Файл успешно сохранен',
    TranslateKey: 'The file saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'ההוצאה נמחקה בהצלחה',
    TranslateKey: 'The expense was successfully deleted',
  },
  {
    LID: '2',
    TranslateData: 'The expense was successfully deleted',
    TranslateKey: 'The expense was successfully deleted',
  },
  {
    LID: '3',
    TranslateData: 'La dépense a été supprimée avec succès',
    TranslateKey: 'The expense was successfully deleted',
  },
  {
    LID: '4',
    TranslateData: 'Расход был успешно удален',
    TranslateKey: 'The expense was successfully deleted',
  },
  {
    LID: '1',
    TranslateData: 'ההודעה נשלחה בהצלחה והוקמה עבורך הוראת קבע',
    TranslateKey:
      'The email was sent successfully and a standing order was established for you',
  },
  {
    LID: '2',
    TranslateData:
      'Message sent successfully and a reocurring payment was setup for you',
    TranslateKey:
      'The email was sent successfully and a standing order was established for you',
  },
  {
    LID: '3',
    TranslateData:
      'Message envoyé avec succès et un paiement récurrent a été configuré pour vous',
    TranslateKey:
      'The email was sent successfully and a standing order was established for you',
  },
  {
    LID: '4',
    TranslateData:
      'Сообщение успешно отправлено, и для вас настроен повторный платеж',
    TranslateKey:
      'The email was sent successfully and a standing order was established for you',
  },
  {
    LID: '1',
    TranslateData: 'ההודעה נשלחה בהצלחה',
    TranslateKey: 'The email was sent successfully',
  },
  {
    LID: '2',
    TranslateData: 'Message sent successfully',
    TranslateKey: 'The email was sent successfully',
  },
  {
    LID: '3',
    TranslateData: 'message envoyé avec succès',
    TranslateKey: 'The email was sent successfully',
  },
  {
    LID: '4',
    TranslateData: 'Сообщение успешно отправлено',
    TranslateKey: 'The email was sent successfully',
  },
  {
    LID: '1',
    TranslateData: 'התיאור חייב להיות באורך 10 תווים לפחות.',
    TranslateKey: 'The description must be at least 10 characters long.',
  },
  {
    LID: '2',
    TranslateData: 'The description must be at least 10 characters long.',
    TranslateKey: 'The description must be at least 10 characters long.',
  },
  {
    LID: '3',
    TranslateData: 'La description doit comporter au moins 10 caractères.',
    TranslateKey: 'The description must be at least 10 characters long.',
  },
  {
    LID: '4',
    TranslateData: 'Описание должно быть не менее 10 символов.',
    TranslateKey: 'The description must be at least 10 characters long.',
  },
  {
    LID: '1',
    TranslateData: 'הבניין לא מאופשר לתשלום בכרטיס אשראי',
    TranslateKey: 'The building is not open for clearing',
  },
  {
    LID: '2',
    TranslateData: 'The building is not setup for redit card payments',
    TranslateKey: 'The building is not open for clearing',
  },
  {
    LID: '3',
    TranslateData:
      "Le bâtiment n'est pas configuré pour les paiements par carte de crédit",
    TranslateKey: 'The building is not open for clearing',
  },
  {
    LID: '4',
    TranslateData: 'Здание не предназначено для оплаты картой Redit.',
    TranslateKey: 'The building is not open for clearing',
  },
  {
    LID: '1',
    TranslateData: 'תקנון האפליקציה',
    TranslateKey: 'The application regulations',
  },
  {
    LID: '2',
    TranslateData: 'The application regulations',
    TranslateKey: 'The application regulations',
  },
  {
    LID: '3',
    TranslateData: "Le règlement d''application",
    TranslateKey: 'The application regulations',
  },
  {
    LID: '4',
    TranslateData: 'Правила применения',
    TranslateKey: 'The application regulations',
  },
  {
    LID: '1',
    TranslateData: 'סכום ההצעה',
    TranslateKey: 'The amount of the offer',
  },
  {
    LID: '2',
    TranslateData: 'Quote amount',
    TranslateKey: 'The amount of the offer',
  },
  {
    LID: '3',
    TranslateData: 'Montant du devis',
    TranslateKey: 'The amount of the offer',
  },
  {
    LID: '4',
    TranslateData: 'Сумма котировки',
    TranslateKey: 'The amount of the offer',
  },
  {
    LID: '1',
    TranslateData: 'סכום עמלת האשראי לעסקאות אלו הוא:',
    TranslateKey:
      'The amount of the full credit fee that will be charged based on these transactions is:',
  },
  {
    LID: '2',
    TranslateData: 'The credit card fee charged for these transactions is:',
    TranslateKey:
      'The amount of the full credit fee that will be charged based on these transactions is:',
  },
  {
    LID: '3',
    TranslateData:
      'Les frais de carte de crédit facturés pour ces transactions sont :',
    TranslateKey:
      'The amount of the full credit fee that will be charged based on these transactions is:',
  },
  {
    LID: '4',
    TranslateData:
      'Комиссия по кредитной карте, взимаемая за эти транзакции, составляет:',
    TranslateKey:
      'The amount of the full credit fee that will be charged based on these transactions is:',
  },
  { LID: '1', TranslateData: 'מאשר ההצעה', TranslateKey: 'Than the proposal' },
  {
    LID: '2',
    TranslateData: 'Approove quote',
    TranslateKey: 'Than the proposal',
  },
  {
    LID: '3',
    TranslateData: 'Approuver le devis',
    TranslateKey: 'Than the proposal',
  },
  {
    LID: '4',
    TranslateData: 'Подтвердить цитату',
    TranslateKey: 'Than the proposal',
  },
  { LID: '1', TranslateData: 'ה', TranslateKey: 'Th' },
  { LID: '2', TranslateData: 'Th', TranslateKey: 'Th' },
  { LID: '3', TranslateData: 'E', TranslateKey: 'Th' },
  { LID: '4', TranslateData: 'Чт', TranslateKey: 'Th' },
  {
    LID: '1',
    TranslateData: 'שלנו.',
    TranslateKey: 'termsAndConditionsEndText',
  },
  { LID: '2', TranslateData: '.', TranslateKey: 'termsAndConditionsEndText' },
  { LID: '3', TranslateData: '.', TranslateKey: 'termsAndConditionsEndText' },
  { LID: '4', TranslateData: '.', TranslateKey: 'termsAndConditionsEndText' },
  { LID: '1', TranslateData: 'תנאי השימוש', TranslateKey: 'terms of use' },
  { LID: '2', TranslateData: 'terms of use', TranslateKey: 'terms of use' },
  {
    LID: '3',
    TranslateData: "conditions d'utilisation",
    TranslateKey: 'terms of use',
  },
  {
    LID: '4',
    TranslateData: 'условия использования',
    TranslateKey: 'terms of use',
  },
  { LID: '1', TranslateData: 'תנאי השירות', TranslateKey: 'Terms of Service' },
  {
    LID: '2',
    TranslateData: 'Terms of Service',
    TranslateKey: 'Terms of Service',
  },
  {
    LID: '3',
    TranslateData: "Conditions d'utilisation",
    TranslateKey: 'Terms of Service',
  },
  {
    LID: '4',
    TranslateData: 'Условия использования',
    TranslateKey: 'Terms of Service',
  },
  { LID: '1', TranslateData: 'חדר דיירים', TranslateKey: "Tenants' room" },
  { LID: '2', TranslateData: "Tenants' room", TranslateKey: "Tenants' room" },
  {
    LID: '3',
    TranslateData: 'Chambre des locataires',
    TranslateKey: "Tenants' room",
  },
  {
    LID: '4',
    TranslateData: 'Комната арендаторов',
    TranslateKey: "Tenants' room",
  },
  { LID: '1', TranslateData: 'דיירים', TranslateKey: 'Tenants' },
  { LID: '2', TranslateData: 'Tenants', TranslateKey: 'Tenants' },
  { LID: '3', TranslateData: 'Locataires', TranslateKey: 'Tenants' },
  { LID: '4', TranslateData: 'Арендаторы', TranslateKey: 'Tenants' },
  { LID: '1', TranslateData: "טל'", TranslateKey: 'Tel' },
  { LID: '2', TranslateData: 'Tel', TranslateKey: 'Tel' },
  { LID: '3', TranslateData: 'Tal', TranslateKey: 'Tel' },
  { LID: '4', TranslateData: 'Таль', TranslateKey: 'Tel' },
  {
    LID: '1',
    TranslateData: 'החלף לכרטיס אחר',
    TranslateKey: 'Switch to another card',
  },
  {
    LID: '2',
    TranslateData: 'Switch to another card',
    TranslateKey: 'Switch to another card',
  },
  {
    LID: '3',
    TranslateData: 'Passer à une autre carte',
    TranslateKey: 'Switch to another card',
  },
  {
    LID: '4',
    TranslateData: 'Переключиться на другую карту',
    TranslateKey: 'Switch to another card',
  },
  { LID: '1', TranslateData: 'החלף', TranslateKey: 'Switch' },
  { LID: '2', TranslateData: 'Switch', TranslateKey: 'Switch' },
  { LID: '3', TranslateData: 'Changer', TranslateKey: 'Switch' },
  { LID: '4', TranslateData: 'Выключатель', TranslateKey: 'Switch' },
  { LID: '1', TranslateData: 'ניצול', TranslateKey: 'Survivor' },
  { LID: '2', TranslateData: 'Survivor', TranslateKey: 'Survivor' },
  { LID: '3', TranslateData: 'Survivant', TranslateKey: 'Survivor' },
  { LID: '4', TranslateData: 'Оставшийся в живых', TranslateKey: 'Survivor' },
  { LID: '1', TranslateData: 'מאגר ספקים', TranslateKey: 'Suppliers' },
  { LID: '2', TranslateData: 'Suppliers', TranslateKey: 'Suppliers' },
  { LID: '3', TranslateData: 'Fournisseurs', TranslateKey: 'Suppliers' },
  { LID: '4', TranslateData: 'Поставщики', TranslateKey: 'Suppliers' },
  {
    LID: '1',
    TranslateData: 'הספק עודכן בהצלחה',
    TranslateKey: 'Supplier successfully updated',
  },
  {
    LID: '2',
    TranslateData: 'Supplier successfully updated',
    TranslateKey: 'Supplier successfully updated',
  },
  {
    LID: '3',
    TranslateData: 'Fournisseur mis à jour avec succès',
    TranslateKey: 'Supplier successfully updated',
  },
  {
    LID: '4',
    TranslateData: 'Поставщик успешно обновлен',
    TranslateKey: 'Supplier successfully updated',
  },
  { LID: '1', TranslateData: 'מייל הספק ', TranslateKey: 'Supplier mail' },
  {
    LID: '2',
    TranslateData: 'Service provider email',
    TranslateKey: 'Supplier mail',
  },
  {
    LID: '3',
    TranslateData: 'Courriel du fournisseur de services',
    TranslateKey: 'Supplier mail',
  },
  {
    LID: '4',
    TranslateData: 'Электронная почта поставщика услуг',
    TranslateKey: 'Supplier mail',
  },
  { LID: '1', TranslateData: 'עמלה מספק', TranslateKey: 'supplier commision' },
  {
    LID: '2',
    TranslateData: 'supplier commision',
    TranslateKey: 'supplier commision',
  },
  {
    LID: '3',
    TranslateData: 'commission fournisseur',
    TranslateKey: 'supplier commision',
  },
  {
    LID: '4',
    TranslateData: 'комиссия поставщика',
    TranslateKey: 'supplier commision',
  },
  { LID: '1', TranslateData: 'ספק', TranslateKey: 'Supplier' },
  { LID: '2', TranslateData: 'Service provider', TranslateKey: 'Supplier' },
  {
    LID: '3',
    TranslateData: 'Fournisseur de services',
    TranslateKey: 'Supplier',
  },
  { LID: '4', TranslateData: 'Поставщик услуг', TranslateKey: 'Supplier' },
  { LID: '1', TranslateData: 'ראשון', TranslateKey: 'Sunday' },
  { LID: '2', TranslateData: 'Sunday', TranslateKey: 'Sunday' },
  { LID: '3', TranslateData: 'Dimanche', TranslateKey: 'Sunday' },
  { LID: '4', TranslateData: 'Воскресенье', TranslateKey: 'Sunday' },
  { LID: '1', TranslateData: 'א', TranslateKey: 'Sun' },
  { LID: '2', TranslateData: 'Sun', TranslateKey: 'Sun' },
  { LID: '3', TranslateData: 'soleil', TranslateKey: 'Sun' },
  { LID: '4', TranslateData: 'солнце', TranslateKey: 'Sun' },
  {
    LID: '1',
    TranslateData: 'סיכום לבניין',
    TranslateKey: 'Summary of the building',
  },
  {
    LID: '2',
    TranslateData: 'Summary of the building',
    TranslateKey: 'Summary of the building',
  },
  {
    LID: '3',
    TranslateData: 'Résumé du bâtiment',
    TranslateKey: 'Summary of the building',
  },
  {
    LID: '4',
    TranslateData: 'Краткое описание здания',
    TranslateKey: 'Summary of the building',
  },
  {
    LID: '1',
    TranslateData: 'סיכום לתשלום',
    TranslateKey: 'Summary for payment',
  },
  {
    LID: '2',
    TranslateData: 'Payment summary',
    TranslateKey: 'Summary for payment',
  },
  {
    LID: '3',
    TranslateData: 'Résumé de paiement',
    TranslateKey: 'Summary for payment',
  },
  {
    LID: '4',
    TranslateData: 'Сводка платежа',
    TranslateKey: 'Summary for payment',
  },
  { LID: '1', TranslateData: 'סיכום', TranslateKey: 'summary' },
  { LID: '2', TranslateData: 'summary', TranslateKey: 'summary' },
  { LID: '3', TranslateData: 'résumé', TranslateKey: 'summary' },
  { LID: '4', TranslateData: 'сводка', TranslateKey: 'summary' },
  { LID: '1', TranslateData: 'סכום', TranslateKey: 'Sum' },
  { LID: '2', TranslateData: 'Sum', TranslateKey: 'Sum' },
  { LID: '3', TranslateData: 'Somme', TranslateKey: 'Sum' },
  { LID: '4', TranslateData: 'Сумма', TranslateKey: 'Sum' },
  { LID: '1', TranslateData: 'נושא', TranslateKey: 'Subject' },
  { LID: '2', TranslateData: 'Subject', TranslateKey: 'Subject' },
  { LID: '3', TranslateData: 'Sujet', TranslateKey: 'Subject' },
  { LID: '4', TranslateData: 'Предмет', TranslateKey: 'Subject' },
  { LID: '1', TranslateData: 'א', TranslateKey: 'Su' },
  { LID: '2', TranslateData: 'Su', TranslateKey: 'Su' },
  { LID: '3', TranslateData: 'Di', TranslateKey: 'Su' },
  { LID: '4', TranslateData: 'Вс', TranslateKey: 'Su' },
  { LID: '1', TranslateData: 'חזק', TranslateKey: 'Strong' },
  { LID: '2', TranslateData: 'Strong', TranslateKey: 'Strong' },
  { LID: '3', TranslateData: 'Fort', TranslateKey: 'Strong' },
  { LID: '4', TranslateData: 'Сильный', TranslateKey: 'Strong' },
  { LID: '1', TranslateData: 'רחוב', TranslateKey: 'street' },
  { LID: '2', TranslateData: 'street', TranslateKey: 'street' },
  { LID: '3', TranslateData: 'rue', TranslateKey: 'street' },
  { LID: '4', TranslateData: 'улица', TranslateKey: 'street' },
  { LID: '1', TranslateData: 'מקום אחסון', TranslateKey: 'Storage Location' },
  {
    LID: '2',
    TranslateData: 'Storage Location',
    TranslateKey: 'Storage Location',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Storage Location' },
  { LID: '4', TranslateData: '', TranslateKey: 'Storage Location' },
  { LID: '1', TranslateData: 'מחסן', TranslateKey: 'Storage' },
  { LID: '2', TranslateData: 'Storage room', TranslateKey: 'Storage' },
  { LID: '3', TranslateData: 'Pièce de stockage', TranslateKey: 'Storage' },
  { LID: '4', TranslateData: 'Кладовая', TranslateKey: 'Storage' },
  { LID: '1', TranslateData: 'סטטוס', TranslateKey: 'Status' },
  { LID: '2', TranslateData: 'Status', TranslateKey: 'Status' },
  { LID: '3', TranslateData: 'Statut', TranslateKey: 'Status' },
  { LID: '4', TranslateData: 'Статус', TranslateKey: 'Status' },
  { LID: '1', TranslateData: 'מתחיל ב', TranslateKey: 'Starts with' },
  { LID: '2', TranslateData: 'Starts with', TranslateKey: 'Starts with' },
  { LID: '3', TranslateData: 'Commence avec', TranslateKey: 'Starts with' },
  { LID: '4', TranslateData: 'Начинается с', TranslateKey: 'Starts with' },
  {
    LID: '1',
    TranslateData: 'שעת התחלה צריכה להיות מאוחרת משעת הסיום',
    TranslateKey: 'Start time should be later than end time',
  },
  {
    LID: '2',
    TranslateData: 'Start time should be later than end time',
    TranslateKey: 'Start time should be later than end time',
  },
  {
    LID: '3',
    TranslateData: "L'heure de début doit être postérieure à l'heure de fin",
    TranslateKey: 'Start time should be later than end time',
  },
  {
    LID: '4',
    TranslateData: 'Время начала должно быть позже времени окончания',
    TranslateKey: 'Start time should be later than end time',
  },
  { LID: '1', TranslateData: 'תאריך התחלה', TranslateKey: 'Start date' },
  { LID: '2', TranslateData: 'Start date', TranslateKey: 'Start date' },
  { LID: '3', TranslateData: 'Date de début', TranslateKey: 'Start date' },
  { LID: '4', TranslateData: 'Дата начала', TranslateKey: 'Start date' },
  { LID: '1', TranslateData: 'הכנסות מיוחדות', TranslateKey: 'Special income' },
  { LID: '2', TranslateData: 'Special income', TranslateKey: 'Special income' },
  { LID: '3', TranslateData: 'Revenu spécial', TranslateKey: 'Special income' },
  { LID: '4', TranslateData: 'Особый доход', TranslateKey: 'Special income' },
  {
    LID: '1',
    TranslateData: 'הוצאות מיוחדות',
    TranslateKey: 'Special expenses',
  },
  {
    LID: '2',
    TranslateData: 'Special expenses',
    TranslateKey: 'Special expenses',
  },
  {
    LID: '3',
    TranslateData: 'Dépenses spéciales',
    TranslateKey: 'Special expenses',
  },
  {
    LID: '4',
    TranslateData: 'Особые расходы',
    TranslateKey: 'Special expenses',
  },
  { LID: '1', TranslateData: 'הוצאה מיוחדת', TranslateKey: 'special edition' },
  {
    LID: '2',
    TranslateData: 'special edition',
    TranslateKey: 'special edition',
  },
  {
    LID: '3',
    TranslateData: 'édition spéciale',
    TranslateKey: 'special edition',
  },
  {
    LID: '4',
    TranslateData: 'специальное издание',
    TranslateKey: 'special edition',
  },
  { LID: '1', TranslateData: 'מיוחד', TranslateKey: 'Special' },
  { LID: '2', TranslateData: 'Special', TranslateKey: 'Special' },
  { LID: '3', TranslateData: 'Spécial', TranslateKey: 'Special' },
  { LID: '4', TranslateData: 'Специальный', TranslateKey: 'Special' },
  { LID: '1', TranslateData: 'מיון', TranslateKey: 'sort' },
  { LID: '2', TranslateData: 'sort', TranslateKey: 'sort' },
  { LID: '3', TranslateData: 'trier', TranslateKey: 'sort' },
  { LID: '4', TranslateData: 'Сортировать', TranslateKey: 'sort' },
  { LID: '1', TranslateData: 'SMS לספק', TranslateKey: 'SMS to supplier' },
  {
    LID: '2',
    TranslateData: 'SMS to supplier',
    TranslateKey: 'SMS to supplier',
  },
  {
    LID: '3',
    TranslateData: 'SMS au fournisseur',
    TranslateKey: 'SMS to supplier',
  },
  {
    LID: '4',
    TranslateData: 'смс поставщику',
    TranslateKey: 'SMS to supplier',
  },
  {
    LID: '1',
    TranslateData: 'הודעת sms לספק',
    TranslateKey: 'Sms message to supplier',
  },
  {
    LID: '2',
    TranslateData: 'Sms message to supplier',
    TranslateKey: 'Sms message to supplier',
  },
  {
    LID: '3',
    TranslateData: 'Message SMS au fournisseur',
    TranslateKey: 'Sms message to supplier',
  },
  {
    LID: '4',
    TranslateData: 'смс-сообщение поставщику',
    TranslateKey: 'Sms message to supplier',
  },
  { LID: '1', TranslateData: 'הודעת SMS ל-', TranslateKey: 'SMS message to' },
  { LID: '2', TranslateData: 'SMS message to', TranslateKey: 'SMS message to' },
  { LID: '3', TranslateData: 'SMS à', TranslateKey: 'SMS message to' },
  {
    LID: '4',
    TranslateData: 'СМС-сообщение на',
    TranslateKey: 'SMS message to',
  },
  { LID: '1', TranslateData: 'הודעת SMS', TranslateKey: 'SMS message' },
  { LID: '2', TranslateData: 'SMS message', TranslateKey: 'SMS message' },
  { LID: '3', TranslateData: 'SMS', TranslateKey: 'SMS message' },
  { LID: '4', TranslateData: 'SMS-сообщение', TranslateKey: 'SMS message' },
  { LID: '1', TranslateData: 'הפצת sms', TranslateKey: 'Sms distribution' },
  {
    LID: '2',
    TranslateData: 'Sms distribution',
    TranslateKey: 'Sms distribution',
  },
  {
    LID: '3',
    TranslateData: 'Diffusion SMS',
    TranslateKey: 'Sms distribution',
  },
  { LID: '4', TranslateData: 'Рассылка смс', TranslateKey: 'Sms distribution' },
  { LID: '1', TranslateData: 'טפסים לחתימה', TranslateKey: 'Signature forms' },
  {
    LID: '2',
    TranslateData: 'Fill out forms',
    TranslateKey: 'Signature forms',
  },
  {
    LID: '3',
    TranslateData: 'Remplissez les formulaires',
    TranslateKey: 'Signature forms',
  },
  {
    LID: '4',
    TranslateData: 'Заполнять формы',
    TranslateKey: 'Signature forms',
  },
  { LID: '1', TranslateData: 'יציאה', TranslateKey: 'Sign out of the system' },
  {
    LID: '2',
    TranslateData: 'Sign out',
    TranslateKey: 'Sign out of the system',
  },
  {
    LID: '3',
    TranslateData: 'Déconnexion',
    TranslateKey: 'Sign out of the system',
  },
  { LID: '4', TranslateData: 'выход', TranslateKey: 'Sign out of the system' },
  { LID: '1', TranslateData: 'הצג לדייר', TranslateKey: 'Show to tenant' },
  { LID: '2', TranslateData: 'Show to tenant', TranslateKey: 'Show to tenant' },
  {
    LID: '3',
    TranslateData: 'Montrer au locataire',
    TranslateKey: 'Show to tenant',
  },
  {
    LID: '4',
    TranslateData: 'Показать арендатору',
    TranslateKey: 'Show to tenant',
  },
  { LID: '1', TranslateData: 'הצג מחזוריות', TranslateKey: 'Show Rules' },
  { LID: '2', TranslateData: 'Show Rules', TranslateKey: 'Show Rules' },
  {
    LID: '3',
    TranslateData: 'Afficher les règles',
    TranslateKey: 'Show Rules',
  },
  { LID: '4', TranslateData: 'Показать правила', TranslateKey: 'Show Rules' },
  {
    LID: '1',
    TranslateData: 'הצג בדף הבית',
    TranslateKey: 'Show on home page',
  },
  {
    LID: '2',
    TranslateData: 'Show on home page',
    TranslateKey: 'Show on home page',
  },
  {
    LID: '3',
    TranslateData: "Afficher sur la page d'accueil",
    TranslateKey: 'Show on home page',
  },
  {
    LID: '4',
    TranslateData: 'Показать на главной странице',
    TranslateKey: 'Show on home page',
  },
  { LID: '1', TranslateData: 'הצג הודעה עד', TranslateKey: 'Show message to' },
  {
    LID: '2',
    TranslateData: 'Show message until',
    TranslateKey: 'Show message to',
  },
  {
    LID: '3',
    TranslateData: "Afficher le message jusqu'à",
    TranslateKey: 'Show message to',
  },
  {
    LID: '4',
    TranslateData: 'Показывать сообщение до',
    TranslateKey: 'Show message to',
  },
  {
    LID: '1',
    TranslateData: 'הצג את כלל החובות של הדירה',
    TranslateKey: 'Show all the obligations of the apartment',
  },
  {
    LID: '2',
    TranslateData: 'Show all the obligations of the apartment',
    TranslateKey: 'Show all the obligations of the apartment',
  },
  {
    LID: '3',
    TranslateData: "Montrer toutes les obligations de l'appartement",
    TranslateKey: 'Show all the obligations of the apartment',
  },
  {
    LID: '4',
    TranslateData: 'Показать все обязательства по квартире',
    TranslateKey: 'Show all the obligations of the apartment',
  },
  { LID: '1', TranslateData: 'הצג', TranslateKey: 'Show' },
  { LID: '2', TranslateData: 'Show', TranslateKey: 'Show' },
  { LID: '3', TranslateData: 'Spectacle', TranslateKey: 'Show' },
  { LID: '4', TranslateData: 'Показывать', TranslateKey: 'Show' },
  {
    LID: '1',
    TranslateData: 'שתף אותנו במחשבותיך',
    TranslateKey: 'Share your thoughts with us',
  },
  {
    LID: '2',
    TranslateData: 'Share your thoughts with us',
    TranslateKey: 'Share your thoughts with us',
  },
  {
    LID: '3',
    TranslateData: 'Partagez vos impressions avec nous',
    TranslateKey: 'Share your thoughts with us',
  },
  {
    LID: '4',
    TranslateData: 'Поделитесь с нами своими мыслями',
    TranslateKey: 'Share your thoughts with us',
  },
  {
    LID: '1',
    TranslateData: 'שתף את הפידבק שלך או רעיונות לשיפור',
    TranslateKey: 'Share your feedback or good ideas',
  },
  {
    LID: '2',
    TranslateData: 'Share your feedback or good ideas',
    TranslateKey: 'Share your feedback or good ideas',
  },
  {
    LID: '3',
    TranslateData: 'Partagez vos retours ou bonnes idées',
    TranslateKey: 'Share your feedback or good ideas',
  },
  {
    LID: '4',
    TranslateData: 'Поделитесь своим отзывом или хорошими идеями',
    TranslateKey: 'Share your feedback or good ideas',
  },
  {
    LID: '1',
    TranslateData: 'שיתוף האפליקציה',
    TranslateKey: 'Share Application',
  },
  {
    LID: '2',
    TranslateData: 'Share Application',
    TranslateKey: 'Share Application',
  },
  {
    LID: '3',
    TranslateData: "Partager l'application",
    TranslateKey: 'Share Application',
  },
  {
    LID: '4',
    TranslateData: 'Поделиться приложением',
    TranslateKey: 'Share Application',
  },
  {
    LID: '1',
    TranslateData: 'הגדרת יום חיוב בחודש',
    TranslateKey: 'Setting a billing day per month',
  },
  {
    LID: '2',
    TranslateData: 'Setting a billing day per month',
    TranslateKey: 'Setting a billing day per month',
  },
  {
    LID: '3',
    TranslateData: 'Fixer un jour de facturation par mois',
    TranslateKey: 'Setting a billing day per month',
  },
  {
    LID: '4',
    TranslateData: 'Установка расчетного дня в месяц',
    TranslateKey: 'Setting a billing day per month',
  },
  {
    LID: '1',
    TranslateData: 'הגדר תאריך סיום לחיוב',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '2',
    TranslateData: 'Set a billing end date',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '3',
    TranslateData: 'Définir une date de fin de facturation',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '4',
    TranslateData: 'Установите дату окончания выставления счета',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '1',
    TranslateData: 'הגדרת תאריך סיום לחיוב',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '2',
    TranslateData: 'Set a billing end date',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '3',
    TranslateData: 'Définir une date de fin de facturation',
    TranslateKey: 'Set a billing end date',
  },
  {
    LID: '4',
    TranslateData: 'Установите дату окончания выставления счета',
    TranslateKey: 'Set a billing end date',
  },
  { LID: '1', TranslateData: 'קריאות שירות', TranslateKey: 'Service calls' },
  { LID: '2', TranslateData: 'Service calls', TranslateKey: 'Service calls' },
  {
    LID: '3',
    TranslateData: 'Appels de service',
    TranslateKey: 'Service calls',
  },
  {
    LID: '4',
    TranslateData: 'Сервисные звонки',
    TranslateKey: 'Service calls',
  },
  {
    LID: '1',
    TranslateData: 'קריאת השירות נסגרה בהצלחה.',
    TranslateKey: 'Service Call closing successfully.',
  },
  {
    LID: '2',
    TranslateData: 'Service Call closing successfully.',
    TranslateKey: 'Service Call closing successfully.',
  },
  {
    LID: '3',
    TranslateData: 'Appel de service clôturé avec succès.',
    TranslateKey: 'Service Call closing successfully.',
  },
  {
    LID: '4',
    TranslateData: 'Вызов службы успешно закрыт.',
    TranslateKey: 'Service Call closing successfully.',
  },
  { LID: '1', TranslateData: 'קריאת שירות', TranslateKey: 'Service call' },
  { LID: '2', TranslateData: 'Service call', TranslateKey: 'Service call' },
  { LID: '3', TranslateData: 'Appel de service', TranslateKey: 'Service call' },
  { LID: '4', TranslateData: 'Сервисный звонок', TranslateKey: 'Service call' },
  { LID: '1', TranslateData: 'ספטמבר', TranslateKey: 'September' },
  { LID: '2', TranslateData: 'September', TranslateKey: 'September' },
  { LID: '3', TranslateData: 'Septembre', TranslateKey: 'September' },
  { LID: '4', TranslateData: 'Сентябрь', TranslateKey: 'September' },
  { LID: '1', TranslateData: 'ספטמבר', TranslateKey: 'Sep' },
  { LID: '2', TranslateData: 'Sep', TranslateKey: 'Sep' },
  { LID: '3', TranslateData: 'Sep', TranslateKey: 'Sep' },
  { LID: '4', TranslateData: 'сен', TranslateKey: 'Sep' },
  { LID: '1', TranslateData: 'נשלח מאת', TranslateKey: 'Sent by' },
  { LID: '2', TranslateData: 'Sent by', TranslateKey: 'Sent by' },
  { LID: '3', TranslateData: 'Envoyée par', TranslateKey: 'Sent by' },
  { LID: '4', TranslateData: 'Отправлено от', TranslateKey: 'Sent by' },
  {
    LID: '1',
    TranslateData: 'שלח קוד אימות',
    TranslateKey: 'Send verify code',
  },
  {
    LID: '2',
    TranslateData: 'Send verify code',
    TranslateKey: 'Send verify code',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer le code de vérification',
    TranslateKey: 'Send verify code',
  },
  {
    LID: '4',
    TranslateData: 'Отправить код подтверждения',
    TranslateKey: 'Send verify code',
  },
  { LID: '1', TranslateData: 'שלח לוועד', TranslateKey: 'Send to committee' },
  {
    LID: '2',
    TranslateData: 'Send to committee',
    TranslateKey: 'Send to committee',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer au comité',
    TranslateKey: 'Send to committee',
  },
  {
    LID: '4',
    TranslateData: 'Отправить в комитет',
    TranslateKey: 'Send to committee',
  },
  {
    LID: '1',
    TranslateData: 'שלח עדכון זה גם לשאר דיירי הבניין',
    TranslateKey:
      'Send this update to the other tenants of the building as well',
  },
  {
    LID: '2',
    TranslateData:
      'Send this update to the other tenants of the building as well',
    TranslateKey:
      'Send this update to the other tenants of the building as well',
  },
  {
    LID: '3',
    TranslateData:
      "Envoyez également cette mise à jour aux autres locataires de l'immeuble",
    TranslateKey:
      'Send this update to the other tenants of the building as well',
  },
  {
    LID: '4',
    TranslateData: 'Отправьте это обновление и другим арендаторам здания.',
    TranslateKey:
      'Send this update to the other tenants of the building as well',
  },
  { LID: '1', TranslateData: 'שלח SMS שוב', TranslateKey: 'Send SMS again' },
  { LID: '2', TranslateData: 'Send SMS again', TranslateKey: 'Send SMS again' },
  {
    LID: '3',
    TranslateData: 'Envoyer à nouveau des SMS',
    TranslateKey: 'Send SMS again',
  },
  {
    LID: '4',
    TranslateData: 'Отправить SMS еще раз',
    TranslateKey: 'Send SMS again',
  },
  {
    LID: '1',
    TranslateData: 'שלח קוד על ידי שיחת טלפון',
    TranslateKey: 'send code by Phone',
  },
  {
    LID: '2',
    TranslateData: 'Send code by phone call',
    TranslateKey: 'send code by Phone',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer le code par appel téléphonique',
    TranslateKey: 'send code by Phone',
  },
  {
    LID: '4',
    TranslateData: 'Отправить код по телефону',
    TranslateKey: 'send code by Phone',
  },
  {
    LID: '1',
    TranslateData: 'דואר אלקטרוני',
    TranslateKey: 'send code by Email',
  },
  { LID: '2', TranslateData: 'E-mail', TranslateKey: 'send code by Email' },
  { LID: '3', TranslateData: 'E-mail', TranslateKey: 'send code by Email' },
  { LID: '4', TranslateData: 'Эл. почта', TranslateKey: 'send code by Email' },
  { LID: '1', TranslateData: 'שלח קוד שוב', TranslateKey: 'Send Code again' },
  {
    LID: '2',
    TranslateData: 'Send Code again',
    TranslateKey: 'Send Code again',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer code à nouveau',
    TranslateKey: 'Send Code again',
  },
  {
    LID: '4',
    TranslateData: 'Отправить код еще раз',
    TranslateKey: 'Send Code again',
  },
  {
    LID: '1',
    TranslateData: 'שתף אפליקציה עם חבר',
    TranslateKey: 'Send App to Friend',
  },
  {
    LID: '2',
    TranslateData: 'Send App to Friend',
    TranslateKey: 'Send App to Friend',
  },
  {
    LID: '3',
    TranslateData: "Envoyer l'application à un ami",
    TranslateKey: 'Send App to Friend',
  },
  {
    LID: '4',
    TranslateData: 'Отправить приложение другу',
    TranslateKey: 'Send App to Friend',
  },
  {
    LID: '1',
    TranslateData: 'שלח הודעה ב SMS',
    TranslateKey: 'Send a message via SMS',
  },
  {
    LID: '2',
    TranslateData: 'Send a message via SMS',
    TranslateKey: 'Send a message via SMS',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer un message par SMS',
    TranslateKey: 'Send a message via SMS',
  },
  {
    LID: '4',
    TranslateData: 'Отправить сообщение через SMS',
    TranslateKey: 'Send a message via SMS',
  },
  {
    LID: '1',
    TranslateData: 'שלח הודעה במייל',
    TranslateKey: 'Send a message by email',
  },
  {
    LID: '2',
    TranslateData: 'Send a message by email',
    TranslateKey: 'Send a message by email',
  },
  {
    LID: '3',
    TranslateData: 'Envoyer un message par email',
    TranslateKey: 'Send a message by email',
  },
  {
    LID: '4',
    TranslateData: 'Отправить сообщение по электронной почте',
    TranslateKey: 'Send a message by email',
  },
  { LID: '1', TranslateData: 'שלח הודעה', TranslateKey: 'Send a message' },
  { LID: '2', TranslateData: 'Send a message', TranslateKey: 'Send a message' },
  {
    LID: '3',
    TranslateData: 'Envoyer un message',
    TranslateKey: 'Send a message',
  },
  {
    LID: '4',
    TranslateData: 'Отправить сообщение',
    TranslateKey: 'Send a message',
  },
  { LID: '1', TranslateData: 'שלח', TranslateKey: 'Send' },
  { LID: '2', TranslateData: 'Send', TranslateKey: 'Send' },
  { LID: '3', TranslateData: 'Envoyer', TranslateKey: 'Send' },
  { LID: '4', TranslateData: 'Отправлять', TranslateKey: 'Send' },
  { LID: '1', TranslateData: 'בחר תחום', TranslateKey: 'Select a topic' },
  { LID: '2', TranslateData: 'Select a topic', TranslateKey: 'Select a topic' },
  {
    LID: '3',
    TranslateData: 'Choisissez un sujet',
    TranslateKey: 'Select a topic',
  },
  { LID: '4', TranslateData: 'Выберите тему', TranslateKey: 'Select a topic' },
  { LID: '1', TranslateData: 'בחר בניין', TranslateKey: 'Select a building' },
  {
    LID: '2',
    TranslateData: 'Select a building',
    TranslateKey: 'Select a building',
  },
  {
    LID: '3',
    TranslateData: 'Sélectionnez un bâtiment',
    TranslateKey: 'Select a building',
  },
  {
    LID: '4',
    TranslateData: 'Выберите здание',
    TranslateKey: 'Select a building',
  },
  {
    LID: '1',
    TranslateData: 'בחר "בעלים", "שוכרים", או את שניהם',
    TranslateKey: 'Select "Owner", "Renters", or both',
  },
  {
    LID: '2',
    TranslateData: 'Select "Owner", "Renters", or both',
    TranslateKey: 'Select "Owner", "Renters", or both',
  },
  {
    LID: '3',
    TranslateData: 'Sélectionnez « Propriétaire », « Locataires », ou les deux',
    TranslateKey: 'Select "Owner", "Renters", or both',
  },
  {
    LID: '4',
    TranslateData: 'Выберите «Владелец», «Арендаторы» или оба варианта.',
    TranslateKey: 'Select "Owner", "Renters", or both',
  },
  { LID: '1', TranslateData: 'בחר', TranslateKey: 'Select' },
  { LID: '2', TranslateData: 'Select', TranslateKey: 'Select' },
  { LID: '3', TranslateData: 'Sélectionner', TranslateKey: 'Select' },
  { LID: '4', TranslateData: 'Выбирать', TranslateKey: 'Select' },
  { LID: '1', TranslateData: 'פקיד שומר', TranslateKey: 'security guard' },
  { LID: '2', TranslateData: 'security guard', TranslateKey: 'security guard' },
  {
    LID: '3',
    TranslateData: 'garde de sécurité',
    TranslateKey: 'security guard',
  },
  { LID: '4', TranslateData: 'охранник', TranslateKey: 'security guard' },
  { LID: '1', TranslateData: 'מאובטח ופשוט', TranslateKey: 'Secure and easy' },
  {
    LID: '2',
    TranslateData: 'Secure and simple',
    TranslateKey: 'Secure and easy',
  },
  {
    LID: '3',
    TranslateData: 'Sécurisé et simple',
    TranslateKey: 'Secure and easy',
  },
  {
    LID: '4',
    TranslateData: 'Надежно и просто',
    TranslateKey: 'Secure and easy',
  },
  { LID: '1', TranslateData: 'סעיף', TranslateKey: 'Section' },
  { LID: '2', TranslateData: 'Section', TranslateKey: 'Section' },
  { LID: '3', TranslateData: 'Section', TranslateKey: 'Section' },
  { LID: '4', TranslateData: 'Раздел', TranslateKey: 'Section' },
  { LID: '1', TranslateData: 'תחום משני', TranslateKey: 'Secondary domain' },
  {
    LID: '2',
    TranslateData: 'Secondary domain',
    TranslateKey: 'Secondary domain',
  },
  {
    LID: '3',
    TranslateData: 'Domaine secondaire',
    TranslateKey: 'Secondary domain',
  },
  {
    LID: '4',
    TranslateData: 'Дополнительный домен',
    TranslateKey: 'Secondary domain',
  },
  {
    LID: '1',
    TranslateData: 'איש קשר משני',
    TranslateKey: 'Secondary contact',
  },
  {
    LID: '2',
    TranslateData: 'Secondary contact',
    TranslateKey: 'Secondary contact',
  },
  {
    LID: '3',
    TranslateData: 'Interlocuteur secondaire',
    TranslateKey: 'Secondary contact',
  },
  {
    LID: '4',
    TranslateData: 'Вторичный контакт',
    TranslateKey: 'Secondary contact',
  },
  {
    LID: '1',
    TranslateData: 'חיפוש על ידי שם או מספר טלפון נמען',
    TranslateKey: 'Search by recipient name or phone number',
  },
  {
    LID: '2',
    TranslateData: 'Search by recipient name or phone number',
    TranslateKey: 'Search by recipient name or phone number',
  },
  {
    LID: '3',
    TranslateData: 'Recherche par nom ou numéro de téléphone du destinataire',
    TranslateKey: 'Search by recipient name or phone number',
  },
  {
    LID: '4',
    TranslateData: 'Поиск по имени получателя или номеру телефона',
    TranslateKey: 'Search by recipient name or phone number',
  },
  { LID: '1', TranslateData: 'חיפוש', TranslateKey: 'search' },
  { LID: '2', TranslateData: 'search', TranslateKey: 'search' },
  { LID: '3', TranslateData: 'recherche', TranslateKey: 'search' },
  { LID: '4', TranslateData: 'поиск', TranslateKey: 'search' },
  {
    LID: '1',
    TranslateData: 'לגלול למטה עד ל- "משתתפים" וללחוץ על "הזמנה באמצעות קישור"',
    TranslateKey:
      'Scroll down to the participants and click on an invitation via a link',
  },
  {
    LID: '2',
    TranslateData:
      'Scroll down to "participants" and click on "invitation via a link"',
    TranslateKey:
      'Scroll down to the participants and click on an invitation via a link',
  },
  {
    LID: '3',
    TranslateData:
      "Faites défiler jusqu'à « participants » et cliquez sur « invitation via un lien »",
    TranslateKey:
      'Scroll down to the participants and click on an invitation via a link',
  },
  {
    LID: '4',
    TranslateData:
      'Прокрутите вниз до «участники» и нажмите «приглашение по ссылке».',
    TranslateKey:
      'Scroll down to the participants and click on an invitation via a link',
  },
  {
    LID: '1',
    TranslateData: 'אירועים שנקבעו',
    TranslateKey: 'Scheduled events',
  },
  {
    LID: '2',
    TranslateData: 'Scheduled events',
    TranslateKey: 'Scheduled events',
  },
  {
    LID: '3',
    TranslateData: 'Évènements planifiés',
    TranslateKey: 'Scheduled events',
  },
  {
    LID: '4',
    TranslateData: 'Запланированные мероприятия',
    TranslateKey: 'Scheduled events',
  },
  { LID: '1', TranslateData: 'שמירת משלוח', TranslateKey: 'Save shipping' },
  { LID: '2', TranslateData: 'Save shipping', TranslateKey: 'Save shipping' },
  {
    LID: '3',
    TranslateData: "Économisez l'expédition",
    TranslateKey: 'Save shipping',
  },
  {
    LID: '4',
    TranslateData: 'Сохранить доставку',
    TranslateKey: 'Save shipping',
  },
  {
    LID: '1',
    TranslateData: 'שמור את פרטי הכרטיס שלי לתשלום חודשי אוטומטי,',
    TranslateKey: 'Save my card details for automatic monthly payment,',
  },
  {
    LID: '2',
    TranslateData: 'Save my card details for monthly payment,',
    TranslateKey: 'Save my card details for automatic monthly payment,',
  },
  {
    LID: '3',
    TranslateData:
      'Enregistrez les détails de ma carte pour le paiement mensuel,',
    TranslateKey: 'Save my card details for automatic monthly payment,',
  },
  {
    LID: '4',
    TranslateData: 'Сохраните данные моей карты для ежемесячной оплаты,',
    TranslateKey: 'Save my card details for automatic monthly payment,',
  },
  { LID: '1', TranslateData: 'שמירת מפתח', TranslateKey: 'Save key' },
  { LID: '2', TranslateData: 'Save key', TranslateKey: 'Save key' },
  { LID: '3', TranslateData: 'Enregistrer la clé', TranslateKey: 'Save key' },
  { LID: '4', TranslateData: 'Сохранить ключ', TranslateKey: 'Save key' },
  {
    LID: '1',
    TranslateData: 'שמור ושלח הודעה',
    TranslateKey: 'Save and send a message',
  },
  {
    LID: '2',
    TranslateData: 'Save and send a message',
    TranslateKey: 'Save and send a message',
  },
  {
    LID: '3',
    TranslateData: 'Enregistrer et envoyer un message',
    TranslateKey: 'Save and send a message',
  },
  {
    LID: '4',
    TranslateData: 'Сохранить и отправить сообщение',
    TranslateKey: 'Save and send a message',
  },
  { LID: '1', TranslateData: 'שמור', TranslateKey: 'Save' },
  { LID: '2', TranslateData: 'Save', TranslateKey: 'Save' },
  { LID: '3', TranslateData: 'sauvegarder', TranslateKey: 'Save' },
  { LID: '4', TranslateData: 'Сохранять', TranslateKey: 'Save' },
  { LID: '1', TranslateData: 'שבת', TranslateKey: 'Saturday' },
  { LID: '2', TranslateData: 'Saturday', TranslateKey: 'Saturday' },
  { LID: '3', TranslateData: 'Samedi', TranslateKey: 'Saturday' },
  { LID: '4', TranslateData: 'Суббота', TranslateKey: 'Saturday' },
  { LID: '1', TranslateData: 'ש', TranslateKey: 'Sat' },
  { LID: '2', TranslateData: 'Sa', TranslateKey: 'Sat' },
  { LID: '3', TranslateData: 'Sa', TranslateKey: 'Sat' },
  { LID: '4', TranslateData: 'Sa', TranslateKey: 'Sat' },
  { LID: '1', TranslateData: 'ש', TranslateKey: 'Sa' },
  { LID: '2', TranslateData: 'Sa', TranslateKey: 'Sa' },
  { LID: '3', TranslateData: 'Sa', TranslateKey: 'Sa' },
  { LID: '4', TranslateData: 'Sa', TranslateKey: 'Sa' },
  { LID: '1', TranslateData: 'מסי חדרים', TranslateKey: 'rooms number' },
  { LID: '2', TranslateData: 'Rooms', TranslateKey: 'rooms number' },
  { LID: '3', TranslateData: 'Pièces', TranslateKey: 'rooms number' },
  { LID: '4', TranslateData: 'Номера', TranslateKey: 'rooms number' },
  { LID: '1', TranslateData: 'תפקיד', TranslateKey: 'role' },
  { LID: '2', TranslateData: 'role', TranslateKey: 'role' },
  { LID: '3', TranslateData: 'rôle', TranslateKey: 'role' },
  { LID: '4', TranslateData: 'роль', TranslateKey: 'role' },
  {
    LID: '1',
    TranslateData: 'הכנסות פחות הוצאות נטו',
    TranslateKey: 'Revenue less net expenses',
  },
  {
    LID: '2',
    TranslateData: 'Revenue less net expenses',
    TranslateKey: 'Revenue less net expenses',
  },
  {
    LID: '3',
    TranslateData: 'Revenus moins dépenses nettes',
    TranslateKey: 'Revenue less net expenses',
  },
  {
    LID: '4',
    TranslateData: 'Выручка за вычетом чистых расходов',
    TranslateKey: 'Revenue less net expenses',
  },
  {
    LID: '1',
    TranslateData: 'חזור למסך קודם',
    TranslateKey: 'Return to previous screen',
  },
  {
    LID: '2',
    TranslateData: 'Return to previous screen',
    TranslateKey: 'Return to previous screen',
  },
  {
    LID: '3',
    TranslateData: "Revenir à l'écran précédent",
    TranslateKey: 'Return to previous screen',
  },
  {
    LID: '4',
    TranslateData: 'Вернуться к предыдущему экрану',
    TranslateKey: 'Return to previous screen',
  },
  { LID: '1', TranslateData: 'חזור', TranslateKey: 'Return' },
  { LID: '2', TranslateData: 'Return', TranslateKey: 'Return' },
  { LID: '3', TranslateData: 'Retourner', TranslateKey: 'Return' },
  { LID: '4', TranslateData: 'Вернуть', TranslateKey: 'Return' },
  {
    LID: '1',
    TranslateData: 'פרטי ספק אחראי ',
    TranslateKey: 'Responsible supplier details',
  },
  {
    LID: '2',
    TranslateData: 'Service provider details',
    TranslateKey: 'Responsible supplier details',
  },
  {
    LID: '3',
    TranslateData: 'Détails du fournisseur de services',
    TranslateKey: 'Responsible supplier details',
  },
  {
    LID: '4',
    TranslateData: 'Детали поставщика услуг',
    TranslateKey: 'Responsible supplier details',
  },
  { LID: '1', TranslateData: 'שדה נדרש', TranslateKey: 'Required field' },
  { LID: '2', TranslateData: 'Required field', TranslateKey: 'Required field' },
  { LID: '3', TranslateData: 'champs requis', TranslateKey: 'Required field' },
  {
    LID: '4',
    TranslateData: 'Обязательное поле',
    TranslateKey: 'Required field',
  },
  {
    LID: '1',
    TranslateData: 'מבקש הצעת מחיר עבור',
    TranslateKey: 'Requesting a quote for',
  },
  {
    LID: '2',
    TranslateData: 'Requesting a quote for',
    TranslateKey: 'Requesting a quote for',
  },
  {
    LID: '3',
    TranslateData: 'Demander un devis pour',
    TranslateKey: 'Requesting a quote for',
  },
  {
    LID: '4',
    TranslateData: 'Запрос предложения на',
    TranslateKey: 'Requesting a quote for',
  },
  {
    LID: '1',
    TranslateData: 'בקשת פרטים נוספים להצעת מחיר',
    TranslateKey: 'Request more details for a quote',
  },
  {
    LID: '2',
    TranslateData: 'Ask for more details',
    TranslateKey: 'Request more details for a quote',
  },
  {
    LID: '3',
    TranslateData: 'Demandez plus de détails',
    TranslateKey: 'Request more details for a quote',
  },
  {
    LID: '4',
    TranslateData: 'Спросите подробности',
    TranslateKey: 'Request more details for a quote',
  },
  {
    LID: '1',
    TranslateData: 'בקשה להצעת מחיר חדשה',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '2',
    TranslateData: 'Request for a new quote',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '3',
    TranslateData: 'Demander un nouveau devis',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '4',
    TranslateData: 'Запрос нового предложения',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '1',
    TranslateData: 'בקשה להצעת מחיר חדשה',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '2',
    TranslateData: 'Quote request',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '3',
    TranslateData: 'Demande de citation',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '4',
    TranslateData: 'Запрос квоты',
    TranslateKey: 'Request for a new quote',
  },
  {
    LID: '1',
    TranslateData: 'אני נציג ועד הבית',
    TranslateKey: 'representative of the House Committee',
  },
  {
    LID: '2',
    TranslateData: "I'm a representative of the House Committee",
    TranslateKey: 'representative of the House Committee',
  },
  {
    LID: '3',
    TranslateData: 'Je suis un représentant du Comité de la Chambre',
    TranslateKey: 'representative of the House Committee',
  },
  {
    LID: '4',
    TranslateData: 'Я представитель Комитета Палаты представителей',
    TranslateKey: 'representative of the House Committee',
  },
  { LID: '1', TranslateData: 'פרטי מדווח', TranslateKey: 'Reporting Details' },
  {
    LID: '2',
    TranslateData: 'Reporting Details',
    TranslateKey: 'Reporting Details',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Reporting Details' },
  { LID: '4', TranslateData: '', TranslateKey: 'Reporting Details' },
  { LID: '1', TranslateData: 'שם מדווח', TranslateKey: 'Reporter Name' },
  { LID: '2', TranslateData: 'Reporter Name', TranslateKey: 'Reporter Name' },
  {
    LID: '3',
    TranslateData: 'Nom du rapporteur',
    TranslateKey: 'Reporter Name',
  },
  { LID: '4', TranslateData: 'Имя репортера', TranslateKey: 'Reporter Name' },
  { LID: '1', TranslateData: 'מדווח', TranslateKey: 'Reporter' },
  { LID: '2', TranslateData: 'Reporter', TranslateKey: 'Reporter' },
  { LID: '3', TranslateData: 'Journaliste', TranslateKey: 'Reporter' },
  { LID: '4', TranslateData: 'Репортер', TranslateKey: 'Reporter' },
  {
    LID: '1',
    TranslateData: 'דיווח נשלח בהצלחה !',
    TranslateKey: 'Report sent successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Report sent successfully !',
    TranslateKey: 'Report sent successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Rapport envoyé avec succès !',
    TranslateKey: 'Report sent successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Отчет успешно отправлен!',
    TranslateKey: 'Report sent successfully!',
  },
  {
    LID: '1',
    TranslateData: 'תקופת הדוח - {0} - {1}',
    TranslateKey: 'Report period - {0} - {1}',
  },
  {
    LID: '2',
    TranslateData: 'Report period - {0} - {1}',
    TranslateKey: 'Report period - {0} - {1}',
  },
  {
    LID: '3',
    TranslateData: 'Période du rapport - {0} - {1}',
    TranslateKey: 'Report period - {0} - {1}',
  },
  {
    LID: '4',
    TranslateData: 'Отчетный период - {0} - {1}',
    TranslateKey: 'Report period - {0} - {1}',
  },
  { LID: '1', TranslateData: 'החלף כרטיס', TranslateKey: 'Replace card' },
  { LID: '2', TranslateData: 'Replace card', TranslateKey: 'Replace card' },
  {
    LID: '3',
    TranslateData: 'Remplacer la carte',
    TranslateKey: 'Replace card',
  },
  { LID: '4', TranslateData: 'Заменить карту', TranslateKey: 'Replace card' },
  { LID: '1', TranslateData: 'שוכרים', TranslateKey: 'Renters' },
  { LID: '2', TranslateData: 'Renters', TranslateKey: 'Renters' },
  { LID: '3', TranslateData: 'Locataires', TranslateKey: 'Renters' },
  { LID: '4', TranslateData: 'Арендаторы', TranslateKey: 'Renters' },
  { LID: '1', TranslateData: 'הסר כלל', TranslateKey: 'Remove Rule' },
  { LID: '2', TranslateData: 'Remove Rule', TranslateKey: 'Remove Rule' },
  {
    LID: '3',
    TranslateData: 'Supprimer la règle',
    TranslateKey: 'Remove Rule',
  },
  { LID: '4', TranslateData: 'Удалить правило', TranslateKey: 'Remove Rule' },
  { LID: '1', TranslateData: 'הערות', TranslateKey: 'Remarks' },
  { LID: '2', TranslateData: 'Remarks', TranslateKey: 'Remarks' },
  { LID: '3', TranslateData: 'Remarques', TranslateKey: 'Remarks' },
  { LID: '4', TranslateData: 'Примечания', TranslateKey: 'Remarks' },
  {
    LID: '1',
    TranslateData: 'הוצאות קשורות',
    TranslateKey: 'Related expenses',
  },
  {
    LID: '2',
    TranslateData: 'Related expenses',
    TranslateKey: 'Related expenses',
  },
  {
    LID: '3',
    TranslateData: 'Dépenses connexes',
    TranslateKey: 'Related expenses',
  },
  {
    LID: '4',
    TranslateData: 'Сопутствующие расходы',
    TranslateKey: 'Related expenses',
  },
  {
    LID: '1',
    TranslateData: 'רישום כדייר בבניין',
    TranslateKey: 'Registration as a tenant in the building',
  },
  {
    LID: '2',
    TranslateData: 'Registration as a tenant in the building',
    TranslateKey: 'Registration as a tenant in the building',
  },
  {
    LID: '3',
    TranslateData: "Inscription en tant que locataire dans l'immeuble",
    TranslateKey: 'Registration as a tenant in the building',
  },
  {
    LID: '4',
    TranslateData: 'Регистрация в качестве арендатора в здании',
    TranslateKey: 'Registration as a tenant in the building',
  },
  { LID: '1', TranslateData: 'נרשם ע"י', TranslateKey: 'Registered by' },
  { LID: '2', TranslateData: 'Registered by', TranslateKey: 'Registered by' },
  { LID: '3', TranslateData: 'Enregistré par', TranslateKey: 'Registered by' },
  {
    LID: '4',
    TranslateData: 'Зарегистрировано',
    TranslateKey: 'Registered by',
  },
  {
    LID: '1',
    TranslateData: 'הרשמה כדייר חדש',
    TranslateKey: 'Register new tenant',
  },
  {
    LID: '2',
    TranslateData: 'Register new tenant',
    TranslateKey: 'Register new tenant',
  },
  {
    LID: '3',
    TranslateData: 'Enregistrer un nouveau locataire',
    TranslateKey: 'Register new tenant',
  },
  {
    LID: '4',
    TranslateData: 'Зарегистрировать нового арендатора',
    TranslateKey: 'Register new tenant',
  },
  { LID: '1', TranslateData: 'מספר אסמכתה', TranslateKey: 'Reference number' },
  {
    LID: '2',
    TranslateData: 'Reference number',
    TranslateKey: 'Reference number',
  },
  {
    LID: '3',
    TranslateData: 'Numéro de réference',
    TranslateKey: 'Reference number',
  },
  { LID: '4', TranslateData: 'Номер ссылки', TranslateKey: 'Reference number' },
  { LID: '1', TranslateData: 'סימוכין', TranslateKey: 'Reference' },
  { LID: '2', TranslateData: 'Reference', TranslateKey: 'Reference' },
  { LID: '3', TranslateData: 'Référence', TranslateKey: 'Reference' },
  { LID: '4', TranslateData: 'Ссылка', TranslateKey: 'Reference' },
  {
    LID: '1',
    TranslateData: 'רישום הוצאות',
    TranslateKey: 'Recording expenses',
  },
  {
    LID: '2',
    TranslateData: 'Recording expenses',
    TranslateKey: 'Recording expenses',
  },
  {
    LID: '3',
    TranslateData: "Dépenses d'enregistrement",
    TranslateKey: 'Recording expenses',
  },
  {
    LID: '4',
    TranslateData: 'Учет расходов',
    TranslateKey: 'Recording expenses',
  },
  { LID: '1', TranslateData: 'טלפון נמען', TranslateKey: 'Recipient phone' },
  {
    LID: '2',
    TranslateData: 'Recipient phone',
    TranslateKey: 'Recipient phone',
  },
  {
    LID: '3',
    TranslateData: 'téléphone du destinataire',
    TranslateKey: 'Recipient phone',
  },
  {
    LID: '4',
    TranslateData: 'телефон получателя',
    TranslateKey: 'Recipient phone',
  },
  { LID: '1', TranslateData: 'שם נמען', TranslateKey: 'Recipient name' },
  { LID: '2', TranslateData: 'Recipient name', TranslateKey: 'Recipient name' },
  {
    LID: '3',
    TranslateData: 'nom du destinataire',
    TranslateKey: 'Recipient name',
  },
  { LID: '4', TranslateData: 'Имя получателя', TranslateKey: 'Recipient name' },
  { LID: '1', TranslateData: 'נמען', TranslateKey: 'Recipient' },
  { LID: '2', TranslateData: 'Recipient ', TranslateKey: 'Recipient' },
  { LID: '3', TranslateData: 'destinataire', TranslateKey: 'Recipient' },
  { LID: '4', TranslateData: 'получатель', TranslateKey: 'Recipient' },
  {
    LID: '1',
    TranslateData: 'קריאות שירות אחרונות',
    TranslateKey: 'Recent service calls',
  },
  {
    LID: '2',
    TranslateData: 'Recent service calls',
    TranslateKey: 'Recent service calls',
  },
  {
    LID: '3',
    TranslateData: 'Appels de service récents',
    TranslateKey: 'Recent service calls',
  },
  {
    LID: '4',
    TranslateData: 'Недавние обращения в службу поддержки',
    TranslateKey: 'Recent service calls',
  },
  { LID: '1', TranslateData: 'תאריך קבלה', TranslateKey: 'Receipt Date' },
  { LID: '2', TranslateData: 'Receipt Date', TranslateKey: 'Receipt Date' },
  {
    LID: '3',
    TranslateData: 'Date de réception',
    TranslateKey: 'Receipt Date',
  },
  { LID: '4', TranslateData: 'Дата чека', TranslateKey: 'Receipt Date' },
  { LID: '1', TranslateData: 'סכום קבלה', TranslateKey: 'Receipt amount' },
  { LID: '2', TranslateData: 'Receipt amount', TranslateKey: 'Receipt amount' },
  {
    LID: '3',
    TranslateData: 'Montant du reçu',
    TranslateKey: 'Receipt amount',
  },
  { LID: '4', TranslateData: 'Сумма чека', TranslateKey: 'Receipt amount' },
  { LID: '1', TranslateData: 'קבלה', TranslateKey: 'Receipt' },
  { LID: '2', TranslateData: 'Receipt', TranslateKey: 'Receipt' },
  { LID: '3', TranslateData: 'reçu', TranslateKey: 'Receipt' },
  { LID: '4', TranslateData: 'чек', TranslateKey: 'Receipt' },
  {
    LID: '1',
    TranslateData: 'ססטוס הקריאה שונה בהצלחה',
    TranslateKey: 'Reading status is successfully modified',
  },
  {
    LID: '2',
    TranslateData: 'Reading status is successfully modified',
    TranslateKey: 'Reading status is successfully modified',
  },
  {
    LID: '3',
    TranslateData: 'Le statut de lecture a été modifié avec succès',
    TranslateKey: 'Reading status is successfully modified',
  },
  {
    LID: '4',
    TranslateData: 'Статус чтения успешно изменен',
    TranslateKey: 'Reading status is successfully modified',
  },
  { LID: '1', TranslateData: "מס' קריאה", TranslateKey: 'Reading number' },
  {
    LID: '2',
    TranslateData: 'Service call No.',
    TranslateKey: 'Reading number',
  },
  {
    LID: '3',
    TranslateData: 'Appel de service n°',
    TranslateKey: 'Reading number',
  },
  {
    LID: '4',
    TranslateData: 'Сервисный вызов No.',
    TranslateKey: 'Reading number',
  },
  { LID: '1', TranslateData: 'ת. קריאה', TranslateKey: 'Reading Date' },
  { LID: '2', TranslateData: 'Reading Date', TranslateKey: 'Reading Date' },
  { LID: '3', TranslateData: 'Date de lecture', TranslateKey: 'Reading Date' },
  { LID: '4', TranslateData: 'Дата чтения', TranslateKey: 'Reading Date' },
  { LID: '1', TranslateData: 'קריאה', TranslateKey: 'Reading' },
  { LID: '2', TranslateData: 'Reading', TranslateKey: 'Reading' },
  { LID: '3', TranslateData: 'En train de lire', TranslateKey: 'Reading' },
  { LID: '4', TranslateData: 'Чтение', TranslateKey: 'Reading' },
  { LID: '1', TranslateData: 'קרא עוד...', TranslateKey: 'read more...' },
  { LID: '2', TranslateData: 'read more...', TranslateKey: 'read more...' },
  { LID: '3', TranslateData: 'Lire la suite...', TranslateKey: 'read more...' },
  { LID: '4', TranslateData: 'читать далее...', TranslateKey: 'read more...' },
  {
    LID: '1',
    TranslateData: 'הצעות מחיר לאישור',
    TranslateKey: 'Quotations for approval',
  },
  {
    LID: '2',
    TranslateData: 'Quotations for approval',
    TranslateKey: 'Quotations for approval',
  },
  {
    LID: '3',
    TranslateData: 'Devis pour approbation',
    TranslateKey: 'Quotations for approval',
  },
  {
    LID: '4',
    TranslateData: 'Расценки на согласование',
    TranslateKey: 'Quotations for approval',
  },
  { LID: '1', TranslateData: 'הודעות דחיפה', TranslateKey: 'Push messages' },
  { LID: '2', TranslateData: 'Push messages', TranslateKey: 'Push messages' },
  { LID: '3', TranslateData: 'Messages push', TranslateKey: 'Push messages' },
  { LID: '4', TranslateData: 'Push-сообщения', TranslateKey: 'Push messages' },
  { LID: '1', TranslateData: 'הודעות Push', TranslateKey: 'Push messages' },
  { LID: '2', TranslateData: 'Push messages', TranslateKey: 'Push messages' },
  { LID: '3', TranslateData: 'Messages push', TranslateKey: 'Push messages' },
  { LID: '4', TranslateData: 'Push-сообщения', TranslateKey: 'Push messages' },
  { LID: '1', TranslateData: 'עבור', TranslateKey: 'Purpose' },
  { LID: '2', TranslateData: 'Purpose', TranslateKey: 'Purpose' },
  { LID: '3', TranslateData: 'But', TranslateKey: 'Purpose' },
  { LID: '4', TranslateData: 'Цель', TranslateKey: 'Purpose' },
  { LID: '1', TranslateData: 'סוג נכס', TranslateKey: 'Property type' },
  { LID: '2', TranslateData: 'Property type', TranslateKey: 'Property type' },
  {
    LID: '3',
    TranslateData: 'Type de propriété',
    TranslateKey: 'Property type',
  },
  {
    LID: '4',
    TranslateData: 'Тип недвижимости',
    TranslateKey: 'Property type',
  },
  { LID: '1', TranslateData: 'מזהה פניה', TranslateKey: 'Problem ID' },
  { LID: '2', TranslateData: 'Problem ID', TranslateKey: 'Problem ID' },
  {
    LID: '3',
    TranslateData: 'Identifiant du problème',
    TranslateKey: 'Problem ID',
  },
  {
    LID: '4',
    TranslateData: 'Идентификатор проблемы',
    TranslateKey: 'Problem ID',
  },
  { LID: '1', TranslateData: 'חניה פרטית', TranslateKey: 'private parking' },
  {
    LID: '2',
    TranslateData: 'private parking',
    TranslateKey: 'private parking',
  },
  { LID: '3', TranslateData: 'parking privé', TranslateKey: 'private parking' },
  {
    LID: '4',
    TranslateData: 'частная парковка',
    TranslateKey: 'private parking',
  },
  {
    LID: '1',
    TranslateData: 'הצהרת פרטיות',
    TranslateKey: 'Privacy Statement',
  },
  {
    LID: '2',
    TranslateData: 'Privacy Statement',
    TranslateKey: 'Privacy Statement',
  },
  {
    LID: '3',
    TranslateData: 'Déclaration de confidentialité',
    TranslateKey: 'Privacy Statement',
  },
  {
    LID: '4',
    TranslateData: 'Заявление о конфиденциальности',
    TranslateKey: 'Privacy Statement',
  },
  { LID: '1', TranslateData: 'מדיניות פרטיות', TranslateKey: 'Privacy policy' },
  { LID: '2', TranslateData: 'Privacy policy', TranslateKey: 'Privacy policy' },
  {
    LID: '3',
    TranslateData: 'Politique de confidentialité',
    TranslateKey: 'Privacy policy',
  },
  {
    LID: '4',
    TranslateData: 'Политика конфиденциальности',
    TranslateKey: 'Privacy policy',
  },
  {
    LID: '1',
    TranslateData: 'פרטיות ותנאי שימוש',
    TranslateKey: 'Privacy and terms of use',
  },
  {
    LID: '2',
    TranslateData: 'Privacy and terms of use',
    TranslateKey: 'Privacy and terms of use',
  },
  {
    LID: '3',
    TranslateData: "Confidentialité et conditions d'utilisation",
    TranslateKey: 'Privacy and terms of use',
  },
  {
    LID: '4',
    TranslateData: 'Конфиденциальность и условия использования',
    TranslateKey: 'Privacy and terms of use',
  },
  {
    LID: '1',
    TranslateData: 'דחיפות - תאריך פתיחה',
    TranslateKey: 'Priority - OpenDate',
  },
  {
    LID: '2',
    TranslateData: 'Priority - OpenDate',
    TranslateKey: 'Priority - OpenDate',
  },
  {
    LID: '3',
    TranslateData: 'Priorité - OpenDate',
    TranslateKey: 'Priority - OpenDate',
  },
  {
    LID: '4',
    TranslateData: 'Приоритет - OpenDate',
    TranslateKey: 'Priority - OpenDate',
  },
  { LID: '1', TranslateData: 'דחיפות', TranslateKey: 'Priority' },
  { LID: '2', TranslateData: 'priority', TranslateKey: 'Priority' },
  { LID: '3', TranslateData: 'priorité', TranslateKey: 'Priority' },
  { LID: '4', TranslateData: 'приоритет', TranslateKey: 'Priority' },
  { LID: '1', TranslateData: 'הצעות מחיר', TranslateKey: 'Price offers' },
  { LID: '2', TranslateData: 'Quotes', TranslateKey: 'Price offers' },
  { LID: '3', TranslateData: 'Devis', TranslateKey: 'Price offers' },
  { LID: '4', TranslateData: 'Котировки', TranslateKey: 'Price offers' },
  {
    LID: '1',
    TranslateData: 'קריאות קודמות בנושא',
    TranslateKey: 'Previous readings on the subject',
  },
  {
    LID: '2',
    TranslateData: 'Previous service calls on this subject',
    TranslateKey: 'Previous readings on the subject',
  },
  {
    LID: '3',
    TranslateData: 'Appels de service antérieurs à ce sujet',
    TranslateKey: 'Previous readings on the subject',
  },
  {
    LID: '4',
    TranslateData: 'Предыдущие обращения в службу поддержки по этой теме',
    TranslateKey: 'Previous readings on the subject',
  },
  {
    LID: '1',
    TranslateData: 'הצגת הוצאות בסכום 0:',
    TranslateKey: 'Presenting expenses in the amount of 0:',
  },
  {
    LID: '2',
    TranslateData: 'Show zero amount expenses:',
    TranslateKey: 'Presenting expenses in the amount of 0:',
  },
  {
    LID: '3',
    TranslateData: 'Afficher les dépenses à montant nul :',
    TranslateKey: 'Presenting expenses in the amount of 0:',
  },
  {
    LID: '4',
    TranslateData: 'Показывать нулевые расходы:',
    TranslateKey: 'Presenting expenses in the amount of 0:',
  },
  { LID: '1', TranslateData: 'העדפות', TranslateKey: 'Preferences' },
  { LID: '2', TranslateData: 'Preferences', TranslateKey: 'Preferences' },
  { LID: '3', TranslateData: 'Préférences', TranslateKey: 'Preferences' },
  { LID: '4', TranslateData: 'Предпочтения', TranslateKey: 'Preferences' },
  {
    LID: '1',
    TranslateData: 'הספק נשמר בהצלחה',
    TranslateKey: 'Power is successfully maintained',
  },
  {
    LID: '2',
    TranslateData: 'Power is successfully maintained',
    TranslateKey: 'Power is successfully maintained',
  },
  {
    LID: '3',
    TranslateData: 'La puissance est maintenue avec succès',
    TranslateKey: 'Power is successfully maintained',
  },
  {
    LID: '4',
    TranslateData: 'Мощность успешно поддерживается',
    TranslateKey: 'Power is successfully maintained',
  },
  {
    LID: '1',
    TranslateData: 'הספק נמחק בהצלחה',
    TranslateKey: 'Power deleted successfully',
  },
  {
    LID: '2',
    TranslateData: 'Power deleted successfully',
    TranslateKey: 'Power deleted successfully',
  },
  {
    LID: '3',
    TranslateData: 'Alimentation supprimée avec succès',
    TranslateKey: 'Power deleted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Сила успешно удалена',
    TranslateKey: 'Power deleted successfully',
  },
  {
    LID: '1',
    TranslateData: 'סוגי קבצים אפשריים לתמונה: ',
    TranslateKey: 'Possible extensions for adding an image are:',
  },
  {
    LID: '2',
    TranslateData: 'Possible picture file extensions are:',
    TranslateKey: 'Possible extensions for adding an image are:',
  },
  {
    LID: '3',
    TranslateData: 'Les extensions de fichier image possibles sont :',
    TranslateKey: 'Possible extensions for adding an image are:',
  },
  {
    LID: '4',
    TranslateData: 'Возможные расширения файлов изображений:',
    TranslateKey: 'Possible extensions for adding an image are:',
  },
  { LID: '1', TranslateData: 'נא לפרט', TranslateKey: 'please specify' },
  { LID: '2', TranslateData: 'please specify', TranslateKey: 'please specify' },
  {
    LID: '3',
    TranslateData: 'veuillez préciser',
    TranslateKey: 'please specify',
  },
  {
    LID: '4',
    TranslateData: 'пожалуйста уточни',
    TranslateKey: 'please specify',
  },
  {
    LID: '1',
    TranslateData: 'אנא החלף את הכרטיס',
    TranslateKey: 'Please replace the card.',
  },
  {
    LID: '2',
    TranslateData: 'Please replace the card',
    TranslateKey: 'Please replace the card.',
  },
  {
    LID: '3',
    TranslateData: 'Veuillez remplacer la carte',
    TranslateKey: 'Please replace the card.',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, замените карту',
    TranslateKey: 'Please replace the card.',
  },
  {
    LID: '1',
    TranslateData:
      'שים לב - מחיקת הכרטיס מהמערכת תגרום לכך שתידרש לשלם באופן עצמאי את דמי ועד הבית כל חודש. הוראת הקבע אינה תופסת מסגרת. האם אתה בטוח ?',
    TranslateKey:
      'Please note - deleting the card from the system will mean that you will be required to pay the housing committee fees independently every month. The standing order does not occupy a frame. Are you sure ?',
  },
  {
    LID: '2',
    TranslateData:
      'Please note - deleting the card from the system will mean that you will be required to pay the housing committee fees independently every month. The standing order does not occupy a frame. Are you sure ?',
    TranslateKey:
      'Please note - deleting the card from the system will mean that you will be required to pay the housing committee fees independently every month. The standing order does not occupy a frame. Are you sure ?',
  },
  {
    LID: '3',
    TranslateData:
      "Attention, la suppression de la carte du système signifie que vous devrez payer les frais du comité de logement de manière indépendante chaque mois. L'ordre permanent n'occupe pas de cadre. Es-tu sûr ?",
    TranslateKey:
      'Please note - deleting the card from the system will mean that you will be required to pay the housing committee fees independently every month. The standing order does not occupy a frame. Are you sure ?',
  },
  {
    LID: '4',
    TranslateData:
      'Обратите внимание – удаление карты из системы будет означать, что вы будете обязаны каждый месяц самостоятельно платить взносы ЖКХ. Постоянное поручение не занимает рамки. Вы уверены ?',
    TranslateKey:
      'Please note - deleting the card from the system will mean that you will be required to pay the housing committee fees independently every month. The standing order does not occupy a frame. Are you sure ?',
  },
  {
    LID: '1',
    TranslateData: 'נא למלא את הפרטים הבאים',
    TranslateKey: 'please fill in the following details',
  },
  {
    LID: '2',
    TranslateData: 'please fill in the following details',
    TranslateKey: 'please fill in the following details',
  },
  {
    LID: '3',
    TranslateData: 'veuillez remplir les détails suivants',
    TranslateKey: 'please fill in the following details',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, заполните следующие данные',
    TranslateKey: 'please fill in the following details',
  },
  {
    LID: '1',
    TranslateData: 'אנא הזן מספר שקיבלת בהודעת SMS',
    TranslateKey: 'Please enter the number you received in the SMS',
  },
  {
    LID: '2',
    TranslateData: 'Please enter the number you received in SMS message',
    TranslateKey: 'Please enter the number you received in the SMS',
  },
  {
    LID: '3',
    TranslateData:
      'Veuillez entrer le numéro que vous avez reçu dans le message SMS',
    TranslateKey: 'Please enter the number you received in the SMS',
  },
  {
    LID: '4',
    TranslateData:
      'Пожалуйста, введите номер, который вы получили в SMS сообщении',
    TranslateKey: 'Please enter the number you received in the SMS',
  },
  {
    LID: '1',
    TranslateData: 'אנא הזן את 5 הספרות האחרונות של המספר שחייג אליך',
    TranslateKey: 'Please enter the number you received in the Phone',
  },
  {
    LID: '2',
    TranslateData: 'Please enter the last 5 digits of the number dialed to you',
    TranslateKey: 'Please enter the number you received in the Phone',
  },
  {
    LID: '3',
    TranslateData:
      'Veuillez entrer les 5 derniers chiffres du numéro qui vous a été composé',
    TranslateKey: 'Please enter the number you received in the Phone',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, введите последние 5 цифр набранного вам номера',
    TranslateKey: 'Please enter the number you received in the Phone',
  },
  {
    LID: '1',
    TranslateData: 'אנא הזן מספר שקיבלת במייל',
    TranslateKey: 'Please enter the number you received in the Mail',
  },
  {
    LID: '2',
    TranslateData: 'Please enter the number you received in the Mail',
    TranslateKey: 'Please enter the number you received in the Mail',
  },
  {
    LID: '3',
    TranslateData: "Veuillez entrer le numéro que vous avez reçu dans l'e-mail",
    TranslateKey: 'Please enter the number you received in the Mail',
  },
  {
    LID: '4',
    TranslateData:
      'Пожалуйста, введите номер, который вы получили в электронном письме',
    TranslateKey: 'Please enter the number you received in the Mail',
  },
  {
    LID: '1',
    TranslateData: 'אנא הזן קוד חברה, שם משתמש וסיסמה',
    TranslateKey: 'Please enter a company code, username and password',
  },
  {
    LID: '2',
    TranslateData: 'Please enter a company code, username and password',
    TranslateKey: 'Please enter a company code, username and password',
  },
  {
    LID: '3',
    TranslateData:
      "Veuillez entrer un code d'entreprise, un nom d'utilisateur et un mot de passe",
    TranslateKey: 'Please enter a company code, username and password',
  },
  {
    LID: '4',
    TranslateData:
      'Пожалуйста, введите код компании, имя пользователя и пароль',
    TranslateKey: 'Please enter a company code, username and password',
  },
  {
    LID: '1',
    TranslateData: 'אנא פנה למנהל המערכת',
    TranslateKey: 'Please contact your system administrator',
  },
  {
    LID: '2',
    TranslateData: 'Please contact your system administrator',
    TranslateKey: 'Please contact your system administrator',
  },
  {
    LID: '3',
    TranslateData: 'Veuillez contacter votre administrateur système',
    TranslateKey: 'Please contact your system administrator',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, обратитесь к системному администратору',
    TranslateKey: 'Please contact your system administrator',
  },
  {
    LID: '1',
    TranslateData: 'אנא פנה לחברת הניהול בטל:',
    TranslateKey:
      'Please contact the management company at the telephone number: ',
  },
  {
    LID: '2',
    TranslateData: 'Please contact the management company at this number: ',
    TranslateKey:
      'Please contact the management company at the telephone number: ',
  },
  {
    LID: '3',
    TranslateData: 'Veuillez contacter la société de gestion à ce numéro :',
    TranslateKey:
      'Please contact the management company at the telephone number: ',
  },
  {
    LID: '4',
    TranslateData: 'Свяжитесь с управляющей компанией по этому номеру:',
    TranslateKey:
      'Please contact the management company at the telephone number: ',
  },
  {
    LID: '1',
    TranslateData: 'אנא הרשה לנו לשלוח לך הודעות',
    TranslateKey: 'Please allow us to send you messages',
  },
  {
    LID: '2',
    TranslateData: 'Please allow us to send you messages',
    TranslateKey: 'Please allow us to send you messages',
  },
  {
    LID: '3',
    TranslateData: 'Veuillez nous permettre de vous envoyer des messages',
    TranslateKey: 'Please allow us to send you messages',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, разрешите нам отправлять вам сообщения',
    TranslateKey: 'Please allow us to send you messages',
  },
  {
    LID: '1',
    TranslateData: 'תחזוקה מתוכננת',
    TranslateKey: 'Planned Maintenance',
  },
  {
    LID: '2',
    TranslateData: 'Planned maintenance',
    TranslateKey: 'Planned Maintenance',
  },
  {
    LID: '3',
    TranslateData: 'Maintenance planifiée',
    TranslateKey: 'Planned Maintenance',
  },
  {
    LID: '4',
    TranslateData: 'Плановое обслуживание',
    TranslateKey: 'Planned Maintenance',
  },
  { LID: '1', TranslateData: 'מתוכננות', TranslateKey: 'Planned' },
  { LID: '2', TranslateData: 'Planned', TranslateKey: 'Planned' },
  { LID: '3', TranslateData: 'Prévu', TranslateKey: 'Planned' },
  { LID: '4', TranslateData: 'Планируется', TranslateKey: 'Planned' },
  { LID: '1', TranslateData: 'תמונה', TranslateKey: 'Picture' },
  { LID: '2', TranslateData: 'Image', TranslateKey: 'Picture' },
  { LID: '3', TranslateData: 'Image', TranslateKey: 'Picture' },
  { LID: '4', TranslateData: 'Изображение', TranslateKey: 'Picture' },
  { LID: '1', TranslateData: 'תמונות', TranslateKey: 'Photos' },
  { LID: '2', TranslateData: 'Images', TranslateKey: 'Photos' },
  { LID: '3', TranslateData: 'Images', TranslateKey: 'Photos' },
  { LID: '4', TranslateData: 'Картинки', TranslateKey: 'Photos' },
  { LID: '1', TranslateData: 'מס’ טלפון', TranslateKey: 'Phone number' },
  { LID: '2', TranslateData: 'Phone No.', TranslateKey: 'Phone number' },
  {
    LID: '3',
    TranslateData: 'Pas de téléphone.',
    TranslateKey: 'Phone number',
  },
  { LID: '4', TranslateData: 'Номер телефона.', TranslateKey: 'Phone number' },
  { LID: '1', TranslateData: 'טלפון חובה', TranslateKey: 'Phone is required' },
  {
    LID: '2',
    TranslateData: 'Phone is required',
    TranslateKey: 'Phone is required',
  },
  {
    LID: '3',
    TranslateData: 'Le téléphone est requis',
    TranslateKey: 'Phone is required',
  },
  {
    LID: '4',
    TranslateData: 'Требуется телефон',
    TranslateKey: 'Phone is required',
  },
  { LID: '1', TranslateData: 'טלפון', TranslateKey: 'Phone' },
  { LID: '2', TranslateData: 'Phone', TranslateKey: 'Phone' },
  { LID: '3', TranslateData: 'Téléphone', TranslateKey: 'Phone' },
  { LID: '4', TranslateData: 'Телефон', TranslateKey: 'Phone' },
  {
    LID: '1',
    TranslateData: 'דוח פרוט פעילות תקופתי',
    TranslateKey: 'Periodic activity detail report',
  },
  {
    LID: '2',
    TranslateData: 'Periodic activity report',
    TranslateKey: 'Periodic activity detail report',
  },
  {
    LID: '3',
    TranslateData: "Rapport d'activité périodique",
    TranslateKey: 'Periodic activity detail report',
  },
  {
    LID: '4',
    TranslateData: 'Отчет о периодической деятельности',
    TranslateKey: 'Periodic activity detail report',
  },
  { LID: '1', TranslateData: 'תשלומים', TranslateKey: 'Payments' },
  { LID: '2', TranslateData: 'Payments', TranslateKey: 'Payments' },
  { LID: '3', TranslateData: 'Paiements', TranslateKey: 'Payments' },
  { LID: '4', TranslateData: 'Платежи', TranslateKey: 'Payments' },
  {
    LID: '1',
    TranslateData: 'תשלום באמצעות כרטיס שמור',
    TranslateKey: 'Payment using a reserved card',
  },
  {
    LID: '2',
    TranslateData: 'Payment using a reserved card',
    TranslateKey: 'Payment using a reserved card',
  },
  {
    LID: '3',
    TranslateData: 'Paiement par carte réservée',
    TranslateKey: 'Payment using a reserved card',
  },
  {
    LID: '4',
    TranslateData: 'Оплата зарезервированной картой',
    TranslateKey: 'Payment using a reserved card',
  },
  { LID: '1', TranslateData: 'תשלום חוב', TranslateKey: 'Payment of debt' },
  {
    LID: '2',
    TranslateData: 'Payment of debt',
    TranslateKey: 'Payment of debt',
  },
  {
    LID: '3',
    TranslateData: 'Paiement de la dette',
    TranslateKey: 'Payment of debt',
  },
  { LID: '4', TranslateData: 'Оплата долга', TranslateKey: 'Payment of debt' },
  { LID: '1', TranslateData: 'אופן תשלום', TranslateKey: 'Payment methods' },
  {
    LID: '2',
    TranslateData: 'Payment method',
    TranslateKey: 'Payment methods',
  },
  {
    LID: '3',
    TranslateData: 'Mode de paiement',
    TranslateKey: 'Payment methods',
  },
  { LID: '4', TranslateData: 'Способ оплаты', TranslateKey: 'Payment methods' },
  {
    LID: '1',
    TranslateData: 'לא ניתן להמשיך לתשלום',
    TranslateKey: 'Payment can not be continued',
  },
  {
    LID: '2',
    TranslateData: 'Payment can not be continued',
    TranslateKey: 'Payment can not be continued',
  },
  {
    LID: '3',
    TranslateData: 'Le paiement ne peut pas être poursuivi',
    TranslateKey: 'Payment can not be continued',
  },
  {
    LID: '4',
    TranslateData: 'Оплата не может быть продолжена',
    TranslateKey: 'Payment can not be continued',
  },
  { LID: '1', TranslateData: 'תשלום', TranslateKey: 'payment' },
  { LID: '2', TranslateData: 'payment', TranslateKey: 'payment' },
  { LID: '3', TranslateData: 'Paiement', TranslateKey: 'payment' },
  { LID: '4', TranslateData: 'оплата', TranslateKey: 'payment' },
  { LID: '1', TranslateData: 'סיסמה', TranslateKey: 'password' },
  { LID: '2', TranslateData: 'password', TranslateKey: 'password' },
  { LID: '3', TranslateData: 'mot de passe', TranslateKey: 'password' },
  { LID: '4', TranslateData: 'пароль', TranslateKey: 'password' },
  { LID: '1', TranslateData: 'שערי חניה', TranslateKey: 'Parking gates' },
  { LID: '2', TranslateData: 'Parking gates', TranslateKey: 'Parking gates' },
  {
    LID: '3',
    TranslateData: 'Barrières de stationnement',
    TranslateKey: 'Parking gates',
  },
  {
    LID: '4',
    TranslateData: 'Парковочные ворота',
    TranslateKey: 'Parking gates',
  },
  { LID: '1', TranslateData: 'שולם', TranslateKey: 'Paid up' },
  { LID: '2', TranslateData: 'Paid', TranslateKey: 'Paid up' },
  { LID: '3', TranslateData: 'Payé', TranslateKey: 'Paid up' },
  { LID: '4', TranslateData: 'Оплаченный', TranslateKey: 'Paid up' },
  {
    LID: '1',
    TranslateData: 'שולם על ידינו עבור הבניין',
    TranslateKey: 'Paid by us for the building',
  },
  {
    LID: '2',
    TranslateData: 'Paid by us for the building',
    TranslateKey: 'Paid by us for the building',
  },
  {
    LID: '3',
    TranslateData: 'Payé par nous pour le bâtiment',
    TranslateKey: 'Paid by us for the building',
  },
  {
    LID: '4',
    TranslateData: 'Оплачено нами за здание',
    TranslateKey: 'Paid by us for the building',
  },
  {
    LID: '1',
    TranslateData: ' ביצע ביקור בבניין היום',
    TranslateKey: 'Paid a visit to the building today',
  },
  {
    LID: '2',
    TranslateData: 'Paid a visit to the building today',
    TranslateKey: 'Paid a visit to the building today',
  },
  {
    LID: '3',
    TranslateData: "J'ai visité le bâtiment aujourd'hui",
    TranslateKey: 'Paid a visit to the building today',
  },
  {
    LID: '4',
    TranslateData: 'Сегодня посетил здание',
    TranslateKey: 'Paid a visit to the building today',
  },
  { LID: '1', TranslateData: 'הדף לא נמצא', TranslateKey: 'Page not found' },
  { LID: '2', TranslateData: 'Page not found', TranslateKey: 'Page not found' },
  {
    LID: '3',
    TranslateData: 'Page non trouvée',
    TranslateKey: 'Page not found',
  },
  {
    LID: '4',
    TranslateData: 'Страница не найдена',
    TranslateKey: 'Page not found',
  },
  { LID: '1', TranslateData: 'בעלים', TranslateKey: 'Owner' },
  { LID: '2', TranslateData: 'Owner', TranslateKey: 'Owner' },
  { LID: '3', TranslateData: 'Propriétaire', TranslateKey: 'Owner' },
  { LID: '4', TranslateData: 'Владелец', TranslateKey: 'Owner' },
  {
    LID: '1',
    TranslateData: 'נציג מטעמנו יהיה בקשר איתך להשלמת הרישום.',
    TranslateKey:
      'our representative will be in touch with you to complete the registration.',
  },
  {
    LID: '2',
    TranslateData:
      'Our representative will be in touch with you to complete the registration.',
    TranslateKey:
      'our representative will be in touch with you to complete the registration.',
  },
  {
    LID: '3',
    TranslateData:
      "le message a été envoyé avec succèsNotre représentant vous contactera pour compléter l'inscription.",
    TranslateKey:
      'our representative will be in touch with you to complete the registration.',
  },
  {
    LID: '4',
    TranslateData:
      'Наш представитель свяжется с вами для завершения регистрации.',
    TranslateKey:
      'our representative will be in touch with you to complete the registration.',
  },
  { LID: '1', TranslateData: 'אחר', TranslateKey: 'Other' },
  { LID: '2', TranslateData: 'Other', TranslateKey: 'Other' },
  { LID: '3', TranslateData: 'Autre', TranslateKey: 'Other' },
  { LID: '4', TranslateData: 'Другой', TranslateKey: 'Other' },
  { LID: '1', TranslateData: 'הכנסות שוטפות', TranslateKey: 'Ordinary income' },
  {
    LID: '2',
    TranslateData: 'Ordinary income',
    TranslateKey: 'Ordinary income',
  },
  {
    LID: '3',
    TranslateData: 'Revenu ordinaire',
    TranslateKey: 'Ordinary income',
  },
  { LID: '4', TranslateData: 'Обычный доход', TranslateKey: 'Ordinary income' },
  {
    LID: '1',
    TranslateData: 'הוצאות שוטפות',
    TranslateKey: 'Ordinary expenses',
  },
  {
    LID: '2',
    TranslateData: 'Ordinary expenses',
    TranslateKey: 'Ordinary expenses',
  },
  {
    LID: '3',
    TranslateData: 'Dépenses ordinaires',
    TranslateKey: 'Ordinary expenses',
  },
  {
    LID: '4',
    TranslateData: 'Обычные расходы',
    TranslateKey: 'Ordinary expenses',
  },
  { LID: '1', TranslateData: 'הזמן שירות לבית', TranslateKey: 'Order service' },
  {
    LID: '2',
    TranslateData: 'Order home service',
    TranslateKey: 'Order service',
  },
  {
    LID: '3',
    TranslateData: 'Commander un service à domicile',
    TranslateKey: 'Order service',
  },
  {
    LID: '4',
    TranslateData: 'Заказать услугу на дом',
    TranslateKey: 'Order service',
  },
  {
    LID: '1',
    TranslateData: 'פתיחת שער חניה',
    TranslateKey: 'Opening of a parking gate',
  },
  {
    LID: '2',
    TranslateData: 'Opening of a parking gate',
    TranslateKey: 'Opening of a parking gate',
  },
  {
    LID: '3',
    TranslateData: "Ouverture d'une porte de parking",
    TranslateKey: 'Opening of a parking gate',
  },
  {
    LID: '4',
    TranslateData: 'Открытие парковочных ворот',
    TranslateKey: 'Opening of a parking gate',
  },
  { LID: '1', TranslateData: 'תאריך פתיחה', TranslateKey: 'Opening date' },
  { LID: '2', TranslateData: 'Opening date', TranslateKey: 'Opening date' },
  { LID: '3', TranslateData: "Date d'ouverture", TranslateKey: 'Opening date' },
  { LID: '4', TranslateData: 'Дата открытия', TranslateKey: 'Opening date' },
  { LID: '1', TranslateData: 'יתרה פתיחה', TranslateKey: 'Opening balance' },
  {
    LID: '2',
    TranslateData: 'Opening balance',
    TranslateKey: 'Opening balance',
  },
  {
    LID: '3',
    TranslateData: 'Solde d’ouverture',
    TranslateKey: 'Opening balance',
  },
  {
    LID: '4',
    TranslateData: 'Начальный баланс',
    TranslateKey: 'Opening balance',
  },
  {
    LID: '1',
    TranslateData: 'פתיחת קריאת שירות',
    TranslateKey: 'Opening a service call',
  },
  {
    LID: '2',
    TranslateData: 'Open a service call',
    TranslateKey: 'Opening a service call',
  },
  {
    LID: '3',
    TranslateData: 'Ouvrir un appel de service',
    TranslateKey: 'Opening a service call',
  },
  {
    LID: '4',
    TranslateData: 'Откройте сервисный звонок',
    TranslateKey: 'Opening a service call',
  },
  {
    LID: '1',
    TranslateData: 'קריאות שירות פתוחות',
    TranslateKey: 'Opened a services call',
  },
  {
    LID: '2',
    TranslateData: 'Open service calls',
    TranslateKey: 'Opened a services call',
  },
  {
    LID: '3',
    TranslateData: 'Appels de service ouverts',
    TranslateKey: 'Opened a services call',
  },
  {
    LID: '4',
    TranslateData: 'Открытые служебные вызовы',
    TranslateKey: 'Opened a services call',
  },
  { LID: '1', TranslateData: 'פתוחות', TranslateKey: 'Open' },
  { LID: '2', TranslateData: 'Open', TranslateKey: 'Open' },
  { LID: '3', TranslateData: 'Ouvert', TranslateKey: 'Open' },
  { LID: '4', TranslateData: 'Открытым', TranslateKey: 'Open' },
  {
    LID: '1',
    TranslateData: 'יש לבחור קובץ מסוג תמונה בלבד!',
    TranslateKey: 'Only an image type file must be selected!',
  },
  {
    LID: '2',
    TranslateData: 'Only an image type file must be selected!',
    TranslateKey: 'Only an image type file must be selected!',
  },
  {
    LID: '3',
    TranslateData: 'Seul un fichier de type image doit être sélectionné !',
    TranslateKey: 'Only an image type file must be selected!',
  },
  {
    LID: '4',
    TranslateData: 'Должен быть выбран только файл типа изображения!',
    TranslateKey: 'Only an image type file must be selected!',
  },
  {
    LID: '1',
    TranslateData: 'אחד או יותר מהפרטים המזהים שהקלדת שגוי',
    TranslateKey:
      'One or more of the identifying information you typed incorrectly',
  },
  {
    LID: '2',
    TranslateData:
      'One or more of the identifying information you typed incorrectly',
    TranslateKey:
      'One or more of the identifying information you typed incorrectly',
  },
  {
    LID: '3',
    TranslateData:
      "Une ou plusieurs des informations d'identification que vous avez mal saisies",
    TranslateKey:
      'One or more of the identifying information you typed incorrectly',
  },
  {
    LID: '4',
    TranslateData:
      'Одна или несколько идентификационных данных, которые вы ввели неправильно',
    TranslateKey:
      'One or more of the identifying information you typed incorrectly',
  },
  {
    LID: '1',
    TranslateData: 'לאחר שהקישור הועתק יש לחזור למסך זה ולהדביק אותו כאן',
    TranslateKey:
      'Once the link has been copied go back to this screen and paste it here',
  },
  {
    LID: '2',
    TranslateData:
      'Once the link has been copied go back to this screen and paste it here',
    TranslateKey:
      'Once the link has been copied go back to this screen and paste it here',
  },
  {
    LID: '3',
    TranslateData:
      'Une fois le lien copié revenez à cet écran et collez-le ici',
    TranslateKey:
      'Once the link has been copied go back to this screen and paste it here',
  },
  {
    LID: '4',
    TranslateData:
      'Как только ссылка будет скопирована, вернитесь на этот экран и вставьте ее сюда.',
    TranslateKey:
      'Once the link has been copied go back to this screen and paste it here',
  },
  { LID: '1', TranslateData: 'אישור', TranslateKey: 'OK' },
  { LID: '2', TranslateData: 'OK', TranslateKey: 'OK' },
  { LID: '3', TranslateData: "d'accord", TranslateKey: 'OK' },
  { LID: '4', TranslateData: 'Ok', TranslateKey: 'OK' },
  { LID: '1', TranslateData: 'טלפון בעבודה', TranslateKey: 'Office phone' },
  { LID: '2', TranslateData: 'Office phone', TranslateKey: 'Office phone' },
  {
    LID: '3',
    TranslateData: 'Téléphone de bureau',
    TranslateKey: 'Office phone',
  },
  { LID: '4', TranslateData: 'Офисный телефон', TranslateKey: 'Office phone' },
  { LID: '1', TranslateData: 'עותק במשרד', TranslateKey: 'Office copy' },
  {
    LID: '2',
    TranslateData: 'Duplicate copy at office',
    TranslateKey: 'Office copy',
  },
  {
    LID: '3',
    TranslateData: 'Copie en double au bureau',
    TranslateKey: 'Office copy',
  },
  { LID: '4', TranslateData: 'Дубликат в офисе', TranslateKey: 'Office copy' },
  { LID: '1', TranslateData: 'באפליקציה', TranslateKey: 'of the application' },
  {
    LID: '2',
    TranslateData: 'of the application',
    TranslateKey: 'of the application',
  },
  {
    LID: '3',
    TranslateData: "de l'application",
    TranslateKey: 'of the application',
  },
  { LID: '4', TranslateData: 'приложения', TranslateKey: 'of the application' },
  { LID: '1', TranslateData: 'אוקטובר', TranslateKey: 'October' },
  { LID: '2', TranslateData: 'October', TranslateKey: 'October' },
  { LID: '3', TranslateData: 'Octobre', TranslateKey: 'October' },
  { LID: '4', TranslateData: 'Октябрь', TranslateKey: 'October' },
  { LID: '1', TranslateData: 'אוקטובר', TranslateKey: 'Oct' },
  { LID: '2', TranslateData: 'Oct', TranslateKey: 'Oct' },
  { LID: '3', TranslateData: 'Oct', TranslateKey: 'Oct' },
  { LID: '4', TranslateData: 'октябрь', TranslateKey: 'Oct' },
  {
    LID: '1',
    TranslateData: 'תפוסת חדר דיירים',
    TranslateKey: "Occupancy of a tenants' room",
  },
  {
    LID: '2',
    TranslateData: "Occupancy of a tenants' room",
    TranslateKey: "Occupancy of a tenants' room",
  },
  {
    LID: '3',
    TranslateData: "Occupation d'une chambre de locataires",
    TranslateKey: "Occupancy of a tenants' room",
  },
  {
    LID: '4',
    TranslateData: 'Заполняемость комнаты арендаторов',
    TranslateKey: "Occupancy of a tenants' room",
  },
  {
    LID: '1',
    TranslateData: 'מספר דירות',
    TranslateKey: 'Number of apartments',
  },
  {
    LID: '2',
    TranslateData: 'Number of apartments',
    TranslateKey: 'Number of apartments',
  },
  {
    LID: '3',
    TranslateData: 'Nombre d’appartements',
    TranslateKey: 'Number of apartments',
  },
  {
    LID: '4',
    TranslateData: 'Количество квартир',
    TranslateKey: 'Number of apartments',
  },
  { LID: '1', TranslateData: "מס'", TranslateKey: 'num' },
  { LID: '2', TranslateData: 'num', TranslateKey: 'num' },
  { LID: '3', TranslateData: 'nombre', TranslateKey: 'num' },
  { LID: '4', TranslateData: 'число', TranslateKey: 'num' },
  { LID: '1', TranslateData: 'נובמבר', TranslateKey: 'November' },
  { LID: '2', TranslateData: 'November', TranslateKey: 'November' },
  { LID: '3', TranslateData: 'Novembre', TranslateKey: 'November' },
  { LID: '4', TranslateData: 'ноябрь', TranslateKey: 'November' },
  { LID: '1', TranslateData: 'נובמבר', TranslateKey: 'Nov' },
  { LID: '2', TranslateData: 'Nov', TranslateKey: 'Nov' },
  { LID: '3', TranslateData: 'Nov', TranslateKey: 'Nov' },
  { LID: '4', TranslateData: 'ноябрь', TranslateKey: 'Nov' },
  {
    LID: '1',
    TranslateData:
      "שים לב: יש בדיקות בסטטוס 'לא נבדק' האם להמשיך בשליחה לועד ? ",
    TranslateKey:
      "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?",
  },
  {
    LID: '2',
    TranslateData:
      "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?",
    TranslateKey:
      "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?",
  },
  {
    LID: '3',
    TranslateData:
      'Remarque : Certains tests ont le statut « Non coché ». Dois-je continuer à envoyer au comité?',
    TranslateKey:
      "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?",
  },
  {
    LID: '4',
    TranslateData:
      'Примечание. Есть тесты со статусом «Не проверено». Должен ли я продолжать посылать в комитет?',
    TranslateKey:
      "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?",
  },
  {
    LID: '1',
    TranslateData: 'שים לב: לא כל הבדיקות הסתיימו, האם להמשיך ?',
    TranslateKey: 'Note: Not all tests have been completed, should continue?',
  },
  {
    LID: '2',
    TranslateData: 'Note: Not all tests have been completed, should continue?',
    TranslateKey: 'Note: Not all tests have been completed, should continue?',
  },
  {
    LID: '3',
    TranslateData:
      'Remarque : tous les tests ne sont pas terminés, faut-il continuer ?',
    TranslateKey: 'Note: Not all tests have been completed, should continue?',
  },
  {
    LID: '4',
    TranslateData: 'Примечание. Не все тесты завершены, следует продолжить?',
    TranslateKey: 'Note: Not all tests have been completed, should continue?',
  },
  { LID: '1', TranslateData: 'לתשומת לבך', TranslateKey: 'Note that' },
  { LID: '2', TranslateData: 'Please note that', TranslateKey: 'Note that' },
  { LID: '3', TranslateData: 'Veuillez noter que', TranslateKey: 'Note that' },
  {
    LID: '4',
    TranslateData: 'Обратите внимание, что',
    TranslateKey: 'Note that',
  },
  {
    LID: '1',
    TranslateData: 'עדיין לא רשום לאפליקציה שלנו?',
    TranslateKey: 'Not yet registered',
  },
  {
    LID: '2',
    TranslateData: 'Not yet registered for our app?',
    TranslateKey: 'Not yet registered',
  },
  {
    LID: '3',
    TranslateData: 'Vous n’êtes pas encore inscrit dans notre application?',
    TranslateKey: 'Not yet registered',
  },
  {
    LID: '4',
    TranslateData: 'Еще не зарегистрированы в нашем приложении?',
    TranslateKey: 'Not yet registered',
  },
  { LID: '1', TranslateData: 'פתוח', TranslateKey: 'Not Tupal' },
  { LID: '2', TranslateData: 'Open', TranslateKey: 'Not Tupal' },
  { LID: '3', TranslateData: 'Ouvrir', TranslateKey: 'Not Tupal' },
  { LID: '4', TranslateData: 'Открыть', TranslateKey: 'Not Tupal' },
  { LID: '1', TranslateData: 'לא התבצע', TranslateKey: 'not performed' },
  { LID: '2', TranslateData: 'not performed', TranslateKey: 'not performed' },
  { LID: '3', TranslateData: 'pas effectué', TranslateKey: 'not performed' },
  { LID: '4', TranslateData: 'Не выполнена', TranslateKey: 'not performed' },
  { LID: '1', TranslateData: 'לא שווה', TranslateKey: 'Not equals' },
  { LID: '2', TranslateData: 'Not equals', TranslateKey: 'Not equals' },
  { LID: '3', TranslateData: 'Pas égal', TranslateKey: 'Not equals' },
  { LID: '4', TranslateData: 'Не равно', TranslateKey: 'Not equals' },
  { LID: '1', TranslateData: 'לא מכיל', TranslateKey: 'Not contains' },
  { LID: '2', TranslateData: 'Not contains', TranslateKey: 'Not contains' },
  { LID: '3', TranslateData: 'Ne contient pas', TranslateKey: 'Not contains' },
  { LID: '4', TranslateData: 'Не содержит', TranslateKey: 'Not contains' },
  { LID: '1', TranslateData: "מס'", TranslateKey: 'No.' },
  { LID: '2', TranslateData: 'No.', TranslateKey: 'No.' },
  { LID: '3', TranslateData: 'Non.', TranslateKey: 'No.' },
  { LID: '4', TranslateData: 'Нет.', TranslateKey: 'No.' },
  {
    LID: '1',
    TranslateData: 'לא קיים ערך בשדה',
    TranslateKey: 'No value exists in the field',
  },
  {
    LID: '2',
    TranslateData: 'No value exists in the field',
    TranslateKey: 'No value exists in the field',
  },
  {
    LID: '3',
    TranslateData: "Aucune valeur n'existe dans le champ",
    TranslateKey: 'No value exists in the field',
  },
  {
    LID: '4',
    TranslateData: 'В поле нет значения',
    TranslateKey: 'No value exists in the field',
  },
  { LID: '1', TranslateData: 'לא תודה', TranslateKey: 'No Thanks' },
  { LID: '2', TranslateData: 'No thanks', TranslateKey: 'No Thanks' },
  { LID: '3', TranslateData: 'Non merci', TranslateKey: 'No Thanks' },
  { LID: '4', TranslateData: 'Нет, спасибо', TranslateKey: 'No Thanks' },
  {
    LID: '1',
    TranslateData: 'לא הוגדרו ספקים לבניין',
    TranslateKey: 'No suppliers were defined for the building',
  },
  {
    LID: '2',
    TranslateData: 'No suppliers were defined for the building',
    TranslateKey: 'No suppliers were defined for the building',
  },
  {
    LID: '3',
    TranslateData: "Aucun fournisseur n'a été défini pour le bâtiment",
    TranslateKey: 'No suppliers were defined for the building',
  },
  {
    LID: '4',
    TranslateData: 'Поставщики для здания не определены',
    TranslateKey: 'No suppliers were defined for the building',
  },
  {
    LID: '1',
    TranslateData: 'לא נמצאו תוצאות',
    TranslateKey: 'No results found',
  },
  {
    LID: '2',
    TranslateData: 'No results found',
    TranslateKey: 'No results found',
  },
  {
    LID: '3',
    TranslateData: 'Aucun résultat trouvé',
    TranslateKey: 'No results found',
  },
  {
    LID: '4',
    TranslateData: 'результатов не найдено',
    TranslateKey: 'No results found',
  },
  {
    LID: '1',
    TranslateData: 'לא צורפו תמונות',
    TranslateKey: 'No photos were attached for this reading',
  },
  {
    LID: '2',
    TranslateData: 'No photos were attached',
    TranslateKey: 'No photos were attached for this reading',
  },
  {
    LID: '3',
    TranslateData: "Aucune photo n'a été jointe",
    TranslateKey: 'No photos were attached for this reading',
  },
  {
    LID: '4',
    TranslateData: 'Фотографии не прикреплены',
    TranslateKey: 'No photos were attached for this reading',
  },
  {
    LID: '1',
    TranslateData: 'לא ניתן לקבוע יותר אירועים עתידיים לדירה זו',
    TranslateKey: 'No more future events can be scheduled for this apartment',
  },
  {
    LID: '2',
    TranslateData: 'No more events can be scheduled for this apartment',
    TranslateKey: 'No more future events can be scheduled for this apartment',
  },
  {
    LID: '3',
    TranslateData:
      'Aucun autre événement ne peut être programmé pour cet appartement',
    TranslateKey: 'No more future events can be scheduled for this apartment',
  },
  {
    LID: '4',
    TranslateData: 'Для этой квартиры больше нельзя запланировать мероприятия.',
    TranslateKey: 'No more future events can be scheduled for this apartment',
  },
  { LID: '1', TranslateData: 'אין הודעות', TranslateKey: 'No messages' },
  { LID: '2', TranslateData: 'No messages', TranslateKey: 'No messages' },
  { LID: '3', TranslateData: 'Pas de messages', TranslateKey: 'No messages' },
  { LID: '4', TranslateData: 'Нет сообщений', TranslateKey: 'No messages' },
  {
    LID: '1',
    TranslateData: 'לא נשלחה הודעה',
    TranslateKey: 'No message was sent',
  },
  {
    LID: '2',
    TranslateData: 'No message was sent',
    TranslateKey: 'No message was sent',
  },
  {
    LID: '3',
    TranslateData: "Aucun message n'a été envoyé",
    TranslateKey: 'No message was sent',
  },
  {
    LID: '4',
    TranslateData: 'Сообщение не было отправлено',
    TranslateKey: 'No message was sent',
  },
  { LID: '1', TranslateData: 'בלי פריטים', TranslateKey: 'No items' },
  { LID: '2', TranslateData: 'No items', TranslateKey: 'No items' },
  { LID: '3', TranslateData: "Pas d'objet", TranslateKey: 'No items' },
  { LID: '4', TranslateData: 'Нет товаров', TranslateKey: 'No items' },
  { LID: '1', TranslateData: 'ללא מסנן', TranslateKey: 'No Filter' },
  { LID: '2', TranslateData: 'No Filter', TranslateKey: 'No Filter' },
  { LID: '3', TranslateData: 'Pas de filtre', TranslateKey: 'No Filter' },
  { LID: '4', TranslateData: 'Нет фильтра', TranslateKey: 'No Filter' },
  {
    LID: '1',
    TranslateData: 'לא נרשמו הוצאות',
    TranslateKey: 'No expenses were recorded for this reading',
  },
  {
    LID: '2',
    TranslateData: 'No expenses were listed',
    TranslateKey: 'No expenses were recorded for this reading',
  },
  {
    LID: '3',
    TranslateData: "Aucune dépense n'a été indiquée",
    TranslateKey: 'No expenses were recorded for this reading',
  },
  {
    LID: '4',
    TranslateData: 'Расходы не указаны',
    TranslateKey: 'No expenses were recorded for this reading',
  },
  {
    LID: '1',
    TranslateData: 'לא נמצאו הוצאות לקריאה זו',
    TranslateKey: 'No expenses were found for this reading',
  },
  {
    LID: '2',
    TranslateData: 'No expenses were found for this reading',
    TranslateKey: 'No expenses were found for this reading',
  },
  {
    LID: '3',
    TranslateData: "Aucune dépense n'a été trouvée pour cette lecture",
    TranslateKey: 'No expenses were found for this reading',
  },
  {
    LID: '4',
    TranslateData: 'Расходов по этому чтению не найдено',
    TranslateKey: 'No expenses were found for this reading',
  },
  {
    LID: '1',
    TranslateData: 'לא קיימת כתובת מייל לשליחת הקוד. הקוד נשלח בשיחת טלפון.',
    TranslateKey: 'no email. sending code by phone',
  },
  {
    LID: '2',
    TranslateData:
      'There is no email address for sending the code. The code was sent in a phone call.',
    TranslateKey: 'no email. sending code by phone',
  },
  {
    LID: '3',
    TranslateData:
      "Il n'y a pas d'adresse e-mail pour envoyer le code. Le code a été envoyé lors d'un appel téléphonique.",
    TranslateKey: 'no email. sending code by phone',
  },
  {
    LID: '4',
    TranslateData:
      'Нет адреса электронной почты для отправки кода. Код был отправлен в телефонном звонке.',
    TranslateKey: 'no email. sending code by phone',
  },
  { LID: '1', TranslateData: '---', TranslateKey: 'No data exists' },
  { LID: '2', TranslateData: '---', TranslateKey: 'No data exists' },
  { LID: '3', TranslateData: '---', TranslateKey: 'No data exists' },
  { LID: '4', TranslateData: '---', TranslateKey: 'No data exists' },
  { LID: '1', TranslateData: 'אין נתונים להצגה', TranslateKey: 'No data' },
  { LID: '2', TranslateData: 'No data to display', TranslateKey: 'No data' },
  {
    LID: '3',
    TranslateData: 'aucune donnée à afficher',
    TranslateKey: 'No data',
  },
  {
    LID: '4',
    TranslateData: 'Нет данных для отображения',
    TranslateKey: 'No data',
  },
  {
    LID: '1',
    TranslateData: 'אין אפשרויות זמינות',
    TranslateKey: 'No available options',
  },
  {
    LID: '2',
    TranslateData: 'No available options',
    TranslateKey: 'No available options',
  },
  {
    LID: '3',
    TranslateData: 'Aucune option disponible',
    TranslateKey: 'No available options',
  },
  {
    LID: '4',
    TranslateData: 'Нет доступных вариантов',
    TranslateKey: 'No available options',
  },
  { LID: '1', TranslateData: 'ללא שיוך', TranslateKey: 'No association' },
  { LID: '2', TranslateData: 'Not associated', TranslateKey: 'No association' },
  { LID: '3', TranslateData: 'Pas associé', TranslateKey: 'No association' },
  { LID: '4', TranslateData: 'Не связано', TranslateKey: 'No association' },
  { LID: '1', TranslateData: 'לא', TranslateKey: 'No' },
  { LID: '2', TranslateData: 'No', TranslateKey: 'No' },
  { LID: '3', TranslateData: 'Non', TranslateKey: 'No' },
  { LID: '4', TranslateData: 'Нет', TranslateKey: 'No' },
  {
    LID: '1',
    TranslateData: 'חדש!! פתיחת שער החניון מהאפליקציה',
    TranslateKey: 'New! Opening the parking lot gate from the app',
  },
  {
    LID: '2',
    TranslateData: 'New!! Opening the parking lot gate from the app',
    TranslateKey: 'New! Opening the parking lot gate from the app',
  },
  {
    LID: '3',
    TranslateData:
      "Nouvelle!! Ouverture de la porte du parking depuis l'application",
    TranslateKey: 'New! Opening the parking lot gate from the app',
  },
  {
    LID: '4',
    TranslateData: 'Новый!! Открытие ворот парковки из приложения',
    TranslateKey: 'New! Opening the parking lot gate from the app',
  },
  { LID: '1', TranslateData: 'קריאה חדשה', TranslateKey: 'New reading' },
  { LID: '2', TranslateData: 'New reading', TranslateKey: 'New reading' },
  { LID: '3', TranslateData: 'Nouvelle lecture', TranslateKey: 'New reading' },
  { LID: '4', TranslateData: 'Новое чтение', TranslateKey: 'New reading' },
  { LID: '1', TranslateData: 'הודעה חדשה', TranslateKey: 'New message' },
  { LID: '2', TranslateData: 'New message', TranslateKey: 'New message' },
  { LID: '3', TranslateData: 'Nouveau message', TranslateKey: 'New message' },
  { LID: '4', TranslateData: 'Новое сообщение', TranslateKey: 'New message' },
  {
    LID: '1',
    TranslateData: 'הדייר נוסף בהצלחה',
    TranslateKey: 'new contact added',
  },
  {
    LID: '2',
    TranslateData: 'new contact added',
    TranslateKey: 'new contact added',
  },
  {
    LID: '3',
    TranslateData: 'nouveau contact ajouté',
    TranslateKey: 'new contact added',
  },
  {
    LID: '4',
    TranslateData: 'добавлен новый контакт',
    TranslateKey: 'new contact added',
  },
  { LID: '1', TranslateData: 'הכנסות נטו', TranslateKey: 'Net Income' },
  { LID: '2', TranslateData: 'Net Income', TranslateKey: 'Net Income' },
  { LID: '3', TranslateData: 'Revenu net', TranslateKey: 'Net Income' },
  { LID: '4', TranslateData: 'Чистая прибыль', TranslateKey: 'Net Income' },
  { LID: '1', TranslateData: 'שם הספק ', TranslateKey: 'Name of supplier' },
  {
    LID: '2',
    TranslateData: 'Name of service provider',
    TranslateKey: 'Name of supplier',
  },
  {
    LID: '3',
    TranslateData: 'Nom du fournisseur de services',
    TranslateKey: 'Name of supplier',
  },
  {
    LID: '4',
    TranslateData: 'Название поставщика услуг',
    TranslateKey: 'Name of supplier',
  },
  { LID: '1', TranslateData: 'שם חובה', TranslateKey: 'Name is required' },
  {
    LID: '2',
    TranslateData: 'Name is required',
    TranslateKey: 'Name is required',
  },
  {
    LID: '3',
    TranslateData: 'Le nom est requis',
    TranslateKey: 'Name is required',
  },
  { LID: '4', TranslateData: 'Укажите имя', TranslateKey: 'Name is required' },
  { LID: '1', TranslateData: 'שם', TranslateKey: 'Name' },
  { LID: '2', TranslateData: 'Name', TranslateKey: 'Name' },
  { LID: '3', TranslateData: 'Nom', TranslateKey: 'Name' },
  { LID: '4', TranslateData: 'Имя', TranslateKey: 'Name' },
  { LID: '1', TranslateData: 'התשלומים שלי', TranslateKey: 'My Payments' },
  { LID: '2', TranslateData: 'My Payments', TranslateKey: 'My Payments' },
  { LID: '3', TranslateData: 'Mes paiements', TranslateKey: 'My Payments' },
  { LID: '4', TranslateData: 'Мои платежи', TranslateKey: 'My Payments' },
  { LID: '1', TranslateData: 'קריאות שלי', TranslateKey: 'My calls' },
  { LID: '2', TranslateData: 'My calls', TranslateKey: 'My calls' },
  { LID: '3', TranslateData: 'Mes appels', TranslateKey: 'My calls' },
  { LID: '4', TranslateData: 'Мои звонки', TranslateKey: 'My calls' },
  { LID: '1', TranslateData: 'מידע נוסף', TranslateKey: 'More info' },
  { LID: '2', TranslateData: 'More info', TranslateKey: 'More info' },
  { LID: '3', TranslateData: "Plus d'informations", TranslateKey: 'More info' },
  { LID: '4', TranslateData: 'Больше информации', TranslateKey: 'More info' },
  { LID: '1', TranslateData: 'פרטים נוספים', TranslateKey: 'More details' },
  { LID: '2', TranslateData: 'More details', TranslateKey: 'More details' },
  { LID: '3', TranslateData: 'Plus de détails', TranslateKey: 'More details' },
  { LID: '4', TranslateData: 'Подробнее', TranslateKey: 'More details' },
  { LID: '1', TranslateData: 'קופה קטנה', TranslateKey: 'Money Petty Cash' },
  {
    LID: '2',
    TranslateData: 'Money Petty Cash',
    TranslateKey: 'Money Petty Cash',
  },
  {
    LID: '3',
    TranslateData: 'Argent Petite Caisse',
    TranslateKey: 'Money Petty Cash',
  },
  {
    LID: '4',
    TranslateData: 'Деньги Мелкая наличность',
    TranslateKey: 'Money Petty Cash',
  },
  { LID: '1', TranslateData: 'שני', TranslateKey: 'Monday' },
  { LID: '2', TranslateData: 'Monday', TranslateKey: 'Monday' },
  { LID: '3', TranslateData: 'Lundi', TranslateKey: 'Monday' },
  { LID: '4', TranslateData: 'Понедельник', TranslateKey: 'Monday' },
  { LID: '1', TranslateData: 'ב', TranslateKey: 'Mon' },
  { LID: '2', TranslateData: 'Mo', TranslateKey: 'Mon' },
  { LID: '3', TranslateData: 'Mo', TranslateKey: 'Mon' },
  { LID: '4', TranslateData: 'Пн', TranslateKey: 'Mon' },
  { LID: '1', TranslateData: 'נייד', TranslateKey: 'Mobile' },
  { LID: '2', TranslateData: 'Mobile', TranslateKey: 'Mobile' },
  { LID: '3', TranslateData: 'Mobile', TranslateKey: 'Mobile' },
  { LID: '4', TranslateData: 'Мобильный', TranslateKey: 'Mobile' },
  { LID: '1', TranslateData: 'ב', TranslateKey: 'Mo' },
  { LID: '2', TranslateData: 'Mo', TranslateKey: 'Mo' },
  { LID: '3', TranslateData: 'Mo', TranslateKey: 'Mo' },
  { LID: '4', TranslateData: 'Пн', TranslateKey: 'Mo' },
  { LID: '1', TranslateData: 'מייל', TranslateKey: 'Miles' },
  { LID: '2', TranslateData: 'Miles', TranslateKey: 'Miles' },
  { LID: '3', TranslateData: 'Milles', TranslateKey: 'Miles' },
  { LID: '4', TranslateData: 'Майлз', TranslateKey: 'Miles' },
  {
    LID: '1',
    TranslateData: 'אמצעי תשלום ',
    TranslateKey: 'Methods of payment',
  },
  {
    LID: '2',
    TranslateData: 'Payment method',
    TranslateKey: 'Methods of payment',
  },
  {
    LID: '3',
    TranslateData: 'Mode de paiement',
    TranslateKey: 'Methods of payment',
  },
  {
    LID: '4',
    TranslateData: 'Способ оплаты',
    TranslateKey: 'Methods of payment',
  },
  {
    LID: '1',
    TranslateData: 'הודעה נשלחה בהצלחה',
    TranslateKey: 'message was sent successfully',
  },
  {
    LID: '2',
    TranslateData: 'Message was sent successfully',
    TranslateKey: 'message was sent successfully',
  },
  {
    LID: '3',
    TranslateData: 'message a été envoyé avec succès',
    TranslateKey: 'message was sent successfully',
  },
  {
    LID: '4',
    TranslateData: 'Сообщение успешно отправлено',
    TranslateKey: 'message was sent successfully',
  },
  { LID: '1', TranslateData: 'תוכן ההודעה', TranslateKey: 'Message content' },
  {
    LID: '2',
    TranslateData: 'Message content',
    TranslateKey: 'Message content',
  },
  {
    LID: '3',
    TranslateData: 'Contenu du message',
    TranslateKey: 'Message content',
  },
  {
    LID: '4',
    TranslateData: 'Содержание сообщения',
    TranslateKey: 'Message content',
  },
  { LID: '1', TranslateData: 'תפריט', TranslateKey: 'Menu' },
  { LID: '2', TranslateData: 'Menu', TranslateKey: 'Menu' },
  { LID: '3', TranslateData: 'Menu', TranslateKey: 'Menu' },
  { LID: '4', TranslateData: 'Меню', TranslateKey: 'Menu' },
  { LID: '1', TranslateData: 'בינוני', TranslateKey: 'Medium' },
  { LID: '2', TranslateData: 'Medium', TranslateKey: 'Medium' },
  { LID: '3', TranslateData: 'Moyen', TranslateKey: 'Medium' },
  { LID: '4', TranslateData: 'Середина', TranslateKey: 'Medium' },
  { LID: '1', TranslateData: 'מאי', TranslateKey: 'May' },
  { LID: '2', TranslateData: 'May', TranslateKey: 'May' },
  { LID: '3', TranslateData: 'Peut', TranslateKey: 'May' },
  { LID: '4', TranslateData: 'Мая', TranslateKey: 'May' },
  {
    LID: '1',
    TranslateData: 'חרגת ממספר הקבצים המרבי, המגבלה היא {0} לכל היותר.',
    TranslateKey: 'Maximum number of files exceeded, limit is {0} at most.',
  },
  {
    LID: '2',
    TranslateData: 'Maximum number of files exceeded, limit is {0} at most.',
    TranslateKey: 'Maximum number of files exceeded, limit is {0} at most.',
  },
  {
    LID: '3',
    TranslateData:
      'Nombre maximal de fichiers dépassé, la limite est de {0} au maximum.',
    TranslateKey: 'Maximum number of files exceeded, limit is {0} at most.',
  },
  {
    LID: '4',
    TranslateData:
      'Превышено максимальное количество файлов, ограничение не более {0}.',
    TranslateKey: 'Maximum number of files exceeded, limit is {0} at most.',
  },
  { LID: '1', TranslateData: 'להתאים לכל', TranslateKey: 'Match Any' },
  { LID: '2', TranslateData: 'Match Any', TranslateKey: 'Match Any' },
  {
    LID: '3',
    TranslateData: "Correspondre à n'importe quel",
    TranslateKey: 'Match Any',
  },
  { LID: '4', TranslateData: 'Совпадение с любым', TranslateKey: 'Match Any' },
  { LID: '1', TranslateData: 'התאם הכל', TranslateKey: 'Match All' },
  { LID: '2', TranslateData: 'Match All', TranslateKey: 'Match All' },
  { LID: '3', TranslateData: 'Tout correspondre', TranslateKey: 'Match All' },
  { LID: '4', TranslateData: 'Сопоставить все', TranslateKey: 'Match All' },
  { LID: '1', TranslateData: 'מרץ', TranslateKey: 'March' },
  { LID: '2', TranslateData: 'March', TranslateKey: 'March' },
  { LID: '3', TranslateData: 'Mars', TranslateKey: 'March' },
  { LID: '4', TranslateData: 'марш', TranslateKey: 'March' },
  { LID: '1', TranslateData: 'מרס', TranslateKey: 'Mar' },
  { LID: '2', TranslateData: 'Mar', TranslateKey: 'Mar' },
  { LID: '3', TranslateData: 'Mar', TranslateKey: 'Mar' },
  { LID: '4', TranslateData: 'март', TranslateKey: 'Mar' },
  {
    LID: '1',
    TranslateData: 'שם חברת הניהול',
    TranslateKey: 'Managment Company:',
  },
  {
    LID: '2',
    TranslateData: 'Managment company',
    TranslateKey: 'Managment Company:',
  },
  {
    LID: '3',
    TranslateData: 'Société de gestion',
    TranslateKey: 'Managment Company:',
  },
  {
    LID: '4',
    TranslateData: 'Управляющая компания',
    TranslateKey: 'Managment Company:',
  },
  { LID: '1', TranslateData: 'סוג ניהול', TranslateKey: 'Management type' },
  {
    LID: '2',
    TranslateData: 'Management type',
    TranslateKey: 'Management type',
  },
  {
    LID: '3',
    TranslateData: 'Type de gestion',
    TranslateKey: 'Management type',
  },
  {
    LID: '4',
    TranslateData: 'Тип управления',
    TranslateKey: 'Management type',
  },
  {
    LID: '1',
    TranslateData: 'ניהול אמצעי תשלום',
    TranslateKey: 'Management of payment methods',
  },
  {
    LID: '2',
    TranslateData: 'Management of payment methods',
    TranslateKey: 'Management of payment methods',
  },
  {
    LID: '3',
    TranslateData: 'Gestion des moyens de paiement',
    TranslateKey: 'Management of payment methods',
  },
  {
    LID: '4',
    TranslateData: 'Управление способами оплаты',
    TranslateKey: 'Management of payment methods',
  },
  {
    LID: '1',
    TranslateData: 'פרטי חברת ניהול',
    TranslateKey: 'Management company details',
  },
  {
    LID: '2',
    TranslateData: 'Management company details',
    TranslateKey: 'Management company details',
  },
  {
    LID: '3',
    TranslateData: 'Détails de la société de gestion',
    TranslateKey: 'Management company details',
  },
  {
    LID: '4',
    TranslateData: 'Реквизиты управляющей компании',
    TranslateKey: 'Management company details',
  },
  { LID: '1', TranslateData: 'חברת ניהול', TranslateKey: 'Management company' },
  {
    LID: '2',
    TranslateData: 'Management company',
    TranslateKey: 'Management company',
  },
  {
    LID: '3',
    TranslateData: 'Société de gestion',
    TranslateKey: 'Management company',
  },
  {
    LID: '4',
    TranslateData: 'Управляющая компания',
    TranslateKey: 'Management company',
  },
  {
    LID: '1',
    TranslateData:
      'וודא שכתובת הדוא"ל תקינה ונסה שנית, או פנה לחברת הניהול לקבלת המסמך.',
    TranslateKey:
      'Make sure the email address is correct and try again, or contact the management company for the document.',
  },
  {
    LID: '2',
    TranslateData:
      'Make sure the email address is correct and try again, or contact the management company to receive the document.',
    TranslateKey:
      'Make sure the email address is correct and try again, or contact the management company for the document.',
  },
  {
    LID: '3',
    TranslateData:
      "Assurez-vous que l'adresse e-mail est correcte et réessayez, ou contactez la société de gestion pour recevoir le document.",
    TranslateKey:
      'Make sure the email address is correct and try again, or contact the management company for the document.',
  },
  {
    LID: '4',
    TranslateData:
      'Убедитесь, что адрес электронной почты верен и попробуйте еще раз, либо обратитесь в управляющую компанию для получения документа.',
    TranslateKey:
      'Make sure the email address is correct and try again, or contact the management company for the document.',
  },
  {
    LID: '1',
    TranslateData: 'תוכנית תחזוקה',
    TranslateKey: 'Maintenance plan',
  },
  {
    LID: '2',
    TranslateData: 'Maintenance plan',
    TranslateKey: 'Maintenance plan',
  },
  {
    LID: '3',
    TranslateData: 'Plan de maintenance',
    TranslateKey: 'Maintenance plan',
  },
  {
    LID: '4',
    TranslateData: 'План обслуживания',
    TranslateKey: 'Maintenance plan',
  },
  { LID: '1', TranslateData: 'תחום אחזקה', TranslateKey: 'Maintenance area' },
  {
    LID: '2',
    TranslateData: 'Maintenance category',
    TranslateKey: 'Maintenance area',
  },
  {
    LID: '3',
    TranslateData: "Catégorie d'entretien",
    TranslateKey: 'Maintenance area',
  },
  {
    LID: '4',
    TranslateData: 'Категория обслуживания',
    TranslateKey: 'Maintenance area',
  },
  { LID: '1', TranslateData: 'תחום אחזקה', TranslateKey: 'maintenance area' },
  {
    LID: '2',
    TranslateData: 'maintenance area',
    TranslateKey: 'maintenance area',
  },
  {
    LID: '3',
    TranslateData: "zone d'entretien",
    TranslateKey: 'maintenance area',
  },
  {
    LID: '4',
    TranslateData: 'зона обслуживания',
    TranslateKey: 'maintenance area',
  },
  {
    LID: '1',
    TranslateData: 'מתקנים ותחזוקה',
    TranslateKey: 'Maintenance and facilities',
  },
  {
    LID: '2',
    TranslateData: 'Maintenance and facilities',
    TranslateKey: 'Maintenance and facilities',
  },
  {
    LID: '3',
    TranslateData: 'Entretien et installations',
    TranslateKey: 'Maintenance and facilities',
  },
  {
    LID: '4',
    TranslateData: 'Техническое обслуживание и удобства',
    TranslateKey: 'Maintenance and facilities',
  },
  { LID: '1', TranslateData: 'תחום ראשי', TranslateKey: 'Main domain' },
  { LID: '2', TranslateData: 'Main domain', TranslateKey: 'Main domain' },
  { LID: '3', TranslateData: 'Domaine principal', TranslateKey: 'Main domain' },
  { LID: '4', TranslateData: 'Основной домен', TranslateKey: 'Main domain' },
  { LID: '1', TranslateData: 'איש קשר ראשי', TranslateKey: 'Main contact' },
  { LID: '2', TranslateData: 'Main contact', TranslateKey: 'Main contact' },
  {
    LID: '3',
    TranslateData: 'Contact principal',
    TranslateKey: 'Main contact',
  },
  { LID: '4', TranslateData: 'Основной контакт', TranslateKey: 'Main contact' },
  {
    LID: '1',
    TranslateData: 'פרטי דואר שמורים',
    TranslateKey: 'Mail items List',
  },
  {
    LID: '2',
    TranslateData: 'E-mail details are reserved',
    TranslateKey: 'Mail items List',
  },
  {
    LID: '3',
    TranslateData: 'Les coordonnées e-mail sont réservées',
    TranslateKey: 'Mail items List',
  },
  {
    LID: '4',
    TranslateData: 'Электронная почта зарезервирована',
    TranslateKey: 'Mail items List',
  },
  { LID: '1', TranslateData: 'מייל חובה', TranslateKey: 'Mail is required' },
  {
    LID: '2',
    TranslateData: 'Mail is required',
    TranslateKey: 'Mail is required',
  },
  {
    LID: '3',
    TranslateData: 'Le courrier est requis',
    TranslateKey: 'Mail is required',
  },
  {
    LID: '4',
    TranslateData: 'Требуется почта',
    TranslateKey: 'Mail is required',
  },
  { LID: '1', TranslateData: 'דוא"ל', TranslateKey: 'Mail' },
  { LID: '2', TranslateData: 'Email', TranslateKey: 'Mail' },
  { LID: '3', TranslateData: 'E-mail', TranslateKey: 'Mail' },
  { LID: '4', TranslateData: 'Электронное письмо', TranslateKey: 'Mail' },
  { LID: '1', TranslateData: 'מ<sup>2</sup>', TranslateKey: 'm<sup>2</sup>' },
  { LID: '2', TranslateData: 'm<sup>2</sup>', TranslateKey: 'm<sup>2</sup>' },
  { LID: '3', TranslateData: 'm<sup>2</sup>', TranslateKey: 'm<sup>2</sup>' },
  {
    LID: '4',
    TranslateData: 'м <sup> 2 </sup>',
    TranslateKey: 'm<sup>2</sup>',
  },
  { LID: '1', TranslateData: 'מ-', TranslateKey: 'M-' },
  { LID: '2', TranslateData: 'From -', TranslateKey: 'M-' },
  { LID: '3', TranslateData: 'De -', TranslateKey: 'M-' },
  { LID: '4', TranslateData: 'От -', TranslateKey: 'M-' },
  {
    LID: '1',
    TranslateData: 'פעולת הכניסה נכשלה',
    TranslateKey: 'Login failed',
  },
  { LID: '2', TranslateData: 'Login failed', TranslateKey: 'Login failed' },
  {
    LID: '3',
    TranslateData: 'Échec de la connexion',
    TranslateKey: 'Login failed',
  },
  {
    LID: '4',
    TranslateData: 'Вход в систему не удался',
    TranslateKey: 'Login failed',
  },
  { LID: '1', TranslateData: 'שגיאה בהתחברות', TranslateKey: 'Login error' },
  { LID: '2', TranslateData: 'Login error', TranslateKey: 'Login error' },
  {
    LID: '3',
    TranslateData: "Erreur d'identification",
    TranslateKey: 'Login error',
  },
  { LID: '4', TranslateData: 'Ошибка входа', TranslateKey: 'Login error' },
  { LID: '1', TranslateData: 'הגבל לתאריך', TranslateKey: 'Limit to date' },
  { LID: '2', TranslateData: 'Limit to date', TranslateKey: 'Limit to date' },
  {
    LID: '3',
    TranslateData: 'Limiter à ce jour',
    TranslateKey: 'Limit to date',
  },
  {
    LID: '4',
    TranslateData: 'Ограничить на дату',
    TranslateKey: 'Limit to date',
  },
  {
    LID: '1',
    TranslateData: 'פחות מ או שווה ל',
    TranslateKey: 'Less than or equal to',
  },
  {
    LID: '2',
    TranslateData: 'Less than or equal to',
    TranslateKey: 'Less than or equal to',
  },
  {
    LID: '3',
    TranslateData: 'Inférieur ou égal à',
    TranslateKey: 'Less than or equal to',
  },
  {
    LID: '4',
    TranslateData: 'Меньше или равно',
    TranslateKey: 'Less than or equal to',
  },
  { LID: '1', TranslateData: 'פחות מ', TranslateKey: 'Less than' },
  { LID: '2', TranslateData: 'Less than', TranslateKey: 'Less than' },
  { LID: '3', TranslateData: 'Moins que', TranslateKey: 'Less than' },
  { LID: '4', TranslateData: 'Меньше, чем', TranslateKey: 'Less than' },
  { LID: '1', TranslateData: 'משפטי', TranslateKey: 'Legal' },
  { LID: '2', TranslateData: 'Legal', TranslateKey: 'Legal' },
  { LID: '3', TranslateData: 'Légal', TranslateKey: 'Legal' },
  { LID: '4', TranslateData: 'Юридический', TranslateKey: 'Legal' },
  {
    LID: '1',
    TranslateData: 'תאריך ביקור אחרון שונה בהצלחה',
    TranslateKey: 'Last visit date successfully changed',
  },
  {
    LID: '2',
    TranslateData: 'Last visit date successfully changed',
    TranslateKey: 'Last visit date successfully changed',
  },
  {
    LID: '3',
    TranslateData: 'La date de la dernière visite a bien été modifiée',
    TranslateKey: 'Last visit date successfully changed',
  },
  {
    LID: '4',
    TranslateData: 'Дата последнего посещения успешно изменена',
    TranslateKey: 'Last visit date successfully changed',
  },
  { LID: '1', TranslateData: 'ביקור אחרון', TranslateKey: 'Last Visit' },
  { LID: '2', TranslateData: 'Last Visit', TranslateKey: 'Last Visit' },
  { LID: '3', TranslateData: 'Derniere visite', TranslateKey: 'Last Visit' },
  {
    LID: '4',
    TranslateData: 'Последнее посещение',
    TranslateKey: 'Last Visit',
  },
  { LID: '1', TranslateData: 'עדכון אחרון', TranslateKey: 'Last update' },
  { LID: '2', TranslateData: 'Last update', TranslateKey: 'Last update' },
  {
    LID: '3',
    TranslateData: 'Dernière mise à jour',
    TranslateKey: 'Last update',
  },
  {
    LID: '4',
    TranslateData: 'Последнее обновление',
    TranslateKey: 'Last update',
  },
  {
    LID: '1',
    TranslateData: 'שם המשפחה חייב להיות באורך 2 תווים לפחות',
    TranslateKey: 'Last name must be at least 2 characters',
  },
  {
    LID: '2',
    TranslateData: 'Last name must be at least 2 characters',
    TranslateKey: 'Last name must be at least 2 characters',
  },
  {
    LID: '3',
    TranslateData: 'Le nom de famille doit comporter au moins 2 caractères',
    TranslateKey: 'Last name must be at least 2 characters',
  },
  {
    LID: '4',
    TranslateData: 'Фамилия должна быть не менее 2 символов',
    TranslateKey: 'Last name must be at least 2 characters',
  },
  { LID: '1', TranslateData: 'שם משפחה', TranslateKey: 'Last name' },
  { LID: '2', TranslateData: 'Last name', TranslateKey: 'Last name' },
  { LID: '3', TranslateData: 'Nom de famille', TranslateKey: 'Last name' },
  { LID: '4', TranslateData: 'Фамилия', TranslateKey: 'Last name' },
  {
    LID: '1',
    TranslateData: '4 ספרות אחרונות של הכרטיס:',
    TranslateKey: 'Last 4 digits of the card:',
  },
  {
    LID: '2',
    TranslateData: 'Card last 4 digits:',
    TranslateKey: 'Last 4 digits of the card:',
  },
  {
    LID: '3',
    TranslateData: 'Carte 4 derniers chiffres :',
    TranslateKey: 'Last 4 digits of the card:',
  },
  {
    LID: '4',
    TranslateData: 'Последние 4 цифры карты:',
    TranslateKey: 'Last 4 digits of the card:',
  },
  { LID: '1', TranslateData: 'שפה', TranslateKey: 'Language' },
  { LID: '2', TranslateData: 'Language', TranslateKey: 'Language' },
  { LID: '3', TranslateData: 'Langue', TranslateKey: 'Language' },
  { LID: '4', TranslateData: 'Язык', TranslateKey: 'Language' },
  { LID: '1', TranslateData: 'מפתחות שמורים', TranslateKey: 'Keys List' },
  { LID: '2', TranslateData: 'Keys are reserved', TranslateKey: 'Keys List' },
  {
    LID: '3',
    TranslateData: 'Les clés sont réservées',
    TranslateKey: 'Keys List',
  },
  {
    LID: '4',
    TranslateData: 'Ключи зарезервированы',
    TranslateKey: 'Keys List',
  },
  { LID: '1', TranslateData: 'סוג המפתח', TranslateKey: 'Key type' },
  { LID: '2', TranslateData: 'Key type', TranslateKey: 'Key type' },
  { LID: '3', TranslateData: 'Type de clé', TranslateKey: 'Key type' },
  { LID: '4', TranslateData: 'Тип ключа', TranslateKey: 'Key type' },
  {
    LID: '1',
    TranslateData: 'רוצה רק לפתוח שיחת שירות ?',
    TranslateKey: 'Just want to open a service call?',
  },
  {
    LID: '2',
    TranslateData: 'I Just want to open a service call',
    TranslateKey: 'Just want to open a service call?',
  },
  {
    LID: '3',
    TranslateData: 'Je veux juste ouvrir un appel de service',
    TranslateKey: 'Just want to open a service call?',
  },
  {
    LID: '4',
    TranslateData: 'Я просто хочу позвонить в сервисный центр',
    TranslateKey: 'Just want to open a service call?',
  },
  { LID: '1', TranslateData: 'יוני', TranslateKey: 'June' },
  { LID: '2', TranslateData: 'June', TranslateKey: 'June' },
  { LID: '3', TranslateData: 'juin', TranslateKey: 'June' },
  { LID: '4', TranslateData: 'июнь', TranslateKey: 'June' },
  { LID: '1', TranslateData: 'יוני', TranslateKey: 'Jun' },
  { LID: '2', TranslateData: 'Jun', TranslateKey: 'Jun' },
  { LID: '3', TranslateData: 'Juin', TranslateKey: 'Jun' },
  { LID: '4', TranslateData: 'июнь', TranslateKey: 'Jun' },
  { LID: '1', TranslateData: 'יולי', TranslateKey: 'July' },
  { LID: '2', TranslateData: 'July', TranslateKey: 'July' },
  { LID: '3', TranslateData: 'juillet', TranslateKey: 'July' },
  { LID: '4', TranslateData: 'июль', TranslateKey: 'July' },
  { LID: '1', TranslateData: 'יולי', TranslateKey: 'Jul' },
  { LID: '2', TranslateData: 'Jul', TranslateKey: 'Jul' },
  { LID: '3', TranslateData: 'Juil', TranslateKey: 'Jul' },
  { LID: '4', TranslateData: 'июль', TranslateKey: 'Jul' },
  { LID: '1', TranslateData: 'ינואר', TranslateKey: 'January' },
  { LID: '2', TranslateData: 'January', TranslateKey: 'January' },
  { LID: '3', TranslateData: 'janvier', TranslateKey: 'January' },
  { LID: '4', TranslateData: 'Январь', TranslateKey: 'January' },
  { LID: '1', TranslateData: 'ינואר', TranslateKey: 'Jan' },
  { LID: '2', TranslateData: 'Jan', TranslateKey: 'Jan' },
  { LID: '3', TranslateData: 'Jan', TranslateKey: 'Jan' },
  { LID: '4', TranslateData: 'Ян', TranslateKey: 'Jan' },
  { LID: '1', TranslateData: 'פריט', TranslateKey: 'Item' },
  { LID: '2', TranslateData: 'Item', TranslateKey: 'Item' },
  { LID: '3', TranslateData: 'Article', TranslateKey: 'Item' },
  { LID: '4', TranslateData: 'Элемент', TranslateKey: 'Item' },
  {
    LID: '1',
    TranslateData: 'לא ניתן לשלם בכרטיס אשראי של אמריקן אקספרס',
    TranslateKey:
      'It is not possible to pay with an American Express credit card',
  },
  {
    LID: '2',
    TranslateData: 'American Express card is not supported',
    TranslateKey:
      'It is not possible to pay with an American Express credit card',
  },
  {
    LID: '3',
    TranslateData: "La carte American Express n'est pas prise en charge",
    TranslateKey:
      'It is not possible to pay with an American Express credit card',
  },
  {
    LID: '4',
    TranslateData: 'Карта American Express не поддерживается',
    TranslateKey:
      'It is not possible to pay with an American Express credit card',
  },
  {
    LID: '1',
    TranslateData: 'לא ניתן להכניס פריט פעמיים',
    TranslateKey: 'It is not possible to insert an item twice',
  },
  {
    LID: '2',
    TranslateData: 'It is not possible to insert an item twice',
    TranslateKey: 'It is not possible to insert an item twice',
  },
  {
    LID: '3',
    TranslateData: "Il n'est pas possible d'insérer un élément deux fois",
    TranslateKey: 'It is not possible to insert an item twice',
  },
  {
    LID: '4',
    TranslateData: 'Невозможно вставить элемент дважды',
    TranslateKey: 'It is not possible to insert an item twice',
  },
  {
    LID: '1',
    TranslateData: 'יש לבחור אפשרות שמירת פרטי כרטיס אשראי',
    TranslateKey:
      'It is mandatory to choose whether to keep credit card information',
  },
  {
    LID: '2',
    TranslateData: 'Please select credit card information save option',
    TranslateKey:
      'It is mandatory to choose whether to keep credit card information',
  },
  {
    LID: '3',
    TranslateData:
      "Veuillez sélectionner l'option d'enregistrement des informations de carte de crédit",
    TranslateKey:
      'It is mandatory to choose whether to keep credit card information',
  },
  {
    LID: '4',
    TranslateData:
      'Пожалуйста, выберите вариант сохранения информации о кредитной карте',
    TranslateKey:
      'It is mandatory to choose whether to keep credit card information',
  },
  { LID: '1', TranslateData: 'ישראליפט', TranslateKey: 'Israelift' },
  { LID: '2', TranslateData: 'Israelift', TranslateKey: 'Israelift' },
  { LID: '3', TranslateData: 'Israélift', TranslateKey: 'Israelift' },
  { LID: '4', TranslateData: 'Израильфт', TranslateKey: 'Israelift' },
  {
    LID: '1',
    TranslateData: 'האם מספר הטלפון שלך מוגדר לפתיחת השער?',
    TranslateKey: 'Is your phone number set to open the gate?',
  },
  {
    LID: '2',
    TranslateData: 'Is your phone number set to open the gate?',
    TranslateKey: 'Is your phone number set to open the gate?',
  },
  {
    LID: '3',
    TranslateData:
      'Votre numéro de téléphone est-il configuré pour ouvrir le portail ?',
    TranslateKey: 'Is your phone number set to open the gate?',
  },
  {
    LID: '4',
    TranslateData: 'Ваш номер телефона настроен на открытие ворот?',
    TranslateKey: 'Is your phone number set to open the gate?',
  },
  { LID: '1', TranslateData: 'טופל', TranslateKey: 'Is Treated' },
  { LID: '2', TranslateData: 'Is Treated', TranslateKey: 'Is Treated' },
  { LID: '3', TranslateData: 'Est traité', TranslateKey: 'Is Treated' },
  { LID: '4', TranslateData: 'Лечится', TranslateKey: 'Is Treated' },
  { LID: '1', TranslateData: 'חשבונית', TranslateKey: 'Invoicing' },
  { LID: '2', TranslateData: 'Invoice', TranslateKey: 'Invoicing' },
  { LID: '3', TranslateData: "Facture d'achat", TranslateKey: 'Invoicing' },
  { LID: '4', TranslateData: 'Счет', TranslateKey: 'Invoicing' },
  { LID: '1', TranslateData: 'חשבוניות', TranslateKey: 'Invoices' },
  { LID: '2', TranslateData: 'Invoices', TranslateKey: 'Invoices' },
  { LID: '3', TranslateData: 'Factures', TranslateKey: 'Invoices' },
  { LID: '4', TranslateData: 'Счета', TranslateKey: 'Invoices' },
  { LID: '1', TranslateData: "מס' חשבונית", TranslateKey: 'Invoice taxes' },
  { LID: '2', TranslateData: 'Invoice No.', TranslateKey: 'Invoice taxes' },
  { LID: '3', TranslateData: 'N° de facture', TranslateKey: 'Invoice taxes' },
  { LID: '4', TranslateData: 'Счет-фактура №', TranslateKey: 'Invoice taxes' },
  { LID: '1', TranslateData: "מס' חשבונית", TranslateKey: 'Invoice num' },
  { LID: '2', TranslateData: 'Invoice num', TranslateKey: 'Invoice num' },
  { LID: '3', TranslateData: 'Numéro de facture', TranslateKey: 'Invoice num' },
  { LID: '4', TranslateData: 'Номер счета', TranslateKey: 'Invoice num' },
  { LID: '1', TranslateData: 'תאריך חשבונית', TranslateKey: 'Invoice date' },
  { LID: '2', TranslateData: 'Invoice date', TranslateKey: 'Invoice date' },
  {
    LID: '3',
    TranslateData: 'Date de la facture',
    TranslateKey: 'Invoice date',
  },
  { LID: '4', TranslateData: 'Дата счета', TranslateKey: 'Invoice date' },
  { LID: '1', TranslateData: 'תאריך חשבונית', TranslateKey: 'Invoice Date' },
  { LID: '2', TranslateData: 'Invoice Date', TranslateKey: 'Invoice Date' },
  {
    LID: '3',
    TranslateData: 'Date de facturation',
    TranslateKey: 'Invoice Date',
  },
  { LID: '4', TranslateData: 'Дата счета', TranslateKey: 'Invoice Date' },
  { LID: '1', TranslateData: 'סכום חשבונית', TranslateKey: 'Invoice amount' },
  { LID: '2', TranslateData: 'Invoice amount', TranslateKey: 'Invoice amount' },
  {
    LID: '3',
    TranslateData: 'Montant de la facture',
    TranslateKey: 'Invoice amount',
  },
  { LID: '4', TranslateData: 'Сумма счета', TranslateKey: 'Invoice amount' },
  { LID: '1', TranslateData: 'חשבונית', TranslateKey: 'Invoice' },
  { LID: '2', TranslateData: 'Invoice', TranslateKey: 'Invoice' },
  { LID: '3', TranslateData: 'facture', TranslateKey: 'Invoice' },
  { LID: '4', TranslateData: 'законопроект', TranslateKey: 'Invoice' },
  {
    LID: '1',
    TranslateData: 'מספר טלפון לא תקין',
    TranslateKey: 'Invalid phone number',
  },
  {
    LID: '2',
    TranslateData: 'Invalid phone number',
    TranslateKey: 'Invalid phone number',
  },
  {
    LID: '3',
    TranslateData: 'Numéro de téléphone invalide',
    TranslateKey: 'Invalid phone number',
  },
  {
    LID: '4',
    TranslateData: 'Неправильный номер телефона',
    TranslateKey: 'Invalid phone number',
  },
  {
    LID: '1',
    TranslateData: 'תבנית מייל לא תקינה',
    TranslateKey: 'Invalid Mail',
  },
  { LID: '2', TranslateData: 'Invalid Mail', TranslateKey: 'Invalid Mail' },
  {
    LID: '3',
    TranslateData: 'Courrier non valide',
    TranslateKey: 'Invalid Mail',
  },
  {
    LID: '4',
    TranslateData: 'Недействительная почта',
    TranslateKey: 'Invalid Mail',
  },
  {
    LID: '1',
    TranslateData: 'כתובת מייל לא תקינה',
    TranslateKey: 'Invalid email address',
  },
  {
    LID: '2',
    TranslateData: 'Invalid email address',
    TranslateKey: 'Invalid email address',
  },
  {
    LID: '3',
    TranslateData: 'Adresse e-mail invalide',
    TranslateKey: 'Invalid email address',
  },
  {
    LID: '4',
    TranslateData: 'Неверный адрес электронной почты',
    TranslateKey: 'Invalid email address',
  },
  {
    LID: '1',
    TranslateData: 'קוד אישור לא חוקי',
    TranslateKey: 'Invalid confirmation code',
  },
  {
    LID: '2',
    TranslateData: 'Invalid confirmation code',
    TranslateKey: 'Invalid confirmation code',
  },
  {
    LID: '3',
    TranslateData: 'code de confirmation invalide',
    TranslateKey: 'Invalid confirmation code',
  },
  {
    LID: '4',
    TranslateData: 'неверный код подтверждения',
    TranslateKey: 'Invalid confirmation code',
  },
  { LID: '1', TranslateData: 'לא תקין', TranslateKey: 'Invalid' },
  { LID: '2', TranslateData: 'Invalid', TranslateKey: 'Invalid' },
  { LID: '3', TranslateData: 'Invalide', TranslateKey: 'Invalid' },
  { LID: '4', TranslateData: 'Неверный', TranslateKey: 'Invalid' },
  { LID: '1', TranslateData: 'ללא תוקף', TranslateKey: 'Invalid' },
  { LID: '2', TranslateData: 'Invalid', TranslateKey: 'Invalid' },
  { LID: '3', TranslateData: 'Invalide', TranslateKey: 'Invalid' },
  { LID: '4', TranslateData: 'Недействителен', TranslateKey: 'Invalid' },
  {
    LID: '1',
    TranslateData: 'התקנת אפליקציה',
    TranslateKey: 'Installing an app',
  },
  {
    LID: '2',
    TranslateData: 'Installing an app',
    TranslateKey: 'Installing an app',
  },
  {
    LID: '3',
    TranslateData: 'Installer une application',
    TranslateKey: 'Installing an app',
  },
  {
    LID: '4',
    TranslateData: 'Установка приложения',
    TranslateKey: 'Installing an app',
  },
  { LID: '1', TranslateData: 'הכנסה', TranslateKey: 'Income' },
  { LID: '2', TranslateData: 'Income', TranslateKey: 'Income' },
  { LID: '3', TranslateData: 'Revenu', TranslateKey: 'Income' },
  { LID: '4', TranslateData: 'Доход', TranslateKey: 'Income' },
  {
    LID: '1',
    TranslateData: 'כולל שנה קודמת',
    TranslateKey: 'Including previous year',
  },
  {
    LID: '2',
    TranslateData: 'Including previous year',
    TranslateKey: 'Including previous year',
  },
  {
    LID: '3',
    TranslateData: "Y compris l'année précédente",
    TranslateKey: 'Including previous year',
  },
  {
    LID: '4',
    TranslateData: 'Включая предыдущий год',
    TranslateKey: 'Including previous year',
  },
  {
    LID: '1',
    TranslateData: 'כולל עמלות אשראי',
    TranslateKey: 'Including credit fees',
  },
  {
    LID: '2',
    TranslateData: 'Including credit card fees',
    TranslateKey: 'Including credit fees',
  },
  {
    LID: '3',
    TranslateData: 'Frais de carte de crédit inclus',
    TranslateKey: 'Including credit fees',
  },
  {
    LID: '4',
    TranslateData: 'Включая комиссию по кредитной карте',
    TranslateKey: 'Including credit fees',
  },
  { LID: '1', TranslateData: 'בטיפול', TranslateKey: 'In treatment' },
  { LID: '2', TranslateData: 'In treatment', TranslateKey: 'In treatment' },
  { LID: '3', TranslateData: 'En traitement', TranslateKey: 'In treatment' },
  { LID: '4', TranslateData: 'В лечении', TranslateKey: 'In treatment' },
  { LID: '1', TranslateData: 'בפועל ', TranslateKey: 'In practice' },
  { LID: '2', TranslateData: 'Actual', TranslateKey: 'In practice' },
  { LID: '3', TranslateData: 'Réel', TranslateKey: 'In practice' },
  { LID: '4', TranslateData: 'Действительный', TranslateKey: 'In practice' },
  {
    LID: '1',
    TranslateData: 'על מנת להירשם כדייר לבניין',
    TranslateKey: 'in order to register as a tenant for the building',
  },
  {
    LID: '2',
    TranslateData: 'in order to register as a tenant for the building',
    TranslateKey: 'in order to register as a tenant for the building',
  },
  {
    LID: '3',
    TranslateData: "afin de s'inscrire comme locataire de l'immeuble",
    TranslateKey: 'in order to register as a tenant for the building',
  },
  {
    LID: '4',
    TranslateData: 'для регистрации в качестве арендатора здания',
    TranslateKey: 'in order to register as a tenant for the building',
  },
  { LID: '1', TranslateData: 'מימוש', TranslateKey: 'Implementaion' },
  { LID: '2', TranslateData: 'Implementaion', TranslateKey: 'Implementaion' },
  { LID: '3', TranslateData: 'Mise en œuvre', TranslateKey: 'Implementaion' },
  { LID: '4', TranslateData: 'Реализация', TranslateKey: 'Implementaion' },
  {
    LID: '1',
    TranslateData: 'יש לצרף תמונה בסיומת jpg בלבד',
    TranslateKey: 'Image with jpg extension should be attached only',
  },
  {
    LID: '2',
    TranslateData: 'only jpg files are allowed',
    TranslateKey: 'Image with jpg extension should be attached only',
  },
  {
    LID: '3',
    TranslateData: 'seuls les fichiers jpg sont autorisés',
    TranslateKey: 'Image with jpg extension should be attached only',
  },
  {
    LID: '4',
    TranslateData: 'разрешены только файлы jpg',
    TranslateKey: 'Image with jpg extension should be attached only',
  },
  {
    LID: '1',
    TranslateData: 'התמונה נשמרה בהצלחה',
    TranslateKey: 'Image saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'Image saved successfully',
    TranslateKey: 'Image saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Image enregistrée avec succès',
    TranslateKey: 'Image saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Изображение успешно сохранено',
    TranslateKey: 'Image saved successfully',
  },
  {
    LID: '1',
    TranslateData:
      'מספר הטלפון שלך אינו רשום במערכת. במידה וקיבלת את הקישור מחברת הניהול יש לפנות אליה כדי לעדכן את הרישום שלך במערכת.',
    TranslateKey: 'If you have received the link from the admin company..',
  },
  {
    LID: '2',
    TranslateData:
      'Your phone number is not registered in the system. If you have received the link from the admin company, please contact it to update your registration on the system.',
    TranslateKey: 'If you have received the link from the admin company..',
  },
  {
    LID: '3',
    TranslateData:
      'Votre numéro de téléphone n’est pas enregistré dans le système. Si vous avez reçu le lien de la société d’administration, veuillez la contacter pour mettre à jour votre inscription sur le système.',
    TranslateKey: 'If you have received the link from the admin company..',
  },
  {
    LID: '4',
    TranslateData:
      'Ваш номер телефона не зарегистрирован в системе. Если вы получили ссылку от админ-компании, пожалуйста, свяжитесь с ней, чтобы обновить свою регистрацию в системе.',
    TranslateKey: 'If you have received the link from the admin company..',
  },
  {
    LID: '1',
    TranslateData:
      'במידה וכרטיס האשראי הונפק מחוץ לישראל העמלה תהיה בגובה 3%+מעמ מסך העסקה',
    TranslateKey:
      'If the credit card was issued outside Israel, the commission will be 3% + VAT of the total transaction',
  },
  {
    LID: '2',
    TranslateData:
      'The system provides a solution for building management and maintenance companies, house committees, service providers and maintenance personnel in the areas of collecting house committee fees, building maintenance, general management and more.',
    TranslateKey:
      'If the credit card was issued outside Israel, the commission will be 3% + VAT of the total transaction',
  },
  {
    LID: '3',
    TranslateData:
      'La commission des cartes étrangères est de 3% + TVA du montant total',
    TranslateKey:
      'If the credit card was issued outside Israel, the commission will be 3% + VAT of the total transaction',
  },
  {
    LID: '4',
    TranslateData:
      'Комиссия по иностранным картам составляет 3% + НДС от общей суммы.',
    TranslateKey:
      'If the credit card was issued outside Israel, the commission will be 3% + VAT of the total transaction',
  },
  {
    LID: '1',
    TranslateData:
      'קיימת לדירה הו"ק פעילה, הוספת כרטיס תעביר את כל חיוב ההו"ק לכרטיס החדש',
    TranslateKey:
      'If the apartment has an active HOC, adding a card will transfer the entire HOC charge to the new card',
  },
  {
    LID: '2',
    TranslateData:
      'If the apartment has an active HOC, adding a card will transfer the entire HOC charge to the new card',
    TranslateKey:
      'If the apartment has an active HOC, adding a card will transfer the entire HOC charge to the new card',
  },
  {
    LID: '3',
    TranslateData:
      "Si l'appartement dispose d'un HOC actif, l'ajout d'une carte transférera la totalité des frais du HOC sur la nouvelle carte.",
    TranslateKey:
      'If the apartment has an active HOC, adding a card will transfer the entire HOC charge to the new card',
  },
  {
    LID: '4',
    TranslateData:
      'Если в квартире есть действующий HOC, при добавлении карты вся сумма HOC будет перенесена на новую карту.',
    TranslateKey:
      'If the apartment has an active HOC, adding a card will transfer the entire HOC charge to the new card',
  },
  { LID: '1', TranslateData: 'חברת חשמל', TranslateKey: 'IEC' },
  { LID: '2', TranslateData: 'IEC', TranslateKey: 'IEC' },
  { LID: '3', TranslateData: 'CEI', TranslateKey: 'IEC' },
  { LID: '4', TranslateData: 'МЭК', TranslateKey: 'IEC' },
  {
    LID: '1',
    TranslateData:
      'אני משתמש בה לניהול הבניין, דיווח תקלות לחברת הניהול ותשלום דמי הועד.',
    TranslateKey:
      'I use it to manage the building, report faults to the management company and pay committee fees.',
  },
  {
    LID: '2',
    TranslateData:
      'I use it to manage the building, report faults to the management company and pay committee fees.',
    TranslateKey:
      'I use it to manage the building, report faults to the management company and pay committee fees.',
  },
  {
    LID: '3',
    TranslateData:
      "Je l'utilise pour gérer l'immeuble, signaler les défauts à la société de gestion et payer les frais de commission.",
    TranslateKey:
      'I use it to manage the building, report faults to the management company and pay committee fees.',
  },
  {
    LID: '4',
    TranslateData:
      'Я использую его для управления зданием, сообщаю о неисправностях управляющей компании и плачу комиссии комитету.',
    TranslateKey:
      'I use it to manage the building, report faults to the management company and pay committee fees.',
  },
  {
    LID: '1',
    TranslateData: 'צרף גם אותי לקריאה זו',
    TranslateKey: 'I too join this service call',
  },
  {
    LID: '2',
    TranslateData: 'Join me to this service call',
    TranslateKey: 'I too join this service call',
  },
  {
    LID: '3',
    TranslateData: 'Rejoignez-moi à cet appel de service',
    TranslateKey: 'I too join this service call',
  },
  {
    LID: '4',
    TranslateData: 'Присоединяйтесь ко мне к этому сервисному вызову',
    TranslateKey: 'I too join this service call',
  },
  {
    LID: '1',
    TranslateData: 'צירפתי את המספר של איי פוינט לרשימת המספרים המורשים',
    TranslateKey: 'I saved the A Point phone number',
  },
  {
    LID: '2',
    TranslateData:
      'I have added the number of A Point to the list of authorized numbers',
    TranslateKey: 'I saved the A Point phone number',
  },
  {
    LID: '3',
    TranslateData:
      "J'ai ajouté le numéro d'Islands Point à la liste des numéros autorisés",
    TranslateKey: 'I saved the A Point phone number',
  },
  {
    LID: '4',
    TranslateData:
      "J'ai ajouté le numéro d'Islands Point à la liste des numéros autorisés",
    TranslateKey: 'I saved the A Point phone number',
  },
  {
    LID: '1',
    TranslateData: 'אין לי שער חניה',
    TranslateKey: 'I do not have a parking gate',
  },
  {
    LID: '2',
    TranslateData: 'I do not have a parking gate',
    TranslateKey: 'I do not have a parking gate',
  },
  {
    LID: '3',
    TranslateData: "Je n'ai pas de barrière de parking",
    TranslateKey: 'I do not have a parking gate',
  },
  {
    LID: '4',
    TranslateData: 'у меня нет парковочных ворот',
    TranslateKey: 'I do not have a parking gate',
  },
  {
    LID: '1',
    TranslateData: 'לא מעוניין',
    TranslateKey: 'I do not agree to accept',
  },
  {
    LID: '2',
    TranslateData: "Don't agree",
    TranslateKey: 'I do not agree to accept',
  },
  {
    LID: '3',
    TranslateData: "Pas d'accord",
    TranslateKey: 'I do not agree to accept',
  },
  {
    LID: '4',
    TranslateData: 'Не согласен',
    TranslateKey: 'I do not agree to accept',
  },
  {
    LID: '1',
    TranslateData: 'איך תרצו לקבל את קוד האימות?',
    TranslateKey: 'How would you like to receive the verification code?',
  },
  {
    LID: '2',
    TranslateData: 'How would you like to receive the verification code?',
    TranslateKey: 'How would you like to receive the verification code?',
  },
  {
    LID: '3',
    TranslateData: 'Comment souhaitez-vous recevoir le code de vérification?',
    TranslateKey: 'How would you like to receive the verification code?',
  },
  {
    LID: '4',
    TranslateData: 'Как бы вы хотели получить код подтверждения?',
    TranslateKey: 'How would you like to receive the verification code?',
  },
  {
    LID: '1',
    TranslateData:
      'דמי ועד הבית משולמים ביום {0} לחודש באמצעות כרטיס אשראי {1} המסתיים ב-{2}',
    TranslateKey:
      'House committee fees are paid on {0} per month using a {1} credit card ending in {2}',
  },
  {
    LID: '2',
    TranslateData:
      'House committee fees are paid on {0} per month using a {1} credit card ending in {2}',
    TranslateKey:
      'House committee fees are paid on {0} per month using a {1} credit card ending in {2}',
  },
  {
    LID: '3',
    TranslateData:
      'Les frais des comités de la Chambre sont payés {0} par mois en utilisant une carte de crédit {1} se terminant par {2}.',
    TranslateKey:
      'House committee fees are paid on {0} per month using a {1} credit card ending in {2}',
  },
  {
    LID: '4',
    TranslateData:
      'Взносы комитета Палаты представителей выплачиваются в размере {0} в месяц с использованием кредитной карты {1}, заканчивающейся на {2}.',
    TranslateKey:
      'House committee fees are paid on {0} per month using a {1} credit card ending in {2}',
  },
  { LID: '1', TranslateData: 'ועד הבית', TranslateKey: 'House committee' },
  {
    LID: '2',
    TranslateData: 'House committee',
    TranslateKey: 'House committee',
  },
  {
    LID: '3',
    TranslateData: 'Comité de la Chambre',
    TranslateKey: 'House committee',
  },
  { LID: '4', TranslateData: 'Дом комитет', TranslateKey: 'House committee' },
  {
    LID: '1',
    TranslateData: 'קריאת שירות לבית',
    TranslateKey: 'Home service call',
  },
  {
    LID: '2',
    TranslateData: 'Home service call',
    TranslateKey: 'Home service call',
  },
  {
    LID: '3',
    TranslateData: 'Appel de service à domicile',
    TranslateKey: 'Home service call',
  },
  {
    LID: '4',
    TranslateData: 'Вызов службы поддержки на дому',
    TranslateKey: 'Home service call',
  },
  { LID: '1', TranslateData: 'שירות לבית', TranslateKey: 'Home service' },
  { LID: '2', TranslateData: 'Home service', TranslateKey: 'Home service' },
  {
    LID: '3',
    TranslateData: 'Service à domicile',
    TranslateKey: 'Home service',
  },
  { LID: '4', TranslateData: 'Домашний сервис', TranslateKey: 'Home service' },
  { LID: '1', TranslateData: 'דף הבית', TranslateKey: 'Home page' },
  { LID: '2', TranslateData: 'Home page', TranslateKey: 'Home page' },
  { LID: '3', TranslateData: "Page d'accueil", TranslateKey: 'Home page' },
  { LID: '4', TranslateData: 'Домашняя страница', TranslateKey: 'Home page' },
  { LID: '1', TranslateData: 'בית', TranslateKey: 'Home' },
  { LID: '2', TranslateData: 'Home', TranslateKey: 'Home' },
  { LID: '3', TranslateData: '', TranslateKey: 'Home' },
  { LID: '4', TranslateData: 'Дом', TranslateKey: 'Home' },
  {
    LID: '1',
    TranslateData: 'הוראת קבע נשמרה בהצלחה!',
    TranslateKey: 'Hok saved successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Hok saved successfully!',
    TranslateKey: 'Hok saved successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Hok enregistré avec succès!',
    TranslateKey: 'Hok saved successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Хок успешно сохранен!',
    TranslateKey: 'Hok saved successfully!',
  },
  { LID: '1', TranslateData: 'הוראת קבע', TranslateKey: 'Hok' },
  { LID: '2', TranslateData: 'Periodic payment', TranslateKey: 'Hok' },
  { LID: '3', TranslateData: 'Paiement périodique', TranslateKey: 'Hok' },
  { LID: '4', TranslateData: 'Периодическая оплата', TranslateKey: 'Hok' },
  { LID: '1', TranslateData: 'הסתר', TranslateKey: 'Hide' },
  { LID: '2', TranslateData: 'Hide', TranslateKey: 'Hide' },
  { LID: '3', TranslateData: 'Cacher', TranslateKey: 'Hide' },
  { LID: '4', TranslateData: 'Скрывать', TranslateKey: 'Hide' },
  {
    LID: '1',
    TranslateData: 'הי, אני משתף איתך את אפליקציית בילד-אפ המצוינת.',
    TranslateKey: 'Hi, I am sharing with you the excellent build-up app.',
  },
  {
    LID: '2',
    TranslateData: 'Hi, I am sharing with you the excellent build-up app.',
    TranslateKey: 'Hi, I am sharing with you the excellent build-up app.',
  },
  {
    LID: '3',
    TranslateData:
      "Bonjour, je partage avec vous l'excellente application de build-up.",
    TranslateKey: 'Hi, I am sharing with you the excellent build-up app.',
  },
  {
    LID: '4',
    TranslateData:
      'Привет, делюсь с вами отличным приложением для наращивания.',
    TranslateKey: 'Hi, I am sharing with you the excellent build-up app.',
  },
  { LID: '1', TranslateData: 'אסמכתה', TranslateKey: 'Her reference' },
  { LID: '2', TranslateData: 'Reference', TranslateKey: 'Her reference' },
  { LID: '3', TranslateData: 'Référence', TranslateKey: 'Her reference' },
  { LID: '4', TranslateData: 'Ссылка', TranslateKey: 'Her reference' },
  { LID: '1', TranslateData: 'שלום', TranslateKey: 'Hello' },
  { LID: '2', TranslateData: 'Hello', TranslateKey: 'Hello' },
  { LID: '3', TranslateData: 'Bonjour', TranslateKey: 'Hello' },
  { LID: '4', TranslateData: 'Привет', TranslateKey: 'Hello' },
  {
    LID: '1',
    TranslateData: 'טופלו בחודש האחרון',
    TranslateKey: 'Have been treated for the past month',
  },
  {
    LID: '2',
    TranslateData: 'Have been treated for the past month',
    TranslateKey: 'Have been treated for the past month',
  },
  {
    LID: '3',
    TranslateData: 'Avoir été traité le mois dernier',
    TranslateKey: 'Have been treated for the past month',
  },
  {
    LID: '4',
    TranslateData: 'Лечились в течение последнего месяца',
    TranslateKey: 'Have been treated for the past month',
  },
  { LID: '1', TranslateData: 'האם טופל', TranslateKey: 'Has been treated' },
  {
    LID: '2',
    TranslateData: 'Has been treated',
    TranslateKey: 'Has been treated',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Has been treated' },
  { LID: '4', TranslateData: 'лечился', TranslateKey: 'Has been treated' },
  {
    LID: '1',
    TranslateData: 'האם בוצע ביקור בבניין היום?',
    TranslateKey: 'Has a visit been made to the building today?',
  },
  {
    LID: '2',
    TranslateData: 'Has a visit been made to the building today?',
    TranslateKey: 'Has a visit been made to the building today?',
  },
  {
    LID: '3',
    TranslateData: '',
    TranslateKey: 'Has a visit been made to the building today?',
  },
  {
    LID: '4',
    TranslateData: 'Был ли сегодня визит в здание?',
    TranslateKey: 'Has a visit been made to the building today?',
  },
  {
    LID: '1',
    TranslateData: 'הנחיות לשמירת קישור לקבוצת וואצאפ:',
    TranslateKey: 'Guidelines for keeping a link to the WhatsApp group:',
  },
  {
    LID: '2',
    TranslateData: 'How to save a link to the WhatsApp group:',
    TranslateKey: 'Guidelines for keeping a link to the WhatsApp group:',
  },
  {
    LID: '3',
    TranslateData: 'Comment enregistrer un lien vers le groupe WhatsApp :',
    TranslateKey: 'Guidelines for keeping a link to the WhatsApp group:',
  },
  {
    LID: '4',
    TranslateData: 'Как сохранить ссылку на группу WhatsApp:',
    TranslateKey: 'Guidelines for keeping a link to the WhatsApp group:',
  },
  { LID: '1', TranslateData: 'תחום', TranslateKey: 'Group' },
  { LID: '2', TranslateData: 'Group', TranslateKey: 'Group' },
  { LID: '3', TranslateData: '', TranslateKey: 'Group' },
  { LID: '4', TranslateData: 'Группа', TranslateKey: 'Group' },
  {
    LID: '1',
    TranslateData: 'גדול מ או שווה ל',
    TranslateKey: 'Greater than or equal to',
  },
  {
    LID: '2',
    TranslateData: 'Greater than or equal to',
    TranslateKey: 'Greater than or equal to',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Greater than or equal to' },
  {
    LID: '4',
    TranslateData: 'Больше или равно',
    TranslateKey: 'Greater than or equal to',
  },
  { LID: '1', TranslateData: 'גדול מ', TranslateKey: 'Greater than' },
  { LID: '2', TranslateData: 'Greater than', TranslateKey: 'Greater than' },
  { LID: '3', TranslateData: '', TranslateKey: 'Greater than' },
  { LID: '4', TranslateData: 'Лучше чем', TranslateKey: 'Greater than' },
  { LID: '1', TranslateData: 'בהצלחה', TranslateKey: 'Goodluck' },
  { LID: '2', TranslateData: 'Good luck', TranslateKey: 'Goodluck' },
  { LID: '3', TranslateData: 'Bonne chance', TranslateKey: 'Goodluck' },
  { LID: '4', TranslateData: 'Удачи', TranslateKey: 'Goodluck' },
  { LID: '1', TranslateData: 'עבור לתשלום', TranslateKey: 'Go to payment' },
  { LID: '2', TranslateData: 'Go to payment', TranslateKey: 'Go to payment' },
  {
    LID: '3',
    TranslateData: 'Aller au paiement',
    TranslateKey: 'Go to payment',
  },
  {
    LID: '4',
    TranslateData: 'Перейти к оплате',
    TranslateKey: 'Go to payment',
  },
  {
    LID: '1',
    TranslateData: 'כללי עד הבית',
    TranslateKey: 'General to the house',
  },
  {
    LID: '2',
    TranslateData: 'General to the house',
    TranslateKey: 'General to the house',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'General to the house' },
  {
    LID: '4',
    TranslateData: 'Генерал к дому',
    TranslateKey: 'General to the house',
  },
  {
    LID: '1',
    TranslateData: 'ביקורת כללית בבניין',
    TranslateKey: 'General inspection of the building',
  },
  {
    LID: '2',
    TranslateData: 'General inspection of the building',
    TranslateKey: 'General inspection of the building',
  },
  {
    LID: '3',
    TranslateData: '',
    TranslateKey: 'General inspection of the building',
  },
  {
    LID: '4',
    TranslateData: 'Общий осмотр здания',
    TranslateKey: 'General inspection of the building',
  },
  { LID: '1', TranslateData: 'כללי', TranslateKey: 'General' },
  { LID: '2', TranslateData: 'General', TranslateKey: 'General' },
  { LID: '3', TranslateData: 'Général', TranslateKey: 'General' },
  { LID: '4', TranslateData: 'Общий', TranslateKey: 'General' },
  { LID: '1', TranslateData: 'שערים', TranslateKey: 'Gates' },
  { LID: '2', TranslateData: 'Gates', TranslateKey: 'Gates' },
  { LID: '3', TranslateData: 'portes', TranslateKey: 'Gates' },
  { LID: '4', TranslateData: 'Ворота', TranslateKey: 'Gates' },
  {
    LID: '1',
    TranslateData: 'השער נשמר בהצלחה!',
    TranslateKey: 'Gate saved successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Gate saved successfully!',
    TranslateKey: 'Gate saved successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Porte enregistrée avec succès !',
    TranslateKey: 'Gate saved successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Ворота успешно сохранены!',
    TranslateKey: 'Gate saved successfully!',
  },
  { LID: '1', TranslateData: 'טלפון שער', TranslateKey: 'Gate phone' },
  { LID: '2', TranslateData: 'Gate phone', TranslateKey: 'Gate phone' },
  { LID: '3', TranslateData: 'Téléphone portail', TranslateKey: 'Gate phone' },
  { LID: '4', TranslateData: 'Телефон ворот', TranslateKey: 'Gate phone' },
  {
    LID: '1',
    TranslateData: 'השער נפתח בהצלחה!',
    TranslateKey: 'Gate opened successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Gate opened successfully!',
    TranslateKey: 'Gate opened successfully!',
  },
  {
    LID: '3',
    TranslateData: "Le portail s'est ouvert avec succès !",
    TranslateKey: 'Gate opened successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Ворота успешно открылись!',
    TranslateKey: 'Gate opened successfully!',
  },
  {
    LID: '1',
    TranslateData: 'השער נמחק בהצלחה!',
    TranslateKey: 'Gate deleted successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Gate deleted successfully!',
    TranslateKey: 'Gate deleted successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Porte supprimée avec succès !',
    TranslateKey: 'Gate deleted successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Ворота успешно удалены!',
    TranslateKey: 'Gate deleted successfully!',
  },
  { LID: '1', TranslateData: 'גלריה', TranslateKey: 'Gallery' },
  { LID: '2', TranslateData: 'Gallery', TranslateKey: 'Gallery' },
  { LID: '3', TranslateData: 'Galerie', TranslateKey: 'Gallery' },
  { LID: '4', TranslateData: 'Галерея', TranslateKey: 'Gallery' },
  {
    LID: '1',
    TranslateData: 'נדרש שם מלא',
    TranslateKey: 'Full name is required',
  },
  {
    LID: '2',
    TranslateData: 'Full name is required',
    TranslateKey: 'Full name is required',
  },
  {
    LID: '3',
    TranslateData: 'Le nom complet est requis',
    TranslateKey: 'Full name is required',
  },
  {
    LID: '4',
    TranslateData: 'Требуется полное имя',
    TranslateKey: 'Full name is required',
  },
  { LID: '1', TranslateData: 'שם מלא', TranslateKey: 'Full name' },
  { LID: '2', TranslateData: 'Full name', TranslateKey: 'Full name' },
  { LID: '3', TranslateData: 'Nom et prénom', TranslateKey: 'Full name' },
  { LID: '4', TranslateData: 'Полное имя', TranslateKey: 'Full name' },
  {
    LID: '1',
    TranslateData: 'מהתפריט למעלה בוחרים פרטי קבוצה',
    TranslateKey: 'From the menu above select group details',
  },
  {
    LID: '2',
    TranslateData: 'From the menu above select group details',
    TranslateKey: 'From the menu above select group details',
  },
  {
    LID: '3',
    TranslateData: 'Dans le menu ci-dessus, sélectionnez les détails du groupe',
    TranslateKey: 'From the menu above select group details',
  },
  {
    LID: '4',
    TranslateData: 'В меню выше выберите сведения о группе',
    TranslateKey: 'From the menu above select group details',
  },
  { LID: '1', TranslateData: 'מתאריך', TranslateKey: 'From date' },
  { LID: '2', TranslateData: 'From date', TranslateKey: 'From date' },
  { LID: '3', TranslateData: 'Partir de la date', TranslateKey: 'From date' },
  { LID: '4', TranslateData: 'С даты', TranslateKey: 'From date' },
  { LID: '1', TranslateData: 'שישי', TranslateKey: 'Friday' },
  { LID: '2', TranslateData: 'Friday', TranslateKey: 'Friday' },
  { LID: '3', TranslateData: '', TranslateKey: 'Friday' },
  { LID: '4', TranslateData: 'Пятница', TranslateKey: 'Friday' },
  { LID: '1', TranslateData: 'ו', TranslateKey: 'Fri' },
  { LID: '2', TranslateData: 'Fr', TranslateKey: 'Fri' },
  { LID: '3', TranslateData: 'Fr', TranslateKey: 'Fri' },
  { LID: '4', TranslateData: 'Пт', TranslateKey: 'Fri' },
  { LID: '1', TranslateData: 'תדירות', TranslateKey: 'Frequency' },
  { LID: '2', TranslateData: 'Frequency', TranslateKey: 'Frequency' },
  { LID: '3', TranslateData: 'La fréquence', TranslateKey: 'Frequency' },
  { LID: '4', TranslateData: 'Частота', TranslateKey: 'Frequency' },
  { LID: '1', TranslateData: 'ו', TranslateKey: 'Fr' },
  { LID: '2', TranslateData: 'Fr', TranslateKey: 'Fr' },
  { LID: '3', TranslateData: 'Fr', TranslateKey: 'Fr' },
  { LID: '4', TranslateData: 'Пт', TranslateKey: 'Fr' },
  { LID: '1', TranslateData: 'לידיעתך', TranslateKey: 'for your information' },
  {
    LID: '2',
    TranslateData: 'for your information',
    TranslateKey: 'for your information',
  },
  {
    LID: '3',
    TranslateData: 'pour votre information',
    TranslateKey: 'for your information',
  },
  {
    LID: '4',
    TranslateData: 'довожу до вашего сведения',
    TranslateKey: 'for your information',
  },
  { LID: '1', TranslateData: 'לידיעתך', TranslateKey: 'for your information' },
  {
    LID: '2',
    TranslateData: 'for your information',
    TranslateKey: 'for your information',
  },
  {
    LID: '3',
    TranslateData: 'pour votre information',
    TranslateKey: 'for your information',
  },
  {
    LID: '4',
    TranslateData: 'довожу до вашего сведения',
    TranslateKey: 'for your information',
  },
  {
    LID: '1',
    TranslateData: 'לקריאות דחופות יש להתקשר למספר',
    TranslateKey: 'For urgent calls contact',
  },
  {
    LID: '2',
    TranslateData: 'For urgent issues please call',
    TranslateKey: 'For urgent calls contact',
  },
  {
    LID: '3',
    TranslateData: 'Pour les problèmes urgents, veuillez appeler',
    TranslateKey: 'For urgent calls contact',
  },
  {
    LID: '4',
    TranslateData: 'По срочным вопросам звоните',
    TranslateKey: 'For urgent calls contact',
  },
  {
    LID: '1',
    TranslateData: 'תשלום דמי ועד בית',
    TranslateKey: 'For details of payments',
  },
  {
    LID: '2',
    TranslateData: 'House committee payment',
    TranslateKey: 'For details of payments',
  },
  {
    LID: '3',
    TranslateData: 'Paiement du comité de la Chambre',
    TranslateKey: 'For details of payments',
  },
  {
    LID: '4',
    TranslateData: 'Оплата домового комитета',
    TranslateKey: 'For details of payments',
  },
  { LID: '1', TranslateData: 'לתשלום', TranslateKey: 'For a fee' },
  { LID: '2', TranslateData: 'To pay', TranslateKey: 'For a fee' },
  { LID: '3', TranslateData: 'Payer', TranslateKey: 'For a fee' },
  { LID: '4', TranslateData: 'Платить', TranslateKey: 'For a fee' },
  {
    LID: '1',
    TranslateData:
      'לכרטיס שהונפק מחוץ לישראל העמלה תהיה בגובה {0}% + מעמ מסך העסקה',
    TranslateKey:
      'For a card issued outside of Israel, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '2',
    TranslateData:
      'For a card issued outside of Israel, the fee will be {0}% + VAT of the total transaction',
    TranslateKey:
      'For a card issued outside of Israel, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '3',
    TranslateData:
      "Pour une carte émise en dehors d'Israël, les frais seront de {0}% + TVA du total de la transaction.",
    TranslateKey:
      'For a card issued outside of Israel, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '4',
    TranslateData:
      'Для карты, выпущенной за пределами Израиля, комиссия составит {0}% + НДС от общей суммы транзакции.',
    TranslateKey:
      'For a card issued outside of Israel, the fee will be {0}% + VAT of the total transaction',
  },
  { LID: '1', TranslateData: 'עבור', TranslateKey: 'For' },
  { LID: '2', TranslateData: 'For', TranslateKey: 'For' },
  { LID: '3', TranslateData: 'Pour', TranslateKey: 'For' },
  { LID: '4', TranslateData: 'За', TranslateKey: 'For' },
  { LID: '1', TranslateData: 'קומה', TranslateKey: 'Floor' },
  { LID: '2', TranslateData: 'Floor', TranslateKey: 'Floor' },
  { LID: '3', TranslateData: 'Sol', TranslateKey: 'Floor' },
  { LID: '4', TranslateData: 'Этаж', TranslateKey: 'Floor' },
  {
    LID: '1',
    TranslateData: 'השם הפרטי חייב להיות בן 2 תווים לפחות',
    TranslateKey: 'First name must be at least 2 characters',
  },
  {
    LID: '2',
    TranslateData: 'First name must be at least 2 characters',
    TranslateKey: 'First name must be at least 2 characters',
  },
  {
    LID: '3',
    TranslateData: 'Le prénom doit comporter au moins 2 caractères',
    TranslateKey: 'First name must be at least 2 characters',
  },
  {
    LID: '4',
    TranslateData: 'Имя должно быть не менее 2 символов',
    TranslateKey: 'First name must be at least 2 characters',
  },
  { LID: '1', TranslateData: 'שם פרטי', TranslateKey: 'First name' },
  { LID: '2', TranslateData: 'First name', TranslateKey: 'First name' },
  { LID: '3', TranslateData: 'Prénom', TranslateKey: 'First name' },
  { LID: '4', TranslateData: 'Имя', TranslateKey: 'First name' },
  { LID: '1', TranslateData: 'סיים בדיקה', TranslateKey: 'Finished testing' },
  {
    LID: '2',
    TranslateData: 'Finished testing',
    TranslateKey: 'Finished testing',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Finished testing' },
  {
    LID: '4',
    TranslateData: 'Завершено тестирование',
    TranslateKey: 'Finished testing',
  },
  {
    LID: '1',
    TranslateData: 'מצב כספי לבניין',
    TranslateKey: 'Financial condition of the building',
  },
  {
    LID: '2',
    TranslateData: 'Financial condition of the building',
    TranslateKey: 'Financial condition of the building',
  },
  {
    LID: '3',
    TranslateData: "Situation financière de l'immeuble",
    TranslateKey: 'Financial condition of the building',
  },
  {
    LID: '4',
    TranslateData: 'Финансовое состояние здания',
    TranslateKey: 'Financial condition of the building',
  },
  {
    LID: '1',
    TranslateData: 'מצב כספי לתאריך: ',
    TranslateKey: 'Financial condition',
  },
  {
    LID: '2',
    TranslateData: 'Financial condition',
    TranslateKey: 'Financial condition',
  },
  {
    LID: '3',
    TranslateData: 'Condition financière',
    TranslateKey: 'Financial condition',
  },
  {
    LID: '4',
    TranslateData: 'Финансовое состояние',
    TranslateKey: 'Financial condition',
  },
  {
    LID: '1',
    TranslateData: 'מסנן הצעות מחיר',
    TranslateKey: 'Filters for list of bids',
  },
  {
    LID: '2',
    TranslateData: 'Filters for list of bids',
    TranslateKey: 'Filters for list of bids',
  },
  {
    LID: '3',
    TranslateData: 'Filtres pour la liste des offres',
    TranslateKey: 'Filters for list of bids',
  },
  {
    LID: '4',
    TranslateData: 'Фильтры для списка ставок',
    TranslateKey: 'Filters for list of bids',
  },
  {
    LID: '1',
    TranslateData: 'מסנן הוצאות',
    TranslateKey: 'Filters for expense list',
  },
  {
    LID: '2',
    TranslateData: 'Filters for expense list',
    TranslateKey: 'Filters for expense list',
  },
  {
    LID: '3',
    TranslateData: 'Filtres pour la liste des dépenses',
    TranslateKey: 'Filters for expense list',
  },
  {
    LID: '4',
    TranslateData: 'Фильтры для списка расходов',
    TranslateKey: 'Filters for expense list',
  },
  {
    LID: '1',
    TranslateData: 'מסנן לרשימת דירות',
    TranslateKey: 'Filters for a list of apartments',
  },
  {
    LID: '2',
    TranslateData: 'Apartment list filter',
    TranslateKey: 'Filters for a list of apartments',
  },
  {
    LID: '3',
    TranslateData: "Filtre de liste d'appartements",
    TranslateKey: 'Filters for a list of apartments',
  },
  {
    LID: '4',
    TranslateData: 'Фильтр списка квартир',
    TranslateKey: 'Filters for a list of apartments',
  },
  { LID: '1', TranslateData: 'סנן', TranslateKey: 'Filters' },
  { LID: '2', TranslateData: 'Filters', TranslateKey: 'Filters' },
  { LID: '3', TranslateData: '', TranslateKey: 'Filters' },
  { LID: '4', TranslateData: 'Фильтры', TranslateKey: 'Filters' },
  {
    LID: '1',
    TranslateData: 'מסנן לקריאות שירות פתוחות',
    TranslateKey: 'Filter for open service calls',
  },
  {
    LID: '2',
    TranslateData: 'Filter for open service calls',
    TranslateKey: 'Filter for open service calls',
  },
  {
    LID: '3',
    TranslateData: 'Filtrer les appels de service ouverts',
    TranslateKey: 'Filter for open service calls',
  },
  {
    LID: '4',
    TranslateData: 'Фильтровать открытые сервисные звонки',
    TranslateKey: 'Filter for open service calls',
  },
  { LID: '1', TranslateData: 'סנן', TranslateKey: 'Filter' },
  { LID: '2', TranslateData: 'Filter', TranslateKey: 'Filter' },
  { LID: '3', TranslateData: 'Filtre', TranslateKey: 'Filter' },
  { LID: '4', TranslateData: 'Фильтр', TranslateKey: 'Filter' },
  {
    LID: '1',
    TranslateData: 'מלא את פרטיך, ונציג שלנו ייצור קשר איתך להמשך רישום',
    TranslateKey: 'Fill in your details',
  },
  {
    LID: '2',
    TranslateData:
      'Fill in your details, and our representative will contact you for further registration',
    TranslateKey: 'Fill in your details',
  },
  {
    LID: '3',
    TranslateData:
      'Remplissez vos coordonnées, et notre représentant vous contactera pour plus d’inscription',
    TranslateKey: 'Fill in your details',
  },
  {
    LID: '4',
    TranslateData:
      'Заполните Ваши данные, и наш представитель свяжется с Вами для дальнейшей регистрации',
    TranslateKey: 'Fill in your details',
  },
  { LID: '1', TranslateData: 'תאור הקובץ', TranslateKey: 'File name text' },
  {
    LID: '2',
    TranslateData: 'File description',
    TranslateKey: 'File name text',
  },
  {
    LID: '3',
    TranslateData: 'Description du fichier',
    TranslateKey: 'File name text',
  },
  { LID: '4', TranslateData: 'Описание файла', TranslateKey: 'File name text' },
  {
    LID: '1',
    TranslateData: 'הורדת הקובץ הסתיימה בהצלחה !',
    TranslateKey: 'File download completed successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Download completed successfully !',
    TranslateKey: 'File download completed successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Téléchargement terminé avec succès !',
    TranslateKey: 'File download completed successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Загрузка успешно завершена!',
    TranslateKey: 'File download completed successfully!',
  },
  {
    LID: '1',
    TranslateData: 'המשוב נשלח בהצלחה !',
    TranslateKey: 'Feedback sent successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Feedback sent successfully !',
    TranslateKey: 'Feedback sent successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Commentaires envoyés avec succès !',
    TranslateKey: 'Feedback sent successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Отзыв успешно отправлен!',
    TranslateKey: 'Feedback sent successfully!',
  },
  { LID: '1', TranslateData: 'פברואר', TranslateKey: 'February' },
  { LID: '2', TranslateData: 'February', TranslateKey: 'February' },
  { LID: '3', TranslateData: 'février', TranslateKey: 'February' },
  { LID: '4', TranslateData: 'Февраль', TranslateKey: 'February' },
  { LID: '1', TranslateData: 'פברואר', TranslateKey: 'Feb' },
  { LID: '2', TranslateData: 'Feb', TranslateKey: 'Feb' },
  { LID: '3', TranslateData: '', TranslateKey: 'Feb' },
  { LID: '4', TranslateData: 'февраль', TranslateKey: 'Feb' },
  { LID: '1', TranslateData: 'פקס', TranslateKey: 'Fax' },
  { LID: '2', TranslateData: 'Fax', TranslateKey: 'Fax' },
  { LID: '3', TranslateData: 'Fax', TranslateKey: 'Fax' },
  { LID: '4', TranslateData: 'Факс', TranslateKey: 'Fax' },
  {
    LID: '1',
    TranslateData: 'פעולת העדכון נכשלה',
    TranslateKey: 'Failed to update',
  },
  {
    LID: '2',
    TranslateData: 'Failed to update',
    TranslateKey: 'Failed to update',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Failed to update' },
  {
    LID: '4',
    TranslateData: 'Не удалось обновить',
    TranslateKey: 'Failed to update',
  },
  {
    LID: '1',
    TranslateData:
      'שמירת האירוע נכשלה, נסה לרענן את הדף ולשמור שנית או צור קשר עם התמיכה',
    TranslateKey:
      'Failed to save event, please try to refresh the page and save again or contact support',
  },
  {
    LID: '2',
    TranslateData:
      'Failed to save event, please try to refresh the page and save again or contact support',
    TranslateKey:
      'Failed to save event, please try to refresh the page and save again or contact support',
  },
  {
    LID: '3',
    TranslateData:
      "Échec de l'enregistrement de l'événement, essayez d'actualiser la page et de l'enregistrer à nouveau ou contactez l'assistance",
    TranslateKey:
      'Failed to save event, please try to refresh the page and save again or contact support',
  },
  {
    LID: '4',
    TranslateData:
      'Не удалось сохранить мероприятие, попробуйте обновить страницу и снова сохранить или обратитесь в службу поддержки.',
    TranslateKey:
      'Failed to save event, please try to refresh the page and save again or contact support',
  },
  { LID: '1', TranslateData: 'נתוני מתקן ', TranslateKey: 'Facility data' },
  { LID: '2', TranslateData: 'Facility data', TranslateKey: 'Facility data' },
  {
    LID: '3',
    TranslateData: "Données de l'installation",
    TranslateKey: 'Facility data',
  },
  { LID: '4', TranslateData: 'Данные объекта', TranslateKey: 'Facility data' },
  { LID: '1', TranslateData: 'הוצאה', TranslateKey: 'Expenses' },
  { LID: '2', TranslateData: 'Expenses', TranslateKey: 'Expenses' },
  { LID: '3', TranslateData: 'Dépenses', TranslateKey: 'Expenses' },
  { LID: '4', TranslateData: 'Расходы', TranslateKey: 'Expenses' },
  {
    LID: '1',
    TranslateData: 'ההוצאה נשמרה בהצלחה',
    TranslateKey: 'Expenditure saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'Expenditure saved successfully',
    TranslateKey: 'Expenditure saved successfully',
  },
  {
    LID: '3',
    TranslateData: '',
    TranslateKey: 'Expenditure saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Расходы сохранены',
    TranslateKey: 'Expenditure saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'רישום הוצאה',
    TranslateKey: 'Expenditure Report',
  },
  {
    LID: '2',
    TranslateData: 'Add expense',
    TranslateKey: 'Expenditure Report',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter une dépense',
    TranslateKey: 'Expenditure Report',
  },
  {
    LID: '4',
    TranslateData: 'Добавить расход',
    TranslateKey: 'Expenditure Report',
  },
  {
    LID: '1',
    TranslateData: 'הוצאות ותקציב',
    TranslateKey: 'Expenditure and budget',
  },
  {
    LID: '2',
    TranslateData: 'Expenditure and budget',
    TranslateKey: 'Expenditure and budget',
  },
  {
    LID: '3',
    TranslateData: 'Dépenses et budget',
    TranslateKey: 'Expenditure and budget',
  },
  {
    LID: '4',
    TranslateData: 'Расходы и бюджет',
    TranslateKey: 'Expenditure and budget',
  },
  { LID: '1', TranslateData: 'הוצאה', TranslateKey: 'Expenditure' },
  { LID: '2', TranslateData: 'Expenditure', TranslateKey: 'Expenditure' },
  { LID: '3', TranslateData: 'Dépense', TranslateKey: 'Expenditure' },
  { LID: '4', TranslateData: 'Статья расхода', TranslateKey: 'Expenditure' },
  {
    LID: '1',
    TranslateData: 'קריאות של כולם',
    TranslateKey: "Everyone's readings",
  },
  {
    LID: '2',
    TranslateData: "Everyone's readings",
    TranslateKey: "Everyone's readings",
  },
  { LID: '3', TranslateData: '', TranslateKey: "Everyone's readings" },
  {
    LID: '4',
    TranslateData: 'Чтение каждого',
    TranslateKey: "Everyone's readings",
  },
  { LID: '1', TranslateData: 'רשימת אירועים', TranslateKey: 'Events list' },
  { LID: '2', TranslateData: 'Events list', TranslateKey: 'Events list' },
  {
    LID: '3',
    TranslateData: 'Liste des événements',
    TranslateKey: 'Events list',
  },
  { LID: '4', TranslateData: 'Список событий', TranslateKey: 'Events list' },
  {
    LID: '1',
    TranslateData: 'שגיאה בעת הורדת הקובץ',
    TranslateKey: 'Error while downloading file',
  },
  {
    LID: '2',
    TranslateData: 'Error while downloading file',
    TranslateKey: 'Error while downloading file',
  },
  {
    LID: '3',
    TranslateData: 'Erreur lors du téléchargement du fichier',
    TranslateKey: 'Error while downloading file',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка при скачивании файла',
    TranslateKey: 'Error while downloading file',
  },
  {
    LID: '1',
    TranslateData: 'שגיאה בשליחת מייל',
    TranslateKey: 'Error sending email',
  },
  {
    LID: '2',
    TranslateData: 'Error sending email',
    TranslateKey: 'Error sending email',
  },
  {
    LID: '3',
    TranslateData: 'Erreur lors de l’envoi d’un e-mail',
    TranslateKey: 'Error sending email',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка при отправке электронной почты',
    TranslateKey: 'Error sending email',
  },
  {
    LID: '1',
    TranslateData:
      'אירעה שגיאה בשליחת הפרטים, בדוק שיש חיבור תקין לאינטרנט ונסה שנית, או צור עימנו קשר טלפוני במספר: 077-2060010',
    TranslateKey: 'error occured while sending the information',
  },
  {
    LID: '2',
    TranslateData:
      'An error occured while sending the information,please check the Internet connection and try again, or contact us by phone: 077-2060010',
    TranslateKey: 'error occured while sending the information',
  },
  {
    LID: '3',
    TranslateData:
      'Une erreur s’est produite lors de l’envoi des informations, veuillez vérifier la connexion Internet et réessayer, ou contactez-nous par téléphone: 077-2060010',
    TranslateKey: 'error occured while sending the information',
  },
  {
    LID: '4',
    TranslateData:
      'Произошла ошибка при отправке информации, пожалуйста, проверьте подключение к Интернету и повторите попытку, или свяжитесь с нами по телефону: 077-2060010',
    TranslateKey: 'error occured while sending the information',
  },
  { LID: '1', TranslateData: 'פרטי השגיאה:', TranslateKey: 'Error Details:' },
  { LID: '2', TranslateData: 'Error Details:', TranslateKey: 'Error Details:' },
  {
    LID: '3',
    TranslateData: "Détails de l'erreur:",
    TranslateKey: 'Error Details:',
  },
  {
    LID: '4',
    TranslateData: 'Подробная информация об ошибке:',
    TranslateKey: 'Error Details:',
  },
  {
    LID: '1',
    TranslateData: 'תיאור השגיאה:',
    TranslateKey: 'Error description:',
  },
  {
    LID: '2',
    TranslateData: 'Error description:',
    TranslateKey: 'Error description:',
  },
  {
    LID: '3',
    TranslateData: 'Erreur de description:',
    TranslateKey: 'Error description:',
  },
  {
    LID: '4',
    TranslateData: 'Описание ошибки:',
    TranslateKey: 'Error description:',
  },
  { LID: '1', TranslateData: 'קוד השגיאה:', TranslateKey: 'Error code:' },
  { LID: '2', TranslateData: 'Error code:', TranslateKey: 'Error code:' },
  { LID: '3', TranslateData: "Code d'erreur:", TranslateKey: 'Error code:' },
  { LID: '4', TranslateData: 'Код ошибки:', TranslateKey: 'Error code:' },
  {
    LID: '1',
    TranslateData: 'שגיאה בצירוף התמונה',
    TranslateKey: 'Error attaching image',
  },
  {
    LID: '2',
    TranslateData: 'Error uploading image',
    TranslateKey: 'Error attaching image',
  },
  {
    LID: '3',
    TranslateData: "Erreur lors de l'envoi de l'image",
    TranslateKey: 'Error attaching image',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка загрузки изображения',
    TranslateKey: 'Error attaching image',
  },
  { LID: '1', TranslateData: 'שגיאה', TranslateKey: 'Error' },
  { LID: '2', TranslateData: 'Error', TranslateKey: 'Error' },
  { LID: '3', TranslateData: '', TranslateKey: 'Error' },
  { LID: '4', TranslateData: 'Ошибка', TranslateKey: 'Error' },
  { LID: '1', TranslateData: 'שווים', TranslateKey: 'Equals' },
  { LID: '2', TranslateData: 'Equals', TranslateKey: 'Equals' },
  { LID: '3', TranslateData: '', TranslateKey: 'Equals' },
  { LID: '4', TranslateData: 'Равно', TranslateKey: 'Equals' },
  { LID: '1', TranslateData: 'כניסה', TranslateKey: 'Entrance' },
  { LID: '2', TranslateData: 'Entrance', TranslateKey: 'Entrance' },
  { LID: '3', TranslateData: 'entrée', TranslateKey: 'Entrance' },
  { LID: '4', TranslateData: 'Вход', TranslateKey: 'Entrance' },
  {
    LID: '1',
    TranslateData: 'הזן כתובת דוא"ל לקבלת אישורי התשלום',
    TranslateKey: 'Enter your email address to receive payment confirmations.',
  },
  {
    LID: '2',
    TranslateData: 'Enter your email address to receive payment confirmation',
    TranslateKey: 'Enter your email address to receive payment confirmations.',
  },
  {
    LID: '3',
    TranslateData:
      'Entrez votre adresse e-mail pour recevoir la confirmation de paiement',
    TranslateKey: 'Enter your email address to receive payment confirmations.',
  },
  {
    LID: '4',
    TranslateData:
      'Введите свой адрес электронной почты, чтобы получить подтверждение оплаты',
    TranslateKey: 'Enter your email address to receive payment confirmations.',
  },
  {
    LID: '1',
    TranslateData: "נכנסים לצ'אט של הקבוצה",
    TranslateKey: 'Enter the group chat',
  },
  {
    LID: '2',
    TranslateData: 'Enter the group chat',
    TranslateKey: 'Enter the group chat',
  },
  {
    LID: '3',
    TranslateData: 'Entrez dans le chat de groupe',
    TranslateKey: 'Enter the group chat',
  },
  {
    LID: '4',
    TranslateData: 'Войдите в групповой чат',
    TranslateKey: 'Enter the group chat',
  },
  {
    LID: '1',
    TranslateData: 'הזן כתובת מייל תקינה',
    TranslateKey: 'Enter a valid email address',
  },
  {
    LID: '2',
    TranslateData: 'Enter a valid email address',
    TranslateKey: 'Enter a valid email address',
  },
  {
    LID: '3',
    TranslateData: 'entrez une adresse e-mail valide',
    TranslateKey: 'Enter a valid email address',
  },
  {
    LID: '4',
    TranslateData: 'Введите действительный адрес электронной почты',
    TranslateKey: 'Enter a valid email address',
  },
  {
    LID: '1',
    TranslateData: 'טקסט לחיפוש',
    TranslateKey: 'Enter a phrase to search for an apartment',
  },
  {
    LID: '2',
    TranslateData: 'Text to search',
    TranslateKey: 'Enter a phrase to search for an apartment',
  },
  {
    LID: '3',
    TranslateData: 'Texte à rechercher',
    TranslateKey: 'Enter a phrase to search for an apartment',
  },
  {
    LID: '4',
    TranslateData: 'Текст для поиска',
    TranslateKey: 'Enter a phrase to search for an apartment',
  },
  { LID: '1', TranslateData: 'הכנס סיסמא', TranslateKey: 'Enter a password' },
  {
    LID: '2',
    TranslateData: 'Enter a password',
    TranslateKey: 'Enter a password',
  },
  { LID: '3', TranslateData: '', TranslateKey: 'Enter a password' },
  {
    LID: '4',
    TranslateData: 'введите пароль',
    TranslateKey: 'Enter a password',
  },
  { LID: '1', TranslateData: 'מסתיים עם', TranslateKey: 'Ends with' },
  { LID: '2', TranslateData: 'Ends with', TranslateKey: 'Ends with' },
  { LID: '3', TranslateData: '', TranslateKey: 'Ends with' },
  { LID: '4', TranslateData: 'Заканчивается на', TranslateKey: 'Ends with' },
  { LID: '1', TranslateData: 'שעת סיום', TranslateKey: 'End time' },
  { LID: '2', TranslateData: 'End time', TranslateKey: 'End time' },
  { LID: '3', TranslateData: 'Heure de fin', TranslateKey: 'End time' },
  { LID: '4', TranslateData: 'Время окончания', TranslateKey: 'End time' },
  { LID: '1', TranslateData: 'עובד', TranslateKey: 'Employee' },
  { LID: '2', TranslateData: 'Employee', TranslateKey: 'Employee' },
  { LID: '3', TranslateData: 'Employé', TranslateKey: 'Employee' },
  { LID: '4', TranslateData: 'Наемный рабочий', TranslateKey: 'Employee' },
  {
    LID: '1',
    TranslateData: 'בקשה לשינוי פרטי הפרופיל נשלחה לחברת הניהול !',
    TranslateKey: 'Email profile request request sent to management company!',
  },
  {
    LID: '2',
    TranslateData: 'Your request was sent to management company !',
    TranslateKey: 'Email profile request request sent to management company!',
  },
  {
    LID: '3',
    TranslateData: 'Votre demande a été envoyée à la société de gestion !',
    TranslateKey: 'Email profile request request sent to management company!',
  },
  {
    LID: '4',
    TranslateData: 'Ваш запрос отправлен в управляющую компанию!',
    TranslateKey: 'Email profile request request sent to management company!',
  },
  { LID: '1', TranslateData: 'אמייל', TranslateKey: 'Email' },
  { LID: '2', TranslateData: 'Email', TranslateKey: 'Email' },
  { LID: '3', TranslateData: '', TranslateKey: 'Email' },
  { LID: '4', TranslateData: 'Эл. адрес', TranslateKey: 'Email' },
  { LID: '1', TranslateData: 'עריכת אירוע', TranslateKey: 'Editing an event' },
  {
    LID: '2',
    TranslateData: 'Editing an event',
    TranslateKey: 'Editing an event',
  },
  {
    LID: '3',
    TranslateData: 'Modifier un événement',
    TranslateKey: 'Editing an event',
  },
  {
    LID: '4',
    TranslateData: 'Редактирование мероприятия',
    TranslateKey: 'Editing an event',
  },
  { LID: '1', TranslateData: 'עריכת הודעה', TranslateKey: 'Edit message' },
  { LID: '2', TranslateData: 'Edit message', TranslateKey: 'Edit message' },
  {
    LID: '3',
    TranslateData: 'Modifier le message',
    TranslateKey: 'Edit message',
  },
  {
    LID: '4',
    TranslateData: 'Редактировать сообщение',
    TranslateKey: 'Edit message',
  },
  { LID: '1', TranslateData: 'עריכת שער', TranslateKey: 'Edit Gate' },
  { LID: '2', TranslateData: 'Edit Gate', TranslateKey: 'Edit Gate' },
  { LID: '3', TranslateData: 'Modifier la porte', TranslateKey: 'Edit Gate' },
  { LID: '4', TranslateData: 'Изменить ворота', TranslateKey: 'Edit Gate' },
  { LID: '1', TranslateData: 'עריכת', TranslateKey: 'Edit a' },
  { LID: '2', TranslateData: 'Edit', TranslateKey: 'Edit a' },
  { LID: '3', TranslateData: 'Éditer', TranslateKey: 'Edit a' },
  { LID: '4', TranslateData: 'Редактировать', TranslateKey: 'Edit a' },
  { LID: '1', TranslateData: 'עריכה', TranslateKey: 'Edit' },
  { LID: '2', TranslateData: 'Edit', TranslateKey: 'Edit' },
  { LID: '3', TranslateData: 'Éditer', TranslateKey: 'Edit' },
  { LID: '4', TranslateData: 'Редактировать', TranslateKey: 'Edit' },
  { LID: '1', TranslateData: 'תאריך יעד', TranslateKey: 'Due Date' },
  { LID: '2', TranslateData: 'Due Date', TranslateKey: 'Due Date' },
  { LID: '3', TranslateData: "Date d'échéance", TranslateKey: 'Due Date' },
  { LID: '4', TranslateData: 'Срок оплаты', TranslateKey: 'Due Date' },
  { LID: '1', TranslateData: 'תאריך פירעון', TranslateKey: 'Due date' },
  { LID: '2', TranslateData: 'Due date', TranslateKey: 'Due date' },
  { LID: '3', TranslateData: "Date d'échéance", TranslateKey: 'Due date' },
  { LID: '4', TranslateData: 'Срок', TranslateKey: 'Due date' },
  { LID: '1', TranslateData: 'יעד', TranslateKey: 'Due' },
  { LID: '2', TranslateData: 'Due', TranslateKey: 'Due' },
  { LID: '3', TranslateData: 'Exigible', TranslateKey: 'Due' },
  { LID: '4', TranslateData: 'В связи', TranslateKey: 'Due' },
  {
    LID: '1',
    TranslateData: 'הורדת אפליקציה',
    TranslateKey: 'Downloading an app',
  },
  {
    LID: '2',
    TranslateData: 'Downloading an app',
    TranslateKey: 'Downloading an app',
  },
  {
    LID: '3',
    TranslateData: 'Télécharger une application',
    TranslateKey: 'Downloading an app',
  },
  {
    LID: '4',
    TranslateData: 'Загрузка приложения',
    TranslateKey: 'Downloading an app',
  },
  {
    LID: '1',
    TranslateData: 'אל תשמור את פרטי הכרטיס',
    TranslateKey: 'Dont Save Card Credentials',
  },
  {
    LID: '2',
    TranslateData: "Don't save my card details",
    TranslateKey: 'Dont Save Card Credentials',
  },
  {
    LID: '3',
    TranslateData: 'Ne pas enregistrer les détails de ma carte',
    TranslateKey: 'Dont Save Card Credentials',
  },
  {
    LID: '4',
    TranslateData: 'Не сохранять данные моей карты',
    TranslateKey: 'Dont Save Card Credentials',
  },
  { LID: '1', TranslateData: 'הסתיים', TranslateKey: 'Done' },
  { LID: '2', TranslateData: 'Done', TranslateKey: 'Done' },
  { LID: '3', TranslateData: 'Terminé', TranslateKey: 'Done' },
  { LID: '4', TranslateData: 'Сделанный', TranslateKey: 'Done' },
  { LID: '1', TranslateData: 'בחירת תחום', TranslateKey: 'Domain selection' },
  {
    LID: '2',
    TranslateData: 'Domain selection',
    TranslateKey: 'Domain selection',
  },
  {
    LID: '3',
    TranslateData: 'Sélection de domaine',
    TranslateKey: 'Domain selection',
  },
  { LID: '4', TranslateData: 'Выбор домена', TranslateKey: 'Domain selection' },
  { LID: '1', TranslateData: 'תחום נדרש', TranslateKey: 'Domain is required' },
  {
    LID: '2',
    TranslateData: 'Domain is required',
    TranslateKey: 'Domain is required',
  },
  {
    LID: '3',
    TranslateData: 'Le domaine est requis',
    TranslateKey: 'Domain is required',
  },
  {
    LID: '4',
    TranslateData: 'Требуется домен',
    TranslateKey: 'Domain is required',
  },
  { LID: '1', TranslateData: 'תחום', TranslateKey: 'Domain' },
  { LID: '2', TranslateData: 'Category', TranslateKey: 'Domain' },
  { LID: '3', TranslateData: 'Catégorie', TranslateKey: 'Domain' },
  { LID: '4', TranslateData: 'Категория', TranslateKey: 'Domain' },
  {
    LID: '1',
    TranslateData: 'לא תופס מסגרת',
    TranslateKey: 'Does not occupy a frame',
  },
  {
    LID: '2',
    TranslateData: 'Does not occupy a frame',
    TranslateKey: 'Does not occupy a frame',
  },
  {
    LID: '3',
    TranslateData: "N'occupe pas de cadre",
    TranslateKey: 'Does not occupy a frame',
  },
  {
    LID: '4',
    TranslateData: 'Не занимает рамку',
    TranslateKey: 'Does not occupy a frame',
  },
  {
    LID: '1',
    TranslateData: 'לא תופס מסגרת, מאובטח. ',
    TranslateKey: 'Does not grab a frame, secure.',
  },
  {
    LID: '2',
    TranslateData: 'Fast, secure and easy.',
    TranslateKey: 'Does not grab a frame, secure.',
  },
  {
    LID: '3',
    TranslateData: 'Rapide, sûr et facile.',
    TranslateKey: 'Does not grab a frame, secure.',
  },
  {
    LID: '4',
    TranslateData: 'Быстро, надежно и просто.',
    TranslateKey: 'Does not grab a frame, secure.',
  },
  {
    LID: '1',
    TranslateData: 'מסמכים ליחידה',
    TranslateKey: 'Documents Per Unit',
  },
  {
    LID: '2',
    TranslateData: 'Unit documents',
    TranslateKey: 'Documents Per Unit',
  },
  {
    LID: '3',
    TranslateData: "Documents de l'unité",
    TranslateKey: 'Documents Per Unit',
  },
  {
    LID: '4',
    TranslateData: 'Документы на единицу',
    TranslateKey: 'Documents Per Unit',
  },
  {
    LID: '1',
    TranslateData:
      'האם ברצונך לשלם באמצעות הכרטיס ששמור במערכת שמסתיים ב {0} תוקף {1} ?',
    TranslateKey:
      'Do you want to pay using the card saved in the system that ends in {0} and expires on {1}?',
  },
  {
    LID: '2',
    TranslateData:
      'Do you want to pay using the card saved in the system that ends in {0} and expires on {1}?',
    TranslateKey:
      'Do you want to pay using the card saved in the system that ends in {0} and expires on {1}?',
  },
  {
    LID: '3',
    TranslateData:
      'Souhaitez-vous payer avec la carte enregistrée dans le système qui se termine en {0} et expire le {1} ?',
    TranslateKey:
      'Do you want to pay using the card saved in the system that ends in {0} and expires on {1}?',
  },
  {
    LID: '4',
    TranslateData:
      'Хотите оплатить с помощью карты, сохраненной в системе, срок действия которой заканчивается на {0} и заканчивается на {1}?',
    TranslateKey:
      'Do you want to pay using the card saved in the system that ends in {0} and expires on {1}?',
  },
  {
    LID: '1',
    TranslateData: 'האם ברצונך לבטל את הפניה?',
    TranslateKey: 'Do you want to cancel the service call?',
  },
  {
    LID: '2',
    TranslateData: 'Do you want to cancel the service call?',
    TranslateKey: 'Do you want to cancel the service call?',
  },
  {
    LID: '3',
    TranslateData: 'Voulez-vous annuler le parrainage ?',
    TranslateKey: 'Do you want to cancel the service call?',
  },
  {
    LID: '4',
    TranslateData: 'Вы хотите отменить реферал?',
    TranslateKey: 'Do you want to cancel the service call?',
  },
  {
    LID: '1',
    TranslateData: 'האם ברצונך להוסיף חשבונית להוצאה?',
    TranslateKey: 'Do you want to add an invoice for spending?',
  },
  {
    LID: '2',
    TranslateData: 'Do you want to add an invoice for spending?',
    TranslateKey: 'Do you want to add an invoice for spending?',
  },
  {
    LID: '3',
    TranslateData: 'Voulez-vous ajouter une facture pour vos dépenses ?',
    TranslateKey: 'Do you want to add an invoice for spending?',
  },
  {
    LID: '4',
    TranslateData: 'Вы хотите добавить счет для расходов?',
    TranslateKey: 'Do you want to add an invoice for spending?',
  },
  {
    LID: '1',
    TranslateData: 'אל תציג הודעה זו שוב',
    TranslateKey: 'Do not show this message again',
  },
  {
    LID: '2',
    TranslateData: 'Do not show this message again',
    TranslateKey: 'Do not show this message again',
  },
  {
    LID: '3',
    TranslateData: 'Ne plus afficher ce message',
    TranslateKey: 'Do not show this message again',
  },
  {
    LID: '4',
    TranslateData: 'Не показывать это сообщение снова',
    TranslateKey: 'Do not show this message again',
  },
  { LID: '1', TranslateData: 'לא יודע', TranslateKey: 'Do not know' },
  { LID: '2', TranslateData: 'Do not know', TranslateKey: 'Do not know' },
  { LID: '3', TranslateData: 'Ne sait pas', TranslateKey: 'Do not know' },
  { LID: '4', TranslateData: 'Не знать', TranslateKey: 'Do not know' },
  { LID: '1', TranslateData: 'לא להציג', TranslateKey: 'Do not display' },
  { LID: '2', TranslateData: 'Do not display', TranslateKey: 'Do not display' },
  {
    LID: '3',
    TranslateData: 'Ne pas afficher',
    TranslateKey: 'Do not display',
  },
  { LID: '4', TranslateData: 'Не отображать', TranslateKey: 'Do not display' },
  { LID: '1', TranslateData: 'טלפון מחייג', TranslateKey: 'Dialing phone' },
  { LID: '2', TranslateData: 'Dialing phone', TranslateKey: 'Dialing phone' },
  {
    LID: '3',
    TranslateData: 'Composer un numéro de téléphone',
    TranslateKey: 'Dialing phone',
  },
  {
    LID: '4',
    TranslateData: 'Набор номера телефона',
    TranslateKey: 'Dialing phone',
  },
  {
    LID: '1',
    TranslateData: 'פרטי הבניין',
    TranslateKey: 'Details of the building',
  },
  {
    LID: '2',
    TranslateData: 'Details of the building',
    TranslateKey: 'Details of the building',
  },
  {
    LID: '3',
    TranslateData: 'Détails du bâtiment',
    TranslateKey: 'Details of the building',
  },
  {
    LID: '4',
    TranslateData: 'Детали здания',
    TranslateKey: 'Details of the building',
  },
  {
    LID: '1',
    TranslateData: 'פירוט מצב כספי',
    TranslateKey: 'Details of financial situation',
  },
  {
    LID: '2',
    TranslateData: 'Details of financial status',
    TranslateKey: 'Details of financial situation',
  },
  {
    LID: '3',
    TranslateData: 'Détails de la situation financière',
    TranslateKey: 'Details of financial situation',
  },
  {
    LID: '4',
    TranslateData: 'Подробная информация о финансовом состоянии',
    TranslateKey: 'Details of financial situation',
  },
  { LID: '1', TranslateData: 'פירוט חובות', TranslateKey: 'Details of debts' },
  {
    LID: '2',
    TranslateData: 'Details of debt',
    TranslateKey: 'Details of debts',
  },
  {
    LID: '3',
    TranslateData: 'Détails de la dette',
    TranslateKey: 'Details of debts',
  },
  { LID: '4', TranslateData: 'Детали долга', TranslateKey: 'Details of debts' },
  {
    LID: '1',
    TranslateData: 'דוח כספי מפורט',
    TranslateKey: 'Detailed financial report',
  },
  {
    LID: '2',
    TranslateData: 'Detailed financial report',
    TranslateKey: 'Detailed financial report',
  },
  {
    LID: '3',
    TranslateData: 'Rapport financier détaillé',
    TranslateKey: 'Detailed financial report',
  },
  {
    LID: '4',
    TranslateData: 'Подробный финансовый отчет',
    TranslateKey: 'Detailed financial report',
  },
  {
    LID: '1',
    TranslateData: 'תיאור הביקור',
    TranslateKey: 'Description of the visit',
  },
  {
    LID: '2',
    TranslateData: 'Description of the visit',
    TranslateKey: 'Description of the visit',
  },
  {
    LID: '3',
    TranslateData: 'Descriptif de la visite',
    TranslateKey: 'Description of the visit',
  },
  {
    LID: '4',
    TranslateData: 'Описание визита',
    TranslateKey: 'Description of the visit',
  },
  {
    LID: '1',
    TranslateData: 'תיאור האפליקציה',
    TranslateKey: 'Description of the application',
  },
  {
    LID: '2',
    TranslateData: 'Description of the application',
    TranslateKey: 'Description of the application',
  },
  {
    LID: '3',
    TranslateData: 'Descriptif de la demande',
    TranslateKey: 'Description of the application',
  },
  {
    LID: '4',
    TranslateData: 'Описание приложения',
    TranslateKey: 'Description of the application',
  },
  {
    LID: '1',
    TranslateData: 'תיאור נדרש',
    TranslateKey: 'Description is required',
  },
  {
    LID: '2',
    TranslateData: 'Description is required',
    TranslateKey: 'Description is required',
  },
  {
    LID: '3',
    TranslateData: 'La description est requise',
    TranslateKey: 'Description is required',
  },
  {
    LID: '4',
    TranslateData: 'Требуется описание',
    TranslateKey: 'Description is required',
  },
  { LID: '1', TranslateData: 'תיאור', TranslateKey: 'Description' },
  { LID: '2', TranslateData: 'Description', TranslateKey: 'Description' },
  { LID: '3', TranslateData: 'La description', TranslateKey: 'Description' },
  { LID: '4', TranslateData: 'Описание', TranslateKey: 'Description' },
  { LID: '1', TranslateData: 'סדר יורד', TranslateKey: 'descending order' },
  {
    LID: '2',
    TranslateData: 'descending order',
    TranslateKey: 'descending order',
  },
  {
    LID: '3',
    TranslateData: 'Ordre décroissant',
    TranslateKey: 'descending order',
  },
  {
    LID: '4',
    TranslateData: 'в порядке убывания',
    TranslateKey: 'descending order',
  },
  { LID: '1', TranslateData: 'הפקדה', TranslateKey: 'deposit' },
  { LID: '2', TranslateData: 'deposit', TranslateKey: 'deposit' },
  { LID: '3', TranslateData: 'verser', TranslateKey: 'deposit' },
  { LID: '4', TranslateData: 'депозит', TranslateKey: 'deposit' },
  { LID: '1', TranslateData: 'לא מאשר', TranslateKey: 'Deny' },
  { LID: '2', TranslateData: 'Deny', TranslateKey: 'Deny' },
  { LID: '3', TranslateData: 'Refuser', TranslateKey: 'Deny' },
  { LID: '4', TranslateData: 'Отрицать', TranslateKey: 'Deny' },
  { LID: '1', TranslateData: 'מסירה', TranslateKey: 'delivery' },
  { LID: '2', TranslateData: 'delivery', TranslateKey: 'delivery' },
  { LID: '3', TranslateData: 'livraison', TranslateKey: 'delivery' },
  { LID: '4', TranslateData: 'доставка', TranslateKey: 'delivery' },
  { LID: '1', TranslateData: 'נמסר ל', TranslateKey: 'Delivered to' },
  { LID: '2', TranslateData: 'Delivered to', TranslateKey: 'Delivered to' },
  { LID: '3', TranslateData: 'Livré à', TranslateKey: 'Delivered to' },
  { LID: '4', TranslateData: 'Доставлен в', TranslateKey: 'Delivered to' },
  { LID: '1', TranslateData: 'שם מוסר', TranslateKey: 'Delivered by' },
  { LID: '2', TranslateData: 'Delivered name', TranslateKey: 'Delivered by' },
  { LID: '3', TranslateData: 'Livrer', TranslateKey: 'Delivered by' },
  { LID: '4', TranslateData: 'Доставлять', TranslateKey: 'Delivered by' },
  {
    LID: '1',
    TranslateData: 'מחיקת פרטי משתמש',
    TranslateKey: 'Deleting the details',
  },
  {
    LID: '2',
    TranslateData: 'Deleting user information',
    TranslateKey: 'Deleting the details',
  },
  {
    LID: '3',
    TranslateData: 'Suppression des détails',
    TranslateKey: 'Deleting the details',
  },
  {
    LID: '4',
    TranslateData: 'Удаление информации о пользователе',
    TranslateKey: 'Deleting the details',
  },
  {
    LID: '1',
    TranslateData: 'מחק פרטי כרטיס',
    TranslateKey: 'Delete card details',
  },
  {
    LID: '2',
    TranslateData: 'Delete card details',
    TranslateKey: 'Delete card details',
  },
  {
    LID: '3',
    TranslateData: 'Supprimer les détails de la carte',
    TranslateKey: 'Delete card details',
  },
  {
    LID: '4',
    TranslateData: 'Удалить данные карты',
    TranslateKey: 'Delete card details',
  },
  { LID: '1', TranslateData: 'מחק', TranslateKey: 'Delete' },
  { LID: '2', TranslateData: 'Delete', TranslateKey: 'Delete' },
  { LID: '3', TranslateData: 'Effacer', TranslateKey: 'Delete' },
  { LID: '4', TranslateData: 'Удалить', TranslateKey: 'Delete' },
  { LID: '1', TranslateData: 'הגדר תוקף', TranslateKey: 'Define validity' },
  {
    LID: '2',
    TranslateData: 'Define validity',
    TranslateKey: 'Define validity',
  },
  {
    LID: '3',
    TranslateData: 'Définir la validité',
    TranslateKey: 'Define validity',
  },
  {
    LID: '4',
    TranslateData: 'Определить действительность',
    TranslateKey: 'Define validity',
  },
  { LID: '1', TranslateData: 'דצמבר', TranslateKey: 'December' },
  { LID: '2', TranslateData: 'December', TranslateKey: 'December' },
  { LID: '3', TranslateData: 'Décembre', TranslateKey: 'December' },
  { LID: '4', TranslateData: 'Декабрь', TranslateKey: 'December' },
  { LID: '1', TranslateData: 'דצמבר', TranslateKey: 'Dec' },
  { LID: '2', TranslateData: 'Dec', TranslateKey: 'Dec' },
  { LID: '3', TranslateData: 'Déc', TranslateKey: 'Dec' },
  { LID: '4', TranslateData: 'декабрь', TranslateKey: 'Dec' },
  { LID: '1', TranslateData: 'חוב', TranslateKey: 'Debt' },
  { LID: '2', TranslateData: 'Debt', TranslateKey: 'Debt' },
  { LID: '3', TranslateData: 'Dette', TranslateKey: 'Debt' },
  { LID: '4', TranslateData: 'Долг', TranslateKey: 'Debt' },
  { LID: '1', TranslateData: 'תאריך בקשה', TranslateKey: 'Date please' },
  { LID: '2', TranslateData: 'Request date', TranslateKey: 'Date please' },
  {
    LID: '3',
    TranslateData: 'Date de la demande',
    TranslateKey: 'Date please',
  },
  { LID: '4', TranslateData: 'Дата заказа', TranslateKey: 'Date please' },
  { LID: '1', TranslateData: 'תאריך תשלום', TranslateKey: 'Date of payment' },
  { LID: '2', TranslateData: 'Payment date', TranslateKey: 'Date of payment' },
  {
    LID: '3',
    TranslateData: 'Date de paiement',
    TranslateKey: 'Date of payment',
  },
  { LID: '4', TranslateData: 'Дата платежа', TranslateKey: 'Date of payment' },
  { LID: '1', TranslateData: 'תאריך פעולה', TranslateKey: 'Date of operation' },
  {
    LID: '2',
    TranslateData: 'Date of operation',
    TranslateKey: 'Date of operation',
  },
  {
    LID: '3',
    TranslateData: "Date d'opération",
    TranslateKey: 'Date of operation',
  },
  {
    LID: '4',
    TranslateData: 'Дата операции',
    TranslateKey: 'Date of operation',
  },
  { LID: '1', TranslateData: 'ת.פעולה', TranslateKey: 'Date of operation' },
  { LID: '2', TranslateData: 'Action date', TranslateKey: 'Date of operation' },
  {
    LID: '3',
    TranslateData: "Date d'intervention",
    TranslateKey: 'Date of operation',
  },
  {
    LID: '4',
    TranslateData: 'Дата действия',
    TranslateKey: 'Date of operation',
  },
  {
    LID: '1',
    TranslateData: 'תאריך מתן הצעה',
    TranslateKey: 'Date of bidding',
  },
  { LID: '2', TranslateData: 'Date of quote', TranslateKey: 'Date of bidding' },
  { LID: '3', TranslateData: 'Date de devis', TranslateKey: 'Date of bidding' },
  {
    LID: '4',
    TranslateData: 'Дата предложения',
    TranslateKey: 'Date of bidding',
  },
  { LID: '1', TranslateData: 'תאריך לא', TranslateKey: 'Date is not' },
  { LID: '2', TranslateData: 'Date is not', TranslateKey: 'Date is not' },
  { LID: '3', TranslateData: "La date n'est pas", TranslateKey: 'Date is not' },
  { LID: '4', TranslateData: 'Дата не', TranslateKey: 'Date is not' },
  {
    LID: '1',
    TranslateData: 'התאריך הוא לפני',
    TranslateKey: 'Date is before',
  },
  { LID: '2', TranslateData: 'Date is before', TranslateKey: 'Date is before' },
  {
    LID: '3',
    TranslateData: 'La date est antérieure',
    TranslateKey: 'Date is before',
  },
  {
    LID: '4',
    TranslateData: 'Дата предшествует',
    TranslateKey: 'Date is before',
  },
  { LID: '1', TranslateData: 'התאריך הוא אחרי', TranslateKey: 'Date is after' },
  { LID: '2', TranslateData: 'Date is after', TranslateKey: 'Date is after' },
  {
    LID: '3',
    TranslateData: 'La date est après',
    TranslateKey: 'Date is after',
  },
  { LID: '4', TranslateData: 'Дата после', TranslateKey: 'Date is after' },
  { LID: '1', TranslateData: 'התאריך הוא', TranslateKey: 'Date is' },
  { LID: '2', TranslateData: 'Date is', TranslateKey: 'Date is' },
  { LID: '3', TranslateData: 'La date est', TranslateKey: 'Date is' },
  { LID: '4', TranslateData: 'Дата', TranslateKey: 'Date is' },
  { LID: '1', TranslateData: 'תאריך ושעה:', TranslateKey: 'Date and time:' },
  { LID: '2', TranslateData: 'Date and time:', TranslateKey: 'Date and time:' },
  {
    LID: '3',
    TranslateData: "Date et l'heure:",
    TranslateKey: 'Date and time:',
  },
  { LID: '4', TranslateData: 'Дата и время:', TranslateKey: 'Date and time:' },
  {
    LID: '1',
    TranslateData: 'תאריך ושעת קבלה',
    TranslateKey: 'Date and time of reception',
  },
  {
    LID: '2',
    TranslateData: 'Date and time of reception',
    TranslateKey: 'Date and time of reception',
  },
  {
    LID: '3',
    TranslateData: 'Date et heure de réception',
    TranslateKey: 'Date and time of reception',
  },
  {
    LID: '4',
    TranslateData: 'Дата и время приема',
    TranslateKey: 'Date and time of reception',
  },
  {
    LID: '1',
    TranslateData: 'תאריך ושעת איסוף',
    TranslateKey: 'Date and time of collection',
  },
  {
    LID: '2',
    TranslateData: 'Date and time of collection',
    TranslateKey: 'Date and time of collection',
  },
  {
    LID: '3',
    TranslateData: 'Date et heure de collecte',
    TranslateKey: 'Date and time of collection',
  },
  {
    LID: '4',
    TranslateData: 'Дата и время сбора',
    TranslateKey: 'Date and time of collection',
  },
  { LID: '1', TranslateData: 'תאריך ושעה', TranslateKey: 'Date and time' },
  { LID: '2', TranslateData: 'Date and time', TranslateKey: 'Date and time' },
  { LID: '3', TranslateData: "Date et l'heure", TranslateKey: 'Date and time' },
  { LID: '4', TranslateData: 'Дата и время', TranslateKey: 'Date and time' },
  { LID: '1', TranslateData: 'תאריך', TranslateKey: 'Date' },
  { LID: '2', TranslateData: 'Date', TranslateKey: 'Date' },
  { LID: '3', TranslateData: 'Date', TranslateKey: 'Date' },
  { LID: '4', TranslateData: 'Дата', TranslateKey: 'Date' },
  {
    LID: '1',
    TranslateData: 'הנתונים נשמרו בהצלחה!',
    TranslateKey: 'Data saved successfully!',
  },
  {
    LID: '2',
    TranslateData: 'Data saved successfully!',
    TranslateKey: 'Data saved successfully!',
  },
  {
    LID: '3',
    TranslateData: 'Données enregistrées avec succès !',
    TranslateKey: 'Data saved successfully!',
  },
  {
    LID: '4',
    TranslateData: 'Данные успешно сохранены!',
    TranslateKey: 'Data saved successfully!',
  },
  { LID: '1', TranslateData: 'תכנון יומי', TranslateKey: 'Daily Plan' },
  { LID: '2', TranslateData: 'Daily Plan', TranslateKey: 'Daily Plan' },
  { LID: '3', TranslateData: 'Forfait quotidien', TranslateKey: 'Daily Plan' },
  { LID: '4', TranslateData: 'Ежедневный план', TranslateKey: 'Daily Plan' },
  {
    LID: '1',
    TranslateData: 'חוב שנה נוכחית',
    TranslateKey: 'Current year debt',
  },
  {
    LID: '2',
    TranslateData: 'Current year debt',
    TranslateKey: 'Current year debt',
  },
  {
    LID: '3',
    TranslateData: "Dette de l'année en cours",
    TranslateKey: 'Current year debt',
  },
  {
    LID: '4',
    TranslateData: 'Долг текущего года',
    TranslateKey: 'Current year debt',
  },
  { LID: '1', TranslateData: 'שוטף', TranslateKey: 'current' },
  { LID: '2', TranslateData: 'current', TranslateKey: 'current' },
  { LID: '3', TranslateData: 'actuel', TranslateKey: 'current' },
  { LID: '4', TranslateData: 'actuel', TranslateKey: 'current' },
  { LID: '1', TranslateData: 'מאזן מצטבר', TranslateKey: 'Cumulative balance' },
  {
    LID: '2',
    TranslateData: 'Cumulative balance',
    TranslateKey: 'Cumulative balance',
  },
  {
    LID: '3',
    TranslateData: 'Solde cumulé',
    TranslateKey: 'Cumulative balance',
  },
  {
    LID: '4',
    TranslateData: 'Накопительный баланс',
    TranslateKey: 'Cumulative balance',
  },
  {
    LID: '1',
    TranslateData: 'יצירת הוראת קבע',
    TranslateKey: 'Creating a standing order',
  },
  {
    LID: '2',
    TranslateData: 'Creating a standing order',
    TranslateKey: 'Creating a standing order',
  },
  {
    LID: '3',
    TranslateData: "Création d'un ordre permanent",
    TranslateKey: 'Creating a standing order',
  },
  {
    LID: '4',
    TranslateData: 'Создание постоянного поручения',
    TranslateKey: 'Creating a standing order',
  },
  { LID: '1', TranslateData: 'הוספת שער', TranslateKey: 'Create Gate' },
  { LID: '2', TranslateData: 'Create Gate', TranslateKey: 'Create Gate' },
  { LID: '3', TranslateData: 'Créer une porte', TranslateKey: 'Create Gate' },
  { LID: '4', TranslateData: 'Создать ворота', TranslateKey: 'Create Gate' },
  {
    LID: '1',
    TranslateData: 'צור קריאת שירות',
    TranslateKey: 'Create a service call',
  },
  {
    LID: '2',
    TranslateData: 'Create a service call',
    TranslateKey: 'Create a service call',
  },
  {
    LID: '3',
    TranslateData: 'Créer un appel de service',
    TranslateKey: 'Create a service call',
  },
  {
    LID: '4',
    TranslateData: 'Создать сервисный вызов',
    TranslateKey: 'Create a service call',
  },
  { LID: '1', TranslateData: 'כמות', TranslateKey: 'Count' },
  { LID: '2', TranslateData: 'Count', TranslateKey: 'Count' },
  { LID: '3', TranslateData: 'Compter', TranslateKey: 'Count' },
  { LID: '4', TranslateData: 'Считать', TranslateKey: 'Count' },
  {
    LID: '1',
    TranslateData: 'עותק למנהל אחזקה',
    TranslateKey: 'Copy to maintenance manager',
  },
  {
    LID: '2',
    TranslateData: 'Copy to maintenance manager',
    TranslateKey: 'Copy to maintenance manager',
  },
  {
    LID: '3',
    TranslateData: 'Copie au responsable de la maintenance',
    TranslateKey: 'Copy to maintenance manager',
  },
  {
    LID: '4',
    TranslateData: 'Скопировать менеджеру по обслуживанию',
    TranslateKey: 'Copy to maintenance manager',
  },
  { LID: '1', TranslateData: 'המשך', TranslateKey: 'Continue' },
  { LID: '2', TranslateData: 'Continue', TranslateKey: 'Continue' },
  { LID: '3', TranslateData: 'A continué', TranslateKey: 'Continue' },
  { LID: '4', TranslateData: 'A continué', TranslateKey: 'Continue' },
  {
    LID: '1',
    TranslateData: 'תוכן העדכון',
    TranslateKey: 'Content of the update',
  },
  {
    LID: '2',
    TranslateData: 'Update details',
    TranslateKey: 'Content of the update',
  },
  {
    LID: '3',
    TranslateData: 'Mettre à jour les détails',
    TranslateKey: 'Content of the update',
  },
  {
    LID: '4',
    TranslateData: 'Детали обновления',
    TranslateKey: 'Content of the update',
  },
  { LID: '1', TranslateData: 'תוכן', TranslateKey: 'Content' },
  { LID: '2', TranslateData: 'Content', TranslateKey: 'Content' },
  { LID: '3', TranslateData: 'Teneur', TranslateKey: 'Content' },
  { LID: '4', TranslateData: 'Содержание', TranslateKey: 'Content' },
  { LID: '1', TranslateData: 'מכיל', TranslateKey: 'Contains' },
  { LID: '2', TranslateData: 'Contains', TranslateKey: 'Contains' },
  { LID: '3', TranslateData: 'Contient', TranslateKey: 'Contains' },
  { LID: '4', TranslateData: 'Содержит', TranslateKey: 'Contains' },
  { LID: '1', TranslateData: 'אנשי קשר', TranslateKey: 'Contacts' },
  { LID: '2', TranslateData: 'Contacts', TranslateKey: 'Contacts' },
  { LID: '3', TranslateData: 'Contacts', TranslateKey: 'Contacts' },
  { LID: '4', TranslateData: 'Контакты', TranslateKey: 'Contacts' },
  { LID: '1', TranslateData: 'צור קשר', TranslateKey: 'Contact Us' },
  { LID: '2', TranslateData: 'Contact Us', TranslateKey: 'Contact Us' },
  { LID: '3', TranslateData: 'Contactez-nous', TranslateKey: 'Contact Us' },
  { LID: '4', TranslateData: 'Связаться с нами', TranslateKey: 'Contact Us' },
  { LID: '1', TranslateData: 'סוג דייר', TranslateKey: 'Contact Type' },
  { LID: '2', TranslateData: 'Contact Type', TranslateKey: 'Contact Type' },
  { LID: '3', TranslateData: 'type de contact', TranslateKey: 'Contact Type' },
  { LID: '4', TranslateData: 'Тип контакта', TranslateKey: 'Contact Type' },
  {
    LID: '1',
    TranslateData: 'יש לפנות טלפונית לחברת הניהול',
    TranslateKey: 'Contact the management company by phone',
  },
  {
    LID: '2',
    TranslateData: 'Contact the management company by phone',
    TranslateKey: 'Contact the management company by phone',
  },
  {
    LID: '3',
    TranslateData: 'Contacter la société de gestion par téléphone',
    TranslateKey: 'Contact the management company by phone',
  },
  {
    LID: '4',
    TranslateData: 'Связаться с управляющей компанией по телефону',
    TranslateKey: 'Contact the management company by phone',
  },
  {
    LID: '1',
    TranslateData: 'צור קשר עם התמיכה',
    TranslateKey: 'Contact support',
  },
  {
    LID: '2',
    TranslateData: 'Contact support',
    TranslateKey: 'Contact support',
  },
  {
    LID: '3',
    TranslateData: 'Connecter Sofort',
    TranslateKey: 'Contact support',
  },
  {
    LID: '4',
    TranslateData: 'Соединим Софорт',
    TranslateKey: 'Contact support',
  },
  {
    LID: '1',
    TranslateData: 'איש הקשר נשמר בהצלחה',
    TranslateKey: 'Contact saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'Contact saved successfully',
    TranslateKey: 'Contact saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Contact enregistré avec succès',
    TranslateKey: 'Contact saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Контакт успешно сохранен',
    TranslateKey: 'Contact saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'פרטי איש קשר לתיאום ושאלות',
    TranslateKey: 'Contact details for coordination and questions',
  },
  {
    LID: '2',
    TranslateData: 'Contact details for more details',
    TranslateKey: 'Contact details for coordination and questions',
  },
  {
    LID: '3',
    TranslateData: 'Coordonnées pour plus de détails',
    TranslateKey: 'Contact details for coordination and questions',
  },
  {
    LID: '4',
    TranslateData: 'Контактные данные для более подробной информации',
    TranslateKey: 'Contact details for coordination and questions',
  },
  {
    LID: '1',
    TranslateData: 'איש הקשר נמחק בהצלחה',
    TranslateKey: 'Contact deleted successfully',
  },
  {
    LID: '2',
    TranslateData: 'Contact deleted successfully',
    TranslateKey: 'Contact deleted successfully',
  },
  {
    LID: '3',
    TranslateData: 'Contact supprimé avec succès',
    TranslateKey: 'Contact deleted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Контакт успешно удален',
    TranslateKey: 'Contact deleted successfully',
  },
  {
    LID: '1',
    TranslateData: 'הדייר כבר רשום לבניין זה',
    TranslateKey: 'contact already exists',
  },
  {
    LID: '2',
    TranslateData: 'contact already exists',
    TranslateKey: 'contact already exists',
  },
  {
    LID: '3',
    TranslateData: 'le contact existe déjà',
    TranslateKey: 'contact already exists',
  },
  {
    LID: '4',
    TranslateData: 'контакт уже существует',
    TranslateKey: 'contact already exists',
  },
  { LID: '1', TranslateData: 'איש קשר', TranslateKey: 'Contact' },
  { LID: '2', TranslateData: 'Contact', TranslateKey: 'Contact' },
  { LID: '3', TranslateData: 'Contact', TranslateKey: 'Contact' },
  { LID: '4', TranslateData: 'Контакт', TranslateKey: 'Contact' },
  {
    LID: '1',
    TranslateData: 'מאשר את תנאי השימוש',
    TranslateKey: 'Confirms the terms of use',
  },
  {
    LID: '2',
    TranslateData: 'Confirms the terms of use',
    TranslateKey: 'Confirms the terms of use',
  },
  {
    LID: '3',
    TranslateData: "Confirme les conditions d'utilisation",
    TranslateKey: 'Confirms the terms of use',
  },
  {
    LID: '4',
    TranslateData: "Confirme les conditions d'utilisation",
    TranslateKey: 'Confirms the terms of use',
  },
  { LID: '1', TranslateData: "אישור מס'", TranslateKey: 'Confirmation No.' },
  {
    LID: '2',
    TranslateData: 'Confirmation No.',
    TranslateKey: 'Confirmation No.',
  },
  {
    LID: '3',
    TranslateData: 'Confirmation Non.',
    TranslateKey: 'Confirmation No.',
  },
  {
    LID: '4',
    TranslateData: 'Подтверждение №',
    TranslateKey: 'Confirmation No.',
  },
  { LID: '1', TranslateData: 'מאשר', TranslateKey: 'Confirm' },
  { LID: '2', TranslateData: 'Confirm', TranslateKey: 'Confirm' },
  { LID: '3', TranslateData: 'Confirmer', TranslateKey: 'Confirm' },
  { LID: '4', TranslateData: 'Подтверждать', TranslateKey: 'Confirm' },
  { LID: '1', TranslateData: 'מתחם', TranslateKey: 'compound' },
  { LID: '2', TranslateData: 'compound', TranslateKey: 'compound' },
  { LID: '3', TranslateData: 'composée', TranslateKey: 'compound' },
  { LID: '4', TranslateData: 'сложный', TranslateKey: 'compound' },
  { LID: '1', TranslateData: 'השתתפות חברה', TranslateKey: 'Company share' },
  { LID: '2', TranslateData: 'Company share', TranslateKey: 'Company share' },
  {
    LID: '3',
    TranslateData: "Part de l'entreprise",
    TranslateKey: 'Company share',
  },
  { LID: '4', TranslateData: 'Доля компании', TranslateKey: 'Company share' },
  { LID: '1', TranslateData: 'שם החברה', TranslateKey: 'Company Name' },
  { LID: '2', TranslateData: 'Company Name', TranslateKey: 'Company Name' },
  {
    LID: '3',
    TranslateData: "Nom de l'entreprise",
    TranslateKey: 'Company Name',
  },
  {
    LID: '4',
    TranslateData: 'Название компании',
    TranslateKey: 'Company Name',
  },
  { LID: '1', TranslateData: 'לוגו החברה', TranslateKey: 'Company logo' },
  { LID: '2', TranslateData: 'Company logo', TranslateKey: 'Company logo' },
  {
    LID: '3',
    TranslateData: "Logo d'entreprise",
    TranslateKey: 'Company logo',
  },
  { LID: '4', TranslateData: 'Логотип компании', TranslateKey: 'Company logo' },
  { LID: '1', TranslateData: 'קוד חברה', TranslateKey: 'Company code' },
  { LID: '2', TranslateData: 'Company code', TranslateKey: 'Company code' },
  {
    LID: '3',
    TranslateData: "Code de l'entreprise",
    TranslateKey: 'Company code',
  },
  { LID: '4', TranslateData: 'Код компании', TranslateKey: 'Company code' },
  {
    LID: '1',
    TranslateData: 'פרטי החברה והבניין',
    TranslateKey: 'Company and building details',
  },
  {
    LID: '2',
    TranslateData: 'Company and building details',
    TranslateKey: 'Company and building details',
  },
  {
    LID: '3',
    TranslateData: "Détails de l'entreprise et du bâtiment",
    TranslateKey: 'Company and building details',
  },
  {
    LID: '4',
    TranslateData: 'Детали компании и здания',
    TranslateKey: 'Company and building details',
  },
  { LID: '1', TranslateData: 'חברי ועד', TranslateKey: 'Committee members' },
  {
    LID: '2',
    TranslateData: 'Committee members',
    TranslateKey: 'Committee members',
  },
  {
    LID: '3',
    TranslateData: 'les membres du comité',
    TranslateKey: 'Committee members',
  },
  {
    LID: '4',
    TranslateData: 'Члены комитета',
    TranslateKey: 'Committee members',
  },
  { LID: '1', TranslateData: 'הערות', TranslateKey: 'Comments' },
  { LID: '2', TranslateData: 'Comments', TranslateKey: 'Comments' },
  { LID: '3', TranslateData: 'commentaires', TranslateKey: 'Comments' },
  { LID: '4', TranslateData: 'Комментарии', TranslateKey: 'Comments' },
  { LID: '1', TranslateData: 'הערה', TranslateKey: 'Comment' },
  { LID: '2', TranslateData: 'Comment', TranslateKey: 'Comment' },
  { LID: '3', TranslateData: 'Commentaire', TranslateKey: 'Comment' },
  { LID: '4', TranslateData: 'Комментарий', TranslateKey: 'Comment' },
  { LID: '1', TranslateData: 'מצב הגבייה', TranslateKey: 'Collection mode' },
  {
    LID: '2',
    TranslateData: 'Collection mode',
    TranslateKey: 'Collection mode',
  },
  {
    LID: '3',
    TranslateData: 'Mode de collecte',
    TranslateKey: 'Collection mode',
  },
  { LID: '4', TranslateData: 'Режим сбора', TranslateKey: 'Collection mode' },
  { LID: '1', TranslateData: 'איסוף מפתח', TranslateKey: 'Collection Key' },
  { LID: '2', TranslateData: 'Collection Key', TranslateKey: 'Collection Key' },
  {
    LID: '3',
    TranslateData: 'Clé de collecte',
    TranslateKey: 'Collection Key',
  },
  { LID: '4', TranslateData: 'Ключ коллекции', TranslateKey: 'Collection Key' },
  { LID: '1', TranslateData: 'איסוף משלוח', TranslateKey: 'Collection Item' },
  {
    LID: '2',
    TranslateData: 'Collection Item',
    TranslateKey: 'Collection Item',
  },
  {
    LID: '3',
    TranslateData: 'Article de collection',
    TranslateKey: 'Collection Item',
  },
  {
    LID: '4',
    TranslateData: 'Предмет коллекции',
    TranslateKey: 'Collection Item',
  },
  { LID: '1', TranslateData: 'גבייה', TranslateKey: 'Collection' },
  { LID: '2', TranslateData: 'Collection', TranslateKey: 'Collection' },
  { LID: '3', TranslateData: 'Collection', TranslateKey: 'Collection' },
  { LID: '4', TranslateData: 'Коллекция', TranslateKey: 'Collection' },
  { LID: '1', TranslateData: 'תאריך סגירה', TranslateKey: 'Closing date' },
  { LID: '2', TranslateData: 'Closing date', TranslateKey: 'Closing date' },
  { LID: '3', TranslateData: 'Date de clôture', TranslateKey: 'Closing date' },
  { LID: '4', TranslateData: 'Дата закрытия', TranslateKey: 'Closing date' },
  { LID: '1', TranslateData: 'סגור', TranslateKey: 'Close' },
  { LID: '2', TranslateData: 'Close', TranslateKey: 'Close' },
  { LID: '3', TranslateData: 'proche', TranslateKey: 'Close' },
  { LID: '4', TranslateData: 'Закрывать', TranslateKey: 'Close' },
  { LID: '1', TranslateData: 'לחץ לתשלום', TranslateKey: 'Click to payment' },
  { LID: '2', TranslateData: 'Click to pay', TranslateKey: 'Click to payment' },
  {
    LID: '3',
    TranslateData: 'Cliquez pour payer',
    TranslateKey: 'Click to payment',
  },
  {
    LID: '4',
    TranslateData: 'Нажмите, чтобы заплатить',
    TranslateKey: 'Click to payment',
  },
  {
    LID: '1',
    TranslateData: 'לחץ כאן להגדרה',
    TranslateKey: 'Click here to set up',
  },
  {
    LID: '2',
    TranslateData: 'Click here to set up',
    TranslateKey: 'Click here to set up',
  },
  {
    LID: '3',
    TranslateData: 'Cliquez ici pour configurer',
    TranslateKey: 'Click here to set up',
  },
  {
    LID: '4',
    TranslateData: 'Нажмите здесь, чтобы настроить',
    TranslateKey: 'Click here to set up',
  },
  { LID: '1', TranslateData: 'לחצו כאן', TranslateKey: 'click here' },
  { LID: '2', TranslateData: 'click here', TranslateKey: 'click here' },
  { LID: '3', TranslateData: 'cliquez ici', TranslateKey: 'click here' },
  { LID: '4', TranslateData: 'нажмите здесь', TranslateKey: 'click here' },
  { LID: '1', TranslateData: 'קוד הסליקה:', TranslateKey: 'Clearing code:' },
  { LID: '2', TranslateData: 'Clearing code:', TranslateKey: 'Clearing code:' },
  {
    LID: '3',
    TranslateData: 'Code de compensation:',
    TranslateKey: 'Clearing code:',
  },
  {
    LID: '4',
    TranslateData: 'Клиринговый код:',
    TranslateKey: 'Clearing code:',
  },
  { LID: '1', TranslateData: 'נקי', TranslateKey: 'Clear' },
  { LID: '2', TranslateData: 'Clear', TranslateKey: 'Clear' },
  { LID: '3', TranslateData: 'Dégager', TranslateKey: 'Clear' },
  { LID: '4', TranslateData: 'чистый', TranslateKey: 'Clear' },
  { LID: '1', TranslateData: 'עיר', TranslateKey: 'city' },
  { LID: '2', TranslateData: 'City', TranslateKey: 'city' },
  { LID: '3', TranslateData: 'ville', TranslateKey: 'city' },
  { LID: '4', TranslateData: 'город', TranslateKey: 'city' },
  {
    LID: '1',
    TranslateData: 'בחר איך ברצונך להמשיך באפליקציה:',
    TranslateKey: 'Choose how you want to proceed with the app:',
  },
  {
    LID: '2',
    TranslateData: 'Choose how you want to proceed with the app:',
    TranslateKey: 'Choose how you want to proceed with the app:',
  },
  {
    LID: '3',
    TranslateData:
      "Choisissez comment vous souhaitez procéder avec l'application :",
    TranslateKey: 'Choose how you want to proceed with the app:',
  },
  {
    LID: '4',
    TranslateData: 'Выберите, как вы хотите продолжить работу с приложением:',
    TranslateKey: 'Choose how you want to proceed with the app:',
  },
  { LID: '1', TranslateData: 'יש לבחור', TranslateKey: 'Choose' },
  { LID: '2', TranslateData: 'Choose', TranslateKey: 'Choose' },
  { LID: '3', TranslateData: 'Choisir', TranslateKey: 'Choose' },
  { LID: '4', TranslateData: 'Выбирать', TranslateKey: 'Choose' },
  { LID: '1', TranslateData: 'תאריך פירעון', TranslateKey: 'Cheque Date' },
  { LID: '2', TranslateData: 'Cheque Date', TranslateKey: 'Cheque Date' },
  { LID: '3', TranslateData: 'Vérifier la date', TranslateKey: 'Cheque Date' },
  { LID: '4', TranslateData: 'Дата проверки', TranslateKey: 'Cheque Date' },
  { LID: '1', TranslateData: 'רשימת בדיקה', TranslateKey: 'check list' },
  { LID: '2', TranslateData: 'check list', TranslateKey: 'check list' },
  { LID: '3', TranslateData: 'liste de contrôle', TranslateKey: 'check list' },
  { LID: '4', TranslateData: 'контрольный список', TranslateKey: 'check list' },
  {
    LID: '1',
    TranslateData: 'שנה יום חיוב בחודש',
    TranslateKey: 'Change the billing day of the month',
  },
  {
    LID: '2',
    TranslateData: 'Change the billing day of the month',
    TranslateKey: 'Change the billing day of the month',
  },
  {
    LID: '3',
    TranslateData: 'Changer le jour de facturation du mois',
    TranslateKey: 'Change the billing day of the month',
  },
  {
    LID: '4',
    TranslateData: 'Изменение расчетного дня месяца',
    TranslateKey: 'Change the billing day of the month',
  },
  {
    LID: '1',
    TranslateData: 'שנה סטטוס קריאה {0} ל',
    TranslateKey: 'Change reading {0} status to',
  },
  {
    LID: '2',
    TranslateData: 'Change reading {0} status to',
    TranslateKey: 'Change reading {0} status to',
  },
  {
    LID: '3',
    TranslateData: 'Changer le statut de lecture {0} en',
    TranslateKey: 'Change reading {0} status to',
  },
  {
    LID: '4',
    TranslateData: 'Изменить статус чтения {0} на',
    TranslateKey: 'Change reading {0} status to',
  },
  { LID: '1', TranslateData: 'סלולר', TranslateKey: 'Cellular' },
  { LID: '2', TranslateData: 'Cellular', TranslateKey: 'Cellular' },
  { LID: '3', TranslateData: 'Cellulaire', TranslateKey: 'Cellular' },
  { LID: '4', TranslateData: 'Сотовый', TranslateKey: 'Cellular' },
  { LID: '1', TranslateData: 'טלפון הספק', TranslateKey: 'Carrier phone' },
  {
    LID: '2',
    TranslateData: "Service provider's phone",
    TranslateKey: 'Carrier phone',
  },
  {
    LID: '3',
    TranslateData: 'Téléphone du fournisseur de services',
    TranslateKey: 'Carrier phone',
  },
  {
    LID: '4',
    TranslateData: 'Телефон поставщика услуг',
    TranslateKey: 'Carrier phone',
  },
  { LID: '1', TranslateData: 'חניון', TranslateKey: 'carpark' },
  { LID: '2', TranslateData: 'carpark', TranslateKey: 'carpark' },
  { LID: '3', TranslateData: 'parking', TranslateKey: 'carpark' },
  { LID: '4', TranslateData: 'парковка', TranslateKey: 'carpark' },
  {
    LID: '1',
    TranslateData: 'הוראת קבע נמחקה בהצלחה',
    TranslateKey: 'Card has been successfully deleted',
  },
  {
    LID: '2',
    TranslateData: 'Card has been successfully deleted',
    TranslateKey: 'Card has been successfully deleted',
  },
  {
    LID: '3',
    TranslateData: 'La carte a été supprimée avec succès',
    TranslateKey: 'Card has been successfully deleted',
  },
  {
    LID: '4',
    TranslateData: 'Карта успешно удалена',
    TranslateKey: 'Card has been successfully deleted',
  },
  { LID: '1', TranslateData: 'ביטול', TranslateKey: 'Cancel' },
  { LID: '2', TranslateData: 'Cancel', TranslateKey: 'Cancel' },
  { LID: '3', TranslateData: 'Annuler', TranslateKey: 'Cancel' },
  { LID: '4', TranslateData: 'Отмена', TranslateKey: 'Cancel' },
  { LID: '1', TranslateData: 'מצלמה', TranslateKey: 'Camera' },
  { LID: '2', TranslateData: 'Camera', TranslateKey: 'Camera' },
  { LID: '3', TranslateData: 'Appareil photo', TranslateKey: 'Camera' },
  { LID: '4', TranslateData: 'Камера', TranslateKey: 'Camera' },
  { LID: '1', TranslateData: 'סוג פניה', TranslateKey: 'Call type' },
  { LID: '2', TranslateData: 'Call type', TranslateKey: 'Call type' },
  { LID: '3', TranslateData: "Type d'appel", TranslateKey: 'Call type' },
  { LID: '4', TranslateData: 'Тип вызова', TranslateKey: 'Call type' },
  {
    LID: '1',
    TranslateData: 'על ידי לחיצה על "שלח", אתה מסכים ל',
    TranslateKey: 'By clicking "Send", you agree to our',
  },
  {
    LID: '2',
    TranslateData: 'By clicking "Send", you agree to our ',
    TranslateKey: 'By clicking "Send", you agree to our',
  },
  {
    LID: '3',
    TranslateData: 'En cliquant sur "Envoyer", vous acceptez notre ',
    TranslateKey: 'By clicking "Send", you agree to our',
  },
  {
    LID: '4',
    TranslateData: 'Нажимая «Отправить», вы соглашаетесь с нашими ',
    TranslateKey: 'By clicking "Send", you agree to our',
  },
  { LID: '1', TranslateData: 'צבע לחצן', TranslateKey: 'Button color' },
  { LID: '2', TranslateData: 'Button color', TranslateKey: 'Button color' },
  {
    LID: '3',
    TranslateData: 'Couleur du bouton',
    TranslateKey: 'Button color',
  },
  { LID: '4', TranslateData: 'Цвет кнопки', TranslateKey: 'Button color' },
  { LID: '1', TranslateData: 'רשימת בניינים', TranslateKey: 'Buildings List' },
  { LID: '2', TranslateData: 'Buildings List', TranslateKey: 'Buildings List' },
  {
    LID: '3',
    TranslateData: 'Liste des bâtiments',
    TranslateKey: 'Buildings List',
  },
  { LID: '4', TranslateData: 'Список зданий', TranslateKey: 'Buildings List' },
  {
    LID: '1',
    TranslateData: 'ספקים לבניין',
    TranslateKey: 'Building suppliers',
  },
  {
    LID: '2',
    TranslateData: 'Building suppliers',
    TranslateKey: 'Building suppliers',
  },
  {
    LID: '3',
    TranslateData: 'Fournisseurs de construction',
    TranslateKey: 'Building suppliers',
  },
  {
    LID: '4',
    TranslateData: 'Поставщики строительных материалов',
    TranslateKey: 'Building suppliers',
  },
  {
    LID: '1',
    TranslateData: 'תקנון הבניין',
    TranslateKey: 'Building regulations',
  },
  {
    LID: '2',
    TranslateData: 'Building regulations',
    TranslateKey: 'Building regulations',
  },
  {
    LID: '3',
    TranslateData: 'Réglementation de la construction',
    TranslateKey: 'Building regulations',
  },
  {
    LID: '4',
    TranslateData: 'Строительные нормы и правила',
    TranslateKey: 'Building regulations',
  },
  { LID: '1', TranslateData: 'פרופיל בניין', TranslateKey: 'Building profile' },
  {
    LID: '2',
    TranslateData: 'Building profile',
    TranslateKey: 'Building profile',
  },
  {
    LID: '3',
    TranslateData: 'Profil du bâtiment',
    TranslateKey: 'Building profile',
  },
  {
    LID: '4',
    TranslateData: 'Строительный профиль',
    TranslateKey: 'Building profile',
  },
  { LID: '1', TranslateData: 'מספר בניין', TranslateKey: 'Building number' },
  {
    LID: '2',
    TranslateData: 'Building number',
    TranslateKey: 'Building number',
  },
  {
    LID: '3',
    TranslateData: 'numéro du bâtiment',
    TranslateKey: 'Building number',
  },
  {
    LID: '4',
    TranslateData: 'building number',
    TranslateKey: 'Building number',
  },
  {
    LID: '1',
    TranslateData: 'פרטי הבנין',
    TranslateKey: 'building information',
  },
  {
    LID: '2',
    TranslateData: 'building information',
    TranslateKey: 'building information',
  },
  {
    LID: '3',
    TranslateData: 'informations sur le bâtiment',
    TranslateKey: 'building information',
  },
  {
    LID: '4',
    TranslateData: 'информация о здании',
    TranslateKey: 'building information',
  },
  { LID: '1', TranslateData: 'בניין', TranslateKey: 'Building' },
  { LID: '2', TranslateData: 'Building', TranslateKey: 'Building' },
  { LID: '3', TranslateData: 'Imeuble', TranslateKey: 'Building' },
  { LID: '4', TranslateData: 'Строительство', TranslateKey: 'Building' },
  {
    LID: '1',
    TranslateData:
      'בילד-אפ היא מערכת תוכנה מתקדמת לניהול ואחזקת מבנים המשרתת אלפי בניינים ברחבי הארץ.\n\rהמערכת נותנת מענה לחברות ניהול ואחזקת מבנים, ועדי בתים, ספקי שירות ואנשי אחזקה בתחומי גביית דמי ועד בית, תחזוקת הבניין, ניהול כללי ועוד.\n\rהמערכת מפותחת על ידי חברת איי פוינט מערכות',
    TranslateKey: 'BuildApp About',
  },
  {
    LID: '2',
    TranslateData:
      'Build-Up is an advanced software management and maintenance system that serves thousands of buildings across the country. The system provides a solution for building management and maintenance companies, house committees, service providers and maintenance personnel in the areas of collecting house committee fees, building maintenance, general management and more. The system is developed by Ai Point Systems "',
    TranslateKey: 'BuildApp About',
  },
  {
    LID: '3',
    TranslateData:
      "Build-Up est un système avancé de gestion et de maintenance de logiciels qui dessert des milliers de bâtiments à travers le pays. Le système fournit une solution pour les sociétés de gestion et d'entretien des bâtiments, les comités de maison, les prestataires de services et le personnel de maintenance dans les domaines de la collecte des frais de comité de maison, de l'entretien des bâtiments, de la direction générale, etc. Le système est développé par Ai Point Systems \"",
    TranslateKey: 'BuildApp About',
  },
  {
    LID: '4',
    TranslateData:
      'Build-Up — передовая система управления и обслуживания программного обеспечения, которая обслуживает тысячи зданий по всей стране. Система предоставляет решение для компаний по управлению и обслуживанию зданий, домовых комитетов, поставщиков услуг и обслуживающего персонала в таких областях, как сбор платы за домовые комитеты, техническое обслуживание зданий, общее управление и многое другое. Система разработана компанией Ai Point Systems»',
    TranslateKey: 'BuildApp About',
  },
  { LID: '1', TranslateData: 'תקציב', TranslateKey: 'Budget' },
  { LID: '2', TranslateData: 'Budget', TranslateKey: 'Budget' },
  { LID: '3', TranslateData: 'Budget', TranslateKey: 'Budget' },
  { LID: '4', TranslateData: 'Бюджет', TranslateKey: 'Budget' },
  { LID: '1', TranslateData: 'בטיפול', TranslateKey: 'BTupal' },
  { LID: '2', TranslateData: 'In Execution', TranslateKey: 'BTupal' },
  { LID: '3', TranslateData: 'En exécution', TranslateKey: 'BTupal' },
  { LID: '4', TranslateData: 'В исполнении', TranslateKey: 'BTupal' },
  {
    LID: '1',
    TranslateData: 'המשך באתר מותאם',
    TranslateKey: 'Browsing a website',
  },
  {
    LID: '2',
    TranslateData: 'Continue on a customized site',
    TranslateKey: 'Browsing a website',
  },
  {
    LID: '3',
    TranslateData: 'Continuer sur un site personnalisé',
    TranslateKey: 'Browsing a website',
  },
  {
    LID: '4',
    TranslateData: 'Продолжить на индивидуальном сайте',
    TranslateKey: 'Browsing a website',
  },
  { LID: '1', TranslateData: 'סניף', TranslateKey: 'Branch' },
  { LID: '2', TranslateData: 'Branch', TranslateKey: 'Branch' },
  { LID: '3', TranslateData: 'Bifurquer', TranslateKey: 'Branch' },
  { LID: '4', TranslateData: 'Ответвляться', TranslateKey: 'Branch' },
  {
    LID: '1',
    TranslateData: 'הזמנת חדר דיירים',
    TranslateKey: "Booking a tenants' room",
  },
  {
    LID: '2',
    TranslateData: "Booking a tenants' room",
    TranslateKey: "Booking a tenants' room",
  },
  {
    LID: '3',
    TranslateData: "Réservation d'une chambre locataire",
    TranslateKey: "Booking a tenants' room",
  },
  {
    LID: '4',
    TranslateData: 'Бронирование комнаты жильцов',
    TranslateKey: "Booking a tenants' room",
  },
  { LID: '1', TranslateData: 'יום חיוב', TranslateKey: 'billing day' },
  { LID: '2', TranslateData: 'billing day', TranslateKey: 'billing day' },
  {
    LID: '3',
    TranslateData: 'jour de facturation',
    TranslateKey: 'billing day',
  },
  { LID: '4', TranslateData: 'расчетный день', TranslateKey: 'billing day' },
  { LID: '1', TranslateData: 'אישור הצעות מחיר', TranslateKey: 'Bid approval' },
  { LID: '2', TranslateData: 'Approve quote', TranslateKey: 'Bid approval' },
  {
    LID: '3',
    TranslateData: 'Approuver le devis',
    TranslateKey: 'Bid approval',
  },
  { LID: '4', TranslateData: 'Утвердить цитату', TranslateKey: 'Bid approval' },
  { LID: '1', TranslateData: 'שעת התחלה', TranslateKey: 'Beginning time' },
  { LID: '2', TranslateData: 'Start time', TranslateKey: 'Beginning time' },
  { LID: '3', TranslateData: 'Heure de début', TranslateKey: 'Beginning time' },
  {
    LID: '4',
    TranslateData: 'Начальное время',
    TranslateKey: 'Beginning time',
  },
  {
    LID: '1',
    TranslateData: 'חשבון בנק של הבניין',
    TranslateKey: 'Bank account of the building',
  },
  {
    LID: '2',
    TranslateData: 'Bank account of the building',
    TranslateKey: 'Bank account of the building',
  },
  {
    LID: '3',
    TranslateData: "Compte bancaire de l'immeuble",
    TranslateKey: 'Bank account of the building',
  },
  {
    LID: '4',
    TranslateData: 'Банковский счет здания',
    TranslateKey: 'Bank account of the building',
  },
  { LID: '1', TranslateData: 'בנק', TranslateKey: 'Bank' },
  { LID: '2', TranslateData: 'Bank', TranslateKey: 'Bank' },
  { LID: '3', TranslateData: 'Banque', TranslateKey: 'Bank' },
  { LID: '4', TranslateData: 'Банк', TranslateKey: 'Bank' },
  { LID: '1', TranslateData: 'יתרה', TranslateKey: 'Balance' },
  { LID: '2', TranslateData: 'Balance', TranslateKey: 'Balance' },
  { LID: '3', TranslateData: 'Équilibre', TranslateKey: 'Balance' },
  { LID: '4', TranslateData: 'Остаток средств', TranslateKey: 'Balance' },
  { LID: '1', TranslateData: 'חזור', TranslateKey: 'Back' },
  { LID: '2', TranslateData: 'Back', TranslateKey: 'Back' },
  { LID: '3', TranslateData: 'Retour', TranslateKey: 'Back' },
  { LID: '4', TranslateData: 'Назад', TranslateKey: 'Back' },
  { LID: '1', TranslateData: 'אוגוסט', TranslateKey: 'Aug' },
  { LID: '2', TranslateData: 'Aug', TranslateKey: 'Aug' },
  { LID: '3', TranslateData: 'Août', TranslateKey: 'Aug' },
  { LID: '4', TranslateData: 'авг', TranslateKey: 'Aug' },
  { LID: '1', TranslateData: 'צורף בתאריך', TranslateKey: 'Attached on' },
  { LID: '2', TranslateData: 'Attached on', TranslateKey: 'Attached on' },
  { LID: '3', TranslateData: 'Attaché sur', TranslateKey: 'Attached on' },
  { LID: '4', TranslateData: 'Прикреплено', TranslateKey: 'Attached on' },
  {
    LID: '1',
    TranslateData: 'מסמכים שצורפו ',
    TranslateKey: 'Attached documents',
  },
  {
    LID: '2',
    TranslateData: 'Attached documents',
    TranslateKey: 'Attached documents',
  },
  {
    LID: '3',
    TranslateData: 'Documents attachés',
    TranslateKey: 'Attached documents',
  },
  {
    LID: '4',
    TranslateData: 'Приложенные документы',
    TranslateKey: 'Attached documents',
  },
  {
    LID: '1',
    TranslateData: 'צירוף חשבונית',
    TranslateKey: 'Attach an invoice',
  },
  {
    LID: '2',
    TranslateData: 'Attach an invoice',
    TranslateKey: 'Attach an invoice',
  },
  {
    LID: '3',
    TranslateData: 'Joindre une facture',
    TranslateKey: 'Attach an invoice',
  },
  {
    LID: '4',
    TranslateData: 'Прикрепите счет',
    TranslateKey: 'Attach an invoice',
  },
  { LID: '1', TranslateData: 'לשירותך', TranslateKey: 'at your service' },
  {
    LID: '2',
    TranslateData: 'at your service',
    TranslateKey: 'at your service',
  },
  {
    LID: '3',
    TranslateData: 'à votre service',
    TranslateKey: 'at your service',
  },
  {
    LID: '4',
    TranslateData: 'к вашим услугам',
    TranslateKey: 'at your service',
  },
  { LID: '1', TranslateData: 'שיוכים', TranslateKey: 'Associations' },
  { LID: '2', TranslateData: 'Associations', TranslateKey: 'Associations' },
  { LID: '3', TranslateData: 'Les associations', TranslateKey: 'Associations' },
  { LID: '4', TranslateData: 'Ассоциации', TranslateKey: 'Associations' },
  { LID: '1', TranslateData: 'סדר עולה', TranslateKey: 'ascending order' },
  {
    LID: '2',
    TranslateData: 'ascending order',
    TranslateKey: 'ascending order',
  },
  {
    LID: '3',
    TranslateData: 'ordre croissant',
    TranslateKey: 'ascending order',
  },
  {
    LID: '4',
    TranslateData: 'возрастающий порядок',
    TranslateKey: 'ascending order',
  },
  { LID: '1', TranslateData: 'שטח', TranslateKey: 'Area' },
  { LID: '2', TranslateData: 'Area', TranslateKey: 'Area' },
  { LID: '3', TranslateData: 'Zone', TranslateKey: 'Area' },
  { LID: '4', TranslateData: 'Площадь', TranslateKey: 'Area' },
  { LID: '1', TranslateData: 'האם אתה בטוח?', TranslateKey: 'Are you sure?' },
  { LID: '2', TranslateData: 'Are you sure?', TranslateKey: 'Are you sure?' },
  { LID: '3', TranslateData: 'Êtes-vous sûr?', TranslateKey: 'Are you sure?' },
  { LID: '4', TranslateData: 'Ты уверен?', TranslateKey: 'Are you sure?' },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך למחוק קריאת שירות זו?',
    TranslateKey: 'Are you sure you want to delete this service call?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to delete this service call?',
    TranslateKey: 'Are you sure you want to delete this service call?',
  },
  {
    LID: '3',
    TranslateData: 'Voulez-vous vraiment supprimer cet appel de service ?',
    TranslateKey: 'Are you sure you want to delete this service call?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите удалить этот сервисный вызов?',
    TranslateKey: 'Are you sure you want to delete this service call?',
  },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך למחוק את העדכון?',
    TranslateKey: 'Are you sure you want to delete the update?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to delete the update?',
    TranslateKey: 'Are you sure you want to delete the update?',
  },
  {
    LID: '3',
    TranslateData: 'Voulez-vous vraiment supprimer la mise à jour ?',
    TranslateKey: 'Are you sure you want to delete the update?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите удалить обновление?',
    TranslateKey: 'Are you sure you want to delete the update?',
  },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך למחוק את התמונה?',
    TranslateKey: 'Are you sure you want to delete the image?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to delete the image?',
    TranslateKey: 'Are you sure you want to delete the image?',
  },
  {
    LID: '3',
    TranslateData: "Voulez-vous vraiment supprimer l'image ?",
    TranslateKey: 'Are you sure you want to delete the image?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите удалить изображение?',
    TranslateKey: 'Are you sure you want to delete the image?',
  },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך למחוק את ההוצאה?',
    TranslateKey: 'Are you sure you want to delete the expense?',
  },
  {
    LID: '2',
    TranslateData: 'August',
    TranslateKey: 'Are you sure you want to delete the expense?',
  },
  {
    LID: '3',
    TranslateData: 'Août',
    TranslateKey: 'Are you sure you want to delete the expense?',
  },
  {
    LID: '4',
    TranslateData: 'Август',
    TranslateKey: 'Are you sure you want to delete the expense?',
  },
  { LID: '1', TranslateData: 'אפריל', TranslateKey: 'April' },
  { LID: '2', TranslateData: 'April', TranslateKey: 'April' },
  { LID: '3', TranslateData: 'avril', TranslateKey: 'April' },
  { LID: '4', TranslateData: 'апрель', TranslateKey: 'April' },
  { LID: '1', TranslateData: 'אפריל', TranslateKey: 'Apr' },
  { LID: '2', TranslateData: 'Apr', TranslateKey: 'Apr' },
  { LID: '3', TranslateData: 'Avr', TranslateKey: 'Apr' },
  { LID: '4', TranslateData: 'апр', TranslateKey: 'Apr' },
  { LID: '1', TranslateData: 'להגיש מועמדות', TranslateKey: 'Apply' },
  { LID: '2', TranslateData: 'Apply', TranslateKey: 'Apply' },
  { LID: '3', TranslateData: 'Appliquer', TranslateKey: 'Apply' },
  { LID: '4', TranslateData: 'Подать заявление', TranslateKey: 'Apply' },
  {
    LID: '1',
    TranslateData: 'אודות בילד אפ',
    TranslateKey: 'Application Feedback',
  },
  {
    LID: '2',
    TranslateData: 'About Build App',
    TranslateKey: 'Application Feedback',
  },
  {
    LID: '3',
    TranslateData: 'À propos de Créer une application',
    TranslateKey: 'Application Feedback',
  },
  {
    LID: '4',
    TranslateData: 'О приложении для сборки',
    TranslateKey: 'Application Feedback',
  },
  {
    LID: '1',
    TranslateData: 'איי פוינט מערכות',
    TranslateKey: 'APoint Systems',
  },
  {
    LID: '2',
    TranslateData: 'A-Point Systems',
    TranslateKey: 'APoint Systems',
  },
  {
    LID: '3',
    TranslateData: 'A-Point Systems',
    TranslateKey: 'APoint Systems',
  },
  {
    LID: '4',
    TranslateData: 'Системы A-Point',
    TranslateKey: 'APoint Systems',
  },
  {
    LID: '1',
    TranslateData: 'דירות ודיירים',
    TranslateKey: 'Apartments and tenants',
  },
  {
    LID: '2',
    TranslateData: 'Apartments and tenants',
    TranslateKey: 'Apartments and tenants',
  },
  {
    LID: '3',
    TranslateData: 'Appartements et locataires',
    TranslateKey: 'Apartments and tenants',
  },
  {
    LID: '4',
    TranslateData: 'Квартиры и арендаторы',
    TranslateKey: 'Apartments and tenants',
  },
  { LID: '1', TranslateData: 'חוב לדירה', TranslateKey: 'Apartment debt' },
  { LID: '2', TranslateData: 'Apartment debt', TranslateKey: 'Apartment debt' },
  {
    LID: '3',
    TranslateData: "Dette d'appartement",
    TranslateKey: 'Apartment debt',
  },
  {
    LID: '4',
    TranslateData: 'Долг по квартире',
    TranslateKey: 'Apartment debt',
  },
  { LID: '1', TranslateData: 'דירה', TranslateKey: 'Apartment' },
  { LID: '2', TranslateData: 'Apartment', TranslateKey: 'Apartment' },
  { LID: '3', TranslateData: 'Appartement', TranslateKey: 'Apartment' },
  { LID: '4', TranslateData: 'Квартира', TranslateKey: 'Apartment' },
  {
    LID: '1',
    TranslateData: 'הודעות',
    TranslateKey: 'Announcements from the House Committee',
  },
  {
    LID: '2',
    TranslateData: 'messages',
    TranslateKey: 'Announcements from the House Committee',
  },
  {
    LID: '3',
    TranslateData: 'messages',
    TranslateKey: 'Announcements from the House Committee',
  },
  {
    LID: '4',
    TranslateData: 'Сообщения',
    TranslateKey: 'Announcements from the House Committee',
  },
  { LID: '1', TranslateData: 'ו', TranslateKey: 'and' },
  { LID: '2', TranslateData: 'and ', TranslateKey: 'and' },
  { LID: '3', TranslateData: 'et ', TranslateKey: 'and' },
  { LID: '4', TranslateData: 'and ', TranslateKey: 'and' },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בהגדרת תוקף',
    TranslateKey: 'An error occurred while setting validity',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while setting validity',
    TranslateKey: 'An error occurred while setting validity',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de la définition de la validité",
    TranslateKey: 'An error occurred while setting validity',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при настройке срока действия.',
    TranslateKey: 'An error occurred while setting validity',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בשמירת הנתונים',
    TranslateKey: 'An error occurred while saving the data',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while saving the data',
    TranslateKey: 'An error occurred while saving the data',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de l'enregistrement des données",
    TranslateKey: 'An error occurred while saving the data',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при сохранении данных',
    TranslateKey: 'An error occurred while saving the data',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בקבלת הנתונים',
    TranslateKey: 'An error occurred while receiving the data',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while receiving the data',
    TranslateKey: 'An error occurred while receiving the data',
  },
  {
    LID: '3',
    TranslateData: "Une erreur s'est produite lors de la réception des données",
    TranslateKey: 'An error occurred while receiving the data',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при получении данных',
    TranslateKey: 'An error occurred while receiving the data',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בסגירת הפניה',
    TranslateKey: 'An error occurred while closing the service call',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while closing the service call',
    TranslateKey: 'An error occurred while closing the service call',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de la fermeture de l'appel de service",
    TranslateKey: 'An error occurred while closing the service call',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при закрытии вызова службы',
    TranslateKey: 'An error occurred while closing the service call',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בעת סליקת האשראי',
    TranslateKey: 'An error occurred while clearing credit',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while performing credit card transaction',
    TranslateKey: 'An error occurred while clearing credit',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de l'exécution de la transaction par carte de crédit",
    TranslateKey: 'An error occurred while clearing credit',
  },
  {
    LID: '4',
    TranslateData:
      'Произошла ошибка при выполнении транзакции по кредитной карте',
    TranslateKey: 'An error occurred while clearing credit',
  },
  { LID: '1', TranslateData: 'אירעה שגיאה', TranslateKey: 'An error occurred' },
  {
    LID: '2',
    TranslateData: 'An error occurred',
    TranslateKey: 'An error occurred',
  },
  {
    LID: '3',
    TranslateData: "Une erreur s'est produite",
    TranslateKey: 'An error occurred',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка',
    TranslateKey: 'An error occurred',
  },
  {
    LID: '1',
    TranslateData: 'סכומים שנגבו בתקופת הדוח ולא שויכו לשנה כלשהי',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '2',
    TranslateData:
      'Amounts collected during the reporting period and not associated with any year',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '3',
    TranslateData:
      'Montants perçus au cours de la période de déclaration et non associés à une année',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '4',
    TranslateData:
      'Суммы, собранные в течение отчетного периода и не связанные с каким-либо годом',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '1',
    TranslateData: 'סכומים שנגבו בתקופת הדוח ולא שויכו לשנה כלשהי',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '2',
    TranslateData:
      'Amounts collected during the reporting period and not associated with any year',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '3',
    TranslateData:
      'Montants perçus au cours de la période de déclaration et non associés à une année',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '4',
    TranslateData:
      'Суммы, собранные в течение отчетного периода и не связанные с каким-либо годом',
    TranslateKey:
      'Amounts collected during the reporting period and not associated with any group',
  },
  {
    LID: '1',
    TranslateData: 'הצג גם פריטים שנמסרו',
    TranslateKey: 'Also view delivered items',
  },
  {
    LID: '2',
    TranslateData: 'Also view delivered items',
    TranslateKey: 'Also view delivered items',
  },
  {
    LID: '3',
    TranslateData: 'Voir aussi les articles livrés',
    TranslateKey: 'Also view delivered items',
  },
  {
    LID: '4',
    TranslateData: 'Также просмотреть доставленные товары',
    TranslateKey: 'Also view delivered items',
  },
  {
    LID: '1',
    TranslateData: 'מאפשר לשלוח הודעות',
    TranslateKey: 'Allows to send messages',
  },
  {
    LID: '2',
    TranslateData: 'Allows to send messages',
    TranslateKey: 'Allows to send messages',
  },
  {
    LID: '3',
    TranslateData: "Autoriser l'envoi de messages",
    TranslateKey: 'Allows to send messages',
  },
  {
    LID: '4',
    TranslateData: 'Разрешить отправлять сообщения',
    TranslateKey: 'Allows to send messages',
  },
  { LID: '1', TranslateData: 'כל הכניסות', TranslateKey: 'All entrances' },
  { LID: '2', TranslateData: 'All entrances', TranslateKey: 'All entrances' },
  {
    LID: '3',
    TranslateData: 'Toutes les entrées',
    TranslateKey: 'All entrances',
  },
  { LID: '4', TranslateData: 'Все входы', TranslateKey: 'All entrances' },
  { LID: '1', TranslateData: 'מסכים לקבל', TranslateKey: 'Agree to accept' },
  {
    LID: '2',
    TranslateData: 'Agree to accept',
    TranslateKey: 'Agree to accept',
  },
  {
    LID: '3',
    TranslateData: "Accepter d'accepter",
    TranslateKey: 'Agree to accept',
  },
  {
    LID: '4',
    TranslateData: 'Согласен принять',
    TranslateKey: 'Agree to accept',
  },
  { LID: '1', TranslateData: 'כתובת', TranslateKey: 'Address' },
  { LID: '2', TranslateData: 'Address', TranslateKey: 'Address' },
  { LID: '3', TranslateData: 'Adresse', TranslateKey: 'Address' },
  { LID: '4', TranslateData: 'Адрес', TranslateKey: 'Address' },
  {
    LID: '1',
    TranslateData: 'חשבוניות נוספות',
    TranslateKey: 'Additional invoices',
  },
  {
    LID: '2',
    TranslateData: 'Additional invoices',
    TranslateKey: 'Additional invoices',
  },
  {
    LID: '3',
    TranslateData: 'Factures supplémentaires',
    TranslateKey: 'Additional invoices',
  },
  {
    LID: '4',
    TranslateData: 'Дополнительные счета',
    TranslateKey: 'Additional invoices',
  },
  {
    LID: '1',
    TranslateData: 'הוספת אירוע חדש',
    TranslateKey: 'Adding a new event',
  },
  {
    LID: '2',
    TranslateData: 'Adding a new event',
    TranslateKey: 'Adding a new event',
  },
  {
    LID: '3',
    TranslateData: "Ajout d'un nouvel événement",
    TranslateKey: 'Adding a new event',
  },
  {
    LID: '4',
    TranslateData: 'Добавление нового события',
    TranslateKey: 'Adding a new event',
  },
  { LID: '1', TranslateData: 'הוספת שער', TranslateKey: 'Adding a gate' },
  { LID: '2', TranslateData: 'Adding a gate', TranslateKey: 'Adding a gate' },
  {
    LID: '3',
    TranslateData: "Ajout d'un portail",
    TranslateKey: 'Adding a gate',
  },
  {
    LID: '4',
    TranslateData: 'Добавление ворот',
    TranslateKey: 'Adding a gate',
  },
  {
    LID: '1',
    TranslateData: 'הוספת חיוב לבניין',
    TranslateKey: 'Adding a charge to the building',
  },
  {
    LID: '2',
    TranslateData: 'Adding a charge to the building',
    TranslateKey: 'Adding a charge to the building',
  },
  {
    LID: '3',
    TranslateData: "Ajout d'une charge à l'immeuble",
    TranslateKey: 'Adding a charge to the building',
  },
  {
    LID: '4',
    TranslateData: 'Добавление заряда к зданию',
    TranslateKey: 'Adding a charge to the building',
  },
  { LID: '1', TranslateData: 'הוספת עדכון', TranslateKey: 'Add update' },
  { LID: '2', TranslateData: 'Add update', TranslateKey: 'Add update' },
  {
    LID: '3',
    TranslateData: 'Ajouter une mise à jour',
    TranslateKey: 'Add update',
  },
  {
    LID: '4',
    TranslateData: 'Добавить обновление',
    TranslateKey: 'Add update',
  },
  { LID: '1', TranslateData: 'הוסף לתשלום', TranslateKey: 'Add to payment' },
  { LID: '2', TranslateData: 'Add to payment', TranslateKey: 'Add to payment' },
  {
    LID: '3',
    TranslateData: 'Ajouter au paiement',
    TranslateKey: 'Add to payment',
  },
  {
    LID: '4',
    TranslateData: 'Добавить к оплате',
    TranslateKey: 'Add to payment',
  },
  {
    LID: '1',
    TranslateData: 'הוסף את בילד-אפ לעמוד הבית',
    TranslateKey: 'Add to home page',
  },
  {
    LID: '2',
    TranslateData: 'Add Build-App to home screen',
    TranslateKey: 'Add to home page',
  },
  {
    LID: '3',
    TranslateData: "Ajouter Build-App à l'écran d'accueil",
    TranslateKey: 'Add to home page',
  },
  {
    LID: '4',
    TranslateData: 'Добавить приложение Build-App на главный экран',
    TranslateKey: 'Add to home page',
  },
  {
    LID: '1',
    TranslateData: 'קריאת שירות חדשה',
    TranslateKey: 'Add Service Call',
  },
  {
    LID: '2',
    TranslateData: 'Add Service Call',
    TranslateKey: 'Add Service Call',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter un appel de service',
    TranslateKey: 'Add Service Call',
  },
  {
    LID: '4',
    TranslateData: 'Добавить сервисный вызов',
    TranslateKey: 'Add Service Call',
  },
  { LID: '1', TranslateData: 'הוסף כלל', TranslateKey: 'Add Rule' },
  { LID: '2', TranslateData: 'Add Rule', TranslateKey: 'Add Rule' },
  { LID: '3', TranslateData: 'Ajouter une règle', TranslateKey: 'Add Rule' },
  { LID: '4', TranslateData: 'Добавить правило', TranslateKey: 'Add Rule' },
  {
    LID: '1',
    TranslateData: 'הוסף פרטי מדווח',
    TranslateKey: 'Add Reporting Details',
  },
  {
    LID: '2',
    TranslateData: 'Add Reporting Details',
    TranslateKey: 'Add Reporting Details',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter des détails de rapport',
    TranslateKey: 'Add Reporting Details',
  },
  {
    LID: '4',
    TranslateData: 'Добавить сведения об отчетах',
    TranslateKey: 'Add Reporting Details',
  },
  { LID: '1', TranslateData: 'הוסף מדווח', TranslateKey: 'Add Reporter' },
  { LID: '2', TranslateData: 'Add Reporter', TranslateKey: 'Add Reporter' },
  {
    LID: '3',
    TranslateData: 'Ajouter un rapporteur',
    TranslateKey: 'Add Reporter',
  },
  {
    LID: '4',
    TranslateData: 'Добавить репортера',
    TranslateKey: 'Add Reporter',
  },
  { LID: '1', TranslateData: 'הוסף תמונה', TranslateKey: 'Add photos' },
  { LID: '2', TranslateData: 'Add an image', TranslateKey: 'Add photos' },
  { LID: '3', TranslateData: 'Ajouter une image', TranslateKey: 'Add photos' },
  {
    LID: '4',
    TranslateData: 'Добавить изображение',
    TranslateKey: 'Add photos',
  },
  { LID: '1', TranslateData: 'הוספת תמונה', TranslateKey: 'Add Photo' },
  { LID: '2', TranslateData: 'Add Photo', TranslateKey: 'Add Photo' },
  { LID: '3', TranslateData: 'Ajouter une photo', TranslateKey: 'Add Photo' },
  { LID: '4', TranslateData: 'Добавить фото', TranslateKey: 'Add Photo' },
  { LID: '1', TranslateData: 'הוספת הוצאה', TranslateKey: 'Add Money' },
  { LID: '2', TranslateData: 'Add Money', TranslateKey: 'Add Money' },
  { LID: '3', TranslateData: "Ajouter de l'argent", TranslateKey: 'Add Money' },
  { LID: '4', TranslateData: 'Добавить деньги', TranslateKey: 'Add Money' },
  { LID: '1', TranslateData: 'הוספת הוצאה', TranslateKey: 'Add Expense' },
  { LID: '2', TranslateData: 'Add Expense', TranslateKey: 'Add Expense' },
  {
    LID: '3',
    TranslateData: 'Ajouter une dépense',
    TranslateKey: 'Add Expense',
  },
  { LID: '4', TranslateData: 'Добавить расходы', TranslateKey: 'Add Expense' },
  {
    LID: '1',
    TranslateData: 'הוסף פרטי כרטיס אשראי לתשלום דמי ועד.',
    TranslateKey: 'Add credit card information to pay commission.',
  },
  {
    LID: '2',
    TranslateData: 'Add credit card information to pay commission.',
    TranslateKey: 'Add credit card information to pay commission.',
  },
  {
    LID: '3',
    TranslateData:
      'Ajoutez des informations de carte de crédit pour payer la commission.',
    TranslateKey: 'Add credit card information to pay commission.',
  },
  {
    LID: '4',
    TranslateData: 'Добавьте данные кредитной карты для оплаты комиссии.',
    TranslateKey: 'Add credit card information to pay commission.',
  },
  { LID: '1', TranslateData: 'הוסף כרטיס', TranslateKey: 'Add card' },
  { LID: '2', TranslateData: 'Add card', TranslateKey: 'Add card' },
  { LID: '3', TranslateData: 'Ajouter une carte', TranslateKey: 'Add card' },
  { LID: '4', TranslateData: 'Добавить карту', TranslateKey: 'Add card' },
  { LID: '1', TranslateData: 'הוספת הוראת קבע', TranslateKey: 'Add Card' },
  { LID: '2', TranslateData: 'Add Card', TranslateKey: 'Add Card' },
  { LID: '3', TranslateData: 'Ajouter une carte', TranslateKey: 'Add Card' },
  { LID: '4', TranslateData: 'Добавить карту', TranslateKey: 'Add Card' },
  { LID: '1', TranslateData: 'הוסף תמונה', TranslateKey: 'Add an image' },
  { LID: '2', TranslateData: 'Add an image', TranslateKey: 'Add an image' },
  {
    LID: '3',
    TranslateData: 'Ajouter une image',
    TranslateKey: 'Add an image',
  },
  {
    LID: '4',
    TranslateData: 'Добавить изображение',
    TranslateKey: 'Add an image',
  },
  {
    LID: '1',
    TranslateData: 'הוספת הודעה חדשה',
    TranslateKey: 'Add a new message',
  },
  {
    LID: '2',
    TranslateData: 'Add a new message',
    TranslateKey: 'Add a new message',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter un nouveau message',
    TranslateKey: 'Add a new message',
  },
  {
    LID: '4',
    TranslateData: 'Добавить новое сообщение',
    TranslateKey: 'Add a new message',
  },
  { LID: '1', TranslateData: 'הוספת', TranslateKey: 'Add' },
  { LID: '2', TranslateData: 'Add', TranslateKey: 'Add' },
  { LID: '3', TranslateData: 'Ajouter', TranslateKey: 'Add' },
  { LID: '4', TranslateData: 'Добавлять', TranslateKey: 'Add' },
  { LID: '1', TranslateData: 'הוסף', TranslateKey: 'Add' },
  { LID: '2', TranslateData: 'Add', TranslateKey: 'Add' },
  { LID: '3', TranslateData: 'Ajouter', TranslateKey: 'Add' },
  { LID: '4', TranslateData: 'Добавлять', TranslateKey: 'Add' },
  { LID: '1', TranslateData: 'שם החשבון', TranslateKey: 'Account name' },
  { LID: '2', TranslateData: 'Account name', TranslateKey: 'Account name' },
  { LID: '3', TranslateData: 'Nom du compte', TranslateKey: 'Account name' },
  {
    LID: '4',
    TranslateData: 'Имя учетной записи',
    TranslateKey: 'Account name',
  },
  { LID: '1', TranslateData: "מס' חשבון", TranslateKey: 'Account' },
  { LID: '2', TranslateData: 'Account', TranslateKey: 'Account' },
  { LID: '3', TranslateData: 'Compte', TranslateKey: 'Account' },
  { LID: '4', TranslateData: 'Счет', TranslateKey: 'Account' },
  {
    LID: '1',
    TranslateData: 'אודות מערכת בילד אפ',
    TranslateKey: 'About the Build App system',
  },
  {
    LID: '2',
    TranslateData: 'About the Build App system',
    TranslateKey: 'About the Build App system',
  },
  {
    LID: '3',
    TranslateData: 'À propos du système Build App',
    TranslateKey: 'About the Build App system',
  },
  {
    LID: '4',
    TranslateData: 'О системе Build App',
    TranslateKey: 'About the Build App system',
  },
  {
    LID: '1',
    TranslateData: 'ביקור בבניין',
    TranslateKey: 'A visit to the building',
  },
  {
    LID: '2',
    TranslateData: 'A visit to the building',
    TranslateKey: 'A visit to the building',
  },
  {
    LID: '3',
    TranslateData: 'Une visite du bâtiment',
    TranslateKey: 'A visit to the building',
  },
  {
    LID: '4',
    TranslateData: 'Посещение здания',
    TranslateKey: 'A visit to the building',
  },
  {
    LID: '1',
    TranslateData: 'נותר לתשלום ₪{0} לשנה זו',
    TranslateKey: 'A total of {0} NIS remains to be paid for this year',
  },
  {
    LID: '2',
    TranslateData: 'A total of {0} NIS remains to be paid for this year',
    TranslateKey: 'A total of {0} NIS remains to be paid for this year',
  },
  {
    LID: '3',
    TranslateData: 'Un total de {0} NIS reste à payer pour cette année',
    TranslateKey: 'A total of {0} NIS remains to be paid for this year',
  },
  {
    LID: '4',
    TranslateData:
      'В этом году необходимо выплатить в общей сложности {0} шекелей.',
    TranslateKey: 'A total of {0} NIS remains to be paid for this year',
  },
  { LID: '1', TranslateData: 'דייר משלם', TranslateKey: 'A tenant pays' },
  { LID: '2', TranslateData: 'A tenant pays', TranslateKey: 'A tenant pays' },
  {
    LID: '3',
    TranslateData: 'Un locataire paie',
    TranslateKey: 'A tenant pays',
  },
  {
    LID: '4',
    TranslateData: 'Арендатор платит',
    TranslateKey: 'A tenant pays',
  },
  {
    LID: '1',
    TranslateData: 'נקבעה הוראת קבע עבורך',
    TranslateKey: 'a standing order was established for you',
  },
  {
    LID: '2',
    TranslateData: 'a standing order was established for you',
    TranslateKey: 'a standing order was established for you',
  },
  {
    LID: '3',
    TranslateData: 'un ordre permanent a été établi pour vous',
    TranslateKey: 'a standing order was established for you',
  },
  {
    LID: '4',
    TranslateData: 'для вас установлен постоянный порядок',
    TranslateKey: 'a standing order was established for you',
  },
  {
    LID: '1',
    TranslateData: 'הוראת קבע לא נוצרה',
    TranslateKey: 'A standing order has not been created',
  },
  {
    LID: '2',
    TranslateData: 'A standing order has not been created',
    TranslateKey: 'A standing order has not been created',
  },
  {
    LID: '3',
    TranslateData: "Aucun ordre permanent n'a été créé",
    TranslateKey: 'A standing order has not been created',
  },
  {
    LID: '4',
    TranslateData: 'Постоянный заказ не создан',
    TranslateKey: 'A standing order has not been created',
  },
  {
    LID: '1',
    TranslateData: 'נשלחה בקשה למחיקת הפרטים למנהל המערכת',
    TranslateKey:
      'A request to delete the details has been sent to the system administrator',
  },
  {
    LID: '2',
    TranslateData:
      'A request to delete the details has been sent to the system administrator',
    TranslateKey:
      'A request to delete the details has been sent to the system administrator',
  },
  {
    LID: '3',
    TranslateData:
      "Une demande de suppression des détails a été envoyée à l'administrateur système",
    TranslateKey:
      'A request to delete the details has been sent to the system administrator',
  },
  {
    LID: '4',
    TranslateData:
      'Запрос на удаление реквизитов отправлен системному администратору',
    TranslateKey:
      'A request to delete the details has been sent to the system administrator',
  },
  {
    LID: '1',
    TranslateData: 'לא ניתן להוסיף מדווח אם לא נבחר בניין',
    TranslateKey: 'A reporter cannot be added if a building is not selected',
  },
  {
    LID: '2',
    TranslateData: 'A reporter cannot be added if a building is not selected',
    TranslateKey: 'A reporter cannot be added if a building is not selected',
  },
  {
    LID: '3',
    TranslateData:
      "Un rapporteur ne peut pas être ajouté si un bâtiment n'est pas sélectionné",
    TranslateKey: 'A reporter cannot be added if a building is not selected',
  },
  {
    LID: '4',
    TranslateData: 'Репортер не может быть добавлен, если здание не выбрано',
    TranslateKey: 'A reporter cannot be added if a building is not selected',
  },
  { LID: '1', TranslateData: 'שיחת טלפון', TranslateKey: 'A phone call' },
  { LID: '2', TranslateData: 'A phone call', TranslateKey: 'A phone call' },
  {
    LID: '3',
    TranslateData: 'Un appel téléphonique',
    TranslateKey: 'A phone call',
  },
  {
    LID: '4',
    TranslateData: 'Телефонный звонок',
    TranslateKey: 'A phone call',
  },
  { LID: '1', TranslateData: 'חודש', TranslateKey: 'A month' },
  { LID: '2', TranslateData: 'A month', TranslateKey: 'A month' },
  { LID: '3', TranslateData: 'Un mois', TranslateKey: 'A month' },
  { LID: '4', TranslateData: 'Месяц', TranslateKey: 'A month' },
  { LID: '1', TranslateData: 'חברת', TranslateKey: 'a company' },
  { LID: '2', TranslateData: 'a company', TranslateKey: 'a company' },
  { LID: '3', TranslateData: 'entreprise', TranslateKey: 'a company' },
  { LID: '4', TranslateData: 'компания', TranslateKey: 'a company' },
  {
    LID: '1',
    TranslateData:
      'לעסקאות בכרטיס אשראי תתווסף עמלת סליקה בסך {0} ש"ח + {1}% מסכום העסקה (כולל מעמ)',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (including VAT) will be added to the transactions amount',
  },
  {
    LID: '2',
    TranslateData:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (including VAT) will be added to the transactions amount',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (including VAT) will be added to the transactions amount',
  },
  {
    LID: '3',
    TranslateData:
      'Des frais de compensation de {0} NIS + {1}% du montant de la transaction (TVA incluse) seront ajoutés au montant de la transaction.',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (including VAT) will be added to the transactions amount',
  },
  {
    LID: '4',
    TranslateData:
      'К сумме транзакции будет добавлена клиринговая комиссия в размере {0} шекелей + {1}% от суммы транзакции (включая НДС).',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (including VAT) will be added to the transactions amount',
  },
  {
    LID: '1',
    TranslateData: '+ הוסף לתשלום',
    TranslateKey: '+ Add to payment',
  },
  {
    LID: '2',
    TranslateData: '+ Add to payment',
    TranslateKey: '+ Add to payment',
  },
  {
    LID: '3',
    TranslateData: "+ Ajouter au paiement'",
    TranslateKey: '+ Add to payment',
  },
  {
    LID: '4',
    TranslateData: "+ Добавить к оплате'",
    TranslateKey: '+ Add to payment',
  },
  {
    LID: '1',
    TranslateData: '{0}: גודל קובץ לא חוקי, גודל הקובץ צריך להיות קטן מ-{1}.',
    TranslateKey:
      '{0}: Invalid file size, file size should be smaller than {1}.',
  },
  {
    LID: '2',
    TranslateData:
      '{0}: Invalid file size, file size should be smaller than {1}.',
    TranslateKey:
      '{0}: Invalid file size, file size should be smaller than {1}.',
  },
  {
    LID: '3',
    TranslateData:
      '{0} : taille de fichier non valide, la taille du fichier doit être inférieure à {1}.',
    TranslateKey:
      '{0}: Invalid file size, file size should be smaller than {1}.',
  },
  {
    LID: '4',
    TranslateData:
      '{0}: неверный размер файла, размер файла должен быть меньше {1}.',
    TranslateKey:
      '{0}: Invalid file size, file size should be smaller than {1}.',
  },
  {
    LID: '1',
    TranslateData: '- נוסף לתשלום',
    TranslateKey: '- Added to payment',
  },
  {
    LID: '2',
    TranslateData: '- Added to payment',
    TranslateKey: '- Added to payment',
  },
  {
    LID: '3',
    TranslateData: "- Ajouté au paiement'",
    TranslateKey: '- Added to payment',
  },
  {
    LID: '4',
    TranslateData: "- Добавлено в оплату'",
    TranslateKey: '- Added to payment',
  },
  { LID: '1', TranslateData: 'בחר תחום', TranslateKey: '  SELECT   a topic' },
  {
    LID: '2',
    TranslateData: 'Select a topic',
    TranslateKey: '  SELECT   a topic',
  },
  {
    LID: '3',
    TranslateData: 'Sélectionnez un bâtiment',
    TranslateKey: '  SELECT   a topic',
  },
  {
    LID: '4',
    TranslateData: 'Выберите тему',
    TranslateKey: '  SELECT   a topic',
  },
  {
    LID: '1',
    TranslateData: 'הגדר תאריך סיום הוראת קבע',
    TranslateKey: 'set end date for reocurring charge',
  },
  {
    LID: '2',
    TranslateData: 'set end date for reocurring charge',
    TranslateKey: 'set end date for reocurring charge',
  },
  {
    LID: '3',
    TranslateData: 'fixer la date de fin des frais récurrents',
    TranslateKey: 'set end date for reocurring charge',
  },
  {
    LID: '4',
    TranslateData: 'установить дату окончания регулярного платежа',
    TranslateKey: 'set end date for reocurring charge',
  },
  {
    LID: '1',
    TranslateData: 'https://noo.mx/0ZK',
    TranslateKey: 'tennatAppShaeToFriendLink',
  },
  {
    LID: '2',
    TranslateData: 'https://noo.mx/0ZL',
    TranslateKey: 'tennatAppShaeToFriendLink',
  },
  {
    LID: '3',
    TranslateData: 'https://noo.mx/0ZM',
    TranslateKey: 'tennatAppShaeToFriendLink',
  },
  {
    LID: '4',
    TranslateData: 'https://noo.mx/0ZN',
    TranslateKey: 'tennatAppShaeToFriendLink',
  },
  { LID: '1', TranslateData: 'עדכון האפליקציה', TranslateKey: 'App update' },
  { LID: '2', TranslateData: 'App update', TranslateKey: 'App update' },
  {
    LID: '3',
    TranslateData: "Mise à jour de l'application",
    TranslateKey: 'App update',
  },
  {
    LID: '4',
    TranslateData: 'Обновление приложения',
    TranslateKey: 'App update',
  },
  {
    LID: '1',
    TranslateData: 'גרסת האפליקציה שברשותכם {0} לא נתמכת יותר',
    TranslateKey: 'The app version you have {0} is no longer supported',
  },
  {
    LID: '2',
    TranslateData: 'The app version you have {0} is no longer supported',
    TranslateKey: 'The app version you have {0} is no longer supported',
  },
  {
    LID: '3',
    TranslateData:
      "La version de l'application que vous possédez {0} n'est plus prise en charge",
    TranslateKey: 'The app version you have {0} is no longer supported',
  },
  {
    LID: '4',
    TranslateData: 'Версия вашего приложения {0} больше не поддерживается',
    TranslateKey: 'The app version you have {0} is no longer supported',
  },
  {
    LID: '1',
    TranslateData: 'יש להתקין גרסה מחדש',
    TranslateKey: 'A new version must be installed',
  },
  {
    LID: '2',
    TranslateData: 'A new version must be installed',
    TranslateKey: 'A new version must be installed',
  },
  {
    LID: '3',
    TranslateData: 'Une nouvelle version doit être installée',
    TranslateKey: 'A new version must be installed',
  },
  {
    LID: '4',
    TranslateData: 'Необходимо установить новую версию',
    TranslateKey: 'A new version must be installed',
  },
  { LID: '1', TranslateData: 'עדכון גרסה', TranslateKey: 'Update version' },
  { LID: '2', TranslateData: 'Update version', TranslateKey: 'Update version' },
  {
    LID: '3',
    TranslateData: 'Version de mise à jour',
    TranslateKey: 'Update version',
  },
  {
    LID: '4',
    TranslateData: 'Обновить версию',
    TranslateKey: 'Update version',
  },
  { LID: '1', TranslateData: 'אחזקת מבנה', TranslateKey: 'אחזקת מבנה' },
  {
    LID: '2',
    TranslateData: 'Building maintenance',
    TranslateKey: 'אחזקת מבנה',
  },
  {
    LID: '3',
    TranslateData: 'Maintenance du batiment',
    TranslateKey: 'אחזקת מבנה',
  },
  {
    LID: '4',
    TranslateData: 'Техническое обслуживание здания',
    TranslateKey: 'אחזקת מבנה',
  },
  { LID: '1', TranslateData: 'טונרים למדפסות', TranslateKey: 'טונרים למדפסות' },
  {
    LID: '2',
    TranslateData: 'toners for printers',
    TranslateKey: 'טונרים למדפסות',
  },
  {
    LID: '3',
    TranslateData: 'toners pour imprimantes',
    TranslateKey: 'טונרים למדפסות',
  },
  {
    LID: '4',
    TranslateData: 'тонеры для принтеров',
    TranslateKey: 'טונרים למדפסות',
  },
  { LID: '1', TranslateData: 'מכונות צילום', TranslateKey: 'מכונות צילום' },
  { LID: '2', TranslateData: 'Photocopiers', TranslateKey: 'מכונות צילום' },
  { LID: '3', TranslateData: 'Photocopieurs', TranslateKey: 'מכונות צילום' },
  {
    LID: '4',
    TranslateData: 'Копировальные аппараты',
    TranslateKey: 'מכונות צילום',
  },
  { LID: '1', TranslateData: 'מחשבים', TranslateKey: 'מחשבים' },
  { LID: '2', TranslateData: 'Computers', TranslateKey: 'מחשבים' },
  { LID: '3', TranslateData: 'Des ordinateurs', TranslateKey: 'מחשבים' },
  { LID: '4', TranslateData: 'Компьютеры', TranslateKey: 'מחשבים' },
  { LID: '1', TranslateData: 'מולטימדיה', TranslateKey: 'מולטימדיה' },
  { LID: '2', TranslateData: 'Multimedia', TranslateKey: 'מולטימדיה' },
  { LID: '3', TranslateData: 'Multimédia', TranslateKey: 'מולטימדיה' },
  { LID: '4', TranslateData: 'Мультимедиа', TranslateKey: 'מולטימדיה' },
  { LID: '1', TranslateData: 'תוכנה', TranslateKey: 'תוכנה' },
  { LID: '2', TranslateData: 'software', TranslateKey: 'תוכנה' },
  { LID: '3', TranslateData: 'logiciel', TranslateKey: 'תוכנה' },
  { LID: '4', TranslateData: 'программное обеспечение', TranslateKey: 'תוכנה' },
  { LID: '1', TranslateData: 'שירות', TranslateKey: 'שירות' },
  { LID: '2', TranslateData: 'Service', TranslateKey: 'שירות' },
  { LID: '3', TranslateData: 'Service', TranslateKey: 'שירות' },
  { LID: '4', TranslateData: 'Услуга', TranslateKey: 'שירות' },
  { LID: '1', TranslateData: 'ריהוט', TranslateKey: 'ריהוט' },
  { LID: '2', TranslateData: 'Furniture', TranslateKey: 'ריהוט' },
  { LID: '3', TranslateData: 'Meubles', TranslateKey: 'ריהוט' },
  { LID: '4', TranslateData: 'Мебель', TranslateKey: 'ריהוט' },
  {
    LID: '1',
    TranslateData: 'מספר דירות בבניין',
    TranslateKey: 'The number of apartments in the building',
  },
  {
    LID: '2',
    TranslateData: 'The number of apartments in the building',
    TranslateKey: 'The number of apartments in the building',
  },
  {
    LID: '3',
    TranslateData: "Le nombre d'appartements dans l'immeuble",
    TranslateKey: 'The number of apartments in the building',
  },
  {
    LID: '4',
    TranslateData: 'Количество квартир в доме',
    TranslateKey: 'The number of apartments in the building',
  },
  { LID: '1', TranslateData: 'מספר דירה', TranslateKey: 'Apartment number' },
  {
    LID: '2',
    TranslateData: 'Apartment number',
    TranslateKey: 'Apartment number',
  },
  {
    LID: '3',
    TranslateData: "Numéro d'appartement",
    TranslateKey: 'Apartment number',
  },
  {
    LID: '4',
    TranslateData: 'Номер квартиры',
    TranslateKey: 'Apartment number',
  },
  {
    LID: '1',
    TranslateData: 'מספר בניין לא תקין',
    TranslateKey: 'Invalid building number',
  },
  {
    LID: '2',
    TranslateData: 'Invalid building number',
    TranslateKey: 'Invalid building number',
  },
  {
    LID: '3',
    TranslateData: 'Numéro de bâtiment invalide',
    TranslateKey: 'Invalid building number',
  },
  {
    LID: '4',
    TranslateData: 'Неверный номер здания',
    TranslateKey: 'Invalid building number',
  },
  {
    LID: '1',
    TranslateData: 'מספר דירה לא תקין',
    TranslateKey: 'Invalid apartment number',
  },
  {
    LID: '2',
    TranslateData: 'Invalid apartment number',
    TranslateKey: 'Invalid apartment number',
  },
  {
    LID: '3',
    TranslateData: "Numéro d'appartement invalide",
    TranslateKey: 'Invalid apartment number',
  },
  {
    LID: '4',
    TranslateData: 'Неверный номер квартиры',
    TranslateKey: 'Invalid apartment number',
  },
  {
    LID: '1',
    TranslateData: 'הכנס כתובת מייל לשליחת הקובץ',
    TranslateKey: 'Enter an email address to send the file',
  },
  {
    LID: '2',
    TranslateData: 'Enter an email address to send the file',
    TranslateKey: 'Enter an email address to send the file',
  },
  {
    LID: '3',
    TranslateData: 'Entrez une adresse e-mail pour envoyer le fichier',
    TranslateKey: 'Enter an email address to send the file',
  },
  {
    LID: '4',
    TranslateData: 'Введите адрес электронной почты для отправки файла',
    TranslateKey: 'Enter an email address to send the file',
  },
  {
    LID: '1',
    TranslateData: 'הקובץ נשמר בהצלחה',
    TranslateKey: 'The file was saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The file was saved successfully',
    TranslateKey: 'The file was saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le fichier a été enregistré avec succès',
    TranslateKey: 'The file was saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Файл успешно сохранен',
    TranslateKey: 'The file was saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה בשמירת הקובץ',
    TranslateKey: 'An error occurred while saving the file',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while saving the file',
    TranslateKey: 'An error occurred while saving the file',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de l'enregistrement du fichier",
    TranslateKey: 'An error occurred while saving the file',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при сохранении файла',
    TranslateKey: 'An error occurred while saving the file',
  },
  {
    LID: '1',
    TranslateData: 'הוספת מסמך לבניין',
    TranslateKey: 'Adding a document to the building',
  },
  {
    LID: '2',
    TranslateData: 'Adding a document to the building',
    TranslateKey: 'Adding a document to the building',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter un document au bâtiment',
    TranslateKey: 'Adding a document to the building',
  },
  {
    LID: '4',
    TranslateData: 'Добавление документа в здание',
    TranslateKey: 'Adding a document to the building',
  },
  {
    LID: '1',
    TranslateData: 'שליחת מסמך במייל',
    TranslateKey: 'Sending a document by email',
  },
  {
    LID: '2',
    TranslateData: 'Sending a document by email',
    TranslateKey: 'Sending a document by email',
  },
  {
    LID: '3',
    TranslateData: "Envoi d'un document par email",
    TranslateKey: 'Sending a document by email',
  },
  {
    LID: '4',
    TranslateData: 'Отправка документа по электронной почте',
    TranslateKey: 'Sending a document by email',
  },
  {
    LID: '1',
    TranslateData: 'הצגת מסמך',
    TranslateKey: 'Presentation of a document',
  },
  {
    LID: '2',
    TranslateData: 'Presentation of a document',
    TranslateKey: 'Presentation of a document',
  },
  {
    LID: '3',
    TranslateData: "Présentation d'un document",
    TranslateKey: 'Presentation of a document',
  },
  {
    LID: '4',
    TranslateData: 'Презентация документа',
    TranslateKey: 'Presentation of a document',
  },
  { LID: '1', TranslateData: 'תיק מסמכים', TranslateKey: 'Documents' },
  { LID: '2', TranslateData: 'Documents', TranslateKey: 'Documents' },
  { LID: '3', TranslateData: 'Documents', TranslateKey: 'Documents' },
  { LID: '4', TranslateData: 'Документы', TranslateKey: 'Documents' },
  { LID: '1', TranslateData: 'עמוד', TranslateKey: 'Page' },
  { LID: '2', TranslateData: 'Page', TranslateKey: 'Page' },
  { LID: '3', TranslateData: 'Page', TranslateKey: 'Page' },
  { LID: '4', TranslateData: 'Страница', TranslateKey: 'Page' },
  {
    LID: '1',
    TranslateData: 'הקובץ לא נמצא בתיקיה',
    TranslateKey: 'The system cannot locate the file in the folder (A)',
  },
  {
    LID: '2',
    TranslateData: 'The file is not found in the folder',
    TranslateKey: 'The system cannot locate the file in the folder (A)',
  },
  {
    LID: '3',
    TranslateData: 'Le fichier est introuvable dans le dossier',
    TranslateKey: 'The system cannot locate the file in the folder (A)',
  },
  {
    LID: '4',
    TranslateData: 'Файл не найден в папке',
    TranslateKey: 'The system cannot locate the file in the folder (A)',
  },
  {
    LID: '1',
    TranslateData: 'הקובץ לא נמצא בתיקיה',
    TranslateKey: 'The system cannot locate the file in the folder (B)',
  },
  {
    LID: '2',
    TranslateData: 'The file is not found in the folder',
    TranslateKey: 'The system cannot locate the file in the folder (B)',
  },
  {
    LID: '3',
    TranslateData: 'Le fichier est introuvable dans le dossier',
    TranslateKey: 'The system cannot locate the file in the folder (B)',
  },
  {
    LID: '4',
    TranslateData: 'Файл не найден в папке',
    TranslateKey: 'The system cannot locate the file in the folder (B)',
  },
  {
    LID: '1',
    TranslateData: 'הקובץ לא נמצא בתיקיה',
    TranslateKey: 'The system cannot locate the file in the folder (C)',
  },
  {
    LID: '2',
    TranslateData: 'The file is not found in the folder',
    TranslateKey: 'The system cannot locate the file in the folder (C)',
  },
  {
    LID: '3',
    TranslateData: 'Le fichier est introuvable dans le dossier',
    TranslateKey: 'The system cannot locate the file in the folder (C)',
  },
  {
    LID: '4',
    TranslateData: 'Файл не найден в папке',
    TranslateKey: 'The system cannot locate the file in the folder (C)',
  },
  {
    LID: '1',
    TranslateData: 'המייל נשלח בהצלחה',
    TranslateKey: 'Email sent successfully',
  },
  {
    LID: '2',
    TranslateData: 'The email was sent successfully',
    TranslateKey: 'Email sent successfully',
  },
  {
    LID: '3',
    TranslateData: "L'e-mail a été envoyé avec succès",
    TranslateKey: 'Email sent successfully',
  },
  {
    LID: '4',
    TranslateData: 'Письмо было успешно отправлено',
    TranslateKey: 'Email sent successfully',
  },
  { LID: '1', TranslateData: 'עמדות טעינה', TranslateKey: 'Electricity meter' },
  {
    LID: '2',
    TranslateData: 'Charging stations',
    TranslateKey: 'Electricity meter',
  },
  {
    LID: '3',
    TranslateData: 'Bornes de recharge',
    TranslateKey: 'Electricity meter',
  },
  {
    LID: '4',
    TranslateData: 'Зарядные станции',
    TranslateKey: 'Electricity meter',
  },
  { LID: '1', TranslateData: 'סיבת חיוב', TranslateKey: 'billing reason' },
  { LID: '2', TranslateData: 'billing reason', TranslateKey: 'billing reason' },
  {
    LID: '3',
    TranslateData: 'motif de facturation',
    TranslateKey: 'billing reason',
  },
  {
    LID: '4',
    TranslateData: 'причина выставления счета',
    TranslateKey: 'billing reason',
  },
  { LID: '1', TranslateData: 'מיוחדת', TranslateKey: 'special' },
  { LID: '2', TranslateData: 'special', TranslateKey: 'special' },
  { LID: '3', TranslateData: 'spécial', TranslateKey: 'special' },
  { LID: '4', TranslateData: 'особенный', TranslateKey: 'special' },
  { LID: '1', TranslateData: 'אחר', TranslateKey: 'Other' },
  { LID: '2', TranslateData: 'Other', TranslateKey: 'Other' },
  { LID: '3', TranslateData: 'Autre', TranslateKey: 'Other' },
  { LID: '4', TranslateData: 'Другой', TranslateKey: 'Other' },
  {
    LID: '1',
    TranslateData: 'החיוב נשמר בהצלחה',
    TranslateKey: 'The charge has been saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The charge has been saved successfully',
    TranslateKey: 'The charge has been saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'La charge a été enregistrée avec succès',
    TranslateKey: 'The charge has been saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Платеж успешно сохранен.',
    TranslateKey: 'The charge has been saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'יצירת חיוב לדירה',
    TranslateKey: 'Adding quick charge',
  },
  {
    LID: '2',
    TranslateData: 'Creating a charge for the apartment',
    TranslateKey: 'Adding quick charge',
  },
  {
    LID: '3',
    TranslateData: 'Создание платы за квартиру',
    TranslateKey: 'Adding quick charge',
  },
  {
    LID: '4',
    TranslateData: "Création d'une charge pour l'appartement",
    TranslateKey: 'Adding quick charge',
  },
  { LID: '1', TranslateData: 'מספר מונה', TranslateKey: 'Counter number' },
  { LID: '2', TranslateData: 'Counter number', TranslateKey: 'Counter number' },
  {
    LID: '3',
    TranslateData: 'Numéro du compteur',
    TranslateKey: 'Counter number',
  },
  { LID: '4', TranslateData: 'Номер счетчика', TranslateKey: 'Counter number' },
  {
    LID: '1',
    TranslateData: 'המונה נשמר בהצלחה',
    TranslateKey: 'The counter was saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The counter was saved successfully',
    TranslateKey: 'The counter was saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le compteur a été enregistré avec succès',
    TranslateKey: 'The counter was saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Счетчик успешно сохранен',
    TranslateKey: 'The counter was saved successfully',
  },
  { LID: '1', TranslateData: 'מחיר לקוט"ש', TranslateKey: 'Price per kWh' },
  { LID: '2', TranslateData: 'Price per kWh', TranslateKey: 'Price per kWh' },
  { LID: '3', TranslateData: 'Prix par kWh', TranslateKey: 'Price per kWh' },
  { LID: '4', TranslateData: 'Цена за кВтч', TranslateKey: 'Price per kWh' },
  {
    LID: '1',
    TranslateData: 'תשלום עבור טעינת רכב',
    TranslateKey: 'Payment for car charging',
  },
  {
    LID: '2',
    TranslateData: 'Payment for car charging',
    TranslateKey: 'Payment for car charging',
  },
  {
    LID: '3',
    TranslateData: 'Paiement pour la recharge de la voiture',
    TranslateKey: 'Payment for car charging',
  },
  {
    LID: '4',
    TranslateData: 'Оплата за зарядку автомобиля',
    TranslateKey: 'Payment for car charging',
  },
  {
    LID: '1',
    TranslateData: 'קריאת מונה אחרונה',
    TranslateKey: 'Last meter reading',
  },
  {
    LID: '2',
    TranslateData: 'Last meter reading',
    TranslateKey: 'Last meter reading',
  },
  {
    LID: '3',
    TranslateData: 'Relevé du dernier compteur',
    TranslateKey: 'Last meter reading',
  },
  {
    LID: '4',
    TranslateData: 'Последнее показание счетчика',
    TranslateKey: 'Last meter reading',
  },
  { LID: '1', TranslateData: 'בתאריך', TranslateKey: 'on the date' },
  { LID: '2', TranslateData: 'on the date', TranslateKey: 'on the date' },
  { LID: '3', TranslateData: 'à la date', TranslateKey: 'on the date' },
  { LID: '4', TranslateData: 'на дату', TranslateKey: 'on the date' },
  {
    LID: '1',
    TranslateData: 'קריאת מונה נוכחית',
    TranslateKey: 'Current meter reading',
  },
  {
    LID: '2',
    TranslateData: 'Current meter reading',
    TranslateKey: 'Current meter reading',
  },
  {
    LID: '3',
    TranslateData: 'Relevé du compteur actuel',
    TranslateKey: 'Current meter reading',
  },
  {
    LID: '4',
    TranslateData: 'Текущие показания счетчика',
    TranslateKey: 'Current meter reading',
  },
  { LID: '1', TranslateData: 'סה"כ צריכה', TranslateKey: 'Total consumption' },
  {
    LID: '2',
    TranslateData: 'Total consumption',
    TranslateKey: 'Total consumption',
  },
  {
    LID: '3',
    TranslateData: 'Consommation totale',
    TranslateKey: 'Total consumption',
  },
  {
    LID: '4',
    TranslateData: 'Общее потребление',
    TranslateKey: 'Total consumption',
  },
  { LID: '1', TranslateData: 'סה"כ לתשלום', TranslateKey: 'Total payment' },
  { LID: '2', TranslateData: 'Total payment', TranslateKey: 'Total payment' },
  { LID: '3', TranslateData: 'Paiement total', TranslateKey: 'Total payment' },
  { LID: '4', TranslateData: 'Всего к оплате', TranslateKey: 'Total payment' },
  {
    LID: '1',
    TranslateData: 'סה"כ כולל עמלה',
    TranslateKey: 'Total including commission',
  },
  {
    LID: '2',
    TranslateData: 'Total including commission',
    TranslateKey: 'Total including commission',
  },
  {
    LID: '3',
    TranslateData: 'Total incluant commission',
    TranslateKey: 'Total including commission',
  },
  {
    LID: '4',
    TranslateData: 'Итого, включая комиссию',
    TranslateKey: 'Total including commission',
  },
  {
    LID: '1',
    TranslateData: 'נא לצרף תמונה של המונה',
    TranslateKey: 'Please attach a photo of the meter',
  },
  {
    LID: '2',
    TranslateData: 'Please attach a photo of the meter',
    TranslateKey: 'Please attach a photo of the meter',
  },
  {
    LID: '3',
    TranslateData: 'Veuillez joindre une photo du compteur',
    TranslateKey: 'Please attach a photo of the meter',
  },
  {
    LID: '4',
    TranslateData: 'Прикрепите пожалуйста фото счетчика',
    TranslateKey: 'Please attach a photo of the meter',
  },
  {
    LID: '1',
    TranslateData: 'קריאת מונה נוכחית צריכה להיות גדולה מקריאה קודמת',
    TranslateKey:
      'Current meter reading should be greater than previous reading',
  },
  {
    LID: '2',
    TranslateData:
      'Current meter reading should be greater than previous reading',
    TranslateKey:
      'Current meter reading should be greater than previous reading',
  },
  {
    LID: '3',
    TranslateData:
      'La lecture du compteur actuel doit être supérieure à la lecture précédente',
    TranslateKey:
      'Current meter reading should be greater than previous reading',
  },
  {
    LID: '4',
    TranslateData:
      'Текущее показание счетчика должно быть больше предыдущего показания.',
    TranslateKey:
      'Current meter reading should be greater than previous reading',
  },
  {
    LID: '1',
    TranslateData: 'שגיאה בשמירת הקריאה',
    TranslateKey: 'Error saving reading',
  },
  {
    LID: '2',
    TranslateData: 'Error saving reading',
    TranslateKey: 'Error saving reading',
  },
  {
    LID: '3',
    TranslateData: "Erreur lors de l'enregistrement de la lecture",
    TranslateKey: 'Error saving reading',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка сохранения чтения.',
    TranslateKey: 'Error saving reading',
  },
  {
    LID: '1',
    TranslateData: 'קריאת המונה נשמרה בהצלחה',
    TranslateKey: 'The meter reading was saved successfully',
  },
  {
    LID: '2',
    TranslateData: 'The meter reading was saved successfully',
    TranslateKey: 'The meter reading was saved successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le relevé du compteur a été enregistré avec succès',
    TranslateKey: 'The meter reading was saved successfully',
  },
  {
    LID: '4',
    TranslateData: 'Показания счетчика успешно сохранены',
    TranslateKey: 'The meter reading was saved successfully',
  },
  {
    LID: '1',
    TranslateData: 'הגדרת מחיר לקוט"ש',
    TranslateKey: 'Price definition per kWh',
  },
  {
    LID: '2',
    TranslateData: 'Price definition per kWh',
    TranslateKey: 'Price definition per kWh',
  },
  {
    LID: '3',
    TranslateData: 'Définition du prix par kWh',
    TranslateKey: 'Price definition per kWh',
  },
  {
    LID: '4',
    TranslateData: 'Определение цены за кВтч',
    TranslateKey: 'Price definition per kWh',
  },
  { LID: '1', TranslateData: 'הוספת מונה', TranslateKey: 'Adding a counter' },
  {
    LID: '2',
    TranslateData: 'Adding a counter',
    TranslateKey: 'Adding a counter',
  },
  {
    LID: '3',
    TranslateData: "Ajout d'un compteur",
    TranslateKey: 'Adding a counter',
  },
  {
    LID: '4',
    TranslateData: 'Добавление счетчика',
    TranslateKey: 'Adding a counter',
  },
  { LID: '1', TranslateData: 'קריאה אחרונה', TranslateKey: 'Last read' },
  { LID: '2', TranslateData: 'Last read', TranslateKey: 'Last read' },
  { LID: '3', TranslateData: 'Dernière lecture', TranslateKey: 'Last read' },
  { LID: '4', TranslateData: 'Последнее чтение', TranslateKey: 'Last read' },
  {
    LID: '1',
    TranslateData: 'ת. קריאה אחרונה',
    TranslateKey: 'Last read date',
  },
  { LID: '2', TranslateData: 'Last read date', TranslateKey: 'Last read date' },
  {
    LID: '3',
    TranslateData: 'Date de la dernière lecture',
    TranslateKey: 'Last read date',
  },
  {
    LID: '4',
    TranslateData: 'Дата последнего чтения',
    TranslateKey: 'Last read date',
  },
  { LID: '1', TranslateData: 'עריכת מונה', TranslateKey: 'Counter editing' },
  {
    LID: '2',
    TranslateData: 'Counter editing',
    TranslateKey: 'Counter editing',
  },
  {
    LID: '3',
    TranslateData: 'Édition du compteur',
    TranslateKey: 'Counter editing',
  },
  {
    LID: '4',
    TranslateData: 'Редактирование счетчика',
    TranslateKey: 'Counter editing',
  },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך למחוק מונה זה?',
    TranslateKey: 'Are you sure you want to delete this meter?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to delete this meter?',
    TranslateKey: 'Are you sure you want to delete this meter?',
  },
  {
    LID: '3',
    TranslateData: 'Êtes-vous sûr de vouloir supprimer ce compteur ?',
    TranslateKey: 'Are you sure you want to delete this meter?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите удалить этот счетчик?',
    TranslateKey: 'Are you sure you want to delete this meter?',
  },
  {
    LID: '1',
    TranslateData: 'המונה נמחק בהצלחה',
    TranslateKey: 'The meter was deleted successfully',
  },
  {
    LID: '2',
    TranslateData: 'The meter was deleted successfully',
    TranslateKey: 'The meter was deleted successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le compteur a été supprimé avec succès',
    TranslateKey: 'The meter was deleted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Счетчик успешно удален',
    TranslateKey: 'The meter was deleted successfully',
  },
  {
    LID: '1',
    TranslateData: 'אירעה שגיאה במחיקת המונה',
    TranslateKey: 'An error occurred while deleting the counter',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while deleting the counter',
    TranslateKey: 'An error occurred while deleting the counter',
  },
  {
    LID: '3',
    TranslateData:
      "Une erreur s'est produite lors de la suppression du compteur",
    TranslateKey: 'An error occurred while deleting the counter',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при удалении счетчика.',
    TranslateKey: 'An error occurred while deleting the counter',
  },
  { LID: '1', TranslateData: 'נותר לתשלום', TranslateKey: 'left to pay' },
  { LID: '2', TranslateData: 'left to pay', TranslateKey: 'left to pay' },
  { LID: '3', TranslateData: 'reste à payer', TranslateKey: 'left to pay' },
  {
    LID: '4',
    TranslateData: 'осталось заплатить',
    TranslateKey: 'left to pay',
  },
  { LID: '1', TranslateData: 'תשלום', TranslateKey: 'payment' },
  { LID: '2', TranslateData: 'payment', TranslateKey: 'payment' },
  { LID: '3', TranslateData: 'paiement', TranslateKey: 'payment' },
  { LID: '4', TranslateData: 'оплата', TranslateKey: 'payment' },
  { LID: '1', TranslateData: 'עלות השכרת', TranslateKey: 'Rental cost' },
  { LID: '2', TranslateData: 'Rental cost', TranslateKey: 'Rental cost' },
  { LID: '3', TranslateData: 'Coût de location', TranslateKey: 'Rental cost' },
  { LID: '4', TranslateData: 'Стоимость аренды', TranslateKey: 'Rental cost' },
  { LID: '1', TranslateData: 'סוג הוצאה', TranslateKey: 'Type of Expense' },
  {
    LID: '2',
    TranslateData: 'Type of Expense',
    TranslateKey: 'Type of Expense',
  },
  {
    LID: '3',
    TranslateData: 'Type de dépense',
    TranslateKey: 'Type of Expense',
  },
  { LID: '4', TranslateData: 'Тип расходов', TranslateKey: 'Type of Expense' },
  {
    LID: '1',
    TranslateData: 'דיווח צריכה',
    TranslateKey: 'Consumption report',
  },
  {
    LID: '2',
    TranslateData: 'Consumption report',
    TranslateKey: 'Consumption report',
  },
  {
    LID: '3',
    TranslateData: 'Rapport de consommation',
    TranslateKey: 'Consumption report',
  },
  {
    LID: '4',
    TranslateData: 'Отчет о потреблении',
    TranslateKey: 'Consumption report',
  },
  {
    LID: '1',
    TranslateData: 'שים לב המחיר יחול על מדידות חדשות שנרשמות בלבד',
    TranslateKey:
      'Note that the price will apply to new measurements that are registered only',
  },
  {
    LID: '2',
    TranslateData:
      'Note that the price will apply to new measurements that are registered only',
    TranslateKey:
      'Note that the price will apply to new measurements that are registered only',
  },
  {
    LID: '3',
    TranslateData:
      "Notez que le prix s'appliquera aux nouvelles mesures enregistrées uniquement",
    TranslateKey:
      'Note that the price will apply to new measurements that are registered only',
  },
  {
    LID: '4',
    TranslateData:
      'Обратите внимание, что цена будет применяться только к новым измерениям, которые зарегистрированы.',
    TranslateKey:
      'Note that the price will apply to new measurements that are registered only',
  },
  {
    LID: '1',
    TranslateData:
      'לבניין זה לא הוגדר מחיר לקוטש יש להגדיר מחיר לפני הוספת עמדות טעינה',
    TranslateKey:
      'No price has been set for this building. A price must be set before adding charging stations',
  },
  {
    LID: '2',
    TranslateData:
      'No price has been set for this building. A price must be set before adding charging stations',
    TranslateKey:
      'No price has been set for this building. A price must be set before adding charging stations',
  },
  {
    LID: '3',
    TranslateData:
      'No price has been set for this building. A price must be set before adding charging stations',
    TranslateKey:
      'No price has been set for this building. A price must be set before adding charging stations',
  },
  {
    LID: '4',
    TranslateData:
      'Для этого здания не установлена ​​цена. Цену необходимо установить перед добавлением зарядных станций.',
    TranslateKey:
      'No price has been set for this building. A price must be set before adding charging stations',
  },
  {
    LID: '1',
    TranslateData: 'קריאת מונה התחלתית',
    TranslateKey: 'Initial meter reading',
  },
  {
    LID: '2',
    TranslateData: 'Initial meter reading',
    TranslateKey: 'Initial meter reading',
  },
  {
    LID: '3',
    TranslateData: 'Relevé initial du compteur',
    TranslateKey: 'Initial meter reading',
  },
  {
    LID: '4',
    TranslateData: 'Начальные показания счетчика',
    TranslateKey: 'Initial meter reading',
  },
  { LID: '1', TranslateData: 'הגדר', TranslateKey: 'definition' },
  { LID: '2', TranslateData: 'definition', TranslateKey: 'definition' },
  { LID: '3', TranslateData: 'définition', TranslateKey: 'definition' },
  { LID: '4', TranslateData: 'определение', TranslateKey: 'definition' },
  {
    LID: '1',
    TranslateData:
      'לעסקה זו תתווסף עמלת סליקה בסך {0} ש"ח + {1}% מסכום העסקה (לפני מע"מ).',
    TranslateKey:
      'A clearing fee of NIS {0} + {1}% of the transaction amount (befor VAT) will be added to this transaction.',
  },
  {
    LID: '2',
    TranslateData:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (before VAT) will be added to this transaction.',
    TranslateKey:
      'A clearing fee of NIS {0} + {1}% of the transaction amount (befor VAT) will be added to this transaction.',
  },
  {
    LID: '3',
    TranslateData:
      'Des frais de compensation de {0} NIS + {1} % du montant de la transaction (avant TVA) seront ajoutés à cette transaction.',
    TranslateKey:
      'A clearing fee of NIS {0} + {1}% of the transaction amount (befor VAT) will be added to this transaction.',
  },
  {
    LID: '4',
    TranslateData:
      'К этой транзакции будет добавлена ​​комиссия за клиринг в размере {0} шекелей + {1}% от суммы транзакции (до НДС).',
    TranslateKey:
      'A clearing fee of NIS {0} + {1}% of the transaction amount (befor VAT) will be added to this transaction.',
  },
  {
    LID: '1',
    TranslateData:
      'לעסקאות בכרטיס אשראי תתווסף עמלת סליקה בסך {0} ש"ח + {1}% מסכום העסקה (לפני מעמ)',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (befor VAT) will be added to the transactions amount',
  },
  {
    LID: '2',
    TranslateData:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (before VAT) will be added to the transactions amount',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (befor VAT) will be added to the transactions amount',
  },
  {
    LID: '3',
    TranslateData:
      'Des frais de compensation de {0} NIS + {1} % du montant de la transaction (avant TVA) seront ajoutés au montant de la transaction.',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (befor VAT) will be added to the transactions amount',
  },
  {
    LID: '4',
    TranslateData:
      'К сумме транзакции будет добавлена ​​комиссия за клиринг в размере {0} шекелей + {1}% от суммы транзакции (до НДС).',
    TranslateKey:
      'A clearing fee of {0} NIS + {1}% of the transaction amount (befor VAT) will be added to the transactions amount',
  },
  {
    LID: '1',
    TranslateData: 'לכרטיס שהונפק בחול תתוסף עמלה בסך {0} ש"ח.',
    TranslateKey:
      'A card issued in the sand will be charged a total fee {0} NIS',
  },
  {
    LID: '2',
    TranslateData:
      'A card issued in the sand will be charged a total fee {0} NIS',
    TranslateKey:
      'A card issued in the sand will be charged a total fee {0} NIS',
  },
  {
    LID: '3',
    TranslateData:
      'Une carte émise dans le sable sera facturée au total {0} NIS',
    TranslateKey:
      'A card issued in the sand will be charged a total fee {0} NIS',
  },
  {
    LID: '4',
    TranslateData: '',
    TranslateKey:
      'A card issued in the sand will be charged a total fee {0} NIS',
  },
  {
    LID: '1',
    TranslateData: 'לא ניתן להוסיף יותר ממונה אחד ליחידה',
    TranslateKey: 'It is not possible to add more than one counter per unit',
  },
  {
    LID: '2',
    TranslateData: 'It is not possible to add more than one counter per unit',
    TranslateKey: 'It is not possible to add more than one counter per unit',
  },
  {
    LID: '3',
    TranslateData:
      "Il n'est pas possible d'ajouter plus d'un compteur par unité",
    TranslateKey: 'It is not possible to add more than one counter per unit',
  },
  {
    LID: '4',
    TranslateData: 'Невозможно добавить более одного счетчика на единицу',
    TranslateKey: 'It is not possible to add more than one counter per unit',
  },
  {
    LID: '1',
    TranslateData:
      'לא הוגדרו עמדות טעינה בבניין זה, לחץ על "עמדת טעינה חדשה" כדי להגדיר',
    TranslateKey:
      'No charging stations have been set in this building, click "New Charging Station" to set up',
  },
  {
    LID: '2',
    TranslateData:
      'No charging stations have been set in this building, click "New Charging Station" to set up',
    TranslateKey:
      'No charging stations have been set in this building, click "New Charging Station" to set up',
  },
  {
    LID: '3',
    TranslateData:
      'Aucune borne de recharge n\'a été installée dans ce bâtiment, cliquez sur "Nouvelle borne de recharge" pour la configurer',
    TranslateKey:
      'No charging stations have been set in this building, click "New Charging Station" to set up',
  },
  {
    LID: '4',
    TranslateData:
      'В этом здании не установлено ни одной зарядной станции. Чтобы настроить, нажмите «Новая зарядная станция».',
    TranslateKey:
      'No charging stations have been set in this building, click "New Charging Station" to set up',
  },
  {
    LID: '1',
    TranslateData: 'הזן קריאת מונה',
    TranslateKey: 'Enter meter reading',
  },
  {
    LID: '2',
    TranslateData: 'Enter meter reading',
    TranslateKey: 'Enter meter reading',
  },
  {
    LID: '3',
    TranslateData: 'Saisir le relevé du compteur',
    TranslateKey: 'Enter meter reading',
  },
  {
    LID: '4',
    TranslateData: 'Введите показания счетчика',
    TranslateKey: 'Enter meter reading',
  },
  {
    LID: '1',
    TranslateData: 'עמדת טעינה חדשה',
    TranslateKey: 'New charging station',
  },
  {
    LID: '2',
    TranslateData: 'New charging station',
    TranslateKey: 'New charging station',
  },
  {
    LID: '3',
    TranslateData: 'Nouvelle borne de recharge',
    TranslateKey: 'New charging station',
  },
  {
    LID: '4',
    TranslateData: 'Новая зарядная станция',
    TranslateKey: 'New charging station',
  },
  {
    LID: '1',
    TranslateData: 'המחיר כולל מע"מ',
    TranslateKey: 'The price includes VAT',
  },
  {
    LID: '2',
    TranslateData: 'The price includes VAT',
    TranslateKey: 'The price includes VAT',
  },
  {
    LID: '3',
    TranslateData: 'Le prix inclut la TVA',
    TranslateKey: 'The price includes VAT',
  },
  {
    LID: '4',
    TranslateData: 'Цена включает НДС',
    TranslateKey: 'The price includes VAT',
  },
  {
    LID: '1',
    TranslateData: 'רשימת קריאות מונה',
    TranslateKey: 'Reading report',
  },
  { LID: '2', TranslateData: 'Reading report', TranslateKey: 'Reading report' },
  {
    LID: '3',
    TranslateData: 'Liste des relevés du compteur',
    TranslateKey: 'Reading report',
  },
  {
    LID: '4',
    TranslateData: 'Список показаний счетчика',
    TranslateKey: 'Reading report',
  },
  {
    LID: '1',
    TranslateData: 'תרגם לעברית',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '2',
    TranslateData: 'Translate into Hebrew',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '3',
    TranslateData: 'Traduire en hébreu',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '4',
    TranslateData: 'Перевести на иврит',
    TranslateKey: 'Translate into Hebrew',
  },
  {
    LID: '1',
    TranslateData: 'תרגם לאנגלית',
    TranslateKey: 'Translate into English',
  },
  {
    LID: '2',
    TranslateData: 'Translate into English',
    TranslateKey: 'Translate into English',
  },
  {
    LID: '3',
    TranslateData: 'Traduire en anglais',
    TranslateKey: 'Translate into English',
  },
  {
    LID: '4',
    TranslateData: 'Перевести на английский',
    TranslateKey: 'Translate into English',
  },
  {
    LID: '1',
    TranslateData: 'תרגם לרוסית',
    TranslateKey: 'Translate into Russian',
  },
  {
    LID: '2',
    TranslateData: 'Translate into Russian',
    TranslateKey: 'Translate into Russian',
  },
  {
    LID: '3',
    TranslateData: 'Traduire en russe',
    TranslateKey: 'Translate into Russian',
  },
  {
    LID: '4',
    TranslateData: 'Перевести на русский язык',
    TranslateKey: 'Translate into Russian',
  },
  { LID: '1', TranslateData: 'קריאת מונה', TranslateKey: 'Meter reading' },
  { LID: '2', TranslateData: 'Meter reading', TranslateKey: 'Meter reading' },
  {
    LID: '3',
    TranslateData: 'Relevé du compteur',
    TranslateKey: 'Meter reading',
  },
  {
    LID: '4',
    TranslateData: 'Показания счетчика',
    TranslateKey: 'Meter reading',
  },
  { LID: '1', TranslateData: 'קריאה התחלתית', TranslateKey: 'Initial reading' },
  {
    LID: '2',
    TranslateData: 'Initial reading',
    TranslateKey: 'Initial reading',
  },
  {
    LID: '3',
    TranslateData: 'Lecture initiale',
    TranslateKey: 'Initial reading',
  },
  {
    LID: '4',
    TranslateData: 'Первоначальное чтение',
    TranslateKey: 'Initial reading',
  },
  { LID: '1', TranslateData: 'שים לב:', TranslateKey: 'Note:' },
  { LID: '2', TranslateData: 'Note:', TranslateKey: 'Note:' },
  { LID: '3', TranslateData: 'Note:', TranslateKey: 'Note:' },
  { LID: '4', TranslateData: 'Примечание:', TranslateKey: 'Note:' },
  {
    LID: '1',
    TranslateData: 'פנייתך הוגשה מחוץ לשעות הפעילות של החברה.',
    TranslateKey:
      "Your service request was submitted outside the company's business hours.",
  },
  {
    LID: '2',
    TranslateData:
      "Your service request was submitted outside the company's business hours.",
    TranslateKey:
      "Your service request was submitted outside the company's business hours.",
  },
  {
    LID: '3',
    TranslateData:
      "Votre demande de service a été soumise en dehors des heures d'ouverture de l'entreprise.",
    TranslateKey:
      "Your service request was submitted outside the company's business hours.",
  },
  {
    LID: '4',
    TranslateData:
      'Ваш запрос на обслуживание был отправлен в нерабочее время компании.',
    TranslateKey:
      "Your service request was submitted outside the company's business hours.",
  },
  {
    LID: '1',
    TranslateData: 'במקרים דחופים בלבד יש ליצור קשר טלפוני למספר:',
    TranslateKey:
      'In urgent cases only, additional contact should be made by phone at the number:',
  },
  {
    LID: '2',
    TranslateData:
      'In urgent cases only, additional contact should be made by phone at the number:',
    TranslateKey:
      'In urgent cases only, additional contact should be made by phone at the number:',
  },
  {
    LID: '3',
    TranslateData:
      "En cas d'urgence uniquement, un contact supplémentaire doit être établi par téléphone au numéro:",
    TranslateKey:
      'In urgent cases only, additional contact should be made by phone at the number:',
  },
  {
    LID: '4',
    TranslateData:
      'Только в срочных случаях дополнительный контакт следует осуществлять по телефону по номеру:',
    TranslateKey:
      'In urgent cases only, additional contact should be made by phone at the number:',
  },
  { LID: '1', TranslateData: 'קראתי', TranslateKey: 'Read' },
  { LID: '2', TranslateData: 'Read', TranslateKey: 'Read' },
  { LID: '3', TranslateData: 'Lire', TranslateKey: 'Read' },
  { LID: '4', TranslateData: 'Читать', TranslateKey: 'Read' },
  {
    LID: '1',
    TranslateData: 'הוספת חשבונית',
    TranslateKey: 'Adding an invoice',
  },
  {
    LID: '2',
    TranslateData: 'Adding an invoice',
    TranslateKey: 'Adding an invoice',
  },
  {
    LID: '3',
    TranslateData: 'Ajouter une facture',
    TranslateKey: 'Adding an invoice',
  },
  {
    LID: '4',
    TranslateData: 'Добавление счета',
    TranslateKey: 'Adding an invoice',
  },
  { LID: '1', TranslateData: "צ'קים", TranslateKey: 'checks' },
  { LID: '2', TranslateData: 'Checks', TranslateKey: 'checks' },
  { LID: '3', TranslateData: 'Chèques', TranslateKey: 'checks' },
  { LID: '4', TranslateData: 'Чеки', TranslateKey: 'checks' },
  { LID: '1', TranslateData: 'חובות עבר', TranslateKey: 'Past Debts' },
  { LID: '2', TranslateData: 'Past Debts', TranslateKey: 'Past Debts' },
  { LID: '3', TranslateData: 'Dettes passées', TranslateKey: 'Past Debts' },
  { LID: '4', TranslateData: 'Прошлые долги', TranslateKey: 'Past Debts' },
  { LID: '1', TranslateData: 'חובות וועד שוטף', TranslateKey: 'Future Debts' },
  { LID: '2', TranslateData: 'Future Debts', TranslateKey: 'Future Debts' },
  { LID: '3', TranslateData: 'Dettes futures', TranslateKey: 'Future Debts' },
  { LID: '4', TranslateData: 'Будущие долги', TranslateKey: 'Future Debts' },
  { LID: '1', TranslateData: 'חובות מיוחדים', TranslateKey: 'Other Debts' },
  { LID: '2', TranslateData: 'Other Debts', TranslateKey: 'Other Debts' },
  { LID: '3', TranslateData: 'Autres dettes', TranslateKey: 'Other Debts' },
  { LID: '4', TranslateData: 'Другие долги', TranslateKey: 'Other Debts' },
  { LID: '1', TranslateData: 'סכום כולל', TranslateKey: 'Total amount' },
  { LID: '2', TranslateData: 'Total amount', TranslateKey: 'Total amount' },
  { LID: '3', TranslateData: 'Montant total', TranslateKey: 'Total amount' },
  { LID: '4', TranslateData: 'Общая сумма', TranslateKey: 'Total amount' },
  {
    LID: '1',
    TranslateData: 'מספר התשלומים',
    TranslateKey: 'Numbers of payments',
  },
  {
    LID: '2',
    TranslateData: 'Numbers of payments',
    TranslateKey: 'Numbers of payments',
  },
  {
    LID: '3',
    TranslateData: 'Nombre de paiements',
    TranslateKey: 'Numbers of payments',
  },
  {
    LID: '4',
    TranslateData: 'Количество платежей',
    TranslateKey: 'Numbers of payments',
  },
  {
    LID: '1',
    TranslateData: 'תאריך צ’ק ראשון',
    TranslateKey: 'First check date',
  },
  {
    LID: '2',
    TranslateData: 'First check date',
    TranslateKey: 'First check date',
  },
  {
    LID: '3',
    TranslateData: 'Date du premier chèque',
    TranslateKey: 'First check date',
  },
  {
    LID: '4',
    TranslateData: 'Дата первого чека',
    TranslateKey: 'First check date',
  },
  {
    LID: '1',
    TranslateData: 'עבור להוספת צ’קים',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '2',
    TranslateData: 'Go to add checks',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '3',
    TranslateData: 'Aller ajouter des chèques',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '4',
    TranslateData: 'Перейти к добавлению чеков',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '1',
    TranslateData: "התרחשה שגיאה בעיבוד הצ'ק",
    TranslateKey: 'An error occurred while processing the check',
  },
  {
    LID: '2',
    TranslateData: 'An error occurred while processing the check',
    TranslateKey: 'An error occurred while processing the check',
  },
  {
    LID: '3',
    TranslateData: "Une erreur s'est produite lors du traitement du chèque",
    TranslateKey: 'An error occurred while processing the check',
  },
  {
    LID: '4',
    TranslateData: 'Произошла ошибка при обработке чека',
    TranslateKey: 'An error occurred while processing the check',
  },
  {
    LID: '1',
    TranslateData: 'משהו השתבש ',
    TranslateKey: 'Something went wrong',
  },
  {
    LID: '2',
    TranslateData: 'Something went wrong',
    TranslateKey: 'Something went wrong',
  },
  {
    LID: '3',
    TranslateData: "Quelque chose s'est mal passé",
    TranslateKey: 'Something went wrong',
  },
  {
    LID: '4',
    TranslateData: 'Что-то пошло не так',
    TranslateKey: 'Something went wrong',
  },
  {
    LID: '1',
    TranslateData: 'משהו השתבש בטעינת התמונה',
    TranslateKey: 'Failed to load check images',
  },
  {
    LID: '2',
    TranslateData: 'Failed to load check images',
    TranslateKey: 'Failed to load check images',
  },
  {
    LID: '3',
    TranslateData: 'Échec du chargement des images de chèque',
    TranslateKey: 'Failed to load check images',
  },
  {
    LID: '4',
    TranslateData: 'Не удалось загрузить изображения проверки.',
    TranslateKey: 'Failed to load check images',
  },
  { LID: '1', TranslateData: 'חסרים פרטי', TranslateKey: 'Missing Details' },
  {
    LID: '2',
    TranslateData: 'Missing Details',
    TranslateKey: 'Missing Details',
  },
  {
    LID: '3',
    TranslateData: 'Détails manquants',
    TranslateKey: 'Missing Details',
  },
  {
    LID: '4',
    TranslateData: 'Недостающие детали',
    TranslateKey: 'Missing Details',
  },
  {
    LID: '1',
    TranslateData: 'חסרים פרטים על מנת להמשיך בתהליך',
    TranslateKey: 'Missing details to continue the process',
  },
  {
    LID: '2',
    TranslateData: 'Missing details to continue the process',
    TranslateKey: 'Missing details to continue the process',
  },
  {
    LID: '3',
    TranslateData: 'Détails manquants pour continuer le processus',
    TranslateKey: 'Missing details to continue the process',
  },
  {
    LID: '4',
    TranslateData: 'Не хватает деталей для продолжения процесса',
    TranslateKey: 'Missing details to continue the process',
  },
  { LID: '1', TranslateData: "הפקדת צ'קים", TranslateKey: 'Checks Deposit' },
  { LID: '2', TranslateData: 'Checks Deposit', TranslateKey: 'Checks Deposit' },
  {
    LID: '3',
    TranslateData: 'Dépôt de chèques',
    TranslateKey: 'Checks Deposit',
  },
  { LID: '4', TranslateData: 'Чеки Депозит', TranslateKey: 'Checks Deposit' },
  {
    LID: '1',
    TranslateData: 'אנא הזן את 6 הספרות האחרונות של המספר שחייג אליך',
    TranslateKey: 'Please enter the 6 last numbers you received in the Phone',
  },
  {
    LID: '2',
    TranslateData: 'Please enter the last 6 digits of the number dialed to you',
    TranslateKey: 'Please enter the 6 last numbers you received in the Phone',
  },
  {
    LID: '3',
    TranslateData:
      'Veuillez entrer les 6 derniers chiffres du numéro qui vous a été composé',
    TranslateKey: 'Please enter the 6 last numbers you received in the Phone',
  },
  {
    LID: '4',
    TranslateData: 'Пожалуйста, введите последние 6 цифр набранного вам номера',
    TranslateKey: 'Please enter the 6 last numbers you received in the Phone',
  },
  {
    LID: '1',
    TranslateData: 'אישור ההפקדה הצליח',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '2',
    TranslateData: 'Deposit confirmation was successful',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '3',
    TranslateData: 'La confirmation du dépôt a réussi',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '4',
    TranslateData: 'Подтверждение депозита прошло успешно',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '1',
    TranslateData: 'אישור הפקדה',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '2',
    TranslateData: 'Deposit confirmation',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '3',
    TranslateData: 'Confirmation du dépôt',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '4',
    TranslateData: 'Подтверждение депозита',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '1',
    TranslateData: 'שגיאה בלכידת ההמחאה, אנא נסה שוב',
    TranslateKey: 'Error capturing the check, please try again',
  },
  {
    LID: '2',
    TranslateData: 'Error capturing the check, please try again',
    TranslateKey: 'Error capturing the check, please try again',
  },
  {
    LID: '3',
    TranslateData: 'Erreur lors de la capture du chèque, veuillez réessayer',
    TranslateKey: 'Error capturing the check, please try again',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка захвата чека, попробуйте еще раз',
    TranslateKey: 'Error capturing the check, please try again',
  },
  {
    LID: '1',
    TranslateData: 'השיק נשמר במערכת',
    TranslateKey: 'The check has been saved in the system',
  },
  {
    LID: '2',
    TranslateData: 'The check has been saved in the system',
    TranslateKey: 'The check has been saved in the system',
  },
  {
    LID: '3',
    TranslateData: 'Le chèque a été enregistré dans le système',
    TranslateKey: 'The check has been saved in the system',
  },
  {
    LID: '4',
    TranslateData: 'Чек сохранен в системе',
    TranslateKey: 'The check has been saved in the system',
  },
  { LID: '1', TranslateData: 'הצלחה', TranslateKey: 'Success' },
  { LID: '2', TranslateData: 'Success', TranslateKey: 'Success' },
  { LID: '3', TranslateData: 'Succès', TranslateKey: 'Success' },
  { LID: '4', TranslateData: 'Успех', TranslateKey: 'Success' },
  { LID: '1', TranslateData: 'שגיאה', TranslateKey: 'Error' },
  { LID: '2', TranslateData: 'Error', TranslateKey: 'Error' },
  { LID: '3', TranslateData: 'Erreur', TranslateKey: 'Error' },
  { LID: '4', TranslateData: 'Ошибка', TranslateKey: 'Error' },
  {
    LID: '1',
    TranslateData: 'אישור הפקדה',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '2',
    TranslateData: 'Deposit confirmation',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '3',
    TranslateData: 'Confirmation du dépôt',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '4',
    TranslateData: 'Подтверждение депозита',
    TranslateKey: 'Deposit confirmation',
  },
  {
    LID: '1',
    TranslateData: 'אישור ההפקדה הצליח',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '2',
    TranslateData: 'Deposit confirmation was successful',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '3',
    TranslateData: 'La confirmation du dépôt a réussi',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '4',
    TranslateData: 'Подтверждение депозита прошло успешно',
    TranslateKey: 'Deposit confirmation was successful',
  },
  {
    LID: '1',
    TranslateData: 'שגיאה באישור ההפקדה',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '2',
    TranslateData: 'Error in deposit confirmation',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '3',
    TranslateData: 'Erreur lors de la confirmation du dépôt',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка подтверждения депозита',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '1',
    TranslateData: 'אישור ההפקדה נכשל, אנא נסה שוב מאוחר יותר',
    TranslateKey: 'Deposit confirmation failed, please try again later',
  },
  {
    LID: '2',
    TranslateData: 'Deposit confirmation failed, please try again later',
    TranslateKey: 'Deposit confirmation failed, please try again later',
  },
  {
    LID: '3',
    TranslateData:
      'La confirmation du dépôt a échoué, veuillez réessayer ultérieurement',
    TranslateKey: 'Deposit confirmation failed, please try again later',
  },
  {
    LID: '4',
    TranslateData:
      'Подтверждение депозита не удалось, попробуйте еще раз позже',
    TranslateKey: 'Deposit confirmation failed, please try again later',
  },
  { LID: '1', TranslateData: 'שוב ללכוד', TranslateKey: 'Capture again' },
  { LID: '2', TranslateData: 'Capture again', TranslateKey: 'Capture again' },
  {
    LID: '3',
    TranslateData: 'Capturer à nouveau',
    TranslateKey: 'Capture again',
  },
  {
    LID: '4',
    TranslateData: 'Захватить еще раз',
    TranslateKey: 'Capture again',
  },
  { LID: '1', TranslateData: "מחק צ'ק", TranslateKey: 'Delete check' },
  { LID: '2', TranslateData: 'Delete check', TranslateKey: 'Delete check' },
  {
    LID: '3',
    TranslateData: 'Supprimer le chèque',
    TranslateKey: 'Delete check',
  },
  { LID: '4', TranslateData: 'Удалить чек', TranslateKey: 'Delete check' },
  { LID: '1', TranslateData: 'הפוך תמונה', TranslateKey: 'Flip image' },
  { LID: '2', TranslateData: 'Flip image', TranslateKey: 'Flip image' },
  { LID: '3', TranslateData: "Retourner l'image", TranslateKey: 'Flip image' },
  {
    LID: '4',
    TranslateData: 'Перевернуть изображение',
    TranslateKey: 'Flip image',
  },
  { LID: '1', TranslateData: "צ'ק", TranslateKey: 'Check' },
  { LID: '2', TranslateData: 'Check', TranslateKey: 'Check' },
  { LID: '3', TranslateData: 'Chèque', TranslateKey: 'Check' },
  { LID: '4', TranslateData: 'Чек', TranslateKey: 'Check' },
  { LID: '1', TranslateData: 'סה"כ', TranslateKey: 'SumTotal' },
  { LID: '2', TranslateData: 'Sum total', TranslateKey: 'SumTotal' },
  { LID: '3', TranslateData: 'SommeTotal', TranslateKey: 'SumTotal' },
  { LID: '4', TranslateData: 'SumTotal', TranslateKey: 'SumTotal' },
  { LID: '1', TranslateData: "סריקת צ'ק", TranslateKey: 'Scan Check' },
  { LID: '2', TranslateData: 'Scan Check', TranslateKey: 'Scan Check' },
  { LID: '3', TranslateData: 'Scanner le chèque', TranslateKey: 'Scan Check' },
  { LID: '4', TranslateData: 'Сканировать чек', TranslateKey: 'Scan Check' },
  {
    LID: '1',
    TranslateData: 'עבור להוספת המחאות',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '2',
    TranslateData: 'Go to add checks',
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '3',
    TranslateData: "Accéder à l'ajout de chèques",
    TranslateKey: 'Go to add checks',
  },
  {
    LID: '4',
    TranslateData: 'Перейти к добавлению чеков',
    TranslateKey: 'Go to add checks',
  },
  { LID: '1', TranslateData: "צ'קים", TranslateKey: 'Checks' },
  { LID: '2', TranslateData: 'Checks', TranslateKey: 'Checks' },
  { LID: '3', TranslateData: 'Vérifications', TranslateKey: 'Checks' },
  { LID: '4', TranslateData: 'Проверки', TranslateKey: 'Checks' },
  { LID: '1', TranslateData: "הנפקת צ'קים", TranslateKey: 'Issuing Checks' },
  { LID: '2', TranslateData: 'Issuing Checks', TranslateKey: 'Issuing Checks' },
  {
    LID: '3',
    TranslateData: 'Émission de chèques',
    TranslateKey: 'Issuing Checks',
  },
  { LID: '4', TranslateData: 'Выдача чеков', TranslateKey: 'Issuing Checks' },
  {
    LID: '1',
    TranslateData: 'פעולה זו תבטל את כל התשלומים, ולא תוכל להמשיך. אתה בטוח?',
    TranslateKey:
      'This action will cancel all payments, and you will not be able to proceed. Are you sure?',
  },
  {
    LID: '2',
    TranslateData:
      'This action will cancel all payments, and you will not be able to proceed. Are you sure?',
    TranslateKey:
      'This action will cancel all payments, and you will not be able to proceed. Are you sure?',
  },
  {
    LID: '3',
    TranslateData:
      'Cette action annulera tous les paiements et vous ne pourrez pas continuer. Êtes-vous sûr ?',
    TranslateKey:
      'This action will cancel all payments, and you will not be able to proceed. Are you sure?',
  },
  {
    LID: '4',
    TranslateData:
      'Это действие отменит все платежи, и вы не сможете продолжить. Вы уверены?',
    TranslateKey:
      'This action will cancel all payments, and you will not be able to proceed. Are you sure?',
  },
  { LID: '1', TranslateData: "צילום צ'ק", TranslateKey: 'Check Imaging' },
  { LID: '2', TranslateData: 'Check Imaging', TranslateKey: 'Check Imaging' },
  {
    LID: '3',
    TranslateData: 'Imagerie de chèques',
    TranslateKey: 'Check Imaging',
  },
  {
    LID: '4',
    TranslateData: 'Проверка изображений',
    TranslateKey: 'Check Imaging',
  },
  {
    LID: '1',
    TranslateData: 'האם אתה בטוח שברצונך לאשר את ההפקדה?',
    TranslateKey: 'Are you sure you want to confirm the deposit?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to confirm the deposit?',
    TranslateKey: 'Are you sure you want to confirm the deposit?',
  },
  {
    LID: '3',
    TranslateData: 'Êtes-vous sûr de vouloir confirmer le dépôt ?',
    TranslateKey: 'Are you sure you want to confirm the deposit?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите подтвердить депозит?',
    TranslateKey: 'Are you sure you want to confirm the deposit?',
  },
  {
    LID: '1',
    TranslateData: "צ'ק ממתין לאישור",
    TranslateKey: 'A check is panding approval',
  },
  {
    LID: '2',
    TranslateData: 'A check is panding approval',
    TranslateKey: 'A check is panding approval',
  },
  {
    LID: '3',
    TranslateData: "Un chèque est en attente d'encaissement",
    TranslateKey: 'A check is panding approval',
  },
  {
    LID: '4',
    TranslateData: 'Чек ожидает проверки',
    TranslateKey: 'A check is panding approval',
  },
  {
    LID: '1',
    TranslateData: 'שגיאה באישור הפקדה',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '2',
    TranslateData: 'Error in deposit confirmation',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '3',
    TranslateData: 'Erreur lors de la confirmation du dépôt',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '4',
    TranslateData: 'Ошибка подтверждения депозита',
    TranslateKey: 'Error in deposit confirmation',
  },
  {
    LID: '1',
    TranslateData: 'אישור הפקדה נכשל ,נסה שוב מאוחר יותר',
    TranslateKey: 'Failed, try again later',
  },
  {
    LID: '2',
    TranslateData: 'Failed, try again later',
    TranslateKey: 'Failed, try again later',
  },
  {
    LID: '3',
    TranslateData: 'Échec, réessayez plus tard',
    TranslateKey: 'Failed, try again later',
  },
  {
    LID: '4',
    TranslateData: 'Не удалось, попробуйте еще раз позже',
    TranslateKey: 'Failed, try again later',
  },
  {
    LID: '1',
    TranslateData: 'כרטיס דיינרס יחויב בתשלום כולל של {0} ש"ח',
    TranslateKey: 'A card diners will be charged a total fee {0} NIS',
  },
  {
    LID: '2',
    TranslateData: 'The Diners card will be charged a total fee of {0} NIS',
    TranslateKey: 'A card diners will be charged a total fee {0} NIS',
  },
  {
    LID: '3',
    TranslateData: 'La carte Diners sera facturée au total : {0} NIS.',
    TranslateKey: 'A card diners will be charged a total fee {0} NIS',
  },
  {
    LID: '4',
    TranslateData:
      'С карты Diners будет снята общая комиссия в размере {0} шекелей.',
    TranslateKey: 'A card diners will be charged a total fee {0} NIS',
  },
  {
    LID: '1',
    TranslateData: 'עבור כרטיס דיינרס, העמלה תהיה {0}% + מע"מ מסך העסקה',
    TranslateKey:
      'For a diners card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '2',
    TranslateData:
      'For the Diners card, the commission will be {0}% + VAT of the total transaction',
    TranslateKey:
      'For a diners card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '3',
    TranslateData:
      'Pour la carte Diners, la commission sera de {0} % + TVA du total de la transaction',
    TranslateKey:
      'For a diners card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '4',
    TranslateData:
      'Для карты Diners комиссия составит {0}% + НДС от общей суммы транзакции.',
    TranslateKey:
      'For a diners card, the fee will be {0}% + VAT of the total transaction',
  },
  { LID: '1', TranslateData: "קבוצת צ'קים", TranslateKey: 'Checks Group' },
  { LID: '2', TranslateData: 'Checks Group', TranslateKey: 'Checks Group' },
  {
    LID: '3',
    TranslateData: 'Groupe de chèques',
    TranslateKey: 'Checks Group',
  },
  { LID: '4', TranslateData: 'Группа чеков', TranslateKey: 'Checks Group' },
  { LID: '1', TranslateData: 'בצע תשלום', TranslateKey: 'Make a payment' },
  { LID: '2', TranslateData: 'Make a payment', TranslateKey: 'Make a payment' },
  {
    LID: '3',
    TranslateData: 'Effectuer un paiement',
    TranslateKey: 'Make a payment',
  },
  { LID: '4', TranslateData: 'Сделать платеж', TranslateKey: 'Make a payment' },
  {
    LID: '1',
    TranslateData: 'שלם בכרטיס אשראי',
    TranslateKey: 'Pay by credit card',
  },
  {
    LID: '2',
    TranslateData: 'Pay by credit card',
    TranslateKey: 'Pay by credit card',
  },
  {
    LID: '3',
    TranslateData: 'Payer par carte de crédit',
    TranslateKey: 'Pay by credit card',
  },
  {
    LID: '4',
    TranslateData: 'Оплатить кредитной картой',
    TranslateKey: 'Pay by credit card',
  },
  { LID: '1', TranslateData: "שלם בצ'קים", TranslateKey: 'Pay by checks' },
  { LID: '2', TranslateData: 'Pay by checks', TranslateKey: 'Pay by checks' },
  {
    LID: '3',
    TranslateData: 'Payer par chèque',
    TranslateKey: 'Pay by checks',
  },
  { LID: '4', TranslateData: 'Оплатить чеками', TranslateKey: 'Pay by checks' },
  {
    LID: '1',
    TranslateData:
      'עבור כרטיס אשראי אמריקן אקספרס, העמלה תהיה {0}% + מע"מ מסך העסקה',
    TranslateKey:
      'For a American Express credit card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '2',
    TranslateData:
      'For a American Express credit card, the fee will be {0}% + VAT of the total transaction',
    TranslateKey:
      'For a American Express credit card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '3',
    TranslateData:
      'Pour une carte de crédit American Express, les frais seront de {0}% + TVA du montant total de la transaction',
    TranslateKey:
      'For a American Express credit card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '4',
    TranslateData:
      'Для кредитной карты American Express комиссия составит {0}% + НДС от общей суммы транзакции.',
    TranslateKey:
      'For a American Express credit card, the fee will be {0}% + VAT of the total transaction',
  },
  {
    LID: '1',
    TranslateData: 'הכנס מספר תקין',
    TranslateKey: 'Set correctly number',
  },
  {
    LID: '2',
    TranslateData: 'Set correctly number',
    TranslateKey: 'Set correctly number',
  },
  {
    LID: '3',
    TranslateData: 'Définir correctement le numéro',
    TranslateKey: 'Set correctly number',
  },
  {
    LID: '4',
    TranslateData: 'Установите правильный номер',
    TranslateKey: 'Set correctly number',
  },
  {
    LID: '1',
    TranslateData:
      'בוצע תשלום עבור קריאת מונה נוכחית, לא ניתן לעדכן, על מנת לעדכן את קריאת המונה יש לשייך את התשלום עבור חיוב אחר או לבצע זיכוי',
    TranslateKey:
      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made',
  },
  {
    LID: '2',
    TranslateData:
      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made',
    TranslateKey:
      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made',
  },
  {
    LID: '3',
    TranslateData:
      'Un paiement a été effectué pour un relevé de compteur actuel, il ne peut pas être mis à jour, afin de mettre à jour le relevé de compteur, le paiement doit être associé à une autre charge ou un crédit doit être effectué',
    TranslateKey:
      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made',
  },
  {
    LID: '4',
    TranslateData:
      'Произведена оплата текущего показания счетчика, не может быть обновлено, для обновления показаний счетчика необходимо связать платеж с другим платежом или сделать кредит',
    TranslateKey:
      'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made',
  },
  {
    LID: '1',
    TranslateData: 'ניתן למחוק רק קריאת מונה אחרונה',
    TranslateKey: 'Only the last meter reading can be deleted',
  },
  {
    LID: '2',
    TranslateData: 'Only the last meter reading can be deleted',
    TranslateKey: 'Only the last meter reading can be deleted',
  },
  {
    LID: '3',
    TranslateData: 'Seul le dernier relevé de compteur peut être supprimé',
    TranslateKey: 'Only the last meter reading can be deleted',
  },
  {
    LID: '4',
    TranslateData: 'Можно удалить только последнее показание счетчика',
    TranslateKey: 'Only the last meter reading can be deleted',
  },
  {
    LID: '1',
    TranslateData: 'קריאת מונה נמחקה בהצלחה',
    TranslateKey: 'The reading was deleted successfully',
  },
  {
    LID: '2',
    TranslateData: 'The reading was deleted successfully',
    TranslateKey: 'The reading was deleted successfully',
  },
  {
    LID: '3',
    TranslateData: 'Le relevé a été supprimé avec succès',
    TranslateKey: 'The reading was deleted successfully',
  },
  {
    LID: '4',
    TranslateData: 'Показание успешно удалено',
    TranslateKey: 'The reading was deleted successfully',
  },
  {
    LID: '1',
    TranslateData: 'אתה בטוח שאתה רוצה למחוק קריאת מונה זו?',
    TranslateKey: 'Are you sure you want to delete this reading?',
  },
  {
    LID: '2',
    TranslateData: 'Are you sure you want to delete this reading?',
    TranslateKey: 'Are you sure you want to delete this reading?',
  },
  {
    LID: '3',
    TranslateData: 'Êtes-vous sûr de vouloir supprimer ce relevé ?',
    TranslateKey: 'Are you sure you want to delete this reading?',
  },
  {
    LID: '4',
    TranslateData: 'Вы уверены, что хотите удалить это показание?',
    TranslateKey: 'Are you sure you want to delete this reading?',
  },
]

export const vocabulary = words.reduce((acc, currVal) => {
  const langIdx = acc.findIndex((lang) => lang.LID === currVal.LID)
  if (langIdx > -1) {
    acc[langIdx] = {
      ...acc[langIdx],
      [currVal.TranslateKey]: currVal.TranslateData,
    }
    return acc
  } else
    acc.push({
      LID: currVal.LID,
      [currVal.TranslateKey]: currVal.TranslateData,
    })
  return acc
}, [])
// Vocabulary is a Grouped Array with 3 objects, each object represnts language.
export const languages = [
  { id: '1', dir: 'rtl', code: 'he' },
  { id: '2', dir: 'ltr', code: 'en' },
  { id: '3', dir: 'ltr', code: 'fr' },
  { id: '4', dir: 'ltr', code: 'ru' },
]
